// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.radio+.radio,.checkbox+.checkbox {
    margin-top: -5px
}

.radio-inline,.checkbox-inline {
    position: relative;
    display: inline-block;
    padding-left: 20px;
    margin-bottom: 0;
    vertical-align: middle;
    font-weight: normal;
    cursor: pointer
}

.radio-inline+.radio-inline,.checkbox-inline+.checkbox-inline {
    margin-top: 0;
    margin-left: 10px
}

input[type=radio][disabled],input[type=radio].disabled,fieldset[disabled] input[type=radio],input[type=checkbox][disabled],input[type=checkbox].disabled,fieldset[disabled] input[type=checkbox] {
    cursor: not-allowed
}

.radio-inline.disabled,fieldset[disabled] .radio-inline,.checkbox-inline.disabled,fieldset[disabled] .checkbox-inline {
    cursor: not-allowed
}

.radio.disabled label,fieldset[disabled] .radio label,.checkbox.disabled label,fieldset[disabled] .checkbox label {
    cursor: not-allowed
}

.form-control-static {
    padding-top: 9px;
    padding-bottom: 9px;
    margin-bottom: 0;
    min-height: 34px
}

.form-control-static.input-lg,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.form-control-static.input-sm,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn {
    padding-left: 0;
    padding-right: 0
}

.input-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn {
    height: 30px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px
}

select.input-sm,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,.input-group-sm>.input-group-btn>select.btn {
    height: 30px;
    line-height: 30px
}

textarea.input-sm,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,.input-group-sm>.input-group-btn>textarea.btn,select[multiple].input-sm,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>.input-group-btn>select[multiple].btn {
    height: auto
}

.form-group-sm .form-control {
    height: 30px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px
}

.form-group-sm select.form-control {
    height: 30px;
    line-height: 30px
}

.form-group-sm textarea.form-control,.form-group-sm select[multiple].form-control {
    height: auto
}

.form-group-sm .form-control-static {
    height: 30px;
    min-height: 32px;
    padding: 6px 10px;
    font-size: 12px;
    line-height: 1.5
}

.input-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn {
    height: 45px;
    padding: 10px 16px;
    font-size: 17px;
    line-height: 1.3333333;
    border-radius: 3px
}

select.input-lg,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,.input-group-lg>.input-group-btn>select.btn {
    height: 45px;
    line-height: 45px
}

textarea.input-lg,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,.input-group-lg>.input-group-btn>textarea.btn,select[multiple].input-lg,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>.input-group-btn>select[multiple].btn {
    height: auto
}

.form-group-lg .form-control {
    height: 45px;
    padding: 10px 16px;
    font-size: 17px;
    line-height: 1.3333333;
    border-radius: 3px
}

.form-group-lg select.form-control {
    height: 45px;
    line-height: 45px
}

.form-group-lg textarea.form-control,.form-group-lg select[multiple].form-control {
    height: auto
}

.form-group-lg .form-control-static {
    height: 45px;
    min-height: 37px;
    padding: 11px 16px;
    font-size: 17px;
    line-height: 1.3333333
}

.has-feedback {
    position: relative
}

.has-feedback .form-control {
    padding-right: 47.5px
}

.form-control-feedback {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    display: block;
    width: 38px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    pointer-events: none
}

.input-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-group-lg+.form-control-feedback,.form-group-lg .form-control+.form-control-feedback {
    width: 45px;
    height: 45px;
    line-height: 45px
}

.input-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-group-sm+.form-control-feedback,.form-group-sm .form-control+.form-control-feedback {
    width: 30px;
    height: 30px;
    line-height: 30px
}

.has-success .help-block,.has-success .control-label,.has-success .radio,.has-success .checkbox,.has-success .radio-inline,.has-success .checkbox-inline,.has-success.radio label,.has-success.checkbox label,.has-success.radio-inline label,.has-success.checkbox-inline label {
    color: #7ed320
}

.has-success .form-control {
    border-color: #7ed320;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075)
}

.has-success .form-control:focus {
    border-color: rgb(99.5555555556,166.7160493827,25.2839506173);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px hsl(88.4916201117,73.6625514403%,67.6470588235%)
}

.has-success .input-group-addon {
    color: #7ed320;
    border-color: #7ed320;
    background-color: rgb(235.65,248.4,221.55)
}

.has-success .form-control-feedback {
    color: #7ed320
}

.has-warning .help-block,.has-warning .control-label,.has-warning .radio,.has-warning .checkbox,.has-warning .radio-inline,.has-warning .checkbox-inline,.has-warning.radio label,.has-warning.checkbox label,.has-warning.radio-inline label,.has-warning.checkbox-inline label {
    color: #f5a623
}

.has-warning .form-control {
    border-color: #f5a623;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075)
}

.has-warning .form-control:focus {
    border-color: rgb(219.0434782609,140.3869565217,9.9565217391);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px hsl(37.4285714286,91.3043478261%,74.9019607843%)
}

.has-warning .input-group-addon {
    color: #f5a623;
    border-color: #f5a623;
    background-color: rgb(254.09,251.88,225.49)
}

.has-warning .form-control-feedback {
    color: #f5a623
}

.has-error .help-block,.has-error .control-label,.has-error .radio,.has-error .checkbox,.has-error .radio-inline,.has-error .checkbox-inline,.has-error.radio label,.has-error.checkbox label,.has-error.radio-inline label,.has-error.checkbox-inline label {
    color: #f52323
}

.has-error .form-control {
    border-color: #f52323;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075)
}

.has-error .form-control:focus {
    border-color: hsl(0,91.3043478261%,44.9019607843%);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px hsl(0,91.3043478261%,74.9019607843%)
}

.has-error .input-group-addon {
    color: #f52323;
    border-color: #f52323;
    background-color: rgb(249.36,224.52,227.64)
}

.has-error .form-control-feedback {
    color: #f52323
}

.has-feedback label~.form-control-feedback {
    top: 25px
}

.has-feedback label.sr-only~.form-control-feedback {
    top: 0
}

.help-block {
    display: block;
    margin-top: 5px;
    margin-bottom: 10px;
    color: rgb(97.75,97.75,97.75)
}

@media(min-width: 768px) {
    .form-inline .form-group {
        display:inline-block;
        margin-bottom: 0;
        vertical-align: middle
    }

    .form-inline .form-control {
        display: inline-block;
        width: auto;
        vertical-align: middle
    }

    .form-inline .form-control-static {
        display: inline-block
    }

    .form-inline .input-group {
        display: inline-table;
        vertical-align: middle
    }

    .form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn,.form-inline .input-group .form-control {
        width: auto
    }

    .form-inline .input-group>.form-control {
        width: 100%
    }

    .form-inline .control-label {
        margin-bottom: 0;
        vertical-align: middle
    }

    .form-inline .radio,.form-inline .checkbox {
        display: inline-block;
        margin-top: 0;
        margin-bottom: 0;
        vertical-align: middle
    }

    .form-inline .radio label,.form-inline .checkbox label {
        padding-left: 0
    }

    .form-inline .radio input[type=radio],.form-inline .checkbox input[type=checkbox] {
        position: relative;
        margin-left: 0
    }

    .form-inline .has-feedback .form-control-feedback {
        top: 0
    }
}

.form-horizontal .radio,.form-horizontal .checkbox,.form-horizontal .radio-inline,.form-horizontal .checkbox-inline {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 9px
}

.form-horizontal .radio,.form-horizontal .checkbox {
    min-height: 29px
}

.form-horizontal .form-group {
    margin-left: -15px;
    margin-right: -15px
}

.form-horizontal .form-group:before,.form-horizontal .form-group:after {
    content: " ";
    display: table
}

.form-horizontal .form-group:after {
    clear: both
}

@media(min-width: 768px) {
    .form-horizontal .control-label {
        text-align:right;
        margin-bottom: 0;
        padding-top: 9px
    }
}

.form-horizontal .has-feedback .form-control-feedback {
    right: 15px
}

@media(min-width: 768px) {
    .form-horizontal .form-group-lg .control-label {
        padding-top:11px;
        font-size: 17px
    }
}

@media(min-width: 768px) {
    .form-horizontal .form-group-sm .control-label {
        padding-top:6px;
        font-size: 12px
    }
}

.btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid rgba(0,0,0,0);
    white-space: nowrap;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 1.428571429;
    border-radius: 4px;
    -webkit-user-select: none;
    user-select: none
}

.btn:focus,.btn.focus,.btn:active:focus,.btn:active.focus,.btn.active:focus,.btn.active.focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px
}

.btn:hover,.btn:focus,.btn.focus {
    color: #4384d0;
    text-decoration: none
}

.btn:active,.btn.active {
    outline: 0;
    background-image: none;
    box-shadow: inset 0 3px 5px rgba(0,0,0,.125)
}

.btn.disabled,.btn[disabled],fieldset[disabled] .btn {
    cursor: not-allowed;
    opacity: .65;
    filter: alpha(opacity=65);
    box-shadow: none
}

a.btn.disabled,fieldset[disabled] a.btn {
    pointer-events: none
}

.btn-default {
    color: #4384d0;
    background-color: #fff;
    border-color: #e4e4e4
}

.btn-default:focus,.btn-default.focus {
    color: #4384d0;
    background-color: hsl(0,0%,90%);
    border-color: #ccc
}

.btn-default:hover {
    color: #4384d0;
    background-color: hsl(0,0%,90%);
    border-color: hsl(0,0%,88%)
}

.btn-default:active,.btn-default.active,.open>.btn-default.dropdown-toggle {
    color: #4384d0;
    background-color: hsl(0,0%,90%);
    border-color: hsl(0,0%,88%)
}

.btn-default:active:hover,.btn-default:active:focus,.btn-default:active.focus,.btn-default.active:hover,.btn-default.active:focus,.btn-default.active.focus,.open>.btn-default.dropdown-toggle:hover,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle.focus {
    color: #4384d0;
    background-color: hsl(0,0%,83%);
    border-color: #ccc
}

.btn-default:active,.btn-default.active,.open>.btn-default.dropdown-toggle {
    background-image: none
}

.btn-default.disabled:hover,.btn-default.disabled:focus,.btn-default.disabled.focus,.btn-default[disabled]:hover,.btn-default[disabled]:focus,.btn-default[disabled].focus,fieldset[disabled] .btn-default:hover,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default.focus {
    background-color: #fff;
    border-color: #e4e4e4
}

.btn-default .badge {
    color: #fff;
    background-color: #4384d0
}

.btn-primary {
    color: #fff;
    background-color: #4384d0;
    border-color: #4384d0
}

.btn-primary:focus,.btn-primary.focus {
    color: #fff;
    background-color: rgb(44.8,106.7574468085,179.2);
    border-color: rgb(34.6,82.4510638298,138.4)
}

.btn-primary:hover {
    color: #fff;
    background-color: rgb(44.8,106.7574468085,179.2);
    border-color: rgb(42.76,101.8961702128,171.04)
}

.btn-primary:active,.btn-primary.active,.open>.btn-primary.dropdown-toggle {
    color: #fff;
    background-color: rgb(44.8,106.7574468085,179.2);
    border-color: rgb(42.76,101.8961702128,171.04)
}

.btn-primary:active:hover,.btn-primary:active:focus,.btn-primary:active.focus,.btn-primary.active:hover,.btn-primary.active:focus,.btn-primary.active.focus,.open>.btn-primary.dropdown-toggle:hover,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle.focus {
    color: #fff;
    background-color: rgb(37.66,89.7429787234,150.64);
    border-color: rgb(34.6,82.4510638298,138.4)
}

.btn-primary:active,.btn-primary.active,.open>.btn-primary.dropdown-toggle {
    background-image: none
}

.btn-primary.disabled:hover,.btn-primary.disabled:focus,.btn-primary.disabled.focus,.btn-primary[disabled]:hover,.btn-primary[disabled]:focus,.btn-primary[disabled].focus,fieldset[disabled] .btn-primary:hover,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary.focus {
    background-color: #4384d0;
    border-color: #4384d0
}

.btn-primary .badge {
    color: #4384d0;
    background-color: #fff
}

.btn-success {
    color: #fff;
    background-color: #7ed320;
    border-color: #7ed320
}

.btn-success:focus,.btn-success.focus {
    color: #fff;
    background-color: rgb(99.5555555556,166.7160493827,25.2839506173);
    border-color: rgb(73.1111111111,122.4320987654,18.5679012346)
}

.btn-success:hover {
    color: #fff;
    background-color: rgb(99.5555555556,166.7160493827,25.2839506173);
    border-color: rgb(94.2666666667,157.8592592593,23.9407407407)
}

.btn-success:active,.btn-success.active,.open>.btn-success.dropdown-toggle {
    color: #fff;
    background-color: rgb(99.5555555556,166.7160493827,25.2839506173);
    border-color: rgb(94.2666666667,157.8592592593,23.9407407407)
}

.btn-success:active:hover,.btn-success:active:focus,.btn-success:active.focus,.btn-success.active:hover,.btn-success.active:focus,.btn-success.active.focus,.open>.btn-success.dropdown-toggle:hover,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle.focus {
    color: #fff;
    background-color: rgb(81.0444444444,135.7172839506,20.5827160494);
    border-color: rgb(73.1111111111,122.4320987654,18.5679012346)
}

.btn-success:active,.btn-success.active,.open>.btn-success.dropdown-toggle {
    background-image: none
}

.btn-success.disabled:hover,.btn-success.disabled:focus,.btn-success.disabled.focus,.btn-success[disabled]:hover,.btn-success[disabled]:focus,.btn-success[disabled].focus,fieldset[disabled] .btn-success:hover,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success.focus {
    background-color: #7ed320;
    border-color: #7ed320
}

.btn-success .badge {
    color: #7ed320;
    background-color: #fff
}

.btn-info {
    color: #fff;
    background-color: #5bc0de;
    border-color: #5bc0de
}

.btn-info:focus,.btn-info.focus {
    color: #fff;
    background-color: rgb(48.5431472081,175.6903553299,213.4568527919);
    border-color: rgb(35.345177665,143.5228426396,175.654822335)
}

.btn-info:hover {
    color: #fff;
    background-color: rgb(48.5431472081,175.6903553299,213.4568527919);
    border-color: rgb(42.1796954315,171.2751269036,209.6203045685)
}

.btn-info:active,.btn-info.active,.open>.btn-info.dropdown-toggle {
    color: #fff;
    background-color: rgb(48.5431472081,175.6903553299,213.4568527919);
    border-color: rgb(42.1796954315,171.2751269036,209.6203045685)
}

.btn-info:active:hover,.btn-info:active:focus,.btn-info:active.focus,.btn-info.active:hover,.btn-info.active:focus,.btn-info.active.focus,.open>.btn-info.dropdown-toggle:hover,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle.focus {
    color: #fff;
    background-color: rgb(37.9081218274,153.9299492386,188.3918781726);
    border-color: rgb(35.345177665,143.5228426396,175.654822335)
}

.btn-info:active,.btn-info.active,.open>.btn-info.dropdown-toggle {
    background-image: none
}

.btn-info.disabled:hover,.btn-info.disabled:focus,.btn-info.disabled.focus,.btn-info[disabled]:hover,.btn-info[disabled]:focus,.btn-info[disabled].focus,fieldset[disabled] .btn-info:hover,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info.focus {
    background-color: #5bc0de;
    border-color: #5bc0de
}

.btn-info .badge {
    color: #5bc0de;
    background-color: #fff
}

.btn-warning {
    color: #fff;
    background-color: #f5a623;
    border-color: #f5a623
}

.btn-warning:focus,.btn-warning.focus {
    color: #fff;
    background-color: rgb(219.0434782609,140.3869565217,9.9565217391);
    border-color: rgb(170.2608695652,109.1217391304,7.7391304348)
}

.btn-warning:hover {
    color: #fff;
    background-color: rgb(219.0434782609,140.3869565217,9.9565217391);
    border-color: rgb(209.2869565217,134.1339130435,9.5130434783)
}

.btn-warning:active,.btn-warning.active,.open>.btn-warning.dropdown-toggle {
    color: #fff;
    background-color: rgb(219.0434782609,140.3869565217,9.9565217391);
    border-color: rgb(209.2869565217,134.1339130435,9.5130434783)
}

.btn-warning:active:hover,.btn-warning:active:focus,.btn-warning:active.focus,.btn-warning.active:hover,.btn-warning.active:focus,.btn-warning.active.focus,.open>.btn-warning.dropdown-toggle:hover,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle.focus {
    color: #fff;
    background-color: rgb(184.8956521739,118.5013043478,8.4043478261);
    border-color: rgb(170.2608695652,109.1217391304,7.7391304348)
}

.btn-warning:active,.btn-warning.active,.open>.btn-warning.dropdown-toggle {
    background-image: none
}

.btn-warning.disabled:hover,.btn-warning.disabled:focus,.btn-warning.disabled.focus,.btn-warning[disabled]:hover,.btn-warning[disabled]:focus,.btn-warning[disabled].focus,fieldset[disabled] .btn-warning:hover,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning.focus {
    background-color: #f5a623;
    border-color: #f5a623
}

.btn-warning .badge {
    color: #f5a623;
    background-color: #fff
}

.btn-danger {
    color: #fff;
    background-color: #d0011b;
    border-color: #d0011b
}

.btn-danger:focus,.btn-danger.focus {
    color: #fff;
    background-color: rgb(157.2440191388,.7559808612,20.4114832536);
    border-color: rgb(106.4880382775,.5119617225,13.8229665072)
}

.btn-danger:hover {
    color: #fff;
    background-color: rgb(157.2440191388,.7559808612,20.4114832536);
    border-color: rgb(147.0928229665,.7071770335,19.0937799043)
}

.btn-danger:active,.btn-danger.active,.open>.btn-danger.dropdown-toggle {
    color: #fff;
    background-color: rgb(157.2440191388,.7559808612,20.4114832536);
    border-color: rgb(147.0928229665,.7071770335,19.0937799043)
}

.btn-danger:active:hover,.btn-danger:active:focus,.btn-danger:active.focus,.btn-danger.active:hover,.btn-danger.active:focus,.btn-danger.active.focus,.open>.btn-danger.dropdown-toggle:hover,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle.focus {
    color: #fff;
    background-color: rgb(121.7148325359,.5851674641,15.7995215311);
    border-color: rgb(106.4880382775,.5119617225,13.8229665072)
}

.btn-danger:active,.btn-danger.active,.open>.btn-danger.dropdown-toggle {
    background-image: none
}

.btn-danger.disabled:hover,.btn-danger.disabled:focus,.btn-danger.disabled.focus,.btn-danger[disabled]:hover,.btn-danger[disabled]:focus,.btn-danger[disabled].focus,fieldset[disabled] .btn-danger:hover,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger.focus {
    background-color: #d0011b;
    border-color: #d0011b
}

.btn-danger .badge {
    color: #d0011b;
    background-color: #fff
}

.btn-link {
    color: #4384d0;
    font-weight: normal;
    border-radius: 0
}

.btn-link,.btn-link:active,.btn-link.active,.btn-link[disabled],fieldset[disabled] .btn-link {
    background-color: rgba(0,0,0,0);
    box-shadow: none
}

.btn-link,.btn-link:hover,.btn-link:focus,.btn-link:active {
    border-color: rgba(0,0,0,0)
}

.btn-link:hover,.btn-link:focus {
    color: rgb(39.7,94.6042553191,158.8);
    text-decoration: underline;
    background-color: rgba(0,0,0,0)
}

.btn-link[disabled]:hover,.btn-link[disabled]:focus,fieldset[disabled] .btn-link:hover,fieldset[disabled] .btn-link:focus {
    color: hsl(0,0%,46.7%);
    text-decoration: none
}

.btn-lg,.btn-group-lg>.btn {
    padding: 10px 16px;
    font-size: 17px;
    line-height: 1.3333333;
    border-radius: 6px
}

.btn-sm,.btn-group-sm>.btn {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px
}

.btn-xs,.btn-group-xs>.btn {
    padding: 1px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px
}

.btn-block {
    display: block;
    width: 100%
}

.btn-block+.btn-block {
    margin-top: 5px
}

input[type=submit].btn-block,input[type=reset].btn-block,input[type=button].btn-block {
    width: 100%
}

.fade {
    opacity: 0;
    transition: opacity .15s linear
}

.fade.in {
    opacity: 1
}

.collapse {
    display: none
}

.collapse.in {
    display: block
}

tr.collapse.in {
    display: table-row
}

tbody.collapse.in {
    display: table-row-group
}

.collapsing {
    position: relative;
    height: 0;
    overflow: hidden;
    transition-property: height,visibility;
    transition-duration: .35s;
    transition-timing-function: ease
}

.caret {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 2px;
    vertical-align: middle;
    border-top: 4px dashed;
    border-top: 4px solid \\9 ;
    border-right: 4px solid rgba(0,0,0,0);
    border-left: 4px solid rgba(0,0,0,0)
}

.dropup,.dropdown {
    position: relative
}

.dropdown-toggle:focus {
    outline: 0
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    list-style: none;
    font-size: 14px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: 4px;
    box-shadow: 0 6px 12px rgba(0,0,0,.175);
    background-clip: padding-box
}

.dropdown-menu.pull-right {
    right: 0;
    left: auto
}

.dropdown-menu .divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #999
}

.dropdown-menu>li>a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: normal;
    line-height: 1.428571429;
    color: #919191;
    white-space: nowrap
}

.dropdown-menu>li>a:hover,.dropdown-menu>li>a:focus {
    text-decoration: none;
    color: rgb(81.25,81.25,81.25);
    background-color: #f5f5f5
}

.dropdown-menu>.active>a,.dropdown-menu>.active>a:hover,.dropdown-menu>.active>a:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    background-color: #4384d0
}

.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:hover,.dropdown-menu>.disabled>a:focus {
    color: hsl(0,0%,46.7%)
}

.dropdown-menu>.disabled>a:hover,.dropdown-menu>.disabled>a:focus {
    text-decoration: none;
    background-color: rgba(0,0,0,0);
    background-image: none;
    filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
    cursor: not-allowed
}

.open>.dropdown-menu {
    display: block
}

.open>a {
    outline: 0
}

.dropdown-menu-right {
    left: auto;
    right: 0
}

.dropdown-menu-left {
    left: 0;
    right: auto
}

.dropdown-header {
    display: block;
    padding: 3px 20px;
    font-size: 12px;
    line-height: 1.428571429;
    color: hsl(0,0%,46.7%);
    white-space: nowrap
}

.dropdown-backdrop {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 990
}

.pull-right>.dropdown-menu {
    right: 0;
    left: auto
}

.dropup .caret,.navbar-fixed-bottom .dropdown .caret {
    border-top: 0;
    border-bottom: 4px dashed;
    border-bottom: 4px solid \\9 ;
    content: ""
}

.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu {
    top: auto;
    bottom: 100%;
    margin-bottom: 2px
}

@media(min-width: 992px) {
    .navbar-right .dropdown-menu {
        right:0;
        left: auto
    }

    .navbar-right .dropdown-menu-left {
        left: 0;
        right: auto
    }
}

.btn-group,.btn-group-vertical {
    position: relative;
    display: inline-block;
    vertical-align: middle
}

.btn-group>.btn,.btn-group-vertical>.btn {
    position: relative;
    float: left
}

.btn-group>.btn:hover,.btn-group>.btn:focus,.btn-group>.btn:active,.btn-group>.btn.active,.btn-group-vertical>.btn:hover,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn.active {
    z-index: 2
}

.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group {
    margin-left: -1px
}

.btn-toolbar {
    margin-left: -5px
}

.btn-toolbar:before,.btn-toolbar:after {
    content: " ";
    display: table
}

.btn-toolbar:after {
    clear: both
}

.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group {
    float: left
}

.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group {
    margin-left: 5px
}

.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
    border-radius: 0
}

.btn-group>.btn:first-child {
    margin-left: 0
}

.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0
}

.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child) {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0
}

.btn-group>.btn-group {
    float: left
}

.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn {
    border-radius: 0
}

.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0
}

.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0
}

.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle {
    outline: 0
}

.btn-group>.btn+.dropdown-toggle {
    padding-left: 8px;
    padding-right: 8px
}

.btn-group>.btn-lg+.dropdown-toggle,.btn-group.btn-group-lg>.btn+.dropdown-toggle {
    padding-left: 12px;
    padding-right: 12px
}

.btn-group.open .dropdown-toggle {
    box-shadow: inset 0 3px 5px rgba(0,0,0,.125)
}

.btn-group.open .dropdown-toggle.btn-link {
    box-shadow: none
}

.btn .caret {
    margin-left: 0
}

.btn-lg .caret,.btn-group-lg>.btn .caret {
    border-width: 5px 5px 0;
    border-bottom-width: 0
}

.dropup .btn-lg .caret,.dropup .btn-group-lg>.btn .caret {
    border-width: 0 5px 5px
}

.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn {
    display: block;
    float: none;
    width: 100%;
    max-width: 100%
}

.btn-group-vertical>.btn-group:before,.btn-group-vertical>.btn-group:after {
    content: " ";
    display: table
}

.btn-group-vertical>.btn-group:after {
    clear: both
}

.btn-group-vertical>.btn-group>.btn {
    float: none
}

.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group {
    margin-top: -1px;
    margin-left: 0
}

.btn-group-vertical>.btn:not(:first-child):not(:last-child) {
    border-radius: 0
}

.btn-group-vertical>.btn:first-child:not(:last-child) {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0
}

.btn-group-vertical>.btn:last-child:not(:first-child) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px
}

.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn {
    border-radius: 0
}

.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0
}

.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child {
    border-top-right-radius: 0;
    border-top-left-radius: 0
}

.btn-group-justified {
    display: table;
    width: 100%;
    table-layout: fixed;
    border-collapse: separate
}

.btn-group-justified>.btn,.btn-group-justified>.btn-group {
    float: none;
    display: table-cell;
    width: 1%
}

.btn-group-justified>.btn-group .btn {
    width: 100%
}

.btn-group-justified>.btn-group .dropdown-menu {
    left: auto
}

[data-toggle=buttons]>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn-group>.btn input[type=checkbox] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none
}

.input-group {
    position: relative;
    display: table;
    border-collapse: separate
}

.input-group[class*=col-] {
    float: none;
    padding-left: 0;
    padding-right: 0
}

.input-group .form-control {
    position: relative;
    z-index: 2;
    float: left;
    width: 100%;
    margin-bottom: 0
}

.input-group .form-control:focus {
    z-index: 3
}

.input-group-addon,.input-group-btn,.input-group .form-control {
    display: table-cell
}

.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child) {
    border-radius: 0
}

.input-group-addon,.input-group-btn {
    width: 1%;
    white-space: nowrap;
    vertical-align: middle
}

.input-group-addon {
    padding: 8px 12px;
    font-size: 14px;
    font-weight: normal;
    line-height: 1;
    color: #222;
    text-align: center;
    background-color: hsl(0,0%,93.5%);
    border: 1px solid #e4e4e4;
    border-radius: 4px
}

.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn {
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 3px
}

.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn {
    padding: 10px 16px;
    font-size: 17px;
    border-radius: 3px
}

.input-group-addon input[type=radio],.input-group-addon input[type=checkbox] {
    margin-top: 0
}

.input-group .form-control:first-child,.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group-btn:last-child>.btn-group:not(:last-child)>.btn {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0
}

.input-group-addon:first-child {
    border-right: 0
}

.input-group .form-control:last-child,.input-group-addon:last-child,.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:first-child>.btn-group:not(:first-child)>.btn {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0
}

.input-group-addon:last-child {
    border-left: 0
}

.input-group-btn {
    position: relative;
    font-size: 0;
    white-space: nowrap
}

.input-group-btn>.btn {
    position: relative
}

.input-group-btn>.btn+.btn {
    margin-left: -1px
}

.input-group-btn>.btn:hover,.input-group-btn>.btn:focus,.input-group-btn>.btn:active {
    z-index: 2
}

.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group {
    margin-right: -1px
}

.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group {
    z-index: 2;
    margin-left: -1px
}

.nav {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none
}

.nav:before,.nav:after {
    content: " ";
    display: table
}

.nav:after {
    clear: both
}

.nav>li {
    position: relative;
    display: block
}

.nav>li>a {
    position: relative;
    display: block;
    padding: 10px 15px
}

.nav>li>a:hover,.nav>li>a:focus {
    text-decoration: none;
    background-color: hsl(0,0%,93.5%)
}

.nav>li.disabled>a {
    color: hsl(0,0%,46.7%)
}

.nav>li.disabled>a:hover,.nav>li.disabled>a:focus {
    color: hsl(0,0%,46.7%);
    text-decoration: none;
    background-color: rgba(0,0,0,0);
    cursor: not-allowed
}

.nav .open>a,.nav .open>a:hover,.nav .open>a:focus {
    background-color: hsl(0,0%,93.5%);
    border-color: #4384d0
}

.nav .nav-divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5
}

.nav>li>a>img {
    max-width: none
}

.nav-tabs {
    border-bottom: 1px solid #d8d8d8
}

.nav-tabs>li {
    float: left;
    margin-bottom: -1px
}

.nav-tabs>li>a {
    margin-right: 2px;
    line-height: 1.428571429;
    border: 1px solid rgba(0,0,0,0);
    border-radius: 4px 4px 0 0
}

.nav-tabs>li>a:hover {
    border-color: rgba(0,0,0,0) rgba(0,0,0,0) #d8d8d8
}

.nav-tabs>li.active>a,.nav-tabs>li.active>a:hover,.nav-tabs>li.active>a:focus {
    color: #222;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,0);
    border-bottom-color: rgba(0,0,0,0);
    cursor: default
}

.nav-pills>li {
    float: left
}

.nav-pills>li>a {
    border-radius: 20px
}

.nav-pills>li+li {
    margin-left: 2px
}

.nav-pills>li.active>a,.nav-pills>li.active>a:hover,.nav-pills>li.active>a:focus {
    color: #fff;
    background-color: #222
}

.nav-stacked>li {
    float: none
}

.nav-stacked>li+li {
    margin-top: 2px;
    margin-left: 0
}

.nav-justified,.nav-tabs.nav-justified {
    width: 100%
}

.nav-justified>li,.nav-tabs.nav-justified>li {
    float: none
}

.nav-justified>li>a,.nav-tabs.nav-justified>li>a {
    text-align: center;
    margin-bottom: 5px
}

.nav-justified>.dropdown .dropdown-menu {
    top: auto;
    left: auto
}

@media(min-width: 768px) {
    .nav-justified>li,.nav-tabs.nav-justified>li {
        display:table-cell;
        width: 1%
    }

    .nav-justified>li>a,.nav-tabs.nav-justified>li>a {
        margin-bottom: 0
    }
}

.nav-tabs-justified,.nav-tabs.nav-justified {
    border-bottom: 0
}

.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a {
    margin-right: 0;
    border-radius: 4px
}

.nav-tabs-justified>.active>a,.nav-tabs.nav-justified>.active>a,.nav-tabs-justified>.active>a:hover,.nav-tabs-justified>.active>a:focus {
    border: 1px solid #ddd
}

@media(min-width: 768px) {
    .nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a {
        border-bottom:1px solid #ddd;
        border-radius: 4px 4px 0 0
    }

    .nav-tabs-justified>.active>a,.nav-tabs.nav-justified>.active>a,.nav-tabs-justified>.active>a:hover,.nav-tabs-justified>.active>a:focus {
        border-bottom-color: #fff
    }
}

.tab-content>.tab-pane {
    display: none
}

.tab-content>.active {
    display: block
}

.nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-right-radius: 0;
    border-top-left-radius: 0
}

.navbar {
    position: relative;
    min-height: 60px;
    margin-bottom: 0;
    border: 1px solid rgba(0,0,0,0)
}

.navbar:before,.navbar:after {
    content: " ";
    display: table
}

.navbar:after {
    clear: both
}

@media(min-width: 992px) {
    .navbar {
        border-radius:0
    }
}

.navbar-header:before,.navbar-header:after {
    content: " ";
    display: table
}

.navbar-header:after {
    clear: both
}

@media(min-width: 992px) {
    .navbar-header {
        float:left
    }
}

.navbar-collapse {
    overflow-x: visible;
    padding-right: 13px;
    padding-left: 13px;
    border-top: 1px solid rgba(0,0,0,0);
    box-shadow: inset 0 1px 0 hsla(0,0%,100%,.1);
    -webkit-overflow-scrolling: touch
}

.navbar-collapse:before,.navbar-collapse:after {
    content: " ";
    display: table
}

.navbar-collapse:after {
    clear: both
}

.navbar-collapse.in {
    overflow-y: auto
}

@media(min-width: 992px) {
    .navbar-collapse {
        width:auto;
        border-top: 0;
        box-shadow: none
    }

    .navbar-collapse.collapse {
        display: block !important;
        height: auto !important;
        padding-bottom: 0;
        overflow: visible !important
    }

    .navbar-collapse.in {
        overflow-y: visible
    }

    .navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse,.navbar-fixed-bottom .navbar-collapse {
        padding-left: 0;
        padding-right: 0
    }
}

.navbar-fixed-top .navbar-collapse,.navbar-fixed-bottom .navbar-collapse {
    max-height: 340px
}

@media(max-device-width: 480px)and (orientation: landscape) {
    .navbar-fixed-top .navbar-collapse,.navbar-fixed-bottom .navbar-collapse {
        max-height:200px
    }
}

.container>.navbar-header,.container>.navbar-collapse,.container-fluid>.navbar-header,.container-fluid>.navbar-collapse {
    margin-right: -13px;
    margin-left: -13px
}

@media(min-width: 992px) {
    .container>.navbar-header,.container>.navbar-collapse,.container-fluid>.navbar-header,.container-fluid>.navbar-collapse {
        margin-right:0;
        margin-left: 0
    }
}

.navbar-static-top {
    z-index: 1000;
    border-width: 0 0 1px
}

@media(min-width: 992px) {
    .navbar-static-top {
        border-radius:0
    }
}

.navbar-fixed-top,.navbar-fixed-bottom {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1030
}

@media(min-width: 992px) {
    .navbar-fixed-top,.navbar-fixed-bottom {
        border-radius:0
    }
}

.navbar-fixed-top {
    top: 0;
    border-width: 0 0 1px
}

.navbar-fixed-bottom {
    bottom: 0;
    margin-bottom: 0;
    border-width: 1px 0 0
}

.navbar-brand {
    float: left;
    padding: 20px 13px;
    font-size: 17px;
    line-height: 20px;
    height: 60px
}

.navbar-brand:hover,.navbar-brand:focus {
    text-decoration: none
}

.navbar-brand>img {
    display: block
}

@media(min-width: 992px) {
    .navbar>.container .navbar-brand,.navbar>.container-fluid .navbar-brand {
        margin-left:-13px
    }
}

.navbar-toggle {
    position: relative;
    float: right;
    margin-right: 13px;
    padding: 9px 10px;
    margin-top: 13px;
    margin-bottom: 13px;
    background-color: rgba(0,0,0,0);
    background-image: none;
    border: 1px solid rgba(0,0,0,0);
    border-radius: 4px
}

.navbar-toggle:focus {
    outline: 0
}

.navbar-toggle .icon-bar {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px
}

.navbar-toggle .icon-bar+.icon-bar {
    margin-top: 4px
}

@media(min-width: 992px) {
    .navbar-toggle {
        display:none
    }
}

.navbar-nav {
    margin: 10px -13px
}

.navbar-nav>li>a {
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 20px
}

@media(max-width: 991px) {
    .navbar-nav .open .dropdown-menu {
        position:static;
        float: none;
        width: auto;
        margin-top: 0;
        background-color: rgba(0,0,0,0);
        border: 0;
        box-shadow: none
    }

    .navbar-nav .open .dropdown-menu>li>a,.navbar-nav .open .dropdown-menu .dropdown-header {
        padding: 5px 15px 5px 25px
    }

    .navbar-nav .open .dropdown-menu>li>a {
        line-height: 20px
    }

    .navbar-nav .open .dropdown-menu>li>a:hover,.navbar-nav .open .dropdown-menu>li>a:focus {
        background-image: none
    }
}

@media(min-width: 992px) {
    .navbar-nav {
        float:left;
        margin: 0
    }

    .navbar-nav>li {
        float: left
    }

    .navbar-nav>li>a {
        padding-top: 20px;
        padding-bottom: 20px
    }
}

.navbar-form {
    margin-left: -13px;
    margin-right: -13px;
    padding: 10px 13px;
    border-top: 1px solid rgba(0,0,0,0);
    border-bottom: 1px solid rgba(0,0,0,0);
    box-shadow: inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);
    margin-top: 11px;
    margin-bottom: 11px
}

@media(min-width: 768px) {
    .navbar-form .form-group {
        display:inline-block;
        margin-bottom: 0;
        vertical-align: middle
    }

    .navbar-form .form-control {
        display: inline-block;
        width: auto;
        vertical-align: middle
    }

    .navbar-form .form-control-static {
        display: inline-block
    }

    .navbar-form .input-group {
        display: inline-table;
        vertical-align: middle
    }

    .navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn,.navbar-form .input-group .form-control {
        width: auto
    }

    .navbar-form .input-group>.form-control {
        width: 100%
    }

    .navbar-form .control-label {
        margin-bottom: 0;
        vertical-align: middle
    }

    .navbar-form .radio,.navbar-form .checkbox {
        display: inline-block;
        margin-top: 0;
        margin-bottom: 0;
        vertical-align: middle
    }

    .navbar-form .radio label,.navbar-form .checkbox label {
        padding-left: 0
    }

    .navbar-form .radio input[type=radio],.navbar-form .checkbox input[type=checkbox] {
        position: relative;
        margin-left: 0
    }

    .navbar-form .has-feedback .form-control-feedback {
        top: 0
    }
}

@media(max-width: 991px) {
    .navbar-form .form-group {
        margin-bottom:5px
    }

    .navbar-form .form-group:last-child {
        margin-bottom: 0
    }
}

@media(min-width: 992px) {
    .navbar-form {
        width:auto;
        border: 0;
        margin-left: 0;
        margin-right: 0;
        padding-top: 0;
        padding-bottom: 0;
        box-shadow: none
    }
}

.navbar-nav>li>.dropdown-menu {
    margin-top: 0;
    border-top-right-radius: 0;
    border-top-left-radius: 0
}

.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu {
    margin-bottom: 0;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0
}

.navbar-btn {
    margin-top: 11px;
    margin-bottom: 11px
}

.navbar-btn.btn-sm,.btn-group-sm>.navbar-btn.btn {
    margin-top: 15px;
    margin-bottom: 15px
}

.navbar-btn.btn-xs,.btn-group-xs>.navbar-btn.btn {
    margin-top: 19px;
    margin-bottom: 19px
}

.navbar-text {
    margin-top: 20px;
    margin-bottom: 20px
}

@media(min-width: 992px) {
    .navbar-text {
        float:left;
        margin-left: 13px;
        margin-right: 13px
    }
}

@media(min-width: 992px) {
    .navbar-left {
        float:left !important
    }

    .navbar-right {
        float: right !important;
        margin-right: -13px
    }

    .navbar-right~.navbar-right {
        margin-right: 0
    }
}

.navbar-default {
    background-color: #fff;
    border-color: #e4e4e4
}

.navbar-default .navbar-brand {
    color: #919191
}

.navbar-default .navbar-brand:hover,.navbar-default .navbar-brand:focus {
    color: rgb(119.5,119.5,119.5);
    background-color: rgba(0,0,0,0)
}

.navbar-default .navbar-text {
    color: #919191
}

.navbar-default .navbar-nav>li>a {
    color: #919191
}

.navbar-default .navbar-nav>li>a:hover,.navbar-default .navbar-nav>li>a:focus {
    color: rgb(81.25,81.25,81.25);
    background-color: rgba(0,0,0,0)
}

.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:hover,.navbar-default .navbar-nav>.active>a:focus {
    color: #000;
    background-color: rgba(0,0,0,0)
}

.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:hover,.navbar-default .navbar-nav>.disabled>a:focus {
    color: #ccc;
    background-color: rgba(0,0,0,0)
}

.navbar-default .navbar-toggle {
    border-color: rgba(0,0,0,0)
}

.navbar-default .navbar-toggle:hover,.navbar-default .navbar-toggle:focus {
    background-color: #ddd
}

.navbar-default .navbar-toggle .icon-bar {
    background-color: #919191
}

.navbar-default .navbar-collapse,.navbar-default .navbar-form {
    border-color: #e4e4e4
}

.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:hover,.navbar-default .navbar-nav>.open>a:focus {
    background-color: rgba(0,0,0,0);
    color: #000
}

@media(max-width: 991px) {
    .navbar-default .navbar-nav .open .dropdown-menu>li>a {
        color:#919191
    }

    .navbar-default .navbar-nav .open .dropdown-menu>li>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus {
        color: rgb(81.25,81.25,81.25);
        background-color: rgba(0,0,0,0)
    }

    .navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus {
        color: #000;
        background-color: rgba(0,0,0,0)
    }

    .navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus {
        color: #ccc;
        background-color: rgba(0,0,0,0)
    }
}

.navbar-default .navbar-link {
    color: #919191
}

.navbar-default .navbar-link:hover {
    color: rgb(81.25,81.25,81.25)
}

.navbar-default .btn-link {
    color: #919191
}

.navbar-default .btn-link:hover,.navbar-default .btn-link:focus {
    color: rgb(81.25,81.25,81.25)
}

.navbar-default .btn-link[disabled]:hover,.navbar-default .btn-link[disabled]:focus,fieldset[disabled] .navbar-default .btn-link:hover,fieldset[disabled] .navbar-default .btn-link:focus {
    color: #ccc
}

.navbar-inverse {
    background-color: #222;
    border-color: rgb(8.5,8.5,8.5)
}

.navbar-inverse .navbar-brand {
    color: hsl(0,0%,61.7%)
}

.navbar-inverse .navbar-brand:hover,.navbar-inverse .navbar-brand:focus {
    color: #fff;
    background-color: rgba(0,0,0,0)
}

.navbar-inverse .navbar-text {
    color: hsl(0,0%,61.7%)
}

.navbar-inverse .navbar-nav>li>a {
    color: hsl(0,0%,61.7%)
}

.navbar-inverse .navbar-nav>li>a:hover,.navbar-inverse .navbar-nav>li>a:focus {
    color: #fff;
    background-color: rgba(0,0,0,0)
}

.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:hover,.navbar-inverse .navbar-nav>.active>a:focus {
    color: #fff;
    background-color: rgb(8.5,8.5,8.5)
}

.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:hover,.navbar-inverse .navbar-nav>.disabled>a:focus {
    color: #444;
    background-color: rgba(0,0,0,0)
}

.navbar-inverse .navbar-toggle {
    border-color: #333
}

.navbar-inverse .navbar-toggle:hover,.navbar-inverse .navbar-toggle:focus {
    background-color: #333
}

.navbar-inverse .navbar-toggle .icon-bar {
    background-color: #fff
}

.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form {
    border-color: rgb(16.15,16.15,16.15)
}

.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:hover,.navbar-inverse .navbar-nav>.open>a:focus {
    background-color: rgb(8.5,8.5,8.5);
    color: #fff
}

@media(max-width: 991px) {
    .navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header {
        border-color:rgb(8.5,8.5,8.5)
    }

    .navbar-inverse .navbar-nav .open .dropdown-menu .divider {
        background-color: rgb(8.5,8.5,8.5)
    }

    .navbar-inverse .navbar-nav .open .dropdown-menu>li>a {
        color: hsl(0,0%,61.7%)
    }

    .navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus {
        color: #fff;
        background-color: rgba(0,0,0,0)
    }

    .navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus {
        color: #fff;
        background-color: rgb(8.5,8.5,8.5)
    }

    .navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus {
        color: #444;
        background-color: rgba(0,0,0,0)
    }
}

.navbar-inverse .navbar-link {
    color: hsl(0,0%,61.7%)
}

.navbar-inverse .navbar-link:hover {
    color: #fff
}

.navbar-inverse .btn-link {
    color: hsl(0,0%,61.7%)
}

.navbar-inverse .btn-link:hover,.navbar-inverse .btn-link:focus {
    color: #fff
}

.navbar-inverse .btn-link[disabled]:hover,.navbar-inverse .btn-link[disabled]:focus,fieldset[disabled] .navbar-inverse .btn-link:hover,fieldset[disabled] .navbar-inverse .btn-link:focus {
    color: #444
}

.breadcrumb {
    padding: 0px 0px;
    margin-bottom: 20px;
    list-style: none;
    background-color: rgba(0,0,0,0);
    border-radius: 4px
}

.breadcrumb>li {
    display: inline-block
}

.breadcrumb>li+li:before {
    content: "· ";
    padding: 0 5px;
    color: #4384d0
}

.breadcrumb>.active {
    color: #222
}

.pagination {
    display: inline-block;
    padding-left: 0;
    margin: 20px 0;
    border-radius: 4px
}

.pagination>li {
    display: inline
}

.pagination>li>a,.pagination>li>span {
    position: relative;
    float: left;
    padding: 8px 12px;
    line-height: 1.428571429;
    text-decoration: none;
    color: #4384d0;
    background-color: #fff;
    border: 1px solid #ddd;
    margin-left: -1px
}

.pagination>li:first-child>a,.pagination>li:first-child>span {
    margin-left: 0;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px
}

.pagination>li:last-child>a,.pagination>li:last-child>span {
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px
}

.pagination>li>a:hover,.pagination>li>a:focus,.pagination>li>span:hover,.pagination>li>span:focus {
    z-index: 2;
    color: rgb(39.7,94.6042553191,158.8);
    background-color: hsl(0,0%,93.5%);
    border-color: #ddd
}

.pagination>.active>a,.pagination>.active>a:hover,.pagination>.active>a:focus,.pagination>.active>span,.pagination>.active>span:hover,.pagination>.active>span:focus {
    z-index: 3;
    color: #fff;
    background-color: #4384d0;
    border-color: #4384d0;
    cursor: default
}

.pagination>.disabled>span,.pagination>.disabled>span:hover,.pagination>.disabled>span:focus,.pagination>.disabled>a,.pagination>.disabled>a:hover,.pagination>.disabled>a:focus {
    color: hsl(0,0%,46.7%);
    background-color: #fff;
    border-color: #ddd;
    cursor: not-allowed
}

.pagination-lg>li>a,.pagination-lg>li>span {
    padding: 10px 16px;
    font-size: 17px;
    line-height: 1.3333333
}

.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span {
    border-bottom-left-radius: 6px;
    border-top-left-radius: 6px
}

.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span {
    border-bottom-right-radius: 6px;
    border-top-right-radius: 6px
}

.pagination-sm>li>a,.pagination-sm>li>span {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5
}

.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span {
    border-bottom-left-radius: 3px;
    border-top-left-radius: 3px
}

.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span {
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px
}

.pager {
    padding-left: 0;
    margin: 20px 0;
    list-style: none;
    text-align: center
}

.pager:before,.pager:after {
    content: " ";
    display: table
}

.pager:after {
    clear: both
}

.pager li {
    display: inline
}

.pager li>a,.pager li>span {
    display: inline-block;
    padding: 5px 14px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 15px
}

.pager li>a:hover,.pager li>a:focus {
    text-decoration: none;
    background-color: hsl(0,0%,93.5%)
}

.pager .next>a,.pager .next>span {
    float: right
}

.pager .previous>a,.pager .previous>span {
    float: left
}

.pager .disabled>a,.pager .disabled>a:hover,.pager .disabled>a:focus,.pager .disabled>span {
    color: hsl(0,0%,46.7%);
    background-color: #fff;
    cursor: not-allowed
}

.label {
    display: inline;
    padding: .2em .6em .3em;
    font-size: 75%;
    font-weight: bold;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25em
}

.label:empty {
    display: none
}

.btn .label {
    position: relative;
    top: -1px
}

a.label:hover,a.label:focus {
    color: #fff;
    text-decoration: none;
    cursor: pointer
}

.label-default {
    background-color: hsl(0,0%,46.7%)
}

.label-default[href]:hover,.label-default[href]:focus {
    background-color: hsl(0,0%,36.7%)
}

.label-primary {
    background-color: #4384d0
}

.label-primary[href]:hover,.label-primary[href]:focus {
    background-color: rgb(44.8,106.7574468085,179.2)
}

.label-success {
    background-color: #7ed320
}

.label-success[href]:hover,.label-success[href]:focus {
    background-color: rgb(99.5555555556,166.7160493827,25.2839506173)
}

.label-info {
    background-color: #5bc0de
}

.label-info[href]:hover,.label-info[href]:focus {
    background-color: rgb(48.5431472081,175.6903553299,213.4568527919)
}

.label-warning {
    background-color: #f5a623
}

.label-warning[href]:hover,.label-warning[href]:focus {
    background-color: rgb(219.0434782609,140.3869565217,9.9565217391)
}

.label-danger {
    background-color: #d0011b
}

.label-danger[href]:hover,.label-danger[href]:focus {
    background-color: rgb(157.2440191388,.7559808612,20.4114832536)
}

.badge {
    display: inline-block;
    min-width: 10px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    line-height: 12px;
    vertical-align: middle;
    white-space: nowrap;
    text-align: center;
    background-color: #919191;
    border-radius: 10px
}

.badge:empty {
    display: none
}

.btn .badge {
    position: relative;
    top: -1px
}

.btn-xs .badge,.btn-group-xs>.btn .badge {
    top: 0;
    padding: 1px 5px
}

.list-group-item.active>.badge,.nav-pills>.active>a>.badge {
    color: #4384d0;
    background-color: #fff
}

.list-group-item>.badge {
    float: right
}

.list-group-item>.badge+.badge {
    margin-right: 5px
}

.nav-pills>li>a>.badge {
    margin-left: 3px
}

a.badge:hover,a.badge:focus {
    color: #fff;
    text-decoration: none;
    cursor: pointer
}

.jumbotron {
    padding-top: 30px;
    padding-bottom: 30px;
    margin-bottom: 30px;
    color: inherit;
    background-color: hsl(0,0%,93.5%)
}

.jumbotron h1,.jumbotron .h1 {
    color: inherit
}

.jumbotron p {
    margin-bottom: 15px;
    font-size: 21px;
    font-weight: 200
}

.jumbotron>hr {
    border-top-color: hsl(0,0%,83.5%)
}

.container .jumbotron,.container-fluid .jumbotron {
    border-radius: 6px;
    padding-left: 15px;
    padding-right: 15px
}

.jumbotron .container {
    max-width: 100%
}

@media screen and (min-width: 768px) {
    .jumbotron {
        padding-top:48px;
        padding-bottom: 48px
    }

    .container .jumbotron,.container-fluid .jumbotron {
        padding-left: 60px;
        padding-right: 60px
    }

    .jumbotron h1,.jumbotron .h1 {
        font-size: 63px
    }
}

.thumbnail {
    display: block;
    padding: 4px;
    margin-bottom: 20px;
    line-height: 1.428571429;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: border .2s ease-in-out
}

.thumbnail>img,.thumbnail a>img {
    display: block;
    max-width: 100%;
    height: auto;
    margin-left: auto;
    margin-right: auto
}

.thumbnail .caption {
    padding: 9px;
    color: #222
}

a.thumbnail:hover,a.thumbnail:focus,a.thumbnail.active {
    border-color: #4384d0
}

.alert {
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid rgba(0,0,0,0);
    border-radius: 4px
}

.alert h4 {
    margin-top: 0;
    color: inherit
}

.alert .alert-link {
    font-weight: bold
}

.alert>p,.alert>ul {
    margin-bottom: 0
}

.alert>p+p {
    margin-top: 5px
}

.alert-dismissable .close,.alert-dismissible .close {
    position: relative;
    top: -2px;
    right: -21px;
    color: inherit
}

.alert-success {
    background-color: #d8f0bc;
    border-color: #d8f0bc;
    color: #222
}

.alert-success hr {
    border-top-color: hsl(87.6923076923,63.4146341463%,78.9215686275%)
}

.alert-success .alert-link {
    color: rgb(8.5,8.5,8.5)
}

.alert-info {
    background-color: #f5f5f5;
    border-color: #f5f5f5;
    color: #222
}

.alert-info hr {
    border-top-color: hsl(0,0%,91.0784313725%)
}

.alert-info .alert-link {
    color: rgb(8.5,8.5,8.5)
}

.alert-warning {
    background-color: #fdf8b8;
    border-color: #fdf8b8;
    color: #222
}

.alert-warning hr {
    border-top-color: rgb(252.301369863,245.5547945205,159.198630137)
}

.alert-warning .alert-link {
    color: rgb(8.5,8.5,8.5)
}

.alert-danger {
    background-color: #ffd8d9;
    border-color: #ffd8d9;
    color: #222
}

.alert-danger hr {
    border-top-color: rgb(255,190.5,192.1538461538)
}

.alert-danger .alert-link {
    color: rgb(8.5,8.5,8.5)
}

@keyframes progress-bar-stripes {
    from {
        background-position: 40px 0
    }

    to {
        background-position: 0 0
    }
}

.progress {
    overflow: hidden;
    height: 20px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border-radius: 4px;
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1)
}

.progress-bar {
    float: left;
    width: 0%;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    background-color: #4384d0;
    box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    transition: width .6s ease
}

.progress-striped .progress-bar,.progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 40px 40px
}

.progress.active .progress-bar,.progress-bar.active {
    animation: progress-bar-stripes 2s linear infinite
}

.progress-bar-success {
    background-color: #7ed320
}

.progress-striped .progress-bar-success {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)
}

.progress-bar-info {
    background-color: #5bc0de
}

.progress-striped .progress-bar-info {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)
}

.progress-bar-warning {
    background-color: #f5a623
}

.progress-striped .progress-bar-warning {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)
}

.progress-bar-danger {
    background-color: #d0011b
}

.progress-striped .progress-bar-danger {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)
}

.media {
    margin-top: 15px
}

.media:first-child {
    margin-top: 0
}

.media,.media-body {
    zoom:1;overflow: hidden
}

.media-body {
    width: 10000px
}

.media-object {
    display: block
}

.media-object.img-thumbnail {
    max-width: none
}

.media-right,.media>.pull-right {
    padding-left: 10px
}

.media-left,.media>.pull-left {
    padding-right: 10px
}

.media-left,.media-right,.media-body {
    display: table-cell;
    vertical-align: top
}

.media-middle {
    vertical-align: middle
}

.media-bottom {
    vertical-align: bottom
}

.media-heading {
    margin-top: 0;
    margin-bottom: 5px
}

.media-list {
    padding-left: 0;
    list-style: none
}

.list-group {
    margin-bottom: 20px;
    padding-left: 0
}

.list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd
}

.list-group-item:first-child {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px
}

.list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px
}

a.list-group-item,button.list-group-item {
    color: #555
}

a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading {
    color: #333
}

a.list-group-item:hover,a.list-group-item:focus,button.list-group-item:hover,button.list-group-item:focus {
    text-decoration: none;
    color: #555;
    background-color: #f5f5f5
}

button.list-group-item {
    width: 100%;
    text-align: left
}

.list-group-item.disabled,.list-group-item.disabled:hover,.list-group-item.disabled:focus {
    background-color: hsl(0,0%,93.5%);
    color: hsl(0,0%,46.7%);
    cursor: not-allowed
}

.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading {
    color: inherit
}

.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text {
    color: hsl(0,0%,46.7%)
}

.list-group-item.active,.list-group-item.active:hover,.list-group-item.active:focus {
    z-index: 2;
    color: #fff;
    background-color: #4384d0;
    border-color: #4384d0
}

.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>small,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading>.small {
    color: inherit
}

.list-group-item.active .list-group-item-text,.list-group-item.active:hover .list-group-item-text,.list-group-item.active:focus .list-group-item-text {
    color: rgb(230.2,238.7744680851,248.8)
}

.list-group-item-success {
    color: #7ed320;
    background-color: rgb(235.65,248.4,221.55)
}

a.list-group-item-success,button.list-group-item-success {
    color: #7ed320
}

a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading {
    color: inherit
}

a.list-group-item-success:hover,a.list-group-item-success:focus,button.list-group-item-success:hover,button.list-group-item-success:focus {
    color: #7ed320;
    background-color: rgb(223.3297752809,244.197752809,200.252247191)
}

a.list-group-item-success.active,a.list-group-item-success.active:hover,a.list-group-item-success.active:focus,button.list-group-item-success.active,button.list-group-item-success.active:hover,button.list-group-item-success.active:focus {
    color: #fff;
    background-color: #7ed320;
    border-color: #7ed320
}

.list-group-item-info {
    color: rgb(46.9,92.4,145.6);
    background-color: rgb(236.2,242.7,250.3)
}

a.list-group-item-info,button.list-group-item-info {
    color: rgb(46.9,92.4,145.6)
}

a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading {
    color: inherit
}

a.list-group-item-info:hover,a.list-group-item-info:focus,button.list-group-item-info:hover,button.list-group-item-info:focus {
    color: rgb(46.9,92.4,145.6);
    background-color: rgb(215.8,229.3531914894,245.2)
}

a.list-group-item-info.active,a.list-group-item-info.active:hover,a.list-group-item-info.active:focus,button.list-group-item-info.active,button.list-group-item-info.active:hover,button.list-group-item-info.active:focus {
    color: #fff;
    background-color: rgb(46.9,92.4,145.6);
    border-color: rgb(46.9,92.4,145.6)
}

.list-group-item-warning {
    color: #f5a623;
    background-color: rgb(254.09,251.88,225.49)
}

a.list-group-item-warning,button.list-group-item-warning {
    color: #f5a623
}

a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading {
    color: inherit
}

a.list-group-item-warning:hover,a.list-group-item-warning:focus,button.list-group-item-warning:hover,button.list-group-item-warning:focus {
    color: #f5a623;
    background-color: hsl(55.3636363636,94.0170940171%,89.0352941176%)
}

a.list-group-item-warning.active,a.list-group-item-warning.active:hover,a.list-group-item-warning.active:focus,button.list-group-item-warning.active,button.list-group-item-warning.active:hover,button.list-group-item-warning.active:focus {
    color: #fff;
    background-color: #f5a623;
    border-color: #f5a623
}

.list-group-item-danger {
    color: #f52323;
    background-color: rgb(249.36,224.52,227.64)
}

a.list-group-item-danger,button.list-group-item-danger {
    color: #f52323
}

a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading {
    color: inherit
}

a.list-group-item-danger:hover,a.list-group-item-danger:focus,button.list-group-item-danger:hover,button.list-group-item-danger:focus {
    color: #f52323;
    background-color: rgb(245.3782724252,203.0017275748,208.3243853821)
}

a.list-group-item-danger.active,a.list-group-item-danger.active:hover,a.list-group-item-danger.active:focus,button.list-group-item-danger.active,button.list-group-item-danger.active:hover,button.list-group-item-danger.active:focus {
    color: #fff;
    background-color: #f52323;
    border-color: #f52323
}

.list-group-item-heading {
    margin-top: 0;
    margin-bottom: 5px
}

.list-group-item-text {
    margin-bottom: 0;
    line-height: 1.3
}

.panel {
    margin-bottom: 20px;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,0);
    border-radius: 4px;
    box-shadow: 0 1px 1px rgba(0,0,0,.05)
}

.panel-body {
    padding: 15px
}

.panel-body:before,.panel-body:after {
    content: " ";
    display: table
}

.panel-body:after {
    clear: both
}

.panel-heading {
    padding: 10px 15px;
    border-bottom: 1px solid rgba(0,0,0,0);
    border-top-right-radius: 3px;
    border-top-left-radius: 3px
}

.panel-heading>.dropdown .dropdown-toggle {
    color: inherit
}

.panel-title {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 16px;
    color: inherit
}

.panel-title>a,.panel-title>small,.panel-title>.small,.panel-title>small>a,.panel-title>.small>a {
    color: inherit
}

.panel-footer {
    padding: 10px 15px;
    background-color: #f5f5f5;
    border-top: 1px solid #ddd;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px
}

.panel>.list-group,.panel>.panel-collapse>.list-group {
    margin-bottom: 0
}

.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item {
    border-width: 1px 0;
    border-radius: 0
}

.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child {
    border-top: 0;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px
}

.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child {
    border-bottom: 0;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px
}

.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child {
    border-top-right-radius: 0;
    border-top-left-radius: 0
}

.panel-heading+.list-group .list-group-item:first-child {
    border-top-width: 0
}

.list-group+.panel-footer {
    border-top-width: 0
}

.panel>.table,.panel>.table-responsive>.table,.panel>.panel-collapse>.table {
    margin-bottom: 0
}

.panel>.table caption,.panel>.table-responsive>.table caption,.panel>.panel-collapse>.table caption {
    padding-left: 15px;
    padding-right: 15px
}

.panel>.table:first-child,.panel>.table-responsive:first-child>.table:first-child {
    border-top-right-radius: 3px;
    border-top-left-radius: 3px
}

.panel>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px
}

.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child {
    border-top-left-radius: 3px
}

.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child {
    border-top-right-radius: 3px
}

.panel>.table:last-child,.panel>.table-responsive:last-child>.table:last-child {
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px
}

.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px
}

.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child {
    border-bottom-left-radius: 3px
}

.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child {
    border-bottom-right-radius: 3px
}

.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body {
    border-top: 1px solid #eaeaea
}

.panel>.table>tbody:first-child>tr:first-child th,.panel>.table>tbody:first-child>tr:first-child td {
    border-top: 0
}

.panel>.table-bordered,.panel>.table-responsive>.table-bordered {
    border: 0
}

.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child {
    border-left: 0
}

.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child {
    border-right: 0
}

.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th {
    border-bottom: 0
}

.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th {
    border-bottom: 0
}

.panel>.table-responsive {
    border: 0;
    margin-bottom: 0
}

.panel-group {
    margin-bottom: 20px
}

.panel-group .panel {
    margin-bottom: 0;
    border-radius: 4px
}

.panel-group .panel+.panel {
    margin-top: 5px
}

.panel-group .panel-heading {
    border-bottom: 0
}

.panel-group .panel-heading+.panel-collapse>.panel-body,.panel-group .panel-heading+.panel-collapse>.list-group {
    border-top: 1px solid #ddd
}

.panel-group .panel-footer {
    border-top: 0
}

.panel-group .panel-footer+.panel-collapse .panel-body {
    border-bottom: 1px solid #ddd
}

.panel-default {
    border-color: #ddd
}

.panel-default>.panel-heading {
    color: #333;
    background-color: #f5f5f5;
    border-color: #ddd
}

.panel-default>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: #ddd
}

.panel-default>.panel-heading .badge {
    color: #f5f5f5;
    background-color: #333
}

.panel-default>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: #ddd
}

.panel-primary {
    border-color: #4384d0
}

.panel-primary>.panel-heading {
    color: #fff;
    background-color: #4384d0;
    border-color: #4384d0
}

.panel-primary>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: #4384d0
}

.panel-primary>.panel-heading .badge {
    color: #4384d0;
    background-color: #fff
}

.panel-primary>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: #4384d0
}

.panel-success {
    border-color: rgb(230.6540262172,244.197752809,200.252247191)
}

.panel-success>.panel-heading {
    color: #7ed320;
    background-color: rgb(235.65,248.4,221.55);
    border-color: rgb(230.6540262172,244.197752809,200.252247191)
}

.panel-success>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: rgb(230.6540262172,244.197752809,200.252247191)
}

.panel-success>.panel-heading .badge {
    color: rgb(235.65,248.4,221.55);
    background-color: #7ed320
}

.panel-success>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: rgb(230.6540262172,244.197752809,200.252247191)
}

.panel-info {
    border-color: rgb(207.64,229.9344680851,243.16)
}

.panel-info>.panel-heading {
    color: rgb(46.9,92.4,145.6);
    background-color: rgb(236.2,242.7,250.3);
    border-color: rgb(207.64,229.9344680851,243.16)
}

.panel-info>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: rgb(207.64,229.9344680851,243.16)
}

.panel-info>.panel-heading .badge {
    color: rgb(236.2,242.7,250.3);
    background-color: rgb(46.9,92.4,145.6)
}

.panel-info>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: rgb(207.64,229.9344680851,243.16)
}

.panel-warning {
    border-color: hsl(45.3636363636,94.0170940171%,89.0352941176%)
}

.panel-warning>.panel-heading {
    color: #f5a623;
    background-color: rgb(254.09,251.88,225.49);
    border-color: hsl(45.3636363636,94.0170940171%,89.0352941176%)
}

.panel-warning>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: hsl(45.3636363636,94.0170940171%,89.0352941176%)
}

.panel-warning>.panel-heading .badge {
    color: rgb(254.09,251.88,225.49);
    background-color: #f5a623
}

.panel-warning>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: hsl(45.3636363636,94.0170940171%,89.0352941176%)
}

.panel-danger {
    border-color: rgb(245.3782724252,203.0017275748,215.3871428571)
}

.panel-danger>.panel-heading {
    color: #f52323;
    background-color: rgb(249.36,224.52,227.64);
    border-color: rgb(245.3782724252,203.0017275748,215.3871428571)
}

.panel-danger>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: rgb(245.3782724252,203.0017275748,215.3871428571)
}

.panel-danger>.panel-heading .badge {
    color: rgb(249.36,224.52,227.64);
    background-color: #f52323
}

.panel-danger>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: rgb(245.3782724252,203.0017275748,215.3871428571)
}

.embed-responsive {
    position: relative;
    display: block;
    height: 0;
    padding: 0;
    overflow: hidden
}

.embed-responsive .embed-responsive-item,.embed-responsive iframe,.embed-responsive embed,.embed-responsive object,.embed-responsive video {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    border: 0
}

.embed-responsive-16by9 {
    padding-bottom: 56.25%
}

.embed-responsive-4by3 {
    padding-bottom: 75%
}

.well {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid hsl(0,0%,89.0784313725%);
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05)
}

.well blockquote {
    border-color: #ddd;
    border-color: rgba(0,0,0,.15)
}

.well-lg {
    padding: 24px;
    border-radius: 6px
}

.well-sm {
    padding: 9px;
    border-radius: 3px
}

.close {
    float: right;
    font-size: 21px;
    font-weight: normal;
    line-height: 1;
    color: #000;
    text-shadow: none;
    opacity: .2;
    filter: alpha(opacity=20)
}

.close:hover,.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
    opacity: .5;
    filter: alpha(opacity=50)
}

button.close {
    padding: 0;
    cursor: pointer;
    background: rgba(0,0,0,0);
    border: 0;
    -webkit-appearance: none
}

.modal-open {
    overflow: hidden
}

.modal {
    display: none;
    overflow: hidden;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    -webkit-overflow-scrolling: touch;
    outline: 0
}

.modal.fade .modal-dialog {
    transform: translate(0, -25%);
    transition: transform .3s ease-out
}

.modal.in .modal-dialog {
    transform: translate(0, 0)
}

.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto
}

.modal-dialog {
    position: relative;
    width: auto;
    margin: 10px
}

.modal-content {
    position: relative;
    background-color: #fff;
    border: 1px solid #999;
    border: 1px solid rgba(0,0,0,0);
    border-radius: 6px;
    box-shadow: 0 3px 9px rgba(0,0,0,.5);
    background-clip: padding-box;
    outline: 0
}

.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background-color: #000
}

.modal-backdrop.fade {
    opacity: 0;
    filter: alpha(opacity=0)
}

.modal-backdrop.in {
    opacity: .5;
    filter: alpha(opacity=50)
}

.modal-header {
    padding: 25px 25px 0;
    border-bottom: 1px solid rgba(0,0,0,0)
}

.modal-header:before,.modal-header:after {
    content: " ";
    display: table
}

.modal-header:after {
    clear: both
}

.modal-header .close {
    margin-top: -2px
}

.modal-title {
    margin: 0;
    line-height: 1.428571429
}

.modal-body {
    position: relative;
    padding: 25px
}

.modal-footer {
    padding: 25px;
    text-align: right;
    border-top: 1px solid rgba(0,0,0,0)
}

.modal-footer:before,.modal-footer:after {
    content: " ";
    display: table
}

.modal-footer:after {
    clear: both
}

.modal-footer .btn+.btn {
    margin-left: 5px;
    margin-bottom: 0
}

.modal-footer .btn-group .btn+.btn {
    margin-left: -1px
}

.modal-footer .btn-block+.btn-block {
    margin-left: 0
}

.modal-scrollbar-measure {
    position: absolute;
    top: -9999px;
    width: 50px;
    height: 50px;
    overflow: scroll
}

@media(min-width: 768px) {
    .modal-dialog {
        width:600px;
        margin: 30px auto
    }

    .modal-content {
        box-shadow: 0 5px 15px rgba(0,0,0,.5)
    }

    .modal-sm {
        width: 406px
    }
}

@media(min-width: 992px) {
    .modal-lg {
        width:900px
    }
}

.tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-style: normal;
    font-weight: normal;
    letter-spacing: normal;
    line-break: auto;
    line-height: 1.428571429;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    white-space: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    font-size: 12px;
    opacity: 0;
    filter: alpha(opacity=0)
}

.tooltip.in {
    opacity: .9;
    filter: alpha(opacity=90)
}

.tooltip.top {
    margin-top: -3px;
    padding: 5px 0
}

.tooltip.right {
    margin-left: 3px;
    padding: 0 5px
}

.tooltip.bottom {
    margin-top: 3px;
    padding: 5px 0
}

.tooltip.left {
    margin-left: -3px;
    padding: 0 5px
}

.tooltip-inner {
    max-width: 200px;
    padding: 3px 8px;
    color: #fff;
    text-align: center;
    background-color: #000;
    border-radius: 4px
}

.tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: rgba(0,0,0,0);
    border-style: solid
}

.tooltip.top .tooltip-arrow {
    bottom: 0;
    left: 50%;
    margin-left: -5px;
    border-width: 5px 5px 0;
    border-top-color: #000
}

.tooltip.top-left .tooltip-arrow {
    bottom: 0;
    right: 5px;
    margin-bottom: -5px;
    border-width: 5px 5px 0;
    border-top-color: #000
}

.tooltip.top-right .tooltip-arrow {
    bottom: 0;
    left: 5px;
    margin-bottom: -5px;
    border-width: 5px 5px 0;
    border-top-color: #000
}

.tooltip.right .tooltip-arrow {
    top: 50%;
    left: 0;
    margin-top: -5px;
    border-width: 5px 5px 5px 0;
    border-right-color: #000
}

.tooltip.left .tooltip-arrow {
    top: 50%;
    right: 0;
    margin-top: -5px;
    border-width: 5px 0 5px 5px;
    border-left-color: #000
}

.tooltip.bottom .tooltip-arrow {
    top: 0;
    left: 50%;
    margin-left: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: #000
}

.tooltip.bottom-left .tooltip-arrow {
    top: 0;
    right: 5px;
    margin-top: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: #000
}

.tooltip.bottom-right .tooltip-arrow {
    top: 0;
    left: 5px;
    margin-top: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: #000
}

.popover {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1060;
    display: none;
    max-width: 265px;
    padding: 1px;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-style: normal;
    font-weight: normal;
    letter-spacing: normal;
    line-break: auto;
    line-height: 1.428571429;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    white-space: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    font-size: 14px;
    background-color: #f3f3f3;
    background-clip: padding-box;
    border: 1px solid #f3f3f3;
    border: 1px solid #f3f3f3;
    border-radius: 6px;
    box-shadow: 0 5px 10px rgba(0,0,0,.2)
}

.popover.top {
    margin-top: -10px
}

.popover.right {
    margin-left: 10px
}

.popover.bottom {
    margin-top: 10px
}

.popover.left {
    margin-left: -10px
}

.popover-title {
    margin: 0;
    padding: 8px 14px;
    font-size: 14px;
    background-color: hsl(0,0%,92.2941176471%);
    border-bottom: 1px solid rgb(222.6,222.6,222.6);
    border-radius: 5px 5px 0 0
}

.popover-content {
    padding: 9px 14px
}

.popover>.arrow,.popover>.arrow:after {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: rgba(0,0,0,0);
    border-style: solid
}

.popover>.arrow {
    border-width: 11px
}

.popover>.arrow:after {
    border-width: 10px;
    content: ""
}

.popover.top>.arrow {
    left: 50%;
    margin-left: -11px;
    border-bottom-width: 0;
    border-top-color: silver;
    border-top-color: #f3f3f3;
    bottom: -11px
}

.popover.top>.arrow:after {
    content: " ";
    bottom: 1px;
    margin-left: -10px;
    border-bottom-width: 0;
    border-top-color: #f3f3f3
}

.popover.right>.arrow {
    top: 50%;
    left: -11px;
    margin-top: -11px;
    border-left-width: 0;
    border-right-color: silver;
    border-right-color: #f3f3f3
}

.popover.right>.arrow:after {
    content: " ";
    left: 1px;
    bottom: -10px;
    border-left-width: 0;
    border-right-color: #f3f3f3
}

.popover.bottom>.arrow {
    left: 50%;
    margin-left: -11px;
    border-top-width: 0;
    border-bottom-color: silver;
    border-bottom-color: #f3f3f3;
    top: -11px
}

.popover.bottom>.arrow:after {
    content: " ";
    top: 1px;
    margin-left: -10px;
    border-top-width: 0;
    border-bottom-color: #f3f3f3
}

.popover.left>.arrow {
    top: 50%;
    right: -11px;
    margin-top: -11px;
    border-right-width: 0;
    border-left-color: silver;
    border-left-color: #f3f3f3
}

.popover.left>.arrow:after {
    content: " ";
    right: 1px;
    border-right-width: 0;
    border-left-color: #f3f3f3;
    bottom: -10px
}

.carousel {
    position: relative
}

.carousel-inner {
    position: relative;
    overflow: hidden;
    width: 100%
}

.carousel-inner>.item {
    display: none;
    position: relative;
    transition: .6s ease-in-out left
}

.carousel-inner>.item>img,.carousel-inner>.item>a>img {
    display: block;
    max-width: 100%;
    height: auto;
    line-height: 1
}

@media all and (transform-3d),(-webkit-transform-3d) {
    .carousel-inner>.item {
        transition: transform .6s ease-in-out;
        backface-visibility: hidden;
        perspective: 1000px
    }

    .carousel-inner>.item.next,.carousel-inner>.item.active.right {
        transform: translate3d(100%, 0, 0);
        left: 0
    }

    .carousel-inner>.item.prev,.carousel-inner>.item.active.left {
        transform: translate3d(-100%, 0, 0);
        left: 0
    }

    .carousel-inner>.item.next.left,.carousel-inner>.item.prev.right,.carousel-inner>.item.active {
        transform: translate3d(0, 0, 0);
        left: 0
    }
}

.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev {
    display: block
}

.carousel-inner>.active {
    left: 0
}

.carousel-inner>.next,.carousel-inner>.prev {
    position: absolute;
    top: 0;
    width: 100%
}

.carousel-inner>.next {
    left: 100%
}

.carousel-inner>.prev {
    left: -100%
}

.carousel-inner>.next.left,.carousel-inner>.prev.right {
    left: 0
}

.carousel-inner>.active.left {
    left: -100%
}

.carousel-inner>.active.right {
    left: 100%
}

.carousel-control {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 15%;
    opacity: .5;
    filter: alpha(opacity=50);
    font-size: 20px;
    color: #fff;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0,0,0,.6);
    background-color: rgba(0,0,0,0)
}

.carousel-control.left {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#80000000", endColorstr="#00000000", GradientType=1)
}

.carousel-control.right {
    left: auto;
    right: 0;
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00000000", endColorstr="#80000000", GradientType=1)
}

.carousel-control:hover,.carousel-control:focus {
    outline: 0;
    color: #fff;
    text-decoration: none;
    opacity: .9;
    filter: alpha(opacity=90)
}

.carousel-control .icon-prev,.carousel-control .icon-next,.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right {
    position: absolute;
    top: 50%;
    margin-top: -10px;
    z-index: 5;
    display: inline-block
}

.carousel-control .icon-prev,.carousel-control .glyphicon-chevron-left {
    left: 50%;
    margin-left: -10px
}

.carousel-control .icon-next,.carousel-control .glyphicon-chevron-right {
    right: 50%;
    margin-right: -10px
}

.carousel-control .icon-prev,.carousel-control .icon-next {
    width: 20px;
    height: 20px;
    line-height: 1;
    font-family: serif
}

.carousel-control .icon-prev:before {
    content: "‹"
}

.carousel-control .icon-next:before {
    content: "›"
}

.carousel-indicators {
    position: absolute;
    bottom: 10px;
    left: 50%;
    z-index: 15;
    width: 60%;
    margin-left: -30%;
    padding-left: 0;
    list-style: none;
    text-align: center
}

.carousel-indicators li {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 1px;
    text-indent: -999px;
    border: 1px solid #fff;
    border-radius: 10px;
    cursor: pointer;
    background-color: #000 \\9 ;
    background-color: rgba(0,0,0,0)
}

.carousel-indicators .active {
    margin: 0;
    width: 12px;
    height: 12px;
    background-color: #fff
}

.carousel-caption {
    position: absolute;
    left: 15%;
    right: 15%;
    bottom: 20px;
    z-index: 10;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #fff;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0,0,0,.6)
}

.carousel-caption .btn {
    text-shadow: none
}

@media screen and (min-width: 768px) {
    .carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-prev,.carousel-control .icon-next {
        width:30px;
        height: 30px;
        margin-top: -10px;
        font-size: 30px
    }

    .carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev {
        margin-left: -10px
    }

    .carousel-control .glyphicon-chevron-right,.carousel-control .icon-next {
        margin-right: -10px
    }

    .carousel-caption {
        left: 20%;
        right: 20%;
        padding-bottom: 30px
    }

    .carousel-indicators {
        bottom: 20px
    }
}

.clearfix:before,.clearfix:after {
    content: " ";
    display: table
}

.clearfix:after {
    clear: both
}

.center-block {
    display: block;
    margin-left: auto;
    margin-right: auto
}

.pull-right {
    float: right !important
}

.pull-left {
    float: left !important
}

.hide {
    display: none !important
}

.show {
    display: block !important
}

.invisible {
    visibility: hidden
}

.text-hide {
    font: 0/0 a;
    color: rgba(0,0,0,0);
    text-shadow: none;
    background-color: rgba(0,0,0,0);
    border: 0
}

.hidden {
    display: none !important
}

.affix {
    position: fixed
}

.visible-xs {
    display: none !important
}

.visible-sm {
    display: none !important
}

.visible-md {
    display: none !important
}

.visible-lg {
    display: none !important
}

.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block {
    display: none !important
}

@media(max-width: 767px) {
    .visible-xs {
        display:block !important
    }

    table.visible-xs {
        display: table !important
    }

    tr.visible-xs {
        display: table-row !important
    }

    th.visible-xs,td.visible-xs {
        display: table-cell !important
    }
}

@media(max-width: 767px) {
    .visible-xs-block {
        display:block !important
    }
}

@media(max-width: 767px) {
    .visible-xs-inline {
        display:inline !important
    }
}

@media(max-width: 767px) {
    .visible-xs-inline-block {
        display:inline-block !important
    }
}

@media(min-width: 768px)and (max-width: 991px) {
    .visible-sm {
        display:block !important
    }

    table.visible-sm {
        display: table !important
    }

    tr.visible-sm {
        display: table-row !important
    }

    th.visible-sm,td.visible-sm {
        display: table-cell !important
    }
}

@media(min-width: 768px)and (max-width: 991px) {
    .visible-sm-block {
        display:block !important
    }
}

@media(min-width: 768px)and (max-width: 991px) {
    .visible-sm-inline {
        display:inline !important
    }
}

@media(min-width: 768px)and (max-width: 991px) {
    .visible-sm-inline-block {
        display:inline-block !important
    }
}

@media(min-width: 992px)and (max-width: 1199px) {
    .visible-md {
        display:block !important
    }

    table.visible-md {
        display: table !important
    }

    tr.visible-md {
        display: table-row !important
    }

    th.visible-md,td.visible-md {
        display: table-cell !important
    }
}

@media(min-width: 992px)and (max-width: 1199px) {
    .visible-md-block {
        display:block !important
    }
}

@media(min-width: 992px)and (max-width: 1199px) {
    .visible-md-inline {
        display:inline !important
    }
}

@media(min-width: 992px)and (max-width: 1199px) {
    .visible-md-inline-block {
        display:inline-block !important
    }
}

@media(min-width: 1200px) {
    .visible-lg {
        display:block !important
    }

    table.visible-lg {
        display: table !important
    }

    tr.visible-lg {
        display: table-row !important
    }

    th.visible-lg,td.visible-lg {
        display: table-cell !important
    }
}

@media(min-width: 1200px) {
    .visible-lg-block {
        display:block !important
    }
}

@media(min-width: 1200px) {
    .visible-lg-inline {
        display:inline !important
    }
}

@media(min-width: 1200px) {
    .visible-lg-inline-block {
        display:inline-block !important
    }
}

@media(max-width: 767px) {
    .hidden-xs {
        display:none !important
    }
}

@media(min-width: 768px)and (max-width: 991px) {
    .hidden-sm {
        display:none !important
    }
}

@media(min-width: 992px)and (max-width: 1199px) {
    .hidden-md {
        display:none !important
    }
}

@media(min-width: 1200px) {
    .hidden-lg {
        display:none !important
    }
}

.visible-print {
    display: none !important
}

@media print {
    .visible-print {
        display: block !important
    }

    table.visible-print {
        display: table !important
    }

    tr.visible-print {
        display: table-row !important
    }

    th.visible-print,td.visible-print {
        display: table-cell !important
    }
}

.visible-print-block {
    display: none !important
}

@media print {
    .visible-print-block {
        display: block !important
    }
}

.visible-print-inline {
    display: none !important
}

@media print {
    .visible-print-inline {
        display: inline !important
    }
}

.visible-print-inline-block {
    display: none !important
}

@media print {
    .visible-print-inline-block {
        display: inline-block !important
    }
}

@media print {
    .hidden-print {
        display: none !important
    }
}

/*!
 * Bootstrap-select v1.13.2 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2018 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */
select.bs-select-hidden,.bootstrap-select>select.bs-select-hidden,select.selectpicker {
    display: none !important
}

.bootstrap-select {
    width: 220px \\0
}

.bootstrap-select>.dropdown-toggle {
    position: relative;
    width: 100%;
    z-index: 1;
    text-align: right;
    white-space: nowrap
}

.bootstrap-select>.dropdown-toggle.bs-placeholder,.bootstrap-select>.dropdown-toggle.bs-placeholder:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder:active {
    color: #999
}

.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-primary,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-secondary,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-success,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-danger,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-info,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-dark,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-primary:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-secondary:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-success:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-danger:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-info:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-dark:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-primary:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-secondary:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-success:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-danger:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-info:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-dark:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-primary:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-secondary:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-success:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-danger:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-info:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-dark:active {
    color: hsla(0,0%,100%,.5)
}

.bootstrap-select>select {
    position: absolute !important;
    bottom: 0;
    left: 50%;
    display: block !important;
    width: .5px !important;
    height: 100% !important;
    padding: 0 !important;
    opacity: 0 !important;
    border: none
}

.bootstrap-select>select.mobile-device {
    top: 0;
    left: 0;
    display: block !important;
    width: 100% !important;
    z-index: 2
}

.has-error .bootstrap-select .dropdown-toggle,.error .bootstrap-select .dropdown-toggle,.bootstrap-select.is-invalid .dropdown-toggle,.was-validated .bootstrap-select .selectpicker:invalid+.dropdown-toggle {
    border-color: #f52323
}

.bootstrap-select.is-valid .dropdown-toggle,.was-validated .bootstrap-select .selectpicker:valid+.dropdown-toggle {
    border-color: #28a745
}

.bootstrap-select.fit-width {
    width: auto !important
}

.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {
    width: 220px
}

.bootstrap-select .dropdown-toggle:focus {
    outline: thin dotted #333 !important;
    outline: 5px auto -webkit-focus-ring-color !important;
    outline-offset: -2px
}

.bootstrap-select.form-control {
    margin-bottom: 0;
    padding: 0;
    border: none
}

:not(.input-group)>.bootstrap-select.form-control:not([class*=col-]) {
    width: 100%
}

.bootstrap-select.form-control.input-group-btn {
    z-index: auto
}

.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child)>.btn {
    border-radius: 0
}

.bootstrap-select:not(.input-group-btn),.bootstrap-select[class*=col-] {
    float: none;
    display: inline-block;
    margin-left: 0
}

.bootstrap-select.dropdown-menu-right,.bootstrap-select[class*=col-].dropdown-menu-right,.row .bootstrap-select[class*=col-].dropdown-menu-right {
    float: right
}

.form-inline .bootstrap-select,.form-horizontal .bootstrap-select,.form-group .bootstrap-select {
    margin-bottom: 0
}

.form-group-lg .bootstrap-select.form-control,.form-group-sm .bootstrap-select.form-control {
    padding: 0
}

.form-group-lg .bootstrap-select.form-control .dropdown-toggle,.form-group-sm .bootstrap-select.form-control .dropdown-toggle {
    height: 100%;
    font-size: inherit;
    line-height: inherit;
    border-radius: inherit
}

.bootstrap-select.form-control-sm .dropdown-toggle,.bootstrap-select.form-control-lg .dropdown-toggle {
    font-size: inherit;
    line-height: inherit;
    border-radius: inherit
}

.bootstrap-select.form-control-sm .dropdown-toggle {
    padding: .25rem .5rem
}

.bootstrap-select.form-control-lg .dropdown-toggle {
    padding: .5rem 1rem
}

.form-inline .bootstrap-select .form-control {
    width: 100%
}

.bootstrap-select.disabled,.bootstrap-select>.disabled {
    cursor: not-allowed
}

.bootstrap-select.disabled:focus,.bootstrap-select>.disabled:focus {
    outline: none !important
}

.bootstrap-select.bs-container {
    position: absolute;
    top: 0;
    left: 0;
    height: 0 !important;
    padding: 0 !important
}

.bootstrap-select.bs-container .dropdown-menu {
    z-index: 1060
}

.bootstrap-select .dropdown-toggle:before {
    content: "";
    display: inline-block
}

.bootstrap-select .dropdown-toggle .filter-option {
    position: absolute;
    top: 0;
    left: 0;
    padding-top: inherit;
    padding-right: inherit;
    padding-bottom: inherit;
    padding-left: inherit;
    height: 100%;
    width: 100%;
    text-align: left
}

.bootstrap-select .dropdown-toggle .filter-option-inner {
    padding-right: inherit
}

.bootstrap-select .dropdown-toggle .filter-option-inner-inner {
    overflow: hidden
}

.bootstrap-select .dropdown-toggle .caret {
    position: absolute;
    top: 50%;
    right: 12px;
    margin-top: -2px;
    vertical-align: middle
}

.input-group .bootstrap-select.form-control .dropdown-toggle {
    border-radius: inherit
}

.bootstrap-select[class*=col-] .dropdown-toggle {
    width: 100%
}

.bootstrap-select .dropdown-menu {
    min-width: 100%;
    box-sizing: border-box
}

.bootstrap-select .dropdown-menu>.inner:focus {
    outline: none !important
}

.bootstrap-select .dropdown-menu.inner {
    position: static;
    float: none;
    border: 0;
    padding: 0;
    margin: 0;
    border-radius: 0;
    box-shadow: none
}

.bootstrap-select .dropdown-menu li {
    position: relative
}

.bootstrap-select .dropdown-menu li.active small {
    color: hsla(0,0%,100%,.5) !important
}

.bootstrap-select .dropdown-menu li.disabled a {
    cursor: not-allowed
}

.bootstrap-select .dropdown-menu li a {
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none
}

.bootstrap-select .dropdown-menu li a.opt {
    position: relative;
    padding-left: 2.25em
}

.bootstrap-select .dropdown-menu li a span.check-mark {
    display: none
}

.bootstrap-select .dropdown-menu li a span.text {
    display: inline-block
}

.bootstrap-select .dropdown-menu li small {
    padding-left: .5em
}

.bootstrap-select .dropdown-menu .notify {
    position: absolute;
    bottom: 5px;
    width: 96%;
    margin: 0 2%;
    min-height: 26px;
    padding: 3px 5px;
    background: #f5f5f5;
    border: 1px solid #e3e3e3;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
    pointer-events: none;
    opacity: .9;
    box-sizing: border-box
}

.bootstrap-select .no-results {
    padding: 3px;
    background: #f5f5f5;
    margin: 0 5px;
    white-space: nowrap
}

.bootstrap-select.fit-width .dropdown-toggle .filter-option {
    position: static;
    display: inline;
    padding: 0
}

.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner,.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner-inner {
    display: inline
}

.bootstrap-select.fit-width .dropdown-toggle .caret {
    position: static;
    top: auto;
    margin-top: -1px
}

.bootstrap-select.show-tick .dropdown-menu .selected span.check-mark {
    position: absolute;
    display: inline-block;
    right: 15px;
    top: 5px
}

.bootstrap-select.show-tick .dropdown-menu li a span.text {
    margin-right: 34px
}

.bootstrap-select .bs-ok-default:after {
    content: "";
    display: block;
    width: .5em;
    height: 1em;
    border-style: solid;
    border-width: 0 .26em .26em 0;
    transform: rotate(45deg)
}

.bootstrap-select.show-menu-arrow.open>.dropdown-toggle,.bootstrap-select.show-menu-arrow.show>.dropdown-toggle {
    z-index: 1061
}

.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:before {
    content: "";
    border-left: 7px solid rgba(0,0,0,0);
    border-right: 7px solid rgba(0,0,0,0);
    border-bottom: 7px solid hsla(0,0%,80%,.2);
    position: absolute;
    bottom: -4px;
    left: 9px;
    display: none
}

.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:after {
    content: "";
    border-left: 6px solid rgba(0,0,0,0);
    border-right: 6px solid rgba(0,0,0,0);
    border-bottom: 6px solid #fff;
    position: absolute;
    bottom: -4px;
    left: 10px;
    display: none
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:before {
    bottom: auto;
    top: -4px;
    border-top: 7px solid hsla(0,0%,80%,.2);
    border-bottom: 0
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:after {
    bottom: auto;
    top: -4px;
    border-top: 6px solid #fff;
    border-bottom: 0
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:before {
    right: 12px;
    left: auto
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:after {
    right: 13px;
    left: auto
}

.bootstrap-select.show-menu-arrow.open>.dropdown-toggle .filter-option:before,.bootstrap-select.show-menu-arrow.show>.dropdown-toggle .filter-option:before,.bootstrap-select.show-menu-arrow.open>.dropdown-toggle .filter-option:after,.bootstrap-select.show-menu-arrow.show>.dropdown-toggle .filter-option:after {
    display: block
}

.bs-searchbox,.bs-actionsbox,.bs-donebutton {
    padding: 4px 8px
}

.bs-actionsbox {
    width: 100%;
    box-sizing: border-box
}

.bs-actionsbox .btn-group button {
    width: 50%
}

.bs-donebutton {
    float: left;
    width: 100%;
    box-sizing: border-box
}

.bs-donebutton .btn-group button {
    width: 100%
}

.bs-searchbox+.bs-actionsbox {
    padding: 0 8px 4px
}

.bs-searchbox .form-control {
    margin-bottom: 0;
    width: 100%;
    float: none
}

.m-0 {
    margin: 0 !important
}

.mt-0,.my-0 {
    margin-top: 0 !important
}

.mr-0,.mx-0 {
    margin-right: 0 !important
}

.mb-0,.my-0 {
    margin-bottom: 0 !important
}

.ml-0,.mx-0 {
    margin-left: 0 !important
}

.m-1 {
    margin: .25rem !important
}

.mt-1,.my-1 {
    margin-top: .25rem !important
}

.mr-1,.mx-1 {
    margin-right: .25rem !important
}

.mb-1,.my-1 {
    margin-bottom: .25rem !important
}

.ml-1,.mx-1 {
    margin-left: .25rem !important
}

.m-2 {
    margin: .5rem !important
}

.mt-2,.my-2 {
    margin-top: .5rem !important
}

.mr-2,.mx-2 {
    margin-right: .5rem !important
}

.mb-2,.my-2 {
    margin-bottom: .5rem !important
}

.ml-2,.mx-2 {
    margin-left: .5rem !important
}

.m-3 {
    margin: 1rem !important
}

.mt-3,.my-3 {
    margin-top: 1rem !important
}

.mr-3,.mx-3 {
    margin-right: 1rem !important
}

.mb-3,.my-3 {
    margin-bottom: 1rem !important
}

.ml-3,.mx-3 {
    margin-left: 1rem !important
}

.m-4 {
    margin: 1.5rem !important
}

.mt-4,.my-4 {
    margin-top: 1.5rem !important
}

.mr-4,.mx-4 {
    margin-right: 1.5rem !important
}

.mb-4,.my-4 {
    margin-bottom: 1.5rem !important
}

.ml-4,.mx-4 {
    margin-left: 1.5rem !important
}

.m-5 {
    margin: 3rem !important
}

.mt-5,.my-5 {
    margin-top: 3rem !important
}

.mr-5,.mx-5 {
    margin-right: 3rem !important
}

.mb-5,.my-5 {
    margin-bottom: 3rem !important
}

.ml-5,.mx-5 {
    margin-left: 3rem !important
}

.p-0 {
    padding: 0 !important
}

.pt-0,.py-0 {
    padding-top: 0 !important
}

.pr-0,.px-0 {
    padding-right: 0 !important
}

.pb-0,.py-0 {
    padding-bottom: 0 !important
}

.pl-0,.px-0 {
    padding-left: 0 !important
}

.p-1 {
    padding: .25rem !important
}

.pt-1,.py-1 {
    padding-top: .25rem !important
}

.pr-1,.px-1 {
    padding-right: .25rem !important
}

.pb-1,.py-1 {
    padding-bottom: .25rem !important
}

.pl-1,.px-1 {
    padding-left: .25rem !important
}

.p-2 {
    padding: .5rem !important
}

.pt-2,.py-2 {
    padding-top: .5rem !important
}

.pr-2,.px-2 {
    padding-right: .5rem !important
}

.pb-2,.py-2 {
    padding-bottom: .5rem !important
}

.pl-2,.px-2 {
    padding-left: .5rem !important
}

.p-3 {
    padding: 1rem !important
}

.pt-3,.py-3 {
    padding-top: 1rem !important
}

.pr-3,.px-3 {
    padding-right: 1rem !important
}

.pb-3,.py-3 {
    padding-bottom: 1rem !important
}

.pl-3,.px-3 {
    padding-left: 1rem !important
}

.p-4 {
    padding: 1.5rem !important
}

.pt-4,.py-4 {
    padding-top: 1.5rem !important
}

.pr-4,.px-4 {
    padding-right: 1.5rem !important
}

.pb-4,.py-4 {
    padding-bottom: 1.5rem !important
}

.pl-4,.px-4 {
    padding-left: 1.5rem !important
}

.p-5 {
    padding: 3rem !important
}

.pt-5,.py-5 {
    padding-top: 3rem !important
}

.pr-5,.px-5 {
    padding-right: 3rem !important
}

.pb-5,.py-5 {
    padding-bottom: 3rem !important
}

.pl-5,.px-5 {
    padding-left: 3rem !important
}

.m-auto {
    margin: auto !important
}

.mt-auto,.my-auto {
    margin-top: auto !important
}

.mr-auto,.mx-auto {
    margin-right: auto !important
}

.mb-auto,.my-auto {
    margin-bottom: auto !important
}

.ml-auto,.mx-auto {
    margin-left: auto !important
}

.counter-list {
    margin-right: -6px;
    margin-bottom: 17px
}

.counter-list .counter-item {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    overflow: hidden;
    text-decoration: none;
    background: #f5f5f5;
    border-radius: 20px;
    padding: 12px 22px;
    margin-right: 6px;
    margin-bottom: 7px
}

.counter-list .counter-item.active {
    background: #222;
    color: #fff
}

.counter-list .counter-item:hover,.counter-list .counter-item:active,.counter-list .counter-item:focus {
    text-decoration: none;
    outline: none
}

.counter-list .counter-param,.counter-list .counter-value {
    display: inline-block;
    margin-left: 2px;
    margin-right: 2px
}

.counter-list .counter-param {
    font-weight: bold
}

.counter-list .counter-value {
    font-size: 11px
}

@media(max-width: 991px) {
    .counter-list .counter-item {
        width:auto !important;
        height: auto !important
    }
}

@media(min-width: 992px) {
    .counter-list.counter-list-pills {
        margin-top:10px
    }

    .counter-list.counter-list-pills .counter-item {
        margin-bottom: 10px;
        width: auto !important;
        height: auto !important
    }

    .counter-list.counter-list-circles {
        margin-bottom: 2px
    }

    .counter-list.counter-list-circles .counter-item {
        border-radius: 50%;
        margin-bottom: 10px;
        width: 100px;
        height: 100px
    }

    .counter-list.counter-list-circles .counter-item .inside {
        position: absolute;
        top: 50%;
        left: 10px;
        right: 10px;
        margin-top: 4px;
        text-align: center;
        transform: translate(0, -50%)
    }

    .counter-list.counter-list-circles .counter-param,.counter-list.counter-list-circles .counter-value {
        margin-left: 0;
        margin-right: 0
    }

    .counter-list.counter-list-circles .counter-param {
        display: flex;
        justify-content: center
    }

    .counter-list.counter-list-circles .counter-value {
        display: block;
        margin-top: 4px
    }

    .counter-list.counter-list-circles.counter-list-wide {
        margin-right: -26px
    }

    .counter-list.counter-list-circles.counter-list-wide .counter-item {
        margin-right: 26px
    }
}

.nav-similar-games {
    padding-left: 0;
    list-style: none;
    margin: 0 0 15px;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 10px 20px
}

.nav-similar-games__item {
    flex: 0 0 auto;
    text-align: center
}

.nav-similar-games__circle {
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #f9f9f9;
    background-size: 100%;
    background-repeat: no-repeat;
    vertical-align: middle
}

.nav-similar-games__link {
    display: inline-block;
    font-weight: bold;
    vertical-align: middle;
    margin-left: .4em
}

.nav-similar-games__item-active .nav-similar-games__link,.nav-similar-games__item-active .nav-similar-games__link:hover,.nav-similar-games__item-active .nav-similar-games__link:focus,.nav-similar-games__item-active .nav-similar-games__link:active {
    color: #222;
    text-decoration: none;
    outline: none
}

@media(max-width: 767px) {
    .nav-similar-games {
        margin-left:-10px;
        margin-right: -10px;
        padding-left: 10px;
        padding-right: 10px;
        flex-wrap: nowrap;
        gap: 0;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;
        scrollbar-width: none
    }

    .nav-similar-games::-webkit-scrollbar {
        display: none
    }

    .nav-similar-games__item {
        width: 80px
    }
}

@media(max-width: 767px)and (min-width: 385px) {
    .nav-similar-games__item {
        width:85px
    }
}

@media(max-width: 767px)and (min-width: 410px) {
    .nav-similar-games__item {
        width:90px
    }
}

@media(max-width: 767px) {
    .nav-similar-games__circle {
        display:block;
        margin: auto
    }

    .nav-similar-games__link {
        display: flex;
        justify-content: center;
        margin: .3em auto auto;
        white-space: normal
    }
}

.megaswitch-items {
    padding-left: 0;
    list-style: none;
    margin-bottom: 0
}

.megaswitch-disabled .megaswitch-items {
    cursor: not-allowed;
    opacity: .65;
    filter: alpha(opacity=65)
}

.megaswitch-head-title {
    font-weight: bold;
    margin-bottom: 10px
}

.megaswitch-radio {
    display: flex;
    align-items: center;
    cursor: pointer
}

.megaswitch-locked .megaswitch-radio {
    cursor: default
}

.megaswitch-disabled .megaswitch-radio {
    cursor: not-allowed
}

.megaswitch-radio+.megaswitch-radio {
    margin-top: 10px
}

.megaswitch-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #b1b1b1;
    border-radius: 50%;
    margin-right: 10px;
    color: #fff;
    font-size: 9px;
    overflow: hidden
}

.megaswitch-icon i {
    display: none
}

.megaswitch-locked .megaswitch-icon {
    border-color: rgba(0,0,0,0)
}

.megaswitch-radio.active .megaswitch-icon {
    border: 5px solid #4384d0
}

.megaswitch-locked .megaswitch-radio.active .megaswitch-icon {
    background-color: #4384d0;
    border: 0
}

.megaswitch-locked .megaswitch-radio.active .megaswitch-icon i {
    display: inline-block
}

.megaswitch-content {
    display: flex;
    flex-direction: column
}

.megaswitch-title {
    font-weight: bold
}

.video-box-fake {
    aspect-ratio: 16/9;
    width: 100%;
    height: auto;
    position: relative
}

.video-box-fake .video-box-fake__play-button svg path:nth-child(1) {
    fill: #212121
}

.video-box-fake:hover .video-box-fake__play-button svg path:nth-child(1) {
    fill: red
}

.video-box-fake__link {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat
}

.video-box-fake__play-button {
    width: 68px;
    height: 48px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none
}

.video-box-fake__play-button svg {
    display: block
}

.attachments-list {
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 10px
}

.attachments-item {
    width: 96px;
    height: 96px;
    border-radius: 4px;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    float: left
}

.attachments-item .attachments-thumb {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    cursor: pointer
}

.attachments-item img {
    object-fit: cover
}

.attachments-item a.attachments-thumb {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat
}

.attachments-new {
    cursor: pointer;
    font-size: 30px;
    color: #4384d0;
    background-color: #fff;
    border: 1px solid #e4e4e4
}

.attachments-upload-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 40px;
    height: 40px;
    margin-left: -20px;
    margin-top: -20px;
    background-color: rgba(0,0,0,.5);
    border-radius: 50%;
    color: #fff;
    border: 3px solid rgba(0,0,0,0);
    z-index: 2
}

.attachments-upload-spinner::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border: 2px solid #fff;
    border-top-color: rgba(0,0,0,0);
    border-radius: 50%;
    animation: attachments-upload-spinner-animation 2s linear infinite
}

@keyframes attachments-upload-spinner-animation {
    0% {
        transform: rotate(0deg)
    }

    100% {
        transform: rotate(360deg)
    }
}

.attachments-upload-cancel {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
    cursor: pointer
}

.attachments-upload-cancel::before,.attachments-upload-cancel::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 16px;
    height: 2px;
    background-color: #fff
}

.attachments-upload-cancel::before {
    transform: translate(-50%, -50%) rotate(45deg)
}

.attachments-upload-cancel::after {
    transform: translate(-50%, -50%) rotate(-45deg)
}

.attachments-controls {
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-wrap: nowrap;
    background-color: rgba(0,0,0,.5);
    color: #fff;
    position: absolute;
    right: 5px;
    top: 5px;
    padding: 0;
    border-radius: 3px;
    font-size: 13px;
    z-index: 2
}

.attachments-control {
    padding: 4px 10px;
    cursor: pointer
}

.ui-sortable-handle {
    touch-action: none
}




::selection {
    background-color: #bfddff;
    color: #222;
    text-shadow: none
}

-webkit-::selection {
    background-color: #bfddff;
    color: #222;
    text-shadow: none
}

::-moz-selection {
    background-color: #bfddff;
    color: #222;
    text-shadow: none
}

img {
    display: inline-block;
    max-width: 100%
}

html>body .mt0 {
    margin-top: 0
}

html>body .mt10 {
    margin-top: 10px
}

html>body .mt20 {
    margin-top: 20px
}

html>body .mt35 {
    margin-top: 35px
}

html>body .mb0 {
    margin-bottom: 0
}

html>body .mb5 {
    margin-bottom: 5px
}

html>body .mb10 {
    margin-bottom: 10px
}

html>body .mb20 {
    margin-bottom: 20px
}

html>body .mb25 {
    margin-bottom: 25px
}

html>body .mb35 {
    margin-bottom: 35px
}

html>body .mb40 {
    margin-bottom: 40px
}

html>body .mb50 {
    margin-bottom: 50px
}

html>body .mr4 {
    margin-right: 4px
}

html>body .mr10 {
    margin-right: 10px
}

html>body .mr20 {
    margin-right: 20px
}

html>body .mr25 {
    margin-right: 25px
}

html>body .pb0 {
    padding-bottom: 0
}

.wfull {
    width: 100%
}

.w-200px {
    width: 200px
}

.w-50 {
    width: 50% !important
}

.font-custom {
    font-family: "Graphik Bold","Helvetica Neue",Helvetica,Arial,sans-serif
}

.text-mini {
    font-size: 11px
}

.text-lg {
    font-size: 17px
}

.text-xl {
    font-size: 21px
}

.text-light {
    color: #888
}

.bg-light-style .text-light {
    color: #555
}

.text-info-muted {
    color: rgb(130.14,157.44,189.36)
}

a.text-info-muted:hover,a.text-info-muted:focus {
    color: rgb(96.7129133858,131.3215748031,171.7870866142)
}

.page-header {
    padding-bottom: 30px
}

.page-content-full .page-header,.with-corner-cd .page-header {
    margin-top: 0
}

.page-header.page-header-no-hr {
    padding-bottom: 0;
    border-bottom: 0
}

.page-header.page-header-params {
    margin-bottom: 30px
}

.page-header h1 {
    padding: 0;
    margin: 0
}

html>body .text-normal {
    font-weight: normal
}

.text-medium {
    font-weight: 500
}

.text-bold {
    font-weight: bold
}

a.text-muted:hover,a.text-muted:focus {
    color: #a6a6a6
}

th.table-col-narrow,td.table-col-narrow {
    width: 1%
}

.block-info {
    color: #777;
    letter-spacing: 1px
}

.bg-light-color {
    background: #f9f9f9
}

h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,.h1:first-child,.h2:first-child,.h3:first-child,.h4:first-child,.h5:first-child,.h6:first-child {
    margin-top: 0
}

h1,.h1 {
    margin-top: 15px;
    line-height: 1;
    font-family: "Graphik Bold","Helvetica Neue",Helvetica,Arial,sans-serif
}

h2,.h2 {
    font-family: "Graphik Bold","Helvetica Neue",Helvetica,Arial,sans-serif
}

h3,h4,.h3,.h4 {
    font-weight: bold
}

dl {
    margin-bottom: 30px
}

h5,.h5,.form-group>label {
    font-size: 9px;
    line-height: 14px;
    vertical-align: top;
    margin-bottom: 7px;
    text-transform: uppercase;
    font-weight: normal;
    letter-spacing: 1.3px;
    color: #666
}

label+.radio {
    margin-top: 0
}

.first-radio-no-margin .radio:first-child {
    margin-top: 0
}

.first-checkbox-no-margin .checkbox:first-child {
    margin-top: 0
}

.has-feedback label~.form-control-feedback {
    top: 21px
}

.row-20 {
    margin-left: -10px;
    margin-right: -10px
}

.row-20>[class^=col-],.row-20>[class*=" col-"] {
    padding-left: 10px;
    padding-right: 10px
}

.inline-block {
    display: inline-block
}

.inline-block-vat {
    display: inline-block;
    vertical-align: top
}

.form-control-inline {
    display: inline-block;
    width: auto;
    vertical-align: middle
}

input[type=range].range-premium {
    appearance: auto
}

.flex {
    display: flex;
    flex-wrap: wrap
}

.flex:before,.flex:after {
    display: none
}

.flex [class^=col-],.flex [class*=" col-"] {
    float: none
}

@media(min-width: 768px) {
    .flex-nowrap {
        display:flex;
        flex-wrap: nowrap
    }

    .flex-nowrap:before,.flex-nowrap:after {
        display: none
    }

    .flex-nowrap>div {
        width: 100%
    }
}

.row-inline [class^=col-],.row-inline [class*=" col-"] {
    float: none;
    display: inline-block;
    vertical-align: top;
    margin-right: -4px
}

.vertical-middle,.row-middle>[class^=col-],.row-middle>[class*=" col-"] {
    vertical-align: middle
}

@media(max-width: 767px) {
    .container {
        padding-left:10px;
        padding-right: 10px
    }

    .row {
        margin-left: -10px;
        margin-right: -10px
    }

    .row [class^=col-],.row [class*=" col-"] {
        padding-left: 10px;
        padding-right: 10px
    }

    .row-inline .col-xs-12 {
        display: block;
        width: 100%;
        margin-right: 0
    }
}

.row-10 {
    margin-left: -5px;
    margin-right: -5px
}

.row-10>[class^=col-],.row-10>[class*=" col-"] {
    padding-left: 5px;
    padding-right: 5px
}

.visible-xxs {
    display: none !important
}

@media(max-width: 480px) {
    .hidden-xxs {
        display:none !important
    }

    .visible-xxs {
        display: block !important
    }
}

ul.form-messages {
    padding-left: 0;
    list-style: none;
    margin-bottom: 17px
}

ul.form-messages li {
    margin-top: 5px
}

ul.form-messages li:first-child {
    margin-top: 0
}

input:not([type=radio]),button {
    box-shadow: none;
    -webkit-appearance: none
}

.has-success .form-control,.has-success .form-control:focus,.has-warning .form-control,.has-warning .form-control:focus,.has-error .form-control,.has-error .form-control:focus {
    box-shadow: none
}

textarea {
    max-width: 100%;
    min-width: 100%
}

.with-corner-cd .navbar-form .form-control {
    color: #919191
}

.form-control {
    font-weight: bold
}

textarea.form-control {
    font-weight: normal
}

.form-control,.form-control:focus {
    box-shadow: none
}

.form-control::-moz-placeholder {
    font-weight: normal
}

.form-control:-ms-input-placeholder {
    font-weight: normal
}

.form-control::-webkit-input-placeholder {
    font-weight: normal
}

.has-feedback .form-control {
    padding-right: 35px
}

.help-block {
    color: #b2b2b2
}

.help-form {
    margin-top: 12px;
    margin-bottom: 0;
    color: #888
}

.help-form>p {
    margin-bottom: 0
}

.help-form>p+p {
    margin-top: 10px
}

.help-form.overpayment-callout {
    margin-bottom: 12px;
    color: #222
}

.checkbox input[type=checkbox] {
    display: none
}

.checkbox label,.form-inline .checkbox label {
    padding-left: 24px
}

.checkbox input[type=checkbox]+i {
    display: block;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 0;
    margin-left: -24px;
    margin-top: 1px;
    border: rgb(202.5,202.5,202.5) 1px solid;
    background: #fff;
    border-radius: 4px;
    cursor: pointer
}

.checkbox label:hover input[type=checkbox]+i {
    border-color: #4384d0
}

.checkbox input[type=checkbox]+i:after {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    background: #fff;
    transform: translate(5px, 10px) rotate(-45deg);
    transform-origin: left
}

.checkbox input[type=checkbox]+i:before {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    background: #fff;
    transform: translate(2px, 6px) rotate(45deg);
    transform-origin: left
}

.checkbox input[type=checkbox]:checked+i {
    border-color: #4384d0;
    background-color: #4384d0
}

.checkbox input[type=checkbox]:checked+i:before {
    width: 5px
}

.checkbox input[type=checkbox]:checked+i:after {
    width: 11px
}

.checkbox input[type=checkbox]:disabled+i {
    opacity: .5;
    cursor: not-allowed
}

.checkbox-switch label,.form-inline .checkbox-switch label {
    padding-left: 35px
}

.checkbox-switch input[type=checkbox]+i {
    width: 27px;
    height: 13px;
    border-radius: 10px;
    background: #ccc;
    border: #ccc 1px solid;
    margin-left: -35px
}

.checkbox-switch label:hover input[type=checkbox]+i,label:hover .checkbox-switch input[type=checkbox]+i {
    background: #b3b3b3;
    border-color: #b3b3b3
}

.checkbox-switch input[type=checkbox]+i:before {
    width: 11px;
    height: 11px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    left: 0;
    top: 0;
    transform: none
}

.checkbox-switch input[type=checkbox]+i:after {
    display: none
}

.checkbox-switch input[type=checkbox]:checked+i {
    background: #4384d0;
    border-color: #4384d0
}

.checkbox-switch input[type=checkbox]:checked+i:before {
    width: 11px;
    left: 14px
}

.checkbox-switch label:hover input[type=checkbox]:checked+i,label:hover .checkbox-switch input[type=checkbox]:checked+i {
    background: rgb(39.7,94.6042553191,158.8);
    border-color: rgb(39.7,94.6042553191,158.8)
}

.form-control-feedback {
    font-family: "Graphik Bold","Helvetica Neue",Helvetica,Arial,sans-serif;
    width: auto;
    right: 14px
}

.form-control-box {
    background: #fff;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    padding: 8px 12px;
    margin-bottom: 0;
    height: 38px;
    position: relative;
    font-weight: bold
}

div.form-group>label.form-control-box {
    display: block;
    opacity: 1;
    margin: 0;
    text-transform: none;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    letter-spacing: 0
}

.form-inline .form-control-box {
    vertical-align: middle
}

.form-control-box.switch {
    padding-right: 53px
}

.form-control-box .checkbox-switch {
    margin: 1px -8px -3px 10px
}

.form-control-box .checkbox-switch.pull-right {
    display: inline-block;
    vertical-align: top;
    margin: 0;
    line-height: 1
}

.form-control-box .checkbox-switch.pull-right {
    position: absolute;
    right: 14px;
    top: 50%;
    margin-top: -8px
}

.form-control-box .checkbox-switch input[type=checkbox]+i {
    margin-left: 0;
    display: inline-block;
    position: relative
}

.form-inline-long {
    margin-right: -3px
}

.form-inline-long .form-group {
    margin-bottom: 5px;
    margin-right: 3px
}

select.selectpicker {
    display: block !important;
    visibility: hidden
}

.bootstrap-select select.selectpicker {
    display: none !important
}

.bootstrap-select>.dropdown-toggle.bs-placeholder,.bootstrap-select>.dropdown-toggle.bs-placeholder:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder:active {
    color: #222
}

.bootstrap-select.input-lg .btn,.input-group-lg>.bootstrap-select.form-control .btn,.input-group-lg>.bootstrap-select.input-group-addon .btn,.input-group-lg>.input-group-btn>.bootstrap-select.btn .btn,.bootstrap-select.input-lg .dropdown-menu>li>a,.input-group-lg>.bootstrap-select.form-control .dropdown-menu>li>a,.input-group-lg>.bootstrap-select.input-group-addon .dropdown-menu>li>a,.input-group-lg>.input-group-btn>.bootstrap-select.btn .dropdown-menu>li>a {
    padding: 10px 16px;
    line-height: 23px
}

.bootstrap-select.input-lg .dropdown-toggle .caret,.input-group-lg>.bootstrap-select.form-control .dropdown-toggle .caret,.input-group-lg>.bootstrap-select.input-group-addon .dropdown-toggle .caret,.input-group-lg>.input-group-btn>.bootstrap-select.btn .dropdown-toggle .caret {
    right: 16px
}

.bootstrap-select .dropdown-menu li a span.text {
    display: block;
    white-space: normal
}

.bootstrap-select .dropdown-menu>li>a {
    color: #222
}

.bootstrap-select .dropdown-menu>.active>a,.bootstrap-select .dropdown-menu>.active>a:hover,.bootstrap-select .dropdown-menu>.active>a:focus {
    background: #f5f5f5;
    color: #222
}

@media(max-width: 767px) {
    .form-inline .form-group {
        margin-right:0 !important
    }

    .form-inline-long {
        margin-right: 0
    }
}

.badge {
    padding: 3px;
    min-width: 18px;
    font-size: 11px
}

.badge-success {
    background: #7ed320
}

.badge-warning {
    background: #f5a623
}

.badge-danger {
    background: #d0011b
}

.badge-primary {
    background: #4384d0
}

.alert {
    position: relative;
    margin: 0
}

.alert-with-icon .alert-icon {
    display: block;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 10px
}

.alert button.close {
    font-size: 22px;
    position: absolute;
    top: 5px;
    right: 5px;
    width: 25px;
    height: 25px;
    outline: none
}

.alert-container {
    margin-bottom: 20px;
    width: 100%;
    position: relative
}

.alert-container .content-with-cd {
    margin-right: 0
}

#content-body>.container>.alert-container {
    margin-top: 20px;
    margin-bottom: -20px
}

.product-page .alert-container {
    margin-top: 20px;
    margin-bottom: -10px
}

.profile-header .alert-container {
    margin-top: 20px
}

.alert-container.default-alert {
    margin-top: -20px
}

.alert-container.with-small-circle,.alert-container.with-chat {
    margin-top: 13px;
    margin-bottom: -10px
}

.alert-container.with-small-circle+.alert-container.with-small-circle {
    margin-top: 23px
}

.alert-container.dark .alert-info {
    background-color: hsl(0,0%,93.0784313725%);
    border-color: hsl(0,0%,93.0784313725%);
    color: #222
}

.alert-container.dark .alert-info hr {
    border-top-color: rgb(224.6,224.6,224.6)
}

.alert-container.dark .alert-info .alert-link {
    color: rgb(8.5,8.5,8.5)
}

@media(max-width: 767px) {
    #content-body>.container>.alert-container {
        margin-bottom:-17px
    }

    .alert-container.default-alert {
        margin-top: -17px
    }

    .alert-container.with-small-circle {
        margin-top: 40px
    }
}

.alert-container:empty {
    display: none
}

@media(min-width: 768px) {
    .alert-with-icon {
        padding-left:48px;
        position: relative
    }

    .alert-with-icon .alert-icon {
        position: absolute;
        left: 20px;
        top: 20px;
        margin-bottom: 0
    }
}

.alert-info .alert-icon {
    color: #4384d0
}

.alert-info .alert-icon.text-success,.alert-success .alert-icon {
    color: #7ed320
}

.alert-warning .alert-icon {
    color: #f8e71c
}

.alert-danger .alert-icon {
    color: #d0011b
}

#header {
    position: relative;
    z-index: 911
}

@media(max-width: 991px) {
    .hide-navbar {
        display:none;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 998
    }

    .menu-opened .hide-navbar {
        display: block
    }

    .container>.navbar-header,.container>.navbar-collapse,.container-fluid>.navbar-header {
        margin-right: -10px;
        margin-left: -10px
    }
}

.navbar {
    position: static;
    border-width: 0;
    border-bottom-width: 1px;
    font-weight: 500;
    margin-left: -10px;
    margin-right: -10px;
    padding-left: 10px;
    padding-right: 10px;
    min-height: 49px
}

@media(min-width: 768px) {
    .navbar {
        margin-left:0;
        margin-right: 0;
        padding-left: 0;
        padding-right: 0
    }
}

@media(min-width: 992px) {
    .navbar {
        min-height:61px
    }
}

@media(max-width: 991px) {
    .nav-container {
        position:relative
    }
}

.navbar .container-fluid {
    padding-left: 0;
    padding-right: 0
}

.navbar-toggle {
    padding-left: 0;
    padding-right: 0;
    margin-top: 7px;
    margin-bottom: 7px
}

.navbar-toggle-logged {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 6px;
    margin-bottom: 6px;
    margin-right: 8px
}

@media(max-width: 767px) {
    .navbar-toggle-logged {
        margin-right:13px
    }
}

a.navbar-xs-icon {
    display: block;
    height: 34px;
    line-height: 34px;
    float: right;
    margin-right: 13px;
    padding: 0 5px;
    margin-top: 7px;
    margin-bottom: 7px;
    position: relative;
    color: #d5d5d5
}

a.navbar-xs-icon svg {
    fill: #d5d5d5
}

a.navbar-xs-icon:hover,a.navbar-xs-icon:focus {
    color: hsl(0,0%,78.5294117647%)
}

a.navbar-xs-icon:hover svg,a.navbar-xs-icon:focus svg {
    fill: hsl(0,0%,78.5294117647%)
}

a.navbar-xs-icon.active,a.navbar-xs-icon.active:hover,a.navbar-xs-icon.active:focus {
    color: #4384d0
}

a.navbar-xs-icon.active svg,a.navbar-xs-icon.active:hover svg,a.navbar-xs-icon.active:focus svg {
    fill: #4384d0
}

@media(min-width: 992px) {
    a.navbar-xs-icon {
        display:none
    }
}

a.navbar-xs-icon i {
    font-size: 28px;
    line-height: inherit
}

a.navbar-xs-icon svg {
    display: block
}

a.navbar-xs-icon span {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    color: #fff;
    font-size: 12px
}

a.navbar-xs-icon.icon-chat {
    padding-top: 4px;
    padding-bottom: 4px
}

a.navbar-xs-icon.icon-chat svg {
    width: 26px;
    height: 26px
}

.navbar-default .navbar-toggle:hover,.navbar-default .navbar-toggle:focus {
    background: rgba(0,0,0,0)
}

.navbar-toggle .icon-bar {
    width: 24px
}

.navbar-brand {
    height: 48px;
    padding-top: 13px;
    padding-bottom: 13px
}

.navbar-brand img {
    height: 22px;
    min-width: 59px
}

.navbar-header>.navbar-form {
    float: left;
    border: none
}

.navbar-form {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 5px;
    margin-bottom: 5px;
    box-shadow: none
}

.navbar-form.dropdown {
    position: static
}

.navbar-form .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle
}

.navbar-form .form-control {
    padding-left: 0;
    padding-right: 0;
    border: rgba(0,0,0,0);
    display: inline-block;
    vertical-align: middle;
    width: 130px
}

.navbar-form .form-control:lang(en) {
    width: 140px
}

.navbar-form .form-control:lang(uk) {
    width: 135px
}

.navbar-form>.btn {
    padding-left: 5px;
    padding-right: 5px
}

.navbar-form>.btn:focus {
    outline: none
}

.navbar-form>.btn i {
    font-size: 12px;
    line-height: inherit;
    position: relative;
    top: 1px
}

@media(min-width: 992px) {
    .navbar-brand {
        height:60px;
        padding-top: 19px;
        padding-bottom: 19px
    }

    .navbar-brand img {
        height: 22px;
        min-width: 59px
    }

    .navbar-form {
        margin-top: 11px;
        margin-bottom: 11px
    }
}

@media(max-width: 370px) {
    .navbar-form .form-control {
        width:43px
    }

    .navbar-form .form-control:lang(en) {
        width: 48px
    }

    .navbar-form .form-control:lang(uk) {
        width: 46px
    }
}

.dropdown-menu.dropdown-autocomplete {
    left: 0;
    right: 0;
    width: 100%;
    margin-top: 0;
    border-radius: 0;
    box-shadow: none;
    border-bottom: #e4e4e4 1px solid;
    padding-top: 2px;
    padding-bottom: 4px
}

.dropdown-menu.dropdown-autocomplete .promo-game-list-header {
    margin-top: 3px
}

.navbar-nav>li>a {
    padding-left: 10px;
    padding-right: 10px
}

.navbar-nav.logged>li>a {
    padding-left: 7px;
    padding-right: 7px
}

@media(max-width: 991px) {
    .navbar-nav {
        margin-top:0;
        margin-bottom: 0
    }

    .navbar-nav>li>a,.navbar-nav.logged>li>a {
        padding: 7px 15px;
        border-top: #f2f2f2 1px solid
    }

    .navbar-nav .open>a,.navbar-nav .open>a:hover,.navbar-nav .open>a:focus {
        border-top: #f2f2f2 1px solid
    }

    .navbar-default .navbar-collapse {
        border-top: none;
        position: absolute;
        right: 0;
        top: 100%;
        border-radius: 4px;
        box-shadow: rgba(0,0,0,.22) 0 1px 4px;
        min-width: 240px;
        left: auto;
        z-index: 999;
        background: #fff;
        margin-left: 0;
        margin-right: 1px;
        margin-top: 12px
    }
}

@media(max-width: 767px) {
    .navbar-default .navbar-collapse {
        margin-right:6px
    }
}

@media(min-width: 992px) {
    .navbar-right {
        margin-right:-23px
    }

    .navbar-right.logged {
        margin-right: -20px
    }
}

.no-transition {
    transition: height .01s !important
}

.no-select {
    -webkit-user-select: none;
    user-select: none
}

.navbar-nav .badge {
    vertical-align: baseline;
    margin-left: 3px;
    margin-bottom: -2px
}

.navbar-nav .badge.badge-balance {
    padding-left: 6px;
    padding-right: 6px
}

.navbar-nav>li>a.user-link {
    padding-top: 13px;
    padding-bottom: 13px
}

.user-link-name {
    color: #222;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
}

.user-link-photo {
    display: inline-block;
    vertical-align: middle;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 2px
}

.form-phone-verification p.phone {
    margin: 0;
    padding: 0;
    color: #888;
    font-size: 1.6em
}


.menu-icon.menu-icon-lang-en {
    background-position: 0px 0
}

.menu-icon.menu-icon-lang-ru {
    background-position: -19px 0
}

.menu-icon.menu-icon-lang-uk {
    background-position: -38px 0
}

.navbar-nav .dropdown-menu li.dropdown:before,.navbar-nav .dropdown-menu li.dropdown:after {
    content: " ";
    display: table
}

.navbar-nav .dropdown-menu li.dropdown:after {
    clear: both
}

.navbar-nav>li>.dropdown-menu,.dropdown-menu,.nav-tabs .dropdown-menu {
    margin-top: 7px;
    border-radius: 4px;
    border: none;
    padding: 0;
    box-shadow: rgba(0,0,0,.22) 0 1px 4px
}

.navbar-nav .dropdown-menu {
    margin-left: -6px
}

.navbar-right .dropdown-menu {
    right: 11px
}

.navbar-right.logged .dropdown-menu {
    right: 8px;
    min-width: 200px
}

.navbar-nav>li>.dropdown-menu>.active>a {
    background: #fff;
    color: #222
}

.navbar-nav>li>.dropdown-menu>.active>a:hover {
    background-color: #f5f5f5
}

.dropdown-menu>li:first-child>a {
    border-radius: 4px 4px 0 0
}

.dropdown-menu>li:last-child>a {
    border-radius: 0 0 4px 4px
}

.dropdown-menu>li>a {
    padding: 7px 15px;
    font-weight: 500
}

.navbar .dropdown-menu .dropdown-menu>li>a {
    padding-left: 30px
}

a.user-link-dropdown .user-link-desc {
    font-size: 12px;
    margin-top: 2px
}

.dropdown-menu>li+li,.dropdown-menu .dropdown-menu>li {
    border-top: #f2f2f2 1px solid
}

@media(min-width: 768px) {
    .dropdown-menu .dropdown-menu {
        position:static;
        margin: 0;
        border-radius: 0;
        box-shadow: none
    }

    .dropdown-menu .dropdown-menu>li:first-child>a,.dropdown-menu .dropdown-menu>li:last-child>a {
        border-radius: 0
    }
}

@media(max-width: 991px) {
    .navbar-nav .open .dropdown-menu>li>a,.navbar-nav .open .dropdown-menu .dropdown-header {
        padding:7px 15px 7px 30px
    }

    .navbar-nav .dropdown-menu {
        margin: 0
    }

    .navbar-nav .dropdown-menu>li:first-child {
        border-top: #f2f2f2 1px solid
    }
}

.breadcrumb {
    margin-bottom: 20px;
    font-weight: bold
}

.breadcrumb>li {
    padding-top: 1px;
    padding-bottom: 1px
}

.breadcrumb>li+li:before {
    padding: 0;
    position: relative;
    top: 1px
}

.nav-tabs {
    font-family: "Graphik Bold","Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 17px
}

.nav-tabs>li {
    margin-right: 20px;
    margin-bottom: 0
}

.nav-tabs>li:last-child {
    margin-right: 0
}

.nav-tabs>li>a {
    padding: 15px 0;
    margin-right: 0
}

.nav-tabs>li>a,.nav-tabs>li.active>a,.nav-tabs>li.active>a:hover,.nav-tabs>li.active>a:focus {
    border: none;
    position: relative;
    background-color: rgba(0,0,0,0)
}

.nav-tabs>li>a:hover,.nav-tabs>li>a:focus {
    background: rgba(0,0,0,0)
}

.nav-tabs>li.active>a:before {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    position: absolute;
    top: 100%;
    left: 0;
    background: #222
}

.nav-tabs .open>a,.nav-tabs .open>a:hover,.nav-tabs .open>a:focus {
    border-color: rgba(0,0,0,0);
    background-color: rgba(0,0,0,0)
}

.nav-tabs-justified>.active>a,.nav-tabs.nav-justified>.active>a,.nav-tabs-justified>.active>a:hover,.nav-tabs-justified>.active>a:focus {
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0
}

@media(max-width: 767px) {
    .nav-tabs {
        font-size:14px
    }
}

.nav-pills {
    margin-right: -10px;
    font-weight: bold
}

.nav-pills>li,.nav-pills>li+li {
    margin-left: 0;
    margin-right: 10px;
    margin-bottom: 10px
}

.nav-pills>li>a {
    padding: 12px 22px
}

.nav-pills>li.dropdown>a {
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    min-width: 40px
}

.nav-pills>li>a,.nav-pills>li>a:hover,.nav-pills>li>a:focus,.nav-pills .open>a,.nav-pills .open>a:hover,.nav-pills .open>a:focus {
    background: #f5f5f5
}

.list-inline {
    margin-left: 0
}

.list-inline>li {
    padding-left: 0;
    padding-right: 0;
    display: inline
}

.list-inline>li:after {
    content: " ·";
    color: #4384d0
}

.list-inline>li:last-child:after {
    display: none
}

.list-inline>.active a,.list-inline>.active a:hover,.list-inline>.active a:focus {
    text-decoration: none;
    cursor: default;
    color: #222
}

.popover-content {
    display: none
}

.popover .popover-content {
    display: block
}

.popover-content>p {
    margin-bottom: 0
}

.popover-content>p+p {
    margin-top: 5px
}

.table-buyers-prices {
    color: #888;
    font-size: 12px;
    line-height: 1.15
}

.table-buyers-prices th,.table-buyers-prices td {
    vertical-align: baseline;
    padding-top: 8px;
    white-space: nowrap
}

.table-buyers-prices tr:first-child th,.table-buyers-prices tr:first-child td {
    padding-top: 0
}

.table-buyers-prices th {
    font-weight: normal
}

.table-buyers-prices td {
    padding-left: 1em
}

label+.table-buyers-prices {
    margin-top: 3px
}

.popover .table-buyers-prices {
    color: #222;
    margin-top: 10px
}

.form-narrow .btn-block,.form-narrow .form-control,.form-narrow .input-group {
    max-width: 300px
}

.form-group-swap {
    position: relative
}

.form-group-swap .swap-btn {
    position: absolute;
    display: block;
    z-index: 100;
    left: 50%;
    top: 21px;
    width: 20px;
    margin-left: -10px;
    line-height: 38px;
    text-align: center
}

.form-group-swap .help-block {
    color: #b2b2b2 !important
}

.btn:active,.btn.active,.btn-group.open .dropdown-toggle {
    box-shadow: none
}

.btn-default {
    color: #4384d0;
    background-color: #fff;
    border-color: #e4e4e4
}

.bg-light-style .btn-default {
    border-color: #fff
}

.btn-default:focus,.btn-default.focus {
    color: #4384d0;
    background-color: hsl(0,0%,95%);
    border-color: hsl(0,0%,85%)
}

.btn-default:hover {
    color: #4384d0;
    background-color: hsl(0,0%,95%);
    border-color: hsl(0,0%,93%)
}

.btn-default:active,.btn-default.active,.open>.btn-default.dropdown-toggle {
    color: #4384d0;
    background-color: hsl(0,0%,95%);
    border-color: hsl(0,0%,93%)
}

.btn-default:active:hover,.btn-default:active:focus,.btn-default:active.focus,.btn-default.active:hover,.btn-default.active:focus,.btn-default.active.focus,.open>.btn-default.dropdown-toggle:hover,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle.focus {
    color: #4384d0;
    background-color: hsl(0,0%,91%);
    border-color: hsl(0,0%,85%)
}

.btn-default:active,.btn-default.active,.open>.btn-default.dropdown-toggle {
    background-image: none
}

.btn-default.disabled:hover,.btn-default.disabled:focus,.btn-default.disabled.focus,.btn-default[disabled]:hover,.btn-default[disabled]:focus,.btn-default[disabled].focus,fieldset[disabled] .btn-default:hover,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default.focus {
    background-color: #fff;
    border-color: #e4e4e4
}

.btn-default .badge {
    color: #fff;
    background-color: #4384d0
}

.btn-default.dropdown-toggle,.btn-default.dropdown-toggle:hover,.btn-default.dropdown-toggle:focus,.btn-default.dropdown-toggle:active,.open>.btn-default.dropdown-toggle,.open>.btn-default.dropdown-toggle:hover,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:active {
    color: #222
}

.btn-dark {
    color: #fff;
    background-color: #222;
    border-color: #222
}

.btn-dark:focus,.btn-dark.focus {
    color: #fff;
    background-color: #4d4d4d;
    border-color: rgb(51.5,51.5,51.5)
}

.btn-dark:hover {
    color: #fff;
    background-color: #4d4d4d;
    border-color: rgb(71.9,71.9,71.9)
}

.btn-dark:active,.btn-dark.active,.open>.btn-dark.dropdown-toggle {
    color: #fff;
    background-color: #4d4d4d;
    border-color: rgb(71.9,71.9,71.9)
}

.btn-dark:active:hover,.btn-dark:active:focus,.btn-dark:active.focus,.btn-dark.active:hover,.btn-dark.active:focus,.btn-dark.active.focus,.open>.btn-dark.dropdown-toggle:hover,.open>.btn-dark.dropdown-toggle:focus,.open>.btn-dark.dropdown-toggle.focus {
    color: #fff;
    background-color: #666;
    border-color: rgb(51.5,51.5,51.5)
}

.btn-dark:active,.btn-dark.active,.open>.btn-dark.dropdown-toggle {
    background-image: none
}

.btn-dark.disabled:hover,.btn-dark.disabled:focus,.btn-dark.disabled.focus,.btn-dark[disabled]:hover,.btn-dark[disabled]:focus,.btn-dark[disabled].focus,fieldset[disabled] .btn-dark:hover,fieldset[disabled] .btn-dark:focus,fieldset[disabled] .btn-dark.focus {
    background-color: #222;
    border-color: #222
}

.btn-dark .badge {
    color: #222;
    background-color: #fff
}

.btn-gray {
    color: #4384d0;
    background-color: #f5f5f5;
    border-color: #f5f5f5
}

.btn-gray:focus,.btn-gray.focus {
    color: #4384d0;
    background-color: rgb(234.8,234.8,234.8);
    border-color: rgb(209.3,209.3,209.3)
}

.btn-gray:hover {
    color: #4384d0;
    background-color: rgb(234.8,234.8,234.8);
    border-color: rgb(229.7,229.7,229.7)
}

.btn-gray:active,.btn-gray.active,.open>.btn-gray.dropdown-toggle {
    color: #4384d0;
    background-color: rgb(234.8,234.8,234.8);
    border-color: rgb(229.7,229.7,229.7)
}

.btn-gray:active:hover,.btn-gray:active:focus,.btn-gray:active.focus,.btn-gray.active:hover,.btn-gray.active:focus,.btn-gray.active.focus,.open>.btn-gray.dropdown-toggle:hover,.open>.btn-gray.dropdown-toggle:focus,.open>.btn-gray.dropdown-toggle.focus {
    color: #4384d0;
    background-color: rgb(219.5,219.5,219.5);
    border-color: rgb(209.3,209.3,209.3)
}

.btn-gray:active,.btn-gray.active,.open>.btn-gray.dropdown-toggle {
    background-image: none
}

.btn-gray.disabled:hover,.btn-gray.disabled:focus,.btn-gray.disabled.focus,.btn-gray[disabled]:hover,.btn-gray[disabled]:focus,.btn-gray[disabled].focus,fieldset[disabled] .btn-gray:hover,fieldset[disabled] .btn-gray:focus,fieldset[disabled] .btn-gray.focus {
    background-color: #f5f5f5;
    border-color: #f5f5f5
}

.btn-gray .badge {
    color: #f5f5f5;
    background-color: #4384d0
}

.btn-info-sm {
    padding-top: 2px;
    padding-bottom: 4px;
    height: 39px;
    line-height: 30px;
    font-size: 11px
}

.btn-info-sm .inside {
    display: inline-block;
    vertical-align: middle;
    line-height: 12px
}

.btn-info-icon {
    padding-left: 37px;
    padding-right: 0;
    position: relative;
    text-align: left
}

.btn-info-icon .inside {
    padding-right: 12px
}

.btn-info-icon .icon {
    position: absolute;
    left: 5px;
    top: 50%;
    width: 27px;
    text-align: center;
    font-size: 16px;
    transform: translate(0, -50%)
}

.btn-xs,.btn-group-xs>.btn {
    padding: 3px 7px 2px 8px;
    font-size: 9px;
    line-height: 1.33333333;
    letter-spacing: 1px
}

.btn-group-xs>span.btn {
    cursor: default
}

.btn-wide {
    padding-left: 20px;
    padding-right: 20px
}

.btn-round {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 0;
    line-height: 40px
}

.chat-form-btn .btn-round {
    font-size: 22px
}

.section {
    padding-top: 50px;
    padding-bottom: 50px
}

html,body {
    height: 100%
}

.wrapper {
    display: flex;
    flex-direction: column;
    height: 100%
}

.wrapper-content {
    flex: 1 0 auto
}

.wrapper-footer {
    flex: 0 0 auto
}

.bg-light-color #header,.bg-light-color .wrapper-footer {
    background-color: #fff
}

.promo-cd {
    position: relative;
    overflow: hidden;
    min-height: 826px
}

.promo-cd .container {
    position: relative
}

.cd-forward {
    position: relative;
    z-index: 200
}

@media(max-width: 767px) {
    .cd-forward {
        margin-top:-50%;
        padding-top: 28px
    }
}

.cd-container {
    position: absolute;
    z-index: 100;
    top: 22px;
    left: 50%;
    margin-left: 562.5px;
    transform: translate(-50%, 0)
}

.cd {
    position: relative;
    z-index: 100;
    border-radius: 50%;
    width: 800px;
    height: 800px;
    overflow: hidden;
    font-family: "Graphik Bold","Helvetica Neue",Helvetica,Arial,sans-serif
}

.cd .spacer {
    width: 100%;
    padding-bottom: 100%;
    background: #f9f9f9
}

.cd img,.cd svg,.cd a {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%
}

.cd a {
    display: block;
    z-index: 100;
    border-radius: 50%
}

.cd .spacer,.cd img,.cd svg {
    pointer-events: none
}

.cd svg {
    fill: #fff
}

.cd-empty svg {
    transform: rotate(30deg)
}

.cd-satellite {
    position: absolute;
    top: 1px;
    left: 14px;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: #4384d0;
    padding: 57px 34px;
    color: #fff;
    line-height: 1.21428571
}

a.cd-satellite,a.cd-satellite:hover,a.cd-satellite:focus,a.cd-satellite:active {
    color: #fff;
    text-decoration: none;
    outline: none
}

a.cd-satellite:hover,a.cd-satellite:focus {
    background: rgb(54.76,123.9919148936,204.94)
}

a.cd-satellite:active {
    background: rgb(49.9,118.9106382979,199.6)
}

.social-statistic-list {
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: 107px;
    z-index: 553;
    max-width: 480px;
    color: #fff
}

.social-statistic-list-xs {
    position: relative;
    top: 0;
    left: 20px;
    margin-top: -130px;
    margin-bottom: 15px;
    width: 10px
}

@media(max-width: 1300px) {
    .social-statistic-list {
        max-width:300px
    }
}

.social-statistic {
    display: inline-block;
    width: 114px;
    height: 114px;
    border-radius: 50%;
    position: relative;
    text-align: center;
    margin-bottom: 4px;
    background: #4384d0
}

.social-statistic,.social-statistic:hover,.social-statistic:active,.social-statistic:focus {
    color: #fff;
    text-decoration: none;
    outline: none
}

.social-statistic:hover,.social-statistic:focus {
    background: rgb(79.24,140.0080851064,211.06)
}

.social-statistic:active {
    background: rgb(91.48,148.0161702128,214.12)
}

.social-statistic-logo {
    position: absolute;
    left: 0;
    right: 0;
    top: 0
}

.social-statistic-logo i,.social-statistic-logo span,.social-statistic-logo svg {
    position: relative
}


.social-statistic-info {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 23px;
    line-height: 1.15;
    font-size: 12px
}

.social-statistic-vk {
    background: #07f
}

.social-statistic-vk:hover,.social-statistic-vk:focus {
    background: hsl(212,100%,53%)
}

.social-statistic-vk:active {
    background: hsl(212,100%,56%)
}

.social-statistic-vk svg {
    width: 29px;
    height: 29px;
    top: 27px
}

.social-statistic-telegram {
    background: #3390ec
}

.social-statistic-telegram:hover,.social-statistic-telegram:focus {
    background: rgb(64.9964125561,151.6156950673,237.3035874439)
}

.social-statistic-telegram:active {
    background: rgb(78.9928251121,159.2313901345,238.6071748879)
}

.social-statistic-telegram svg {
    color: #fff;
    width: 39px;
    height: 31px;
    top: 24px
}

.social-statistic-fb {
    background: #1877f2
}

.social-statistic-fb:hover,.social-statistic-fb:focus {
    background: rgb(38.4848360656,127.5278688525,242.8151639344)
}

.social-statistic-fb:active {
    background: rgb(52.9696721311,136.0557377049,243.6303278689)
}

.social-statistic-fb i {
    font-size: 31px;
    top: 26px
}

.social-statistic-goha {
    background: #222
}

.social-statistic-goha:hover,.social-statistic-goha:focus {
    background: rgb(51.85,51.85,51.85)
}

.social-statistic-goha:active {
    background: rgb(59.5,59.5,59.5)
}

.social-statistic-goha span {
    background-position: 0 -142px;
    width: 50px;
    height: 23px;
    top: 30px
}

.social-statistic-wot {
    background: #042e3c
}

.social-statistic-wot:hover,.social-statistic-wot:focus {
    background: hsl(195,87.5%,15.5490196078%)
}

.social-statistic-wot:active {
    background: rgb(5.9125,67.99375,88.6875)
}

.social-statistic-wot span {
    background-position: 0 -117px;
    width: 64px;
    height: 24px;
    top: 30px;
    left: -2px
}

.social-statistic-trustpilot {
    background: #000032
}

.social-statistic-trustpilot:hover,.social-statistic-trustpilot:focus {
    background: rgb(0,0,70.4)
}

.social-statistic-trustpilot:active {
    background: rgb(0,0,85.7)
}

.social-statistic-trustpilot span {
    background-position: 0 -95px;
    width: 82px;
    height: 21px;
    top: 30px
}

.promo-games {
    padding-top: 22px;
    padding-bottom: 0
}

.content-with-cd {
    margin-right: 440px
}

.content-with-cd:before,.content-with-cd:after {
    content: " ";
    display: table
}

.content-with-cd:after {
    clear: both
}

.content-with-cd-wide {
    margin-left: -12px;
    margin-right: -12px;
    padding: 12px;
    background: #fff;
    border-radius: 4px
}

.promo-game-list-header {
    float: left;
    width: 40px
}

.nav-abc {
    font-size: 10px;
    overflow: hidden;
    font-weight: bold
}

.nav-abc.affix {
    top: 20px;
    position: fixed
}

.nav-abc.affix-bottom {
    position: absolute;
    top: auto
}

.nav-abc ul {
    height: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch
}

.nav-abc ul .active a,.nav-abc ul .active a:hover,.nav-abc ul .active a:focus {
    text-decoration: none;
    cursor: default;
    color: #222
}

.nav-abc ul li {
    margin-bottom: 6px
}

.nav-abc .nav>li>a {
    display: inline-block;
    padding: 0
}

.nav-abc .nav>li>a,.nav-abc .nav>li>a:hover,.nav-abc .nav>li>a:focus {
    background: rgba(0,0,0,0)
}

.title-mini {
    font-size: 9px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1.3px;
    line-height: 1.22222222
}

.promo-game-list {
    margin-left: 80px
}

.game-title {
    margin-bottom: 7px;
    font-family: "Graphik Semibold","Helvetica Neue",Helvetica,Arial,sans-serif
}

.game-title a {
    color: #222;
    text-decoration: none
}

.game-title a:hover,.game-title a:focus {
    text-decoration: underline
}

.promo-game-item {
    margin-bottom: 20px
}

.promo-game-item .btn-group {
    margin-bottom: 5px
}

.promo-game-item .btn-group .btn {
    margin-left: 0
}

.promo-game-item .btn-group .btn,.promo-game-item .btn-group .btn:hover,.promo-game-item .btn-group .btn:focus,.promo-game-item .btn-group .btn:active,.promo-game-item .btn-group .btn:active:hover,.promo-game-item .btn-group .btn:active:focus {
    outline: none
}

.promo-game-item .list-inline {
    font-size: 13px;
    line-height: 20px
}

.promo-game-item .list-inline li {
    white-space: nowrap
}

.promo-game-list-title {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 10px;
    color: #888
}

.promo-games-all {
    margin-bottom: 20px
}

@media(max-width: 1199px) {
    .content-with-cd {
        margin-right:320px
    }
}

@media(max-width: 991px) {
    .content-with-cd {
        margin-right:220px
    }
}

@media(max-width: 767px) {
    .promo-cd {
        min-height:auto
    }

    .cd-container {
        position: static;
        left: auto;
        top: auto;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        transform: none
    }

    .cd {
        width: auto;
        height: auto;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 4px
    }

    .cd-container+.promo-games {
        margin-top: -16px
    }

    .content-with-cd {
        margin-right: 0
    }

    .promo-abc .content-with-cd {
        margin-right: 20px
    }

    .promo-game-list-header {
        float: none;
        width: auto;
        margin-bottom: 16px
    }

    .promo-game-list {
        margin-left: 0
    }

    .nav-abc {
        position: absolute;
        right: 10px;
        margin-top: 16px
    }

    .nav-abc.affix {
        margin-top: 0
    }

    .nav-abc ul {
        text-align: center
    }
}

@media(max-width: 480px) {
    .cd {
        margin-left:10px;
        margin-right: 10px
    }

    .social-statistic-list-xs {
        left: 10px
    }
}

@media(max-width: 767px) {
    .showcase-filters label.control-label {
        display:block;
        margin-bottom: 0
    }
}

@media(min-width: 768px) {
    .showcase-filters {
        display:block !important;
        height: auto !important
    }

    .showcase-filters .showcase-filter-text {
        width: 14em
    }

    .filter-container {
        margin-bottom: 3px
    }
}

@media(max-width: 767px) {
    .form-inline .form-control {
        width:100%
    }

    .form-inline .bootstrap-select select.form-control {
        width: .5px !important
    }

    .filter-btn-container {
        display: flex !important;
        flex-wrap: nowrap;
        padding-bottom: 10px
    }

    .filter-btn-container:before,.filter-btn-container:after {
        display: none
    }

    .filter-btn-container>div {
        width: 100%
    }

    .offer-btn .btn-wide {
        width: 100%
    }
}

@media(max-width: 480px) {
    .filter-btn-container .btn {
        padding-left:8px;
        padding-right: 8px
    }
}

.tc {
    display: table;
    width: 100%;
    margin-bottom: 20px
}

.tc:not(.tc-selling):not(.tc-finance) .tc-item>div {
    border-top: #eaeaea 1px solid
}

.tc:not(.tc-selling):not(.tc-finance) .tc-header>div {
    border-bottom: none
}

.tc-header,.tc-item {
    display: table-row
}

.tc-header>div,.tc-header>[class^=col-],.tc-header>[class*=" col-"],.tc-item>div,.tc-item>[class^=col-],.tc-item>[class*=" col-"] {
    display: table-cell;
    float: none;
    vertical-align: top;
    padding-left: 8px;
    padding-right: 8px
}

a.tc-item {
    color: #222;
    text-decoration: none
}

a.tc-item .pseudo-a,a.tc-item .pseudo-a:hover,a.tc-item .pseudo-a:focus,a.tc-item .pseudo-a:active {
    outline: none
}

a.tc-item .pseudo-a:hover {
    text-decoration: underline
}

.tc-header>div {
    padding-top: 12px;
    padding-bottom: 12px;
    border-bottom: #eaeaea 1px solid
}

.tc-item>div {
    padding-top: 12px;
    padding-bottom: 12px;
    height: 67px
}

.media-user {
    margin-top: 0
}

.tc .media-user {
    display: block
}

.tc .media-user .media-body {
    width: auto
}

.tc .form-group {
    margin-bottom: 0
}

.tc .checkbox-switch {
    margin-top: 2px;
    margin-bottom: 3px;
    line-height: 1
}

.media-user.style-circle .avatar-photo {
    overflow: visible
}

.media-user.style-circle .avatar-photo:after {
    display: block;
    width: 16px;
    height: 16px;
    background: #a6a6a6;
    border: 3px solid #fff;
    border-radius: 50%;
    content: "";
    position: absolute;
    right: -3px;
    bottom: -3px;
    z-index: 10
}

.media-user.style-circle.online .avatar-photo:after {
    background: #7ed320
}

.media-user.style-circle.offline .media-user-name,.media-user.style-circle.offline .media-user-name .pseudo-a {
    color: #a6a6a6
}

.media-user.style-circle.offline .media-user-reviews {
    color: #888
}

.tc-visible-inside {
    display: none
}

.table>thead>tr>th {
    border-bottom-width: 1px
}

table.table-clickable tbody tr,.tc.table-clickable .tc-item {
    cursor: pointer
}

.tc.table-hover .tc-item:hover {
    background-color: #f9f9f9
}

.tc-desc-text a {
    color: #222
}

.showcase-table .tc-desc-text {
    word-wrap: break-word;
    word-break: break-word
}

@media(max-width: 767px) {
    .showcase-table .tc-header>div,.showcase-table .tc-item>div {
        padding-left:5px;
        padding-right: 5px
    }

    .showcase-table .media-user-name {
        max-width: 120px
    }
}

.showcase-has-actions .showcase-actions {
    display: none
}

.showcase-has-actions .showcase-actions span {
    color: #888
}

.showcase-has-actions .showcase-actions span:hover {
    color: #222
}

.showcase-has-actions .tc-item:hover .tc-price .price-admin {
    display: none
}

.showcase-has-actions .tc-item:hover .showcase-actions {
    display: block
}

.tc-amount,.tc-price {
    text-align: right;
    white-space: nowrap
}

.tc-amount .unit {
    font-size: 12px
}

.tc-item .tc-price {
    font-weight: bold
}

.tc .image-list-mini {
    margin-top: 3px
}

a.image-list-mini {
    display: inline-block;
    text-decoration: none
}

.tc-user .media-user {
    line-height: 1.15
}

.image-list-mini-title {
    display: inline-block;
    vertical-align: top;
    margin-right: 6px;
    margin-bottom: 4px
}

.image-list-mini-item {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 4px;
    line-height: 1
}

.table-condensed .tc-header>div,.table-condensed .tc-item>div {
    padding: 5px
}

@media(max-width: 767px) {
    .tc {
        margin-bottom:14px
    }

    .tc .tc-header>div,.tc .tc-item>div {
        height: auto
    }

    .tc:not(.tc-selling):not(.tc-finance) .tc-item>div {
        border-top: #eaeaea 1px solid
    }

    .tc:not(.tc-selling) .tc-header>div {
        border-bottom: none
    }

    .tc-item>div.tc-amount,.tc-item>div.tc-price {
        padding-top: 10px
    }

    .tc-visible-inside {
        display: block;
        margin-bottom: 5px
    }

    .tc-server-inside,.tc-side-inside {
        display: inline
    }

    .tc-visible-inside,.tc-server-inside,.tc-side-inside {
        font-size: 12px;
        line-height: 1.16666667;
        color: #888
    }

    .tc-server-inside:after {
        content: " ·"
    }

    .tc-server-inside:last-child:after {
        display: none
    }

    .tc-desc-text {
        display: inline;
        margin-right: 10px
    }

    .tc .image-list-mini {
        display: inline-block;
        margin-top: 0
    }

    .tc .media-user-name {
        font-size: 12px
    }

    .tc .media-user-name .pseudo-a {
        color: #4384d0
    }

    .tc-price .unit {
        font-size: 12px
    }
}

@media(max-width: 480px) {
    .tc-short,.tc-short .tc-item,.tc.tc-short .tc-item>div {
        display:block
    }

    .tc-short .tc-header {
        display: table;
        width: 100%
    }

    .tc-short .tc-item {
        border-top: #eaeaea 1px solid;
        padding-top: 12px;
        padding-bottom: 12px;
        position: relative
    }

    .tc.tc-short .tc-item>div {
        border: none !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .tc-item .tc-desc,.tc-item .tc-user {
        margin-right: 85px
    }

    .tc-item .tc-user {
        margin-top: 5px
    }

    .tc-short .tc-item .tc-price {
        position: absolute;
        right: 0;
        top: 9px
    }
}

.game-about {
    border-top: #e4e4e4 1px solid;
    padding-top: 34px;
    padding-bottom: 34px
}

.game-about,.game-about h3,.game-about .h3 {
    line-height: 1.29411764
}

.game-about h3,.game-about .h3 {
    margin-bottom: 11px
}

.game-about .block-info>:last-child {
    margin-bottom: 0
}

@media(max-width: 767px) {
    .game-about {
        padding-top:17px;
        padding-bottom: 17px
    }
}

.chat-promo {
    display: table;
    width: 100%;
    margin-bottom: 12px;
    border: 1px solid #f9f9f9;
    border-radius: 4px;
    background: #f9f9f9;
    padding: 15px;
    height: 72px
}

.chat-promo>div {
    display: table-cell;
    vertical-align: middle
}

.chat-promo-user {
    width: 26.31578947%;
    padding-right: 15px
}

.media-user>div {
    vertical-align: middle
}

.media-user .avatar-photo {
    width: 40px;
    height: 40px
}

.chat-promo-user .avatar-photo,.tc .avatar-photo {
    width: 36px;
    height: 36px
}

.media-user-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold
}

.media-user-name a {
    color: #222
}

.chat-promo-user .media-user-name {
    max-width: 250px
}

.media-user-reviews {
    white-space: nowrap
}

.media-user-reviews,.media-user-status,.media-user-info {
    font-size: 12px
}

.media-user-info {
    color: #a6a6a6;
    font-weight: bold
}

.media-user-status {
    font-weight: bold
}

.chat-header .media-user-status,.profile h1 .media-user-status {
    font-size: 14px
}

.profile h1 .media-user-status {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif
}

.online .media-user-status {
    color: #7ed320
}

.offline .media-user-status {
    color: #a6a6a6
}

.banned .media-user-status {
    color: #f52323
}

.chat-header .offline .media-user-status {
    font-weight: normal
}

.chat-promo-desc {
    width: 57.2368421%;
    padding-right: 15px
}

.chat-promo-desc>.inside {
    overflow: hidden;
    max-height: 2.857142858em
}

.chat-promo-btn {
    width: 16.44736842%
}

@media(max-width: 767px) {
    .chat-promo>div {
        display:block;
        width: auto;
        padding-right: 0
    }

    .chat-promo-user {
        margin-bottom: 10px
    }

    .chat-promo-desc {
        margin-bottom: 15px
    }

    .profile h1,.profile .h1 {
        margin-bottom: 28px !important
    }

    .profile h1 .media-user-status,.profile .h1 .media-user-status {
        display: block;
        margin-top: 6px
    }
}

.chat {
    height: 500px;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    background: #fff;
    margin-bottom: 18px
}

.chat-img {
    display: inline-block;
    border-radius: 4px;
    background-color: #f9f9f9
}

.chat-img-link {
    display: inline-block;
    outline: none
}

.chat-float {
    height: 595px
}

.chat.affix {
    position: static
}

@media(min-width: 992px) {
    .chat.affix {
        position:fixed;
        top: 13px
    }

    .chat.affix-bottom {
        position: absolute
    }

    .chat.affix,.chat.affix-bottom {
        width: 374px
    }
}

@media(min-width: 1200px) {
    .chat.affix,.chat.affix-bottom {
        width:451px
    }
}

.chat-not-selected .chat-header,.chat-not-selected .chat-form {
    display: none
}

.chat-not-selected .chat-message-container {
    border-bottom: 1px solid #eaeaea
}

@media(min-width: 768px) {
    .chat-not-selected .chat-message-container {
        border-top:1px solid #eaeaea
    }
}

.chat-header {
    border-radius: 4px 4px 0 0;
    border: #eaeaea 1px solid;
    padding: 15px 15px 15px 20px
}

.chat-header.bg-light-style {
    border-color: #f9f9f9
}

.chat-float .chat-header {
    padding: 10px 13px 10px 20px
}

.chat-header .media-user-name {
    max-width: 134px
}

.chat-header h1,.chat-header .h1 {
    margin-bottom: 0
}

.chat-header .media-left img {
    min-width: 50px
}

.h1 .fa-clone {
    vertical-align: text-top;
    position: relative;
    top: 8px;
    margin-left: 4px;
    font-size: 21px
}

.chat-user-count {
    display: inline-block;
    vertical-align: text-top;
    margin-left: 12px;
    margin-top: 11px;
    font-size: 14px;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif
}

.chat-header {
    display: table;
    width: 100%;
    height: 72px
}

.chat-header>div {
    display: table-cell;
    vertical-align: middle
}

.chat-header .media-user {
    display: block
}

.chat-header .media-user .media-body {
    width: auto
}

.chat-panel-mobile {
    line-height: 1.15;
    padding: 10px;
    border-bottom: 1px solid #eaeaea
}

@media(min-width: 768px) {
    .chat-panel-mobile {
        padding:10px 20px;
        border-left: 1px solid #eaeaea;
        border-right: 1px solid #eaeaea
    }
}

@media(min-width: 992px) {
    .chat-panel-mobile {
        display:none
    }
}

.chat-panel-mobile a {
    word-wrap: break-word
}

.chat-header .media-body {
    height: 50px;
    vertical-align: middle
}

.chat-header-controls {
    text-align: right;
    white-space: nowrap
}

.chat-header-controls .chat-control {
    margin-right: 4px
}

.chat-header-controls .chat-control:last-child {
    margin-right: 0
}

.chat-message-container {
    flex: 1 1 auto;
    border-left: #eaeaea 1px solid;
    border-right: #eaeaea 1px solid;
    display: flex;
    position: relative
}

.chat-message-list-date {
    position: relative;
    margin-bottom: 18px;
    text-align: center;
    color: #a6a6a6
}

.chat-message-list-date:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 1px;
    background: rgb(239.1,239.1,239.1);
    font-size: 0;
    margin-top: 1px
}

.chat-message-list-date .inside {
    display: inline-block;
    vertical-align: top;
    padding-left: 9px;
    padding-right: 9px;
    background: #fff;
    position: relative;
    z-index: 1
}

.chat-empty {
    display: flex;
    align-items: center;
    text-align: center
}

.chat-message-list,.chat-empty {
    padding: 0 20px;
    overflow-x: hidden;
    overflow-y: auto
}

.chat-message-list .chat-msg-item,.chat-empty .chat-msg-item {
    margin-bottom: 6px
}

.chat-message-list .chat-msg-item:first-child,.chat-empty .chat-msg-item:first-child {
    margin-top: 20px
}

.chat-message-list .chat-msg-item:last-child,.chat-empty .chat-msg-item:last-child {
    margin-bottom: 20px
}

.chat-message-container .chat-message-list,.chat-message-container .chat-empty {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0
}

.chat-msg-with-head {
    margin-top: 18px
}

.chat-msg-author-label {
    display: inline-block;
    position: relative;
    top: -1px
}

.message-append-compact {
    padding-left: 50px
}

.chat-msg-text {
    word-break: break-word;
    white-space: pre-wrap
}

.chat-msg-widget {
    margin-top: 18px
}

.chat-message:after {
    clear: both
}

.chat-message .media-user>div {
    vertical-align: top
}

.chat-message .media-user-name {
    margin-bottom: 3px
}

.chat-message.blocked .chat-msg-author-link {
    color: #a6a6a6
}

.chat-message.blocked .chat-msg-text {
    color: #a6a6a6
}

.chat-message.blocked .avatar-photo {
    opacity: .5
}

.chat-msg-date {
    float: right;
    width: 20%;
    padding-left: 10px;
    padding-top: 1px;
    white-space: nowrap;
    text-align: right;
    color: #a6a6a6;
    font-weight: normal;
    display: inline-block
}

.chat-msg-body {
    position: relative
}

.chat-msg-meta {
    color: #a6a6a6;
    opacity: .5;
    position: absolute;
    top: 0;
    right: 0
}

.chat-msg-meta.chat-msg-meta-inside-alert {
    right: 4px
}

.chat-msg-author-color-seller .chat-msg-author-link {
    color: rgb(46.9,92.4,145.6)
}

.chat-msg-author-color-buyer .chat-msg-author-link {
    color: #ce671b
}

.chat-msg-author-color-user1 .chat-msg-author-link {
    color: #cd4073
}

.chat-msg-author-color-user2 .chat-msg-author-link {
    color: #2996ad
}

.chat-form {
    border: #eaeaea 1px solid;
    padding: 10px 14px 10px 25px;
    border-radius: 0 0 4px 4px;
    position: relative
}

.chat-form form {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%
}

.chat-form button,.chat-form button:hover,.chat-form button:focus,.chat-form button:active,.chat-form button:active:hover,.chat-form button:active:focus {
    outline: none
}

.chat-form-input {
    width: 100%;
    padding-right: 12px
}

.chat-form-input textarea[readonly],.chat-form-input textarea[disabled] {
    background: none;
    color: #a6a6a6
}

.chat-form-input textarea[readonly]::-moz-placeholder,.chat-form-input textarea[disabled]::-moz-placeholder {
    color: rgb(170.5,170.5,170.5);
    opacity: 1
}

.chat-form-input textarea[readonly]:-ms-input-placeholder,.chat-form-input textarea[disabled]:-ms-input-placeholder {
    color: rgb(170.5,170.5,170.5)
}

.chat-form-input textarea[readonly]::-webkit-input-placeholder,.chat-form-input textarea[disabled]::-webkit-input-placeholder {
    color: rgb(170.5,170.5,170.5)
}

.chat-form-input .form-group {
    width: 100%;
    margin-bottom: 0;
    position: relative
}

.chat-form-input .form-control {
    resize: none;
    border-color: rgba(0,0,0,0);
    border-width: 0;
    outline: none;
    max-height: 12.1428571em
}

.chat-form-input .form-control,.chat-form-input .hiddendiv {
    padding: 10px 10px 10px 0;
    line-height: 1.21428571;
    font-weight: normal;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden
}

.chat-form-input .form-control.over,.chat-form-input .hiddendiv.over {
    overflow: auto
}

.chat-form-input .hiddendiv {
    position: absolute;
    z-index: -1;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    border: none
}

.chat-form-attach {
    padding-right: 12px
}

@media(max-width: 767px) {
    .chat-message-list,.chat-header,.chat-form {
        padding-left:20px
    }

    .chat-header {
        padding-right: 20px
    }

    .chat-header h1,.chat-header .h1 {
        margin-bottom: 10px
    }

    .chat-msg-date {
        width: auto;
        float: unset
    }

    .chat-float .chat-header {
        padding-left: 10px;
        padding-right: 10px;
        position: relative
    }

    .chat-header .media-user {
        overflow: hidden;
        display: block
    }

    .chat-header .media-user .media-left {
        padding-right: 5px
    }

    .chat-full .chat-header-controls {
        position: absolute;
        z-index: 10;
        right: 10px;
        top: 50%;
        transform: translate(0, -50%)
    }
}

.chat-profile-container {
    float: right
}

@media(min-width: 992px) {
    .chat-profile-container {
        padding-left:16px !important
    }
}

@media(max-width: 991px) {
    .chat-profile-container {
        float:unset
    }
}

.chat-full-container {
    padding-top: 20px;
    padding-bottom: 20px
}

.chat-full {
    display: flex;
    width: 100%;
    height: 270px
}

.chat-full .chat {
    margin-bottom: 0;
    width: 50.22222222%;
    height: auto
}

.chat-full .chat-header,.chat-full .chat-form,.chat-full .chat-message-list {
    border-radius: 0
}

.chat-not-selected-info {
    margin: auto;
    color: #a6a6a6
}

.chat-not-selected-info i {
    display: block;
    font-size: 80px
}

.chat-not-selected-info span {
    display: block;
    margin-top: 10px
}

.chat-bookmarks-empty .chat-not-selected-info .bookmarks-nonempty,.chat-bookmarks-nonempty .chat-not-selected-info .bookmarks-empty {
    display: none
}

.chat-contacts,.chat-detail {
    width: 24.88888889%;
    background: #fff;
    border: #eaeaea 1px solid;
    display: flex;
    flex-direction: column
}

.chat-contacts {
    border-radius: 4px 0 0 4px;
    border-right: none
}

.chat-detail {
    border-radius: 0 4px 4px 0;
    border-left: none
}

.chat-full-header {
    padding: 20px;
    border-bottom: #eaeaea 1px solid;
    white-space: nowrap
}

.chat-full-header h1 {
    margin: 0
}

.chat-full-header .badge {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-weight: 500
}

.contact-list {
    flex: 1 1 auto;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto
}

.custom-scroll,.chat-message-list,.chat-empty,.chat-form-input .form-control,.chat-form-input .hiddendiv {
    -webkit-overflow-scrolling: touch
}

.custom-scroll::-webkit-scrollbar,.chat-message-list::-webkit-scrollbar,.chat-empty::-webkit-scrollbar,.chat-form-input .form-control::-webkit-scrollbar,.chat-form-input .hiddendiv::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background: #fff;
    border: 0
}

.custom-scroll::-webkit-scrollbar-thumb,.chat-message-list::-webkit-scrollbar-thumb,.chat-empty::-webkit-scrollbar-thumb,.chat-form-input .form-control::-webkit-scrollbar-thumb,.chat-form-input .hiddendiv::-webkit-scrollbar-thumb {
    cursor: pointer;
    background: #ddd;
    border: 0
}

.contact-item {
    line-height: 1.15;
    border-bottom: #eaeaea 1px solid;
    padding: 6px 10px 6px 75px;
    position: relative;
    cursor: pointer;
    letter-spacing: .2px;
    display: block
}

.contact-item:before,.contact-item:after {
    content: " ";
    display: table
}

.contact-item:after {
    clear: both
}

.contact-item:hover {
    background: #f9f9f9
}

.contact-item.active,.contact-item.active:hover,.contact-item.active:focus {
    background: #4384d0
}

.contact-item.active,.contact-item.active>div {
    color: #fff
}

.contact-item.unread {
    background: #f5a623
}

.contact-item.unread:hover,.contact-item.unread:focus {
    background: rgb(244.1130434783,158.1060869565,15.4869565217)
}

.contact-item.unread,.contact-item.unread>div {
    color: #fff
}

.contact-item .media-user-name {
    margin-right: 50px
}

a.contact-item {
    text-decoration: none;
    color: unset
}

.contact-item-photo {
    width: 50px;
    float: left;
    margin-left: -65px
}

.contact-item-message {
    margin-top: 2px;
    line-height: 15px;
    height: 30px;
    overflow: hidden;
    color: #c2c2c2
}

.contact-item-time {
    position: absolute;
    top: 6px;
    right: 10px;
    color: #4a4a4a
}

a.chat-clone {
    text-decoration: none;
    color: unset
}

.chat-detail {
    padding: 15px 0 15px 0
}

.chat-detail-list {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 50px;
    padding-left: 65px
}

.chat-back {
    display: none
}

@media(max-width: 1199px) {
    .chat-detail-list {
        padding-right:20px;
        padding-left: 20px
    }
}

@media(max-width: 991px) {
    .chat-detail {
        display:none
    }

    .chat-contacts {
        width: 35%
    }

    .chat-full .chat {
        width: 65%
    }

    .chat-full .chat-header {
        border-radius: 0 4px 0 0
    }

    .chat-full .chat-form {
        border-radius: 0 0 4px 0
    }
}

@media(max-width: 767px) {
    .chat-full-container {
        padding-top:0;
        padding-bottom: 0;
        overflow: hidden
    }

    .chat-full-container .container {
        padding-left: 0;
        padding-right: 0
    }

    .chat-contacts {
        border: none;
        border-radius: 0
    }

    .chat-full {
        width: 200%;
        transition: transform .3s ease-in-out
    }

    .chat-full .chat-header,.chat-full .chat-message-container,.chat-full .chat-form {
        border-left: none;
        border-right: none;
        border-radius: 0
    }

    .chat-full .chat-form {
        border-bottom: none
    }

    .chat-full.moved {
        transform: translate(-50%, 0)
    }

    .chat-contacts,.chat-full .chat {
        width: 50%
    }

    .chat-full .chat-header {
        padding-right: 10px;
        border-top: none
    }

    .chat-full .chat-message-list {
        padding: 0 10px
    }

    .chat-full .chat-message-list .chat-msg-item:first-child {
        margin-top: 10px
    }

    .chat-full .chat-message-list .chat-msg-item:last-child {
        margin-bottom: 10px
    }

    .chat-full .chat-form {
        padding-left: 10px;
        padding-right: 10px
    }

    .chat-full.chat-bookmarks-nonempty .chat-header {
        padding-left: 35px
    }

    .chat-full.chat-bookmarks-nonempty .chat-back {
        display: block;
        position: absolute;
        left: 10px;
        width: 15px;
        text-align: center;
        top: 50%;
        font-size: 16px;
        transform: translate(0, -50%);
        cursor: pointer
    }
}

.chat-message-list.no-padding .chat-msg-item {
    margin-top: 10px;
    margin-bottom: 0
}

.chat-message-list.no-padding .chat-msg-item:first-child {
    margin-top: 0
}

.chat-msg-item .video-box-fake {
    margin-top: 1em
}


.rating-stars {
    display: inline-block;
    vertical-align: middle;
    font-size: 8px
}

.rating-stars .fas:before,.rating-stars .far:before {
    content: ""
}

.rating-stars.rating-1,.rating-stars.rating-2,.rating-stars.rating-3 {
    color: #d0011b
}

.rating-stars.rating-4 {
    color: #f5a623
}

.rating-stars.rating-5 {
    color: #f8e71c
}

.rating-mini-count {
    color: #888;
    vertical-align: middle
}

.rating-value {
    font-family: "Graphik Bold","Helvetica Neue",Helvetica,Arial,sans-serif
}

.rating-value .big {
    display: inline-block;
    margin-right: 8px;
    position: relative;
    line-height: .83333333;
    font-size: 60px;
    letter-spacing: -3px
}

.rating-value>* {
    vertical-align: baseline
}

.rating-full {
    line-height: 10px;
    white-space: nowrap
}

.rating-full .rating-mini {
    margin-right: 3px;
    vertical-align: top
}

.rating-full-item4 .rating-mini {
    width: 40px;
    margin-left: 10px
}

.rating-full-item3 .rating-mini {
    width: 30px;
    margin-left: 20px
}

.rating-full-item2 .rating-mini {
    width: 20px;
    margin-left: 30px
}

.rating-full-item1 .rating-mini {
    width: 10px;
    margin-left: 40px
}

.rating-progress {
    display: inline-block;
    vertical-align: top;
    margin-top: 4px;
    height: 1px;
    width: 67px;
    background: #dcdcdc
}

.rating-progress>div {
    height: 1px;
    background: #444
}




.rating>span {
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer
}



.rating1 {
    width: 17px
}

.rating2 {
    width: 37px
}

.rating3 {
    width: 57px
}

.rating4 {
    width: 77px
}

.rating5 {
    width: 97px
}

.review-container {
    border-top: #e4e4e4 1px solid
}

.review-editor-review {
    padding-top: 21px;
    margin-bottom: -30px
}

.review-item {
    padding-top: 21px;
    padding-bottom: 20px;
    padding-left: 55px
}

.review-item:before,.review-item:after {
    content: " ";
    display: table
}

.review-item:after {
    clear: both
}

.review-item-user {
    margin-right: -7px
}

.review-item-user>div {
    display: inline-block;
    vertical-align: top;
    margin-right: 7px;
    margin-bottom: 3px
}

.review-item-photo {
    width: 40px;
    float: left;
    margin-left: -55px;
    margin-top: 3px
}

.review-item-photo img {
    width: 100%;
    border-radius: 40px
}

.review-item-detail {
    color: #a6a6a6;
    font-weight: bold
}

.review-item-order {
    font-weight: bold
}

.review-item-rating.pull-right {
    margin-right: 4px
}

.review-item-text {
    margin-top: 5px
}

.review-item-answer {
    display: inline-block;
    padding: 16px 20px;
    background: #f5f5f5;
    border-radius: 4px;
    position: relative
}

.bg-light-style .review-item-answer {
    background: hsl(0,0%,95.0784313725%)
}

.review-item-text,.review-item-answer {
    word-wrap: break-word;
    word-break: break-word
}

@media(max-width: 767px) {
    .review-item {
        padding-left:0
    }

    .review-item-user {
        padding-left: 55px;
        margin-right: 0;
        margin-bottom: 5px
    }

    .review-item-user:before,.review-item-user:after {
        content: " ";
        display: table
    }

    .review-item-user:after {
        clear: both
    }

    .review-item-user>div {
        display: block;
        margin-right: 0
    }

    .review-item-rating {
        margin-top: 3px
    }
}

.dyn-table-filter .filter-text {
    display: inline-block;
    min-width: 7.5em;
    text-align: left
}

.review-rating {
    display: inline-block;
    color: #f8e71c
}

.review-rating a {
    font-size: 30px;
    color: inherit;
    text-decoration: none;
    outline: none;
    padding: 0 6px
}

.review-rating a:first-child {
    padding-left: 0
}

.review-rating a:last-child {
    padding-right: 0
}

.review-rating span {
    font-size: 16px
}

@media(min-width: 768px) {
    .review-empty-text {
        margin-left:-55px
    }
}

.reviews-filter {
    position: relative
}

.reviews-filter .dropdown-toggle {
    padding-left: 0;
    padding-right: 0
}

.reviews-filter .dropdown-toggle .filter-text {
    min-width: unset
}

.reviews-filter .dropdown-menu {
    min-width: initial;
    width: 100%;
    left: inherit
}

.reviews-filter .dropdown-menu .review-rating>.rating {
    background: none
}

.reviews-filter .review-rating {
    position: relative;
    top: 2px
}

.review-controls {
    margin-top: 15px
}

.review-item>.review-item-row {
    margin-bottom: 20px
}

.review-item>.review-item-row:last-child {
    margin-bottom: 0
}

.with-corner-cd {
    position: relative
}

.with-corner-cd .wrapper {
    position: relative
}

.navbar-brand>img.logo-white {
    display: none
}

.with-corner-cd .navbar-brand>img.logo-white {
    display: block
}

.with-corner-cd .navbar-brand>img.logo-color {
    display: none
}

.with-corner-cd .navbar-default,.with-corner-cd .navbar-form .form-control {
    background: rgba(0,0,0,0)
}

.with-corner-cd .back-link a {
    color: #fff
}

.corner-cd-container {
    width: 100%;
    height: 450px;
    position: absolute;
    left: 0;
    right: 0;
    overflow: hidden
}

.corner-cd {
    width: 715px;
    height: 715px;
    position: absolute;
    z-index: -1;
    right: 50%;
    margin-right: 352px;
    bottom: 100%;
    margin-bottom: -293px;
    border-radius: 500px;
    overflow: hidden
}

.corner-cd img {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 100
}

.corner-cd:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 200;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) 85%, rgba(0, 0, 0, 0.8) 100%)
}

@media(max-width: 1199px) {
    .corner-cd {
        margin-right:270px
    }
}

@media(max-width: 991px) {
    .corner-cd {
        margin-right:140px
    }
}

@media(max-width: 767px) {
    .corner-cd {
        margin-right:0;
        right: auto;
        margin-bottom: -132px;
        left: 0;
        margin-left: -275px
    }

    .with-corner-cd .navbar-default {
        background: #fff
    }

    .with-corner-cd .navbar-brand>img.logo-color {
        display: block
    }

    .with-corner-cd .navbar-brand>img.logo-white {
        display: none
    }
}

.back-link {
    margin-top: 32px
}

.back-link a {
    display: inline-block;
    padding-left: 25px;
    min-height: 2.857142858em;
    line-height: 2.657142858;
    position: relative;
    font-weight: bold
}

.back-link .inside {
    display: inline-block;
    vertical-align: middle;
    line-height: 1.428571429
}

.back-link i {
    position: absolute;
    left: 2px;
    top: 50%;
    transform: translate(0, -50%)
}

@media(max-width: 767px) {
    .back-link {
        max-width:200px;
        margin-top: 22px;
        margin-bottom: 15px
    }

    body:not(.with-corner-cd) .product-page .back-link {
        margin-bottom: -15px
    }
}

.page-content {
    padding-top: 30px;
    padding-bottom: 30px
}

.product-page .page-content {
    padding-right: 12px
}

@media(max-width: 767px) {
    .page-content-custom {
        padding-bottom:0
    }
}

.page-content-full {
    padding-top: 40px;
    padding-bottom: 30px
}

.param-item {
    margin-bottom: 25px
}

.param-item .h1 {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif
}

.payment {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    padding-right: 8px
}

.dropdown-menu .payment {
    padding-right: 24px
}

.payment .payment-logo {
    margin-right: 8px
}

.selectpicker-option-normal {
    font-weight: normal
}

.payment-title {
    width: 46.57534246%;
    font-weight: normal;
    flex-grow: 2
}

.payment-value {
    width: 22.73972603%;
    text-align: right;
    font-weight: bold;
    flex-grow: 1
}

.btn .payment-logo,.btn .payment-title,.btn .payment-value {
    overflow: hidden
}

@media(max-width: 1199px) {
    .product-page .page-content {
        padding-left:0;
        padding-right: 0
    }
}

@media(max-width: 767px) {
    .page-content-full {
        padding-top:27px
    }

    .payment-value {
        width: 38%
    }

    .payment-title {
        display: block;
        width: 62%
    }
}

@media(min-width: 992px) {
    .product-page-with-chat {
        min-height:630px
    }

    .product-page>.row {
        position: relative
    }

    .product-page>.row>div {
        position: static
    }

    .chat-float-container {
        position: absolute;
        right: 0;
        top: 13px;
        width: 41.6666666667%;
        padding-left: 15px;
        padding-right: 15px
    }
}

.seller-promo {
    width: 250px;
    margin-left: auto;
    margin-right: auto
}

.seller-promo .rating-stars {
    font-size: 24px;
    letter-spacing: 8px;
    margin-right: -8px;
    margin-bottom: 11px
}

.seller-promo-title,.seller-promo-desc {
    margin-bottom: 14px
}

.seller-promo .rating {
    margin-bottom: 15px
}

.seller-promo-note {
    color: #a6a6a6
}

.payment-card {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    margin: 30px 0
}

.payment-card .payment-title {
    display: inline-block;
    width: 100%
}

.payment-row .payment-logo {
    display: inline-block;
    vertical-align: 1px
}

.payment-row .payment-title {
    display: inline;
    width: auto;
    white-space: nowrap
}

@media(max-width: 767px) {
    .payment-card {
        margin-top:0;
        margin-left: -10px;
        margin-right: -10px;
        padding: 20px 10px;
        border-radius: 0
    }
}

.profile-cover-container {
    position: absolute;
    bottom: 0;
    left: -150px;
    right: -150px;
    width: auto;
    overflow: hidden;
    padding-top: 100%;
    border-radius: 50%
}



.profile-cover {
    position: relative;
    overflow: hidden;
    margin-left: -30px;
    margin-right: -30px;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 63px
}

.profile-cover:before,.profile-cover:after {
    content: " ";
    display: table
}

.profile-cover:after {
    clear: both
}

.avatar {
    float: left;
    position: relative;
    z-index: 100
}


.avatar-photo:before {
    content: "";
    display: block;
    width: 100%;
    padding-bottom: 100%
}

.avatar-photo a {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    border-radius: 50%
}

.avatar .avatar-photo {
    width: 170px;
    height: 170px
}

.edit-avatar {
    position: absolute;
    top: 3px;
    right: 3px
}

.edit-cover {
    float: right;
    margin-right: 60px;
    position: relative;
    z-index: 200
}

@media(max-width: 1280px) {
    .profile-cover {
        padding-left:15px;
        padding-right: 15px;
        margin-left: -15px;
        margin-right: -15px
    }

    .profile-cover-container {
        left: -140px;
        right: -140px
    }
}

@media(max-width: 1199px) {
    .profile-cover {
        padding-left:30px;
        padding-right: 30px;
        margin-left: -30px;
        margin-right: -30px
    }

    .profile-cover-container {
        left: -90px;
        right: -90px
    }
}

@media(max-width: 1050px) {
    .profile-cover {
        padding-left:15px;
        padding-right: 15px;
        margin-left: -15px;
        margin-right: -15px
    }

    .profile-cover-container {
        left: -80px;
        right: -80px
    }
}

@media(max-width: 991px) {
    .profile-cover {
        padding-left:35px;
        padding-right: 35px;
        margin-left: -35px;
        margin-right: -35px
    }

    .profile-cover-container {
        left: -35px;
        right: -35px
    }
}

@media(max-width: 820px) {
    .profile-cover {
        padding-left:15px;
        padding-right: 15px;
        margin-left: -15px;
        margin-right: -15px
    }

    .profile-cover-container {
        left: -28px;
        right: -28px
    }
}

@media(max-width: 991px) {
    .profile-cover {
        padding-top:30px
    }

    .edit-cover {
        margin-right: 0
    }
}

@media(max-width: 767px) {
    .profile-cover {
        padding-top:33px;
        margin-left: 0;
        margin-right: 0;
        padding-left: 0;
        padding-right: 0
    }

    .profile-cover-container {
        left: 0;
        right: 0
    }

    .avatar .avatar-photo {
        width: 70px;
        height: 70px
    }
}

.profile {
    margin-top: 30px
}

.achievement-item {
    margin-top: 5px
}

.achievement-icon {
    display: inline-block;
    width: 20px;
    margin-right: 2px;
    text-align: center
}

.profile-header-cols {
    display: flex;
    flex-wrap: wrap;
    gap: 0 80px;
    margin-bottom: 10px
}

.profile-header-cols .param-item {
    margin-bottom: 15px
}

.profile .rating-value {
    margin-left: -2px;
    margin-top: 4px
}

.profile .rating-full {
    margin-right: 15px;
    margin-top: 4px;
    margin-left: -24px
}

.rating-full-count {
    display: inline-block;
    font-weight: bold
}

.offer {
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 13px
}

.offer .tc {
    margin-bottom: 0
}

.btn-plus {
    width: 33px;
    height: 33px;
    padding: 7px
}

.btn-plus .inside {
    position: relative;
    top: -1px
}

.offer-tc-container {
    border-top: #eaeaea 1px solid
}

.offer-tc-container .tc {
    padding-bottom: 0
}

@media(max-width: 767px) {
    .profile {
        margin-top:17px
    }

    .profile-header-cols {
        gap: 0 30px
    }

    .profile-header-col-rating {
        width: 100%
    }

    .rating-full-count {
        display: block;
        margin-top: 12px
    }

    .rating-full-count br {
        display: none
    }

    .offer {
        padding-right: 16px
    }

    .offer .tc-header>div {
        padding-bottom: 12px
    }
}

.offer-controls {
    margin-top: 20px;
    margin-bottom: 9px
}

@media(min-width: 992px) {
    .offer-controls {
        margin-left:15px;
        margin-top: -4px;
        margin-bottom: 0
    }
}

@media(min-width: 1200px) {
    .offer-controls {
        margin-left:25px
    }
}

.setting-group {
    padding: 30px 0
}

.setting-group+.setting-group {
    border-top: 1px solid #eaeaea
}

.setting-item {
    margin-bottom: 40px
}

.setting-item:last-child {
    margin-bottom: 0
}

.setting-item h3,.setting-item .h3 {
    margin-top: 0
}

.setting-item .btn {
    width: 209px
}

.setting-item .btn-gray,.setting-item .btn-gray:hover,.setting-item .btn-gray:focus,.setting-item .btn-gray:active {
    color: #222
}

.setting-buttons {
    padding-left: 0;
    list-style: none;
    padding: 0;
    margin: 0
}

.setting-buttons li {
    margin-top: 8px
}

.setting-buttons li:first-child {
    margin-top: 0
}

.setting-photo {
    width: 115px;
    margin-bottom: 20px;
    font-size: 45px;
    color: #fff
}

.setting-photo .avatar-photo {
    background-color: #4384d0;
    background-image: none
}


.setting-photo img,.setting-photo i {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%)
}

@media(min-width: 768px) {
    .setting-item {
        padding-left:140px
    }

    .setting-item:before,.setting-item:after {
        content: " ";
        display: table
    }

    .setting-item:after {
        clear: both
    }

    .setting-photo {
        float: left;
        margin-left: -140px;
        margin-bottom: 0
    }
}

.modal-auth .nav-tabs {
    font-size: 23px;
    font-weight: normal;
    margin-top: -22px;
    margin-bottom: 15px
}

.modal-auth .nav-tabs>li>a {
    padding: 15px 0
}

.modal-auth .nav-tabs>li:last-child {
    float: right
}

.social-login {
    margin-right: -10px
}

.social-login-item {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    margin-right: 10px;
    background: #eee;
    border: none;
    border-radius: 50%;
    width: 74px;
    height: 74px;
    line-height: 74px;
    text-align: center;
    font-size: 28px
}

.social-login-item-google {
    background: #fff;
    border: 1px solid #777
}

.social-login-item-google svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%
}

.social-login-item-google:hover,.social-login-item-google:focus,.social-login-item-google:active {
    background: #fcfcfc
}

.social-login-item-vk {
    background: #07f
}

.social-login-item-vk svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 36px;
    height: 36px
}

.social-login-item-vk:hover,.social-login-item-vk:focus,.social-login-item-vk:active {
    background: #0071f2
}

.success-icon {
    margin-top: 3px;
    font-size: 74px
}

@media(max-width: 767px) {
    .modal-auth .nav-tabs {
        font-size:21px
    }

    .modal-auth .nav-tabs>li {
        margin-right: 5%
    }

    .modal-auth .nav-tabs>li:last-child {
        margin-right: 0;
        float: left
    }

    .social-login-item {
        width: 64px;
        height: 64px;
        line-height: 64px
    }

    .social-login-item-vk svg {
        width: 32px;
        height: 32px
    }
}

.balances-header .balances-list {
    font-size: .8em
}

.balances-header .balances-list .balances-delimiter {
    margin: 0 14px;
    color: #888
}

.balances-header .balances-list .balances-value {
    display: inline-block;
    white-space: nowrap
}

@media(max-width: 480px) {
    .balances-header .balances-list {
        display:block;
        margin-top: 10px;
        font-size: .7em
    }

    .balances-header .balances-list .balances-delimiter {
        display: none
    }

    .balances-header .balances-list .balances-value {
        display: block;
        margin-top: 6px
    }
}

.finance-controls:before,.finance-controls:after {
    content: " ";
    display: table
}

.finance-controls:after {
    clear: both
}

.finance-controls .pull-right {
    padding-left: 3px
}

.tc-finance {
    border-bottom: #eaeaea 1px solid
}

.tc-finance .tc-header>div,.tc-finance .tc-item>div {
    padding-top: 16px;
    padding-bottom: 17px;
    border-top: #eaeaea 1px solid;
    height: auto
}

.tc-finance .tc-header>div {
    border-bottom: none
}

.tc-finance .payment-logo {
    display: inline-block;
    margin: -6px 0
}

.tc-finance .tc-item>div.tc-go {
    width: 2.66666667%;
    text-align: right;
    font-size: 16px;
    line-height: 1.25;
    color: #4384d0
}

.tc-finance .tc-go i {
    position: relative;
    top: 1px
}

.tc-finance .tc-date-time {
    margin-right: 4px
}

.tc-finance .tc-payment-number {
    white-space: nowrap
}

.tc-finance .tc-date-left,.tc-finance .tc-txn-obj-info,.tc-finance .tc-payment-number {
    color: #a6a6a6
}

.tc-finance .tc-title,.tc-finance .tc-payment-number {
    margin-right: 10px
}

.tc-finance .tc-title a {
    color: #222
}

.tc-finance .dyn-table-body {
    display: table-row-group
}

.tc-finance .tc-item .tc-status {
    font-weight: bold
}

@media(max-width: 767px) {
    .tc-finance {
        display:block;
        border-top: #eaeaea 1px solid
    }

    .tc-finance .tc-header {
        width: 100%;
        display: table
    }

    .tc-finance .tc-header>div,.tc-finance .tc-header>[class^=col-],.tc-finance .tc-header>[class*=" col-"] {
        padding-top: 15px;
        padding-bottom: 14px;
        float: left;
        border-top: none
    }

    .tc-finance .tc-header>div.tc-price {
        float: right
    }

    .tc-finance .tc-item {
        border-top: #eaeaea 1px solid;
        display: block;
        position: relative;
        padding-top: 11px;
        padding-bottom: 12px
    }

    .tc-finance .tc-item:before,.tc-finance .tc-item:after {
        content: " ";
        display: table
    }

    .tc-finance .tc-item:after {
        clear: both
    }

    .tc-finance .tc-item>div {
        display: block;
        border-top: none
    }

    .tc-finance .tc-item>div {
        padding-top: 4px;
        padding-bottom: 4px
    }

    .tc-finance .tc-item .tc-status,.tc-finance .tc-item .tc-price {
        float: left;
        width: 50%
    }

    .tc-finance .tc-title {
        display: block
    }

    .tc-finance .tc-txn-obj-info,.tc-finance .tc-payment-number {
        display: inline-block;
        margin-top: 8px
    }

    .tc-finance .tc-item>div.tc-go {
        position: absolute;
        right: 0;
        top: 12px;
        width: auto
    }

    .tc-finance .tc-order {
        font-weight: bold
    }

    .tc-finance .tc-date-time,.tc-finance .tc-date-left {
        display: inline-block
    }

    .tc-finance .dyn-table-body {
        display: block
    }
}

@media(max-width: 480px) {
    .tc-finance .tc-item .tc-desc {
        margin-right:0
    }
}

.selling-min {
    margin-top: 32px;
    margin-bottom: 30px
}

.selling-min.affix {
    position: static
}

@media(min-width: 992px) {
    .selling-min.affix {
        position:fixed;
        top: 13px;
        margin-top: 0
    }

    .selling-min.affix-bottom {
        position: absolute
    }

    .selling-min.affix,.selling-min.affix-bottom {
        width: 187px
    }
}

@media(min-width: 1200px) {
    .selling-min.affix,.selling-min.affix-bottom {
        width:225px
    }
}

.tooltip-inner {
    white-space: pre-line
}

.help-tooltip {
    display: inline-block;
    vertical-align: middle;
    margin-top: -3px;
    line-height: 18px;
    font-size: 18px
}

.help-tooltip a,.help-tooltip i {
    display: block;
    text-decoration: none
}

.popover {
    box-shadow: none
}

.popover>.arrow,.popover>.arrow:after {
    border-left-width: 20px;
    border-right-width: 20px
}

.popover.bottom>.arrow,.popover.top>.arrow {
    margin-left: -20px
}

.popover.bottom>.arrow:after,.popover.top>.arrow:after {
    margin-left: -20px
}

.popover h5,.popover .h5 {
    color: #222
}

.popover.bottom {
    margin-top: 19px
}

.popover-content {
    padding: 16px 17px
}

.tc-selling {
    margin-bottom: 17px
}

.tc-selling .help-block {
    margin-top: 0;
    margin-bottom: 0;
    display: inline
}

.tc-selling .help-block.complete {
    color: #222
}

.tc-selling-divider {
    height: 5px
}

.tc-selling .tc-item>div {
    height: auto
}

.tc-selling .tc-item>div.tc-input {
    padding-top: 4px;
    padding-bottom: 16px
}

.tc-selling .tc-item>div.tc-checkbox,.tc-selling .tc-item>div.tc-server,.tc-selling .tc-item>div.tc-side {
    padding-top: 3px;
    padding-bottom: 5px
}

@media(max-width: 767px) {
    .fixed-btn {
        position:fixed;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        padding: 9px 10px;
        border-top: #e4e4e4 1px solid;
        z-index: 1020
    }

    .tc-selling .tc-header>div,.tc-selling .tc-header>[class^=col-],.tc-selling .tc-header>[class*=" col-"],.tc-selling .tc-item>div,.tc-selling .tc-item>[class^=col-],.tc-selling .tc-item>[class*=" col-"] {
        padding-right: 0;
        padding-left: 8px
    }

    .tc-selling .tc-header>div:first-child,.tc-selling .tc-header>[class^=col-]:first-child,.tc-selling .tc-header>[class*=" col-"]:first-child,.tc-selling .tc-item>div:first-child,.tc-selling .tc-item>[class^=col-]:first-child,.tc-selling .tc-item>[class*=" col-"]:first-child {
        padding-left: 0
    }

    .tc-selling .tc-header>div.tc-server {
        padding-left: 0
    }

    .tc-selling .form-group {
        margin-top: 0;
        margin-bottom: 0
    }

    .catalog-price.help-block {
        margin-top: 5px;
        width: 200%;
        font-size: 12px
    }
}

#footer {
    padding-top: 24px;
    padding-bottom: 26px;
    border-top: #e4e4e4 1px solid;
    display: flex;
    align-items: center
}

.footer-block {
    flex-shrink: 0;
    white-space: nowrap;
    margin-left: 30px
}

.footer-block:first-child {
    margin-left: 0
}

.footer-block-strings {
    flex: 1 1 auto;
    white-space: normal
}

.footer-block-strings>span,.footer-block-strings>a {
    display: inline-block;
    margin-right: 20px
}

.footer-block-social a {
    font-size: 24px;
    font-weight: normal;
    margin-left: 5px
}

.footer-block-social a:first-child {
    margin-left: 0
}

.footer-block-als {
    display: flex
}

.footer-block-als img {
    width: 100px;
    height: 45px;
    margin-right: 12px
}

.footer-block-als div {
    display: inline-block;
    font-size: 10px
}

@media(max-width: 767px) {
    #footer {
        display:block
    }

    .footer-block {
        margin-left: 0;
        margin-top: 20px
    }

    .footer-block:first-child {
        margin-top: 0
    }
}

.modal-footer {
    padding-top: 0
}

.modal-actions {
    padding-top: 25px;
    text-align: right;
    border-top: 1px solid rgba(0,0,0,0)
}

.modal-actions .btn+.btn {
    margin-left: 5px;
    margin-bottom: 0
}

.modal-dialog {
    margin: 0
}

.modal-dialog .close {
    outline: none;
    position: absolute;
    top: -40px;
    right: 0;
    color: #fff;
    font-size: 36px;
    opacity: 1;
    filter: alpha(opacity=100)
}

.modal-dialog .close:hover,.modal-dialog .close:focus {
    opacity: 1;
    filter: alpha(opacity=100);
    color: hsl(0,0%,90%)
}

.modal-dialog .close i:before {
    content: "×"
}

.modal-content {
    border-radius: 4px 4px 0 0;
    box-shadow: none
}

@media(max-width: 767px) {
    .modal-header,.modal-body,.modal-footer {
        padding-left:10px;
        padding-right: 10px
    }

    .modal-dialog {
        width: 100%;
        height: 100%;
        padding-top: 80px
    }

    .modal-dialog .close {
        top: 0;
        right: 0;
        left: 0;
        width: 100%;
        height: 80px;
        text-align: right;
        padding-right: 20px
    }

    .modal-content {
        min-height: 100%
    }

    .modal-open .modal {
        padding-left: 0 !important;
        padding-right: 0 !important
    }
}

@media(min-width: 768px) {
    .modal {
        text-align:center
    }

    .modal:after {
        display: inline-block;
        vertical-align: middle;
        height: 100%;
        margin-left: -0.05em;
        content: ""
    }

    .modal-dialog {
        display: inline-block;
        vertical-align: top;
        text-align: left;
        margin: 45px 0;
        max-width: 94%
    }

    .modal-content {
        border-radius: 4px
    }
}

.modal-header>.h1 {
    margin-bottom: 0
}

.image-item+.image-item {
    margin-top: 37px
}

.descending .caret {
    transform: rotate(180deg);
    position: relative;
    top: -1px
}

.no-padding {
    padding: 0
}

#global-origin {
    position: relative
}

#site-message {
    position: fixed;
    z-index: 5000;
    font-size: 1.1em;
    padding: .8em 1em;
    margin: 0;
    white-space: pre-line;
    display: none
}

#db-log {
    margin-bottom: 20px;
    padding: .5em;
    border: 1px solid #ddd;
    background-color: #f4f1ec;
    font-size: 12px;
    font-family: Menlo,Monaco,Consolas,"Courier New",monospace
}

#db-log>div {
    margin-top: .5em
}

#db-log>div:first-child {
    margin-top: 0
}

textarea {
    resize: vertical
}

.fa-margin-left {
    margin-left: 5px
}

.param-list>hr {
    margin-top: 0;
    margin-bottom: 25px
}

.param-list .param-item {
    word-wrap: break-word
}

.lot-fields {
    display: inline
}

.sort>a {
    white-space: nowrap
}

.profile-container {
    margin-top: 44px;
    margin-bottom: 18px
}

.profile-data-container {
    margin-top: -24px
}

.profile-data-container .offer-list-title-container {
    display: flex;
    align-items: center;
    margin-bottom: 15px
}

.profile-data-container .offer-list-title-container .offer-list-title {
    flex-grow: 1
}

.profile-data-container .offer-list-title-container .offer-list-title h3 {
    font-family: "Graphik Bold","Helvetica Neue",Helvetica,Arial,sans-serif;
    margin-bottom: 0
}

.profile-data-container .offer-list-title-container .offer-list-title-button {
    padding-left: 20px
}

table.values {
    border-collapse: collapse;
    border: 0;
    padding: 0;
    margin: 0
}

table.values>tbody>tr>* {
    vertical-align: baseline;
    text-align: left;
    padding: .6em 0 0 1.2em
}

table.values>tbody>tr:first-child>* {
    padding-top: 0
}

table.values>tbody>tr.top>* {
    vertical-align: top
}

table.values>tbody>tr>th {
    padding-left: 0;
    font-weight: bold;
    color: #888;
    white-space: nowrap
}

table.values>tbody>tr>th.wrap {
    white-space: normal
}

ul.user-gates {
    padding: 0;
    margin: 0;
    list-style: none
}

ul.user-gates li {
    margin-top: 10px;
    white-space: nowrap
}

ul.user-gates li:first-child {
    margin-top: 0
}

ul.user-gates li .pic,ul.user-gates li .body {
    display: inline-block;
    vertical-align: middle
}

ul.user-gates li .pic {
    margin-right: 10px
}

ul.user-gates li .pic img {
    display: inline-block;
    width: 36px;
    height: 36px;
    border-radius: 5px;
    background: hsl(0,0%,93.5%)
}

ul.user-gates li .body {
    line-height: 1.15
}

ul.user-gates li .name {
    font-size: 1.3em
}

ul.user-gates li .email {
    color: #888
}

.profile-operator-block {
    margin-bottom: 44px
}

.margin-top {
    margin-top: 20px
}

.margin-bottom {
    margin-bottom: 20px
}

.margin-bottom-half {
    margin-bottom: 10px
}

.modal-body {
    overflow-x: hidden
}

.guess-rating table .player {
    width: 100%
}

.guess-rating table .pos,.guess-rating table .points,.guess-rating table .prize {
    text-align: right
}

.guess-rating td {
    white-space: nowrap
}

.modal .guess-rating {
    margin-top: 20px
}

.modal .guess-rating:first-child {
    margin-top: 0
}

.modal .guess-rating h3,.modal .guess-rating h4 {
    margin-top: 0
}

.modal .guess-rating table {
    margin-bottom: 0
}

.guess-box div.image {
    width: 360px;
    height: 360px
}

.guess-box .btn {
    margin-right: 10px
}

.guess-box .online {
    color: #a6a6a6
}

.guess-box .tab-game {
    font-size: 1.3em
}

.guess-box .tab-game td {
    vertical-align: top
}

.guess-box .tab-game td.right {
    padding-left: 20px;
    white-space: nowrap
}

.guess-box .tab-game ul {
    list-style: none;
    padding: 0;
    margin: 20px 0 0
}

.guess-box .tab-game li.img {
    padding: 2px 0 3px
}

.guess-box .tab-game li.img a {
    display: block;
    height: 20px;
    float: left;
    overflow: hidden
}

.guess-box .tab-game li.img a img {
    display: block
}

.guess-box .tab-game li.img a img:hover {
    margin-top: -20px
}

.guess-box .ratings {
    margin-top: 20px
}

.guess-box .ratings .guess-rating {
    float: left;
    margin-right: 40px
}

.guess-box .ratings .guess-rating table {
    width: 300px
}

body.vk-z-index .navbar-static-top {
    z-index: 999
}

body.vk-z-index .modal-backdrop {
    z-index: 1000
}

body.vk-z-index .modal {
    z-index: 1001
}

.no-margin-bottom {
    margin-bottom: 0
}

.no-margin-top {
    margin-top: 0
}

.mw150 {
    min-width: 150px
}

.input-group-btn .btn {
    border: 1px solid #e4e4e4 !important
}

table.exchange-rates-edit {
    margin-bottom: 20px
}

table.exchange-rates-edit td {
    vertical-align: middle;
    padding: 8px
}

table.exchange-rates-edit td:first-child {
    padding-left: 0
}

.pb20 {
    padding-bottom: 20px
}

.monospace {
    font-family: Menlo,Monaco,Consolas,"Courier New",monospace
}

.masked-links a {
    color: inherit
}

.ajax-alert {
    padding: 20px;
    border-radius: 4px
}

.ajax-alert-danger {
    background-color: rgb(249.36,224.52,227.64);
    color: #f52323
}

.ajax-alert-info {
    background-color: rgb(236.2,242.7,250.3);
    color: rgb(46.9,92.4,145.6)
}

h1 .user-badges {
    position: relative;
    top: -2px
}

.w100 {
    width: 100px
}

.w200p {
    width: 200%
}

.blur {
    opacity: .5
}

.callout {
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #e4e4e4;
    border-left-width: 5px;
    border-radius: 3px
}

.callout.callout-info {
    border-left-color: #4384d0
}

.callout.callout-warning {
    border-left-color: #f5a623
}

.callout.callout-danger {
    border-left-color: #d0011b
}

.cd-click {
    position: absolute;
    background: none;
    z-index: 551;
    margin-top: 0
}

.cd-small {
    width: 400px;
    height: 400px
}

.pr10 {
    padding-right: 10px
}

.menu-img-blur {
    filter: brightness(0.5)
}

.chat-btn-image {
    border: none;
    color: #a6a6a6;
    font-size: 27px;
    padding: 0 5px;
    margin: -5px 0
}

.chat-btn-image,.chat-btn-image:hover,.chat-btn-image:focus,.chat-btn-image:active,.chat-btn-image:active:hover,.chat-btn-image:active:focus {
    background: none
}

.modal {
    -webkit-overflow-scrolling: auto
}

.modal-lightbox .link-original-box {
    margin-top: 12px
}

.drop-area {
    display: flex;
    align-items: center;
    min-height: 200px;
    color: #888;
    font-size: 17px;
    border: 2px dashed #888;
    border-radius: 5px
}

.drop-area.hover {
    background: #f9f9f9
}

.drop-area.error {
    background: #ffd8d9
}

.drop-area .drop-area-hint {
    pointer-events: none;
    width: 100%;
    text-align: center;
    padding: 20px
}

.drop-area .drop-area-hint i {
    display: block;
    font-size: 40px;
    margin-bottom: 10px
}

.crop-save {
    float: right
}

label.payment-method {
    width: 100%
}

label.payment-method span {
    float: right
}

.w100 {
    width: 100px
}


.payment-logo.payment-method-1 {
    background-position: -345px -94px
}

.payment-logo.payment-method-2 {
    background-position: -345px -34px
}

.payment-logo.payment-method-3 {
    background-position: -345px -64px
}

.payment-logo.payment-method-4 {
    background-position: -345px -64px
}

.payment-logo.payment-method-5 {
    background-position: -345px -64px
}

.payment-logo.payment-method-6 {
    background-position: -345px -64px
}

.payment-logo.payment-method-7 {
    background-position: -345px -4px
}

.payment-logo.payment-method-8 {
    background-position: -345px -124px
}

.payment-logo.payment-method-9 {
    background-position: -345px -154px
}

.payment-logo.payment-method-10 {
    background-position: -345px -64px
}

.payment-logo.payment-method-11 {
    background-position: -345px -4px
}

.payment-logo.payment-method-12 {
    background-position: -345px -274px
}

.payment-logo.payment-method-13 {
    background-position: -345px -304px
}

.payment-logo.payment-method-14 {
    background-position: -345px -244px
}

.payment-logo.payment-method-15 {
    background-position: -345px -4px
}

.payment-logo.payment-method-16 {
    background-position: -345px -4px
}

.payment-logo.payment-method-17 {
    background-position: -345px -244px
}

.payment-logo.payment-method-18 {
    background-position: -345px -244px
}

.payment-logo.payment-method-19 {
    background-position: -345px -154px
}

.payment-logo.payment-method-20 {
    background-position: -345px -154px
}

.payment-logo.payment-method-21 {
    background-position: -345px -364px
}

.payment-logo.payment-method-22 {
    background-position: -345px -274px
}

.payment-logo.payment-method-23 {
    background-position: -345px -274px
}

.payment-logo.payment-method-24 {
    background-position: -345px -214px
}

.payment-logo.payment-method-25 {
    background-position: -345px -4px
}

.payment-logo.payment-method-26 {
    background-position: -345px -4px
}

.payment-logo.payment-method-27 {
    background-position: -345px -4px
}

.payment-logo.payment-method-28 {
    background-position: -345px -304px
}

.payment-logo.payment-method-29 {
    background-position: -345px -304px
}

.payment-logo.payment-method-30 {
    background-position: -375px -4px
}

.payment-logo.payment-method-31 {
    background-position: -375px -34px
}

.payment-logo.payment-method-32 {
    background-position: -345px -4px
}

.payment-logo.payment-method-33 {
    background-position: -345px -4px
}

.payment-logo.payment-method-34 {
    background-position: -345px -4px
}

.payment-logo.payment-method-35 {
    background-position: -345px -4px
}

.payment-logo.payment-method-36 {
    background-position: -345px -184px
}

.payment-logo.payment-method-37 {
    background-position: -345px -4px
}

.payment-logo.payment-method-38 {
    background-position: -345px -4px
}

.payment-logo.payment-method-39 {
    background-position: -345px -4px
}

.payment-logo.payment-method-40 {
    background-position: -345px -4px
}

.payment-logo.payment-method-41 {
    background-position: -375px -64px
}

.payment-logo.payment-method-card_eur {
    background-position: -345px -4px
}

.payment-logo.payment-method-card_rub {
    background-position: -345px -4px
}

.payment-logo.payment-method-card_uah {
    background-position: -345px -4px
}

.payment-logo.payment-method-card_usd {
    background-position: -345px -4px
}

.payment-logo.payment-method-fps {
    background-position: -345px -364px
}

.payment-logo.payment-method-paypal {
    background-position: -345px -184px
}

.payment-logo.payment-method-qiwi {
    background-position: -345px -94px
}

.payment-logo.payment-method-wme {
    background-position: -345px -64px
}

.payment-logo.payment-method-wmp {
    background-position: -345px -64px
}

.payment-logo.payment-method-wmr {
    background-position: -345px -64px
}

.payment-logo.payment-method-wmz {
    background-position: -345px -64px
}

.payment-logo.payment-method-yandex {
    background-position: -345px -34px
}

.payment-logo.payment-method-usdt_trc {
    background-position: -375px -64px
}

.payment-logo.payment-method-binance_usdc {
    background-position: -375px -34px
}

.payment-logo.payment-method-binance_usdt {
    background-position: -375px -34px
}

.withdraw-select .dropdown-menu {
    width: 100%
}

.orders-table .order-desc {
    word-wrap: break-word;
    word-break: break-word
}

.orders-filter {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px
}

.orders-filter .form-group {
    margin-bottom: 0
}

.orders-filter .filter-text {
    width: 11em
}

.orders-filter .filter-range {
    width: 8em
}

@media(max-width: 767px) {
    .w100 {
        width:100%
    }
}

.panel-heading-buttons {
    display: inline-block;
    margin-left: 15px
}

.panel-heading-buttons button,.panel-heading-buttons .btn {
    vertical-align: top;
    margin: -2px 0 -5px 0
}

@media(max-width: 767px) {
    .panel-heading-buttons button span,.panel-heading-buttons .btn span {
        display:none
    }
}

.lot-field .lot-field-range {
    width: 6em;
    display: inline-block
}

.lot-field .lot-field-radio-box {
    margin-bottom: -4px
}

.lot-field .lot-field-radio-box button {
    margin-bottom: 4px
}

@media(min-width: 768px) {
    .lot-field .lot-field-range-box {
        display:inline-block;
        vertical-align: middle
    }
}

.modal-upload-preview img.preview {
    display: block;
    width: 100%;
    height: 200px;
    object-fit: contain;
    background-color: hsl(0,0%,93.5%)
}

@media(min-width: 768px) {
    .form-inline-margins .form-group {
        margin-right:10px
    }

    .form-inline-margins .form-group label {
        margin-right: 5px
    }
}

.withdraw-box .slave {
    background-color: #f5f5f5
}

.withdraw-box .slave:hover {
    background-color: #fff
}

.withdraw-box .preview .wallet {
    word-wrap: break-word;
    word-break: break-word
}

.transaction-values {
    word-break: break-word
}

.transaction-status-complete .transaction-status {
    color: #7ed320
}

.transaction-status-waiting .transaction-status {
    color: #f5a623
}

.transaction-status-cancel .transaction-status {
    color: #f52323
}

.table>thead>tr>td.transaction-status-waiting,.table>thead>tr>th.transaction-status-waiting,.table>thead>tr.transaction-status-waiting>td,.table>thead>tr.transaction-status-waiting>th,.table>tbody>tr>td.transaction-status-waiting,.table>tbody>tr>th.transaction-status-waiting,.table>tbody>tr.transaction-status-waiting>td,.table>tbody>tr.transaction-status-waiting>th,.table>tfoot>tr>td.transaction-status-waiting,.table>tfoot>tr>th.transaction-status-waiting,.table>tfoot>tr.transaction-status-waiting>td,.table>tfoot>tr.transaction-status-waiting>th {
    background-color: rgb(254.09,251.88,225.49)
}

.table-hover>tbody>tr>td.transaction-status-waiting:hover,.table-hover>tbody>tr>th.transaction-status-waiting:hover,.table-hover>tbody>tr.transaction-status-waiting:hover>td,.table-hover>tbody>tr:hover>.transaction-status-waiting,.table-hover>tbody>tr.transaction-status-waiting:hover>th {
    background-color: hsl(55.3636363636,94.0170940171%,89.0352941176%)
}

.tc.table-hover .tc-item.transaction-status-waiting {
    background-color: rgb(254.09,251.88,225.49)
}

.tc.table-hover .tc-item.transaction-status-waiting:hover {
    background-color: hsl(55.3636363636,94.0170940171%,89.0352941176%)
}

.nav-pills>li,.nav-pills>li+li {
    margin-bottom: 0
}

form div.captcha {
    display: block;
    height: 80px;
    margin-bottom: 1em;
    line-height: 80px;
    vertical-align: middle
}

form div.captcha img {
    width: 180px;
    height: 80px;
    vertical-align: bottom;
    cursor: pointer
}

form div.captcha span {
    margin-left: 1em;
    cursor: pointer;
    color: #a6a6a6
}

form div.captcha span:hover {
    color: #222
}

table.table-controls tbody>tr>td {
    vertical-align: middle
}

table.table-controls div.checkbox {
    margin-top: 0;
    margin-bottom: 0
}

table.table-controls div.checkbox label {
    vertical-align: bottom
}

table.table-controls select.form-control {
    width: auto
}

.table-sortable .sort,.tc-sortable .sort {
    cursor: pointer
}

.table-sortable .sort .fa,.tc-sortable .sort .fa {
    margin-left: 1px;
    vertical-align: -1px
}

.table-sortable .sort .fa:before,.tc-sortable .sort .fa:before {
    content: ""
}

.table-sortable .sort.descending .fa,.tc-sortable .sort.descending .fa {
    vertical-align: -1px
}

.table-sortable .sort.descending .fa:before,.tc-sortable .sort.descending .fa:before {
    content: ""
}

.table-sortable .sort.ascending .fa,.tc-sortable .sort.ascending .fa {
    vertical-align: 0
}

.table-sortable .sort.ascending .fa:before,.tc-sortable .sort.ascending .fa:before {
    content: ""
}

.table-sortable .sort.loading .fa,.tc-sortable .sort.loading .fa {
    color: #a6a6a6
}

.main-container {
    padding-top: 20px;
    padding-bottom: 80px
}

.security-challenge {
    max-width: 400px;
    margin: 0 auto
}

.security-challenge h1 {
    margin-bottom: 20px
}

.search-fade {
    background: #000;
    position: absolute;
    left: 0;
    top: 61px;
    width: 100%;
    height: 100%;
    opacity: .5;
    z-index: 900;
    display: none
}

.js-price-row i {
    font-size: 12px
}

.layout-swap {
    display: table;
    table-layout: fixed;
    width: 100%
}

.layout-swap>div {
    display: table-row-group
}

.layout-swap>div:first-child {
    display: table-footer-group
}

.layout-swap .content-with-cd-wide.tbl-footer {
    padding-top: 0
}

.layout-swap>.with-tbl-footer .content-with-cd-wide.showcase {
    padding-bottom: 20px;
    border-bottom-right-radius: 0
}

.layout-swap>.with-tbl-footer .content-with-cd-wide.showcase .tc {
    margin-bottom: 0
}

.layout-swap.layout-swap-disabled>div {
    display: table-row-group
}

.content-lots-node .layout-swap .content-with-cd-wide.tbl-footer {
    border-top-right-radius: 0
}

@media(max-width: 767px) {
    .layout-swap>.with-tbl-footer .content-with-cd-wide.showcase {
        padding-bottom:14px
    }
}

.container.nested-menu+.container .page-content-full {
    padding-top: 0;
    margin-top: 20px
}

.lazyload-hidden {
    display: none !important
}

@media(max-width: 767px) {
    .btn-block-mobile {
        display:block;
        width: 100%
    }

    .btn-block-mobile+.btn-block-mobile {
        margin-top: 5px
    }

    .modal-footer .btn-block-mobile+.btn-block-mobile,.modal-actions .btn-block-mobile+.btn-block-mobile {
        margin-left: 0
    }
}

@media(min-width: 768px) {
    .modal-offer-editor .modal-dialog {
        width:540px
    }
}

.order-log-table th:first-child,.order-log-table td:first-child {
    padding-left: 0
}

.order-log-table th:last-child,.order-log-table td:last-child {
    padding-right: 0
}

.order-log-table .order-log-actor {
    width: 37%;
    min-width: 50px;
    max-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
}

.order-log-table .ip-info .pseudo-a {
    color: #a6a6a6;
    text-decoration: none
}

.order-log-table .ip-info .pseudo-a:hover,.order-log-table .ip-info .pseudo-a:focus {
    color: #a6a6a6;
    text-decoration: underline
}

@media(min-width: 480px) {
    .order-log-table {
        white-space:nowrap
    }
}

.account-blocked-box .h5 {
    margin-top: 20px
}

.account-blocked-comment {
    padding: 10px 16px;
    background: #f5f5f5;
    border-radius: 4px;
    max-width: 100%;
    word-wrap: break-word
}

@media(min-width: 480px) {
    .account-blocked-comment {
        display:inline-block;
        min-width: 250px
    }
}

.account-blocked-comment.balance-claim-box {
    font-size: 10px
}

.table-site-rules td:first-child,.table-site-rules th:first-child {
    width: 60%;
    padding-left: 0
}

.table-site-rules td:last-child,.table-site-rules th:last-child {
    width: 40%;
    padding-right: 0
}

.modal-custom-bg-block {
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 17px;
    margin-bottom: 0
}

.modal .modal-custom-bg-block {
    margin-left: -25px;
    margin-right: -25px
}

@media(max-width: 767px) {
    .modal-custom-bg-block {
        padding-left:10px;
        padding-right: 10px
    }

    .modal .modal-custom-bg-block {
        margin-left: -10px;
        margin-right: -10px
    }
}

.modal-custom-bg-block.modal-custom-bg-block-top {
    padding-top: 17px
}

.modal-custom-bg-block .help-block {
    margin-bottom: 0
}

.lot-fields-multilingual {
    border-bottom: 1px solid #d8d8d8;
    margin-bottom: 17px
}

.lot-fields-multilingual .nav-tabs {
    font-size: 14px
}

.lot-fields-multilingual .nav-tabs a {
    padding-top: 0;
    padding-bottom: 8px
}



@media(max-width: 1400px) {
    .note-choose-server {
        display:none
    }
}

.note-choose-server:lang(ru),.note-choose-server:lang(uk) {
    display: none
}

.payment-hold-box blockquote {
    margin: 10px 0
}

.payment-hold-box blockquote em {
    color: #a6a6a6;
    font-style: normal
}

.payment-hold-box img {
    border-radius: 4px
}

.ip-info {
    cursor: pointer
}

.ip-info .label {
    top: -0.125em;
    position: relative
}

.ip-info .pseudo-a {
    color: #4384d0;
    text-decoration: none
}

.ip-info .pseudo-a:hover,.ip-info .pseudo-a:focus {
    color: rgb(39.7,94.6042553191,158.8);
    text-decoration: underline
}

.ip-info-popover .label {
    top: -0.125em;
    position: relative
}

.relation-cases {
    cursor: pointer;
    color: #4384d0;
    text-decoration: none
}

.relation-cases:hover,.relation-cases:focus {
    color: rgb(39.7,94.6042553191,158.8);
    text-decoration: underline
}

.relation-cases-details {
    word-break: break-word
}

.relation-cases-details .relation-cases-category:not(:last-child) {
    padding-bottom: 20px
}

.modal-cookie-consent .panel-title {
    font-size: 12px
}

.modal-cookie-consent .checkbox-indent {
    margin-left: 24px
}

.banner-cookie-consent {
    position: fixed;
    bottom: 8px;
    z-index: 1030;
    background-color: rgb(209.8,225.4276595745,243.7);
    padding: 12px 18px;
    border-radius: 4px
}

@media(max-width: 767px) {
    .banner-cookie-consent {
        bottom:0;
        left: 0;
        right: 0;
        padding: 10px;
        border-radius: 0
    }

    .banner-cookie-consent .cc-text {
        margin-bottom: 10px
    }
}

@media(min-width: 768px) {
    .banner-cookie-consent {
        width:720px;
        display: flex;
        align-items: center
    }

    .banner-cookie-consent .cc-text {
        flex: 1 1 auto
    }

    .banner-cookie-consent .cc-buttons {
        margin-left: 50px
    }

    .banner-cookie-consent .cc-buttons .btn {
        float: right;
        margin: 4px 0 4px 8px
    }
}

@media(min-width: 992px) {
    .banner-cookie-consent {
        margin-left:20px;
        width: 900px
    }

    .banner-cookie-consent .cc-buttons {
        flex-shrink: 0
    }
}

@media(min-width: 1200px) {
    .banner-cookie-consent {
        margin-left:112.5px
    }
}

.cursor-pointer {
    cursor: pointer
}

.form-two-factor .secret-box {
    font-size: 17px;
    white-space: nowrap
}

.form-two-factor .secret-placeholder {
    font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
    margin-right: .4em
}

.table-payments-admin .text-clipped-s,.table-payments-admin .text-clipped-l {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.table-payments-admin .text-clipped-s {
    max-width: 10em
}

.table-payments-admin .text-clipped-l {
    max-width: 15em
}

.textarea-lot-secrets {
    font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
    white-space: pre;
    word-wrap: normal
}

.order-secrets-box {
    background: #d8f0bc;
    padding: 20px;
    border-radius: 4px;
    color: #222
}

.order-secrets-box h5 {
    color: #222
}

.order-secrets-list {
    padding-left: 0;
    list-style: none;
    font-size: 16px;
    margin-bottom: 0
}

.order-secrets-list li+li {
    margin-top: .4em
}

.order-secrets-list .secret-placeholder {
    font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
    margin-right: .4em
}

.auto-dlv-icon {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    color: #4384d0
}

.auto-dlv-icon:before {
    content: ""
}

.offer-header-auto-dlv-label {
    font-size: 15px;
    margin-top: .6em
}

.promo-offer-icon {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    color: #f5a623
}

.promo-offer-icon:before {
    content: ""
}

.qr-code-box {
    width: 150px;
    height: 150px;
    display: block
}

@media(max-width: 767px) {
    .details-editor .btn-link {
        padding-left:0;
        padding-right: 0
    }

    .details-editor .detail-data {
        margin-top: 5px;
        margin-bottom: 5px
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FunPayOrder/style.css"],"names":[],"mappings":";;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IAErB;AACJ;;AAEA;IACI,6DAA6D;IAE7D;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IAErB;AACJ;;AAEA;IACI,6DAA6D;IAE7D;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IAErB;AACJ;;AAEA;IACI,kDAAkD;IAElD;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB,aAAa;QACb,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;IACtB,+BAA+B;IAC/B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IAGzB;AACJ;;AAEA;IACI,0CAA0C;IAC1C;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IAEtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IAEzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,gDAAgD;IAChD;AACJ;;AAEA;IACI,WAAW;IACX,gDAAgD;IAChD;AACJ;;AAEA;IACI,WAAW;IACX,gDAAgD;IAChD;AACJ;;AAEA;IACI,WAAW;IACX,iDAAiD;IACjD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,iEAAiE;IACjE;AACJ;;AAEA;IACI,WAAW;IACX,iEAAiE;IACjE;AACJ;;AAEA;IACI,WAAW;IACX,iEAAiE;IACjE;AACJ;;AAEA;IACI,WAAW;IACX,iEAAiE;IACjE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,kEAAkE;IAClE;AACJ;;AAEA;IACI,WAAW;IACX,kEAAkE;IAClE;AACJ;;AAEA;IACI,WAAW;IACX,kEAAkE;IAClE;AACJ;;AAEA;IACI,WAAW;IACX,kEAAkE;IAClE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,iEAAiE;IACjE;AACJ;;AAEA;IACI,WAAW;IACX,iEAAiE;IACjE;AACJ;;AAEA;IACI,WAAW;IACX,iEAAiE;IACjE;AACJ;;AAEA;IACI,WAAW;IACX,iEAAiE;IACjE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,+DAA+D;IAC/D;AACJ;;AAEA;IACI,WAAW;IACX,+DAA+D;IAC/D;AACJ;;AAEA;IACI,WAAW;IACX,+DAA+D;IAC/D;AACJ;;AAEA;IACI,WAAW;IACX,+DAA+D;IAC/D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI,+BAA+B;IAE/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IAGV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAEhB,sCAAsC;IAEtC,yBAAyB;IAEzB;AACJ;;AAEA;IACI,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;IACrC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAElB,uCAAuC;IACvC;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,sBAAsB;IACtB,mEAAmE;IACnE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,OAAO;IACP;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,sBAAsB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,OAAO;QACP;IACJ;;IAEA;QACI,OAAO;QACP;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,yBAAyB;IACzB;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,+BAA+B;IAC/B;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,+BAA+B;IAC/B,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;IACnC,4CAA4C;IAC5C;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,UAAU;QACV,aAAa;QACb;IACJ;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;QACvB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,OAAO;IACP;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,MAAM;IACN;AACJ;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;IAC/B,sBAAsB;IACtB,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,WAAW;QACX,aAAa;QACb,+BAA+B;QAC/B,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;IACnC,sCAAsC;IAEtC,uEAAuE;IACvE,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB,aAAa;QACb,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,SAAS;QACT,cAAc;QACd,eAAe;QACf,cAAc;QACd,iBAAiB;QAEjB;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B;AACJ;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,iCAAiC;IACjC;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,MAAM;IACN;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,wBAAwB;IACxB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAGlB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAYA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAElB;AACJ;;AAEA;IACI,WAAW;IACX,SAAS;IACT,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IAEzB,0CAA0C;IAG1C;AACJ;;AAEA;IAGI,qMAAqM;IACrM;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,MAAM,CAAC;AACX;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;IAC/B,kBAAkB;IAElB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B;AACJ;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,2CAA2C;IAC3C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,2CAA2C;IAC3C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,0CAA0C;IAC1C,kBAAkB;IAElB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC;AACJ;;AAEA;IAII,6BAA6B;IAI7B;AACJ;;AAEA;IAII;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,+BAA+B;IAC/B,kBAAkB;IAElB,oCAAoC;IACpC,4BAA4B;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;;IAEA;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,wDAAwD;IACxD,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B;AACJ;;AAEA;IACI,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,uBAAuB;IACvB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,SAAS;IACT,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,gBAAgB;IAChB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,QAAQ;IACR,QAAQ;IACR,gBAAgB;IAChB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,MAAM;IACN,SAAS;IACT,iBAAiB;IACjB,uBAAuB;IACvB;AACJ;;AAEA;IACI,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,wDAAwD;IACxD,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAElB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,0CAA0C;IAC1C,+CAA+C;IAC/C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB;AACJ;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAGlB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI;QAII,qCAAqC;QAGrC,2BAA2B;QAG3B;IACJ;;IAEA;QAEI,kCAAkC;QAClC;IACJ;;IAEA;QAEI,mCAAmC;QACnC;IACJ;;IAEA;QAEI,+BAA+B;QAC/B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC;AACJ;;AAEA;IAGI,8FAA8F;IAC9F,2BAA2B;IAC3B;AACJ;;AAEA;IACI,UAAU;IACV,QAAQ;IAGR,8FAA8F;IAC9F,2BAA2B;IAC3B;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,UAAU;IACV;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,SAAS;QACT,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAMA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;;;EAKE;AACF;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,qDAAqD;IACrD;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IAGf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,UAAU;IACV,SAAS;IACT,gBAAgB;IAEhB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IAGzB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IAEzB,2CAA2C;IAC3C,oBAAoB;IACpB,WAAW;IAGX;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAI7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,qCAAqC;IACrC,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,uCAAuC;IACvC;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,0BAA0B;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IAGX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IAGX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,WAAW;QACX,eAAe;QACf,kBAAkB;QAIlB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,MAAM;QACN,gBAAgB;QAChB,kBAAkB;QAClB,iCAAiC;QACjC,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,sBAAsB;IACtB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,+BAA+B;IAC/B;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,+BAA+B;IAC/B,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,gCAAgC;IAChC,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IAEI;AACJ;;;;;AAKA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,8CAA8C;IAE9C;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,4CAA4C;IAE5C;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,uEAAuE;IACvE,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,OAAO;QACP,QAAQ;QACR,MAAM;QACN,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAElB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;IACb,gBAAgB;IAEhB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,kBAAkB;QAElB,qCAAqC;QACrC,gBAAgB;QAChB,UAAU;QACV,YAAY;QACZ,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IAKI;AACJ;;AAEA;IAII,yBAAyB;IACzB;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX;AACJ;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,UAAU;IAEV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,gBAAgB;QAEhB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,uEAAuE;IACvE;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,SAAS;IACT,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,SAAS;IACT,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,SAAS;QACT,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI,uBAAuB;QACvB,yBAAyB;QACzB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,8BAA8B;QAC9B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,+BAA+B;IAC/B,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,kCAAkC;IAClC,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,0BAA0B;IAC1B;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wDAAwD;IACxD;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,WAAW;QAGX;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,eAAe;QACf,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI,qBAAqB;IACrB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;;;;AAKA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN;AACJ;;;;AAIA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,qBAAqB;QACrB,OAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;;;AAIA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;;AAGA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,eAAe;QACf;IACJ;;IAEA;QACI,OAAO;QACP;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,cAAc;QACd,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,OAAO;QACP,QAAQ;QACR,SAAS;QACT,gBAAgB;QAChB,iBAAiB;QACjB,6BAA6B;QAC7B;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,eAAe;QACf,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,eAAe;IACf,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAE1B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,sBAAsB;QACtB,YAAY;QACZ,oBAAoB;QACpB;IACJ;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,gBAAgB;QAChB,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uEAAuE;IACvE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,2CAA2C;IAC3C;AACJ;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;;;AAIA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,iDAAiD;IACjD,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,QAAQ;QACR,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,0DAA0D;IAC1D;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0DAA0D;IAC1D,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0DAA0D;IAC1D;AACJ;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;QACI,cAAc;QACd;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;AACJ","sourcesContent":["\n\n.radio+.radio,.checkbox+.checkbox {\n    margin-top: -5px\n}\n\n.radio-inline,.checkbox-inline {\n    position: relative;\n    display: inline-block;\n    padding-left: 20px;\n    margin-bottom: 0;\n    vertical-align: middle;\n    font-weight: normal;\n    cursor: pointer\n}\n\n.radio-inline+.radio-inline,.checkbox-inline+.checkbox-inline {\n    margin-top: 0;\n    margin-left: 10px\n}\n\ninput[type=radio][disabled],input[type=radio].disabled,fieldset[disabled] input[type=radio],input[type=checkbox][disabled],input[type=checkbox].disabled,fieldset[disabled] input[type=checkbox] {\n    cursor: not-allowed\n}\n\n.radio-inline.disabled,fieldset[disabled] .radio-inline,.checkbox-inline.disabled,fieldset[disabled] .checkbox-inline {\n    cursor: not-allowed\n}\n\n.radio.disabled label,fieldset[disabled] .radio label,.checkbox.disabled label,fieldset[disabled] .checkbox label {\n    cursor: not-allowed\n}\n\n.form-control-static {\n    padding-top: 9px;\n    padding-bottom: 9px;\n    margin-bottom: 0;\n    min-height: 34px\n}\n\n.form-control-static.input-lg,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.form-control-static.input-sm,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.input-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn {\n    height: 30px;\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px\n}\n\nselect.input-sm,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,.input-group-sm>.input-group-btn>select.btn {\n    height: 30px;\n    line-height: 30px\n}\n\ntextarea.input-sm,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,.input-group-sm>.input-group-btn>textarea.btn,select[multiple].input-sm,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>.input-group-btn>select[multiple].btn {\n    height: auto\n}\n\n.form-group-sm .form-control {\n    height: 30px;\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px\n}\n\n.form-group-sm select.form-control {\n    height: 30px;\n    line-height: 30px\n}\n\n.form-group-sm textarea.form-control,.form-group-sm select[multiple].form-control {\n    height: auto\n}\n\n.form-group-sm .form-control-static {\n    height: 30px;\n    min-height: 32px;\n    padding: 6px 10px;\n    font-size: 12px;\n    line-height: 1.5\n}\n\n.input-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn {\n    height: 45px;\n    padding: 10px 16px;\n    font-size: 17px;\n    line-height: 1.3333333;\n    border-radius: 3px\n}\n\nselect.input-lg,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,.input-group-lg>.input-group-btn>select.btn {\n    height: 45px;\n    line-height: 45px\n}\n\ntextarea.input-lg,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,.input-group-lg>.input-group-btn>textarea.btn,select[multiple].input-lg,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>.input-group-btn>select[multiple].btn {\n    height: auto\n}\n\n.form-group-lg .form-control {\n    height: 45px;\n    padding: 10px 16px;\n    font-size: 17px;\n    line-height: 1.3333333;\n    border-radius: 3px\n}\n\n.form-group-lg select.form-control {\n    height: 45px;\n    line-height: 45px\n}\n\n.form-group-lg textarea.form-control,.form-group-lg select[multiple].form-control {\n    height: auto\n}\n\n.form-group-lg .form-control-static {\n    height: 45px;\n    min-height: 37px;\n    padding: 11px 16px;\n    font-size: 17px;\n    line-height: 1.3333333\n}\n\n.has-feedback {\n    position: relative\n}\n\n.has-feedback .form-control {\n    padding-right: 47.5px\n}\n\n.form-control-feedback {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    display: block;\n    width: 38px;\n    height: 38px;\n    line-height: 38px;\n    text-align: center;\n    pointer-events: none\n}\n\n.input-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-group-lg+.form-control-feedback,.form-group-lg .form-control+.form-control-feedback {\n    width: 45px;\n    height: 45px;\n    line-height: 45px\n}\n\n.input-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-group-sm+.form-control-feedback,.form-group-sm .form-control+.form-control-feedback {\n    width: 30px;\n    height: 30px;\n    line-height: 30px\n}\n\n.has-success .help-block,.has-success .control-label,.has-success .radio,.has-success .checkbox,.has-success .radio-inline,.has-success .checkbox-inline,.has-success.radio label,.has-success.checkbox label,.has-success.radio-inline label,.has-success.checkbox-inline label {\n    color: #7ed320\n}\n\n.has-success .form-control {\n    border-color: #7ed320;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075)\n}\n\n.has-success .form-control:focus {\n    border-color: rgb(99.5555555556,166.7160493827,25.2839506173);\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px hsl(88.4916201117,73.6625514403%,67.6470588235%);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px hsl(88.4916201117,73.6625514403%,67.6470588235%)\n}\n\n.has-success .input-group-addon {\n    color: #7ed320;\n    border-color: #7ed320;\n    background-color: rgb(235.65,248.4,221.55)\n}\n\n.has-success .form-control-feedback {\n    color: #7ed320\n}\n\n.has-warning .help-block,.has-warning .control-label,.has-warning .radio,.has-warning .checkbox,.has-warning .radio-inline,.has-warning .checkbox-inline,.has-warning.radio label,.has-warning.checkbox label,.has-warning.radio-inline label,.has-warning.checkbox-inline label {\n    color: #f5a623\n}\n\n.has-warning .form-control {\n    border-color: #f5a623;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075)\n}\n\n.has-warning .form-control:focus {\n    border-color: rgb(219.0434782609,140.3869565217,9.9565217391);\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px hsl(37.4285714286,91.3043478261%,74.9019607843%);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px hsl(37.4285714286,91.3043478261%,74.9019607843%)\n}\n\n.has-warning .input-group-addon {\n    color: #f5a623;\n    border-color: #f5a623;\n    background-color: rgb(254.09,251.88,225.49)\n}\n\n.has-warning .form-control-feedback {\n    color: #f5a623\n}\n\n.has-error .help-block,.has-error .control-label,.has-error .radio,.has-error .checkbox,.has-error .radio-inline,.has-error .checkbox-inline,.has-error.radio label,.has-error.checkbox label,.has-error.radio-inline label,.has-error.checkbox-inline label {\n    color: #f52323\n}\n\n.has-error .form-control {\n    border-color: #f52323;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075)\n}\n\n.has-error .form-control:focus {\n    border-color: hsl(0,91.3043478261%,44.9019607843%);\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px hsl(0,91.3043478261%,74.9019607843%);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px hsl(0,91.3043478261%,74.9019607843%)\n}\n\n.has-error .input-group-addon {\n    color: #f52323;\n    border-color: #f52323;\n    background-color: rgb(249.36,224.52,227.64)\n}\n\n.has-error .form-control-feedback {\n    color: #f52323\n}\n\n.has-feedback label~.form-control-feedback {\n    top: 25px\n}\n\n.has-feedback label.sr-only~.form-control-feedback {\n    top: 0\n}\n\n.help-block {\n    display: block;\n    margin-top: 5px;\n    margin-bottom: 10px;\n    color: rgb(97.75,97.75,97.75)\n}\n\n@media(min-width: 768px) {\n    .form-inline .form-group {\n        display:inline-block;\n        margin-bottom: 0;\n        vertical-align: middle\n    }\n\n    .form-inline .form-control {\n        display: inline-block;\n        width: auto;\n        vertical-align: middle\n    }\n\n    .form-inline .form-control-static {\n        display: inline-block\n    }\n\n    .form-inline .input-group {\n        display: inline-table;\n        vertical-align: middle\n    }\n\n    .form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn,.form-inline .input-group .form-control {\n        width: auto\n    }\n\n    .form-inline .input-group>.form-control {\n        width: 100%\n    }\n\n    .form-inline .control-label {\n        margin-bottom: 0;\n        vertical-align: middle\n    }\n\n    .form-inline .radio,.form-inline .checkbox {\n        display: inline-block;\n        margin-top: 0;\n        margin-bottom: 0;\n        vertical-align: middle\n    }\n\n    .form-inline .radio label,.form-inline .checkbox label {\n        padding-left: 0\n    }\n\n    .form-inline .radio input[type=radio],.form-inline .checkbox input[type=checkbox] {\n        position: relative;\n        margin-left: 0\n    }\n\n    .form-inline .has-feedback .form-control-feedback {\n        top: 0\n    }\n}\n\n.form-horizontal .radio,.form-horizontal .checkbox,.form-horizontal .radio-inline,.form-horizontal .checkbox-inline {\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-top: 9px\n}\n\n.form-horizontal .radio,.form-horizontal .checkbox {\n    min-height: 29px\n}\n\n.form-horizontal .form-group {\n    margin-left: -15px;\n    margin-right: -15px\n}\n\n.form-horizontal .form-group:before,.form-horizontal .form-group:after {\n    content: \" \";\n    display: table\n}\n\n.form-horizontal .form-group:after {\n    clear: both\n}\n\n@media(min-width: 768px) {\n    .form-horizontal .control-label {\n        text-align:right;\n        margin-bottom: 0;\n        padding-top: 9px\n    }\n}\n\n.form-horizontal .has-feedback .form-control-feedback {\n    right: 15px\n}\n\n@media(min-width: 768px) {\n    .form-horizontal .form-group-lg .control-label {\n        padding-top:11px;\n        font-size: 17px\n    }\n}\n\n@media(min-width: 768px) {\n    .form-horizontal .form-group-sm .control-label {\n        padding-top:6px;\n        font-size: 12px\n    }\n}\n\n.btn {\n    display: inline-block;\n    margin-bottom: 0;\n    font-weight: bold;\n    text-align: center;\n    vertical-align: middle;\n    touch-action: manipulation;\n    cursor: pointer;\n    background-image: none;\n    border: 1px solid rgba(0,0,0,0);\n    white-space: nowrap;\n    padding: 8px 12px;\n    font-size: 14px;\n    line-height: 1.428571429;\n    border-radius: 4px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none\n}\n\n.btn:focus,.btn.focus,.btn:active:focus,.btn:active.focus,.btn.active:focus,.btn.active.focus {\n    outline: 5px auto -webkit-focus-ring-color;\n    outline-offset: -2px\n}\n\n.btn:hover,.btn:focus,.btn.focus {\n    color: #4384d0;\n    text-decoration: none\n}\n\n.btn:active,.btn.active {\n    outline: 0;\n    background-image: none;\n    -webkit-box-shadow: inset 0 3px 5px rgba(0,0,0,.125);\n    box-shadow: inset 0 3px 5px rgba(0,0,0,.125)\n}\n\n.btn.disabled,.btn[disabled],fieldset[disabled] .btn {\n    cursor: not-allowed;\n    opacity: .65;\n    filter: alpha(opacity=65);\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\na.btn.disabled,fieldset[disabled] a.btn {\n    pointer-events: none\n}\n\n.btn-default {\n    color: #4384d0;\n    background-color: #fff;\n    border-color: #e4e4e4\n}\n\n.btn-default:focus,.btn-default.focus {\n    color: #4384d0;\n    background-color: hsl(0,0%,90%);\n    border-color: #ccc\n}\n\n.btn-default:hover {\n    color: #4384d0;\n    background-color: hsl(0,0%,90%);\n    border-color: hsl(0,0%,88%)\n}\n\n.btn-default:active,.btn-default.active,.open>.btn-default.dropdown-toggle {\n    color: #4384d0;\n    background-color: hsl(0,0%,90%);\n    border-color: hsl(0,0%,88%)\n}\n\n.btn-default:active:hover,.btn-default:active:focus,.btn-default:active.focus,.btn-default.active:hover,.btn-default.active:focus,.btn-default.active.focus,.open>.btn-default.dropdown-toggle:hover,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle.focus {\n    color: #4384d0;\n    background-color: hsl(0,0%,83%);\n    border-color: #ccc\n}\n\n.btn-default:active,.btn-default.active,.open>.btn-default.dropdown-toggle {\n    background-image: none\n}\n\n.btn-default.disabled:hover,.btn-default.disabled:focus,.btn-default.disabled.focus,.btn-default[disabled]:hover,.btn-default[disabled]:focus,.btn-default[disabled].focus,fieldset[disabled] .btn-default:hover,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default.focus {\n    background-color: #fff;\n    border-color: #e4e4e4\n}\n\n.btn-default .badge {\n    color: #fff;\n    background-color: #4384d0\n}\n\n.btn-primary {\n    color: #fff;\n    background-color: #4384d0;\n    border-color: #4384d0\n}\n\n.btn-primary:focus,.btn-primary.focus {\n    color: #fff;\n    background-color: rgb(44.8,106.7574468085,179.2);\n    border-color: rgb(34.6,82.4510638298,138.4)\n}\n\n.btn-primary:hover {\n    color: #fff;\n    background-color: rgb(44.8,106.7574468085,179.2);\n    border-color: rgb(42.76,101.8961702128,171.04)\n}\n\n.btn-primary:active,.btn-primary.active,.open>.btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: rgb(44.8,106.7574468085,179.2);\n    border-color: rgb(42.76,101.8961702128,171.04)\n}\n\n.btn-primary:active:hover,.btn-primary:active:focus,.btn-primary:active.focus,.btn-primary.active:hover,.btn-primary.active:focus,.btn-primary.active.focus,.open>.btn-primary.dropdown-toggle:hover,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle.focus {\n    color: #fff;\n    background-color: rgb(37.66,89.7429787234,150.64);\n    border-color: rgb(34.6,82.4510638298,138.4)\n}\n\n.btn-primary:active,.btn-primary.active,.open>.btn-primary.dropdown-toggle {\n    background-image: none\n}\n\n.btn-primary.disabled:hover,.btn-primary.disabled:focus,.btn-primary.disabled.focus,.btn-primary[disabled]:hover,.btn-primary[disabled]:focus,.btn-primary[disabled].focus,fieldset[disabled] .btn-primary:hover,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary.focus {\n    background-color: #4384d0;\n    border-color: #4384d0\n}\n\n.btn-primary .badge {\n    color: #4384d0;\n    background-color: #fff\n}\n\n.btn-success {\n    color: #fff;\n    background-color: #7ed320;\n    border-color: #7ed320\n}\n\n.btn-success:focus,.btn-success.focus {\n    color: #fff;\n    background-color: rgb(99.5555555556,166.7160493827,25.2839506173);\n    border-color: rgb(73.1111111111,122.4320987654,18.5679012346)\n}\n\n.btn-success:hover {\n    color: #fff;\n    background-color: rgb(99.5555555556,166.7160493827,25.2839506173);\n    border-color: rgb(94.2666666667,157.8592592593,23.9407407407)\n}\n\n.btn-success:active,.btn-success.active,.open>.btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: rgb(99.5555555556,166.7160493827,25.2839506173);\n    border-color: rgb(94.2666666667,157.8592592593,23.9407407407)\n}\n\n.btn-success:active:hover,.btn-success:active:focus,.btn-success:active.focus,.btn-success.active:hover,.btn-success.active:focus,.btn-success.active.focus,.open>.btn-success.dropdown-toggle:hover,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle.focus {\n    color: #fff;\n    background-color: rgb(81.0444444444,135.7172839506,20.5827160494);\n    border-color: rgb(73.1111111111,122.4320987654,18.5679012346)\n}\n\n.btn-success:active,.btn-success.active,.open>.btn-success.dropdown-toggle {\n    background-image: none\n}\n\n.btn-success.disabled:hover,.btn-success.disabled:focus,.btn-success.disabled.focus,.btn-success[disabled]:hover,.btn-success[disabled]:focus,.btn-success[disabled].focus,fieldset[disabled] .btn-success:hover,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success.focus {\n    background-color: #7ed320;\n    border-color: #7ed320\n}\n\n.btn-success .badge {\n    color: #7ed320;\n    background-color: #fff\n}\n\n.btn-info {\n    color: #fff;\n    background-color: #5bc0de;\n    border-color: #5bc0de\n}\n\n.btn-info:focus,.btn-info.focus {\n    color: #fff;\n    background-color: rgb(48.5431472081,175.6903553299,213.4568527919);\n    border-color: rgb(35.345177665,143.5228426396,175.654822335)\n}\n\n.btn-info:hover {\n    color: #fff;\n    background-color: rgb(48.5431472081,175.6903553299,213.4568527919);\n    border-color: rgb(42.1796954315,171.2751269036,209.6203045685)\n}\n\n.btn-info:active,.btn-info.active,.open>.btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: rgb(48.5431472081,175.6903553299,213.4568527919);\n    border-color: rgb(42.1796954315,171.2751269036,209.6203045685)\n}\n\n.btn-info:active:hover,.btn-info:active:focus,.btn-info:active.focus,.btn-info.active:hover,.btn-info.active:focus,.btn-info.active.focus,.open>.btn-info.dropdown-toggle:hover,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle.focus {\n    color: #fff;\n    background-color: rgb(37.9081218274,153.9299492386,188.3918781726);\n    border-color: rgb(35.345177665,143.5228426396,175.654822335)\n}\n\n.btn-info:active,.btn-info.active,.open>.btn-info.dropdown-toggle {\n    background-image: none\n}\n\n.btn-info.disabled:hover,.btn-info.disabled:focus,.btn-info.disabled.focus,.btn-info[disabled]:hover,.btn-info[disabled]:focus,.btn-info[disabled].focus,fieldset[disabled] .btn-info:hover,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info.focus {\n    background-color: #5bc0de;\n    border-color: #5bc0de\n}\n\n.btn-info .badge {\n    color: #5bc0de;\n    background-color: #fff\n}\n\n.btn-warning {\n    color: #fff;\n    background-color: #f5a623;\n    border-color: #f5a623\n}\n\n.btn-warning:focus,.btn-warning.focus {\n    color: #fff;\n    background-color: rgb(219.0434782609,140.3869565217,9.9565217391);\n    border-color: rgb(170.2608695652,109.1217391304,7.7391304348)\n}\n\n.btn-warning:hover {\n    color: #fff;\n    background-color: rgb(219.0434782609,140.3869565217,9.9565217391);\n    border-color: rgb(209.2869565217,134.1339130435,9.5130434783)\n}\n\n.btn-warning:active,.btn-warning.active,.open>.btn-warning.dropdown-toggle {\n    color: #fff;\n    background-color: rgb(219.0434782609,140.3869565217,9.9565217391);\n    border-color: rgb(209.2869565217,134.1339130435,9.5130434783)\n}\n\n.btn-warning:active:hover,.btn-warning:active:focus,.btn-warning:active.focus,.btn-warning.active:hover,.btn-warning.active:focus,.btn-warning.active.focus,.open>.btn-warning.dropdown-toggle:hover,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle.focus {\n    color: #fff;\n    background-color: rgb(184.8956521739,118.5013043478,8.4043478261);\n    border-color: rgb(170.2608695652,109.1217391304,7.7391304348)\n}\n\n.btn-warning:active,.btn-warning.active,.open>.btn-warning.dropdown-toggle {\n    background-image: none\n}\n\n.btn-warning.disabled:hover,.btn-warning.disabled:focus,.btn-warning.disabled.focus,.btn-warning[disabled]:hover,.btn-warning[disabled]:focus,.btn-warning[disabled].focus,fieldset[disabled] .btn-warning:hover,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning.focus {\n    background-color: #f5a623;\n    border-color: #f5a623\n}\n\n.btn-warning .badge {\n    color: #f5a623;\n    background-color: #fff\n}\n\n.btn-danger {\n    color: #fff;\n    background-color: #d0011b;\n    border-color: #d0011b\n}\n\n.btn-danger:focus,.btn-danger.focus {\n    color: #fff;\n    background-color: rgb(157.2440191388,.7559808612,20.4114832536);\n    border-color: rgb(106.4880382775,.5119617225,13.8229665072)\n}\n\n.btn-danger:hover {\n    color: #fff;\n    background-color: rgb(157.2440191388,.7559808612,20.4114832536);\n    border-color: rgb(147.0928229665,.7071770335,19.0937799043)\n}\n\n.btn-danger:active,.btn-danger.active,.open>.btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: rgb(157.2440191388,.7559808612,20.4114832536);\n    border-color: rgb(147.0928229665,.7071770335,19.0937799043)\n}\n\n.btn-danger:active:hover,.btn-danger:active:focus,.btn-danger:active.focus,.btn-danger.active:hover,.btn-danger.active:focus,.btn-danger.active.focus,.open>.btn-danger.dropdown-toggle:hover,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle.focus {\n    color: #fff;\n    background-color: rgb(121.7148325359,.5851674641,15.7995215311);\n    border-color: rgb(106.4880382775,.5119617225,13.8229665072)\n}\n\n.btn-danger:active,.btn-danger.active,.open>.btn-danger.dropdown-toggle {\n    background-image: none\n}\n\n.btn-danger.disabled:hover,.btn-danger.disabled:focus,.btn-danger.disabled.focus,.btn-danger[disabled]:hover,.btn-danger[disabled]:focus,.btn-danger[disabled].focus,fieldset[disabled] .btn-danger:hover,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger.focus {\n    background-color: #d0011b;\n    border-color: #d0011b\n}\n\n.btn-danger .badge {\n    color: #d0011b;\n    background-color: #fff\n}\n\n.btn-link {\n    color: #4384d0;\n    font-weight: normal;\n    border-radius: 0\n}\n\n.btn-link,.btn-link:active,.btn-link.active,.btn-link[disabled],fieldset[disabled] .btn-link {\n    background-color: rgba(0,0,0,0);\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\n.btn-link,.btn-link:hover,.btn-link:focus,.btn-link:active {\n    border-color: rgba(0,0,0,0)\n}\n\n.btn-link:hover,.btn-link:focus {\n    color: rgb(39.7,94.6042553191,158.8);\n    text-decoration: underline;\n    background-color: rgba(0,0,0,0)\n}\n\n.btn-link[disabled]:hover,.btn-link[disabled]:focus,fieldset[disabled] .btn-link:hover,fieldset[disabled] .btn-link:focus {\n    color: hsl(0,0%,46.7%);\n    text-decoration: none\n}\n\n.btn-lg,.btn-group-lg>.btn {\n    padding: 10px 16px;\n    font-size: 17px;\n    line-height: 1.3333333;\n    border-radius: 6px\n}\n\n.btn-sm,.btn-group-sm>.btn {\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px\n}\n\n.btn-xs,.btn-group-xs>.btn {\n    padding: 1px 5px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px\n}\n\n.btn-block {\n    display: block;\n    width: 100%\n}\n\n.btn-block+.btn-block {\n    margin-top: 5px\n}\n\ninput[type=submit].btn-block,input[type=reset].btn-block,input[type=button].btn-block {\n    width: 100%\n}\n\n.fade {\n    opacity: 0;\n    -webkit-transition: opacity .15s linear;\n    -o-transition: opacity .15s linear;\n    transition: opacity .15s linear\n}\n\n.fade.in {\n    opacity: 1\n}\n\n.collapse {\n    display: none\n}\n\n.collapse.in {\n    display: block\n}\n\ntr.collapse.in {\n    display: table-row\n}\n\ntbody.collapse.in {\n    display: table-row-group\n}\n\n.collapsing {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    -webkit-transition-property: height,visibility;\n    transition-property: height,visibility;\n    -webkit-transition-duration: .35s;\n    transition-duration: .35s;\n    -webkit-transition-timing-function: ease;\n    transition-timing-function: ease\n}\n\n.caret {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 2px;\n    vertical-align: middle;\n    border-top: 4px dashed;\n    border-top: 4px solid \\9 ;\n    border-right: 4px solid rgba(0,0,0,0);\n    border-left: 4px solid rgba(0,0,0,0)\n}\n\n.dropup,.dropdown {\n    position: relative\n}\n\n.dropdown-toggle:focus {\n    outline: 0\n}\n\n.dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    display: none;\n    float: left;\n    min-width: 160px;\n    padding: 5px 0;\n    margin: 2px 0 0;\n    list-style: none;\n    font-size: 14px;\n    text-align: left;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border: 1px solid rgba(0,0,0,.15);\n    border-radius: 4px;\n    -webkit-box-shadow: 0 6px 12px rgba(0,0,0,.175);\n    box-shadow: 0 6px 12px rgba(0,0,0,.175);\n    background-clip: padding-box\n}\n\n.dropdown-menu.pull-right {\n    right: 0;\n    left: auto\n}\n\n.dropdown-menu .divider {\n    height: 1px;\n    margin: 9px 0;\n    overflow: hidden;\n    background-color: #999\n}\n\n.dropdown-menu>li>a {\n    display: block;\n    padding: 3px 20px;\n    clear: both;\n    font-weight: normal;\n    line-height: 1.428571429;\n    color: #919191;\n    white-space: nowrap\n}\n\n.dropdown-menu>li>a:hover,.dropdown-menu>li>a:focus {\n    text-decoration: none;\n    color: rgb(81.25,81.25,81.25);\n    background-color: #f5f5f5\n}\n\n.dropdown-menu>.active>a,.dropdown-menu>.active>a:hover,.dropdown-menu>.active>a:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    background-color: #4384d0\n}\n\n.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:hover,.dropdown-menu>.disabled>a:focus {\n    color: hsl(0,0%,46.7%)\n}\n\n.dropdown-menu>.disabled>a:hover,.dropdown-menu>.disabled>a:focus {\n    text-decoration: none;\n    background-color: rgba(0,0,0,0);\n    background-image: none;\n    filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n    cursor: not-allowed\n}\n\n.open>.dropdown-menu {\n    display: block\n}\n\n.open>a {\n    outline: 0\n}\n\n.dropdown-menu-right {\n    left: auto;\n    right: 0\n}\n\n.dropdown-menu-left {\n    left: 0;\n    right: auto\n}\n\n.dropdown-header {\n    display: block;\n    padding: 3px 20px;\n    font-size: 12px;\n    line-height: 1.428571429;\n    color: hsl(0,0%,46.7%);\n    white-space: nowrap\n}\n\n.dropdown-backdrop {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 990\n}\n\n.pull-right>.dropdown-menu {\n    right: 0;\n    left: auto\n}\n\n.dropup .caret,.navbar-fixed-bottom .dropdown .caret {\n    border-top: 0;\n    border-bottom: 4px dashed;\n    border-bottom: 4px solid \\9 ;\n    content: \"\"\n}\n\n.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-bottom: 2px\n}\n\n@media(min-width: 992px) {\n    .navbar-right .dropdown-menu {\n        right:0;\n        left: auto\n    }\n\n    .navbar-right .dropdown-menu-left {\n        left: 0;\n        right: auto\n    }\n}\n\n.btn-group,.btn-group-vertical {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle\n}\n\n.btn-group>.btn,.btn-group-vertical>.btn {\n    position: relative;\n    float: left\n}\n\n.btn-group>.btn:hover,.btn-group>.btn:focus,.btn-group>.btn:active,.btn-group>.btn.active,.btn-group-vertical>.btn:hover,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn.active {\n    z-index: 2\n}\n\n.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group {\n    margin-left: -1px\n}\n\n.btn-toolbar {\n    margin-left: -5px\n}\n\n.btn-toolbar:before,.btn-toolbar:after {\n    content: \" \";\n    display: table\n}\n\n.btn-toolbar:after {\n    clear: both\n}\n\n.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group {\n    float: left\n}\n\n.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group {\n    margin-left: 5px\n}\n\n.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n    border-radius: 0\n}\n\n.btn-group>.btn:first-child {\n    margin-left: 0\n}\n\n.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0\n}\n\n.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child) {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0\n}\n\n.btn-group>.btn-group {\n    float: left\n}\n\n.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn {\n    border-radius: 0\n}\n\n.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0\n}\n\n.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0\n}\n\n.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle {\n    outline: 0\n}\n\n.btn-group>.btn+.dropdown-toggle {\n    padding-left: 8px;\n    padding-right: 8px\n}\n\n.btn-group>.btn-lg+.dropdown-toggle,.btn-group.btn-group-lg>.btn+.dropdown-toggle {\n    padding-left: 12px;\n    padding-right: 12px\n}\n\n.btn-group.open .dropdown-toggle {\n    -webkit-box-shadow: inset 0 3px 5px rgba(0,0,0,.125);\n    box-shadow: inset 0 3px 5px rgba(0,0,0,.125)\n}\n\n.btn-group.open .dropdown-toggle.btn-link {\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\n.btn .caret {\n    margin-left: 0\n}\n\n.btn-lg .caret,.btn-group-lg>.btn .caret {\n    border-width: 5px 5px 0;\n    border-bottom-width: 0\n}\n\n.dropup .btn-lg .caret,.dropup .btn-group-lg>.btn .caret {\n    border-width: 0 5px 5px\n}\n\n.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn {\n    display: block;\n    float: none;\n    width: 100%;\n    max-width: 100%\n}\n\n.btn-group-vertical>.btn-group:before,.btn-group-vertical>.btn-group:after {\n    content: \" \";\n    display: table\n}\n\n.btn-group-vertical>.btn-group:after {\n    clear: both\n}\n\n.btn-group-vertical>.btn-group>.btn {\n    float: none\n}\n\n.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group {\n    margin-top: -1px;\n    margin-left: 0\n}\n\n.btn-group-vertical>.btn:not(:first-child):not(:last-child) {\n    border-radius: 0\n}\n\n.btn-group-vertical>.btn:first-child:not(:last-child) {\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.btn-group-vertical>.btn:last-child:not(:first-child) {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px\n}\n\n.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn {\n    border-radius: 0\n}\n\n.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0\n}\n\n.btn-group-justified {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n    border-collapse: separate\n}\n\n.btn-group-justified>.btn,.btn-group-justified>.btn-group {\n    float: none;\n    display: table-cell;\n    width: 1%\n}\n\n.btn-group-justified>.btn-group .btn {\n    width: 100%\n}\n\n.btn-group-justified>.btn-group .dropdown-menu {\n    left: auto\n}\n\n[data-toggle=buttons]>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn-group>.btn input[type=checkbox] {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none\n}\n\n.input-group {\n    position: relative;\n    display: table;\n    border-collapse: separate\n}\n\n.input-group[class*=col-] {\n    float: none;\n    padding-left: 0;\n    padding-right: 0\n}\n\n.input-group .form-control {\n    position: relative;\n    z-index: 2;\n    float: left;\n    width: 100%;\n    margin-bottom: 0\n}\n\n.input-group .form-control:focus {\n    z-index: 3\n}\n\n.input-group-addon,.input-group-btn,.input-group .form-control {\n    display: table-cell\n}\n\n.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child) {\n    border-radius: 0\n}\n\n.input-group-addon,.input-group-btn {\n    width: 1%;\n    white-space: nowrap;\n    vertical-align: middle\n}\n\n.input-group-addon {\n    padding: 8px 12px;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 1;\n    color: #222;\n    text-align: center;\n    background-color: hsl(0,0%,93.5%);\n    border: 1px solid #e4e4e4;\n    border-radius: 4px\n}\n\n.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn {\n    padding: 5px 10px;\n    font-size: 12px;\n    border-radius: 3px\n}\n\n.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn {\n    padding: 10px 16px;\n    font-size: 17px;\n    border-radius: 3px\n}\n\n.input-group-addon input[type=radio],.input-group-addon input[type=checkbox] {\n    margin-top: 0\n}\n\n.input-group .form-control:first-child,.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group-btn:last-child>.btn-group:not(:last-child)>.btn {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0\n}\n\n.input-group-addon:first-child {\n    border-right: 0\n}\n\n.input-group .form-control:last-child,.input-group-addon:last-child,.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:first-child>.btn-group:not(:first-child)>.btn {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0\n}\n\n.input-group-addon:last-child {\n    border-left: 0\n}\n\n.input-group-btn {\n    position: relative;\n    font-size: 0;\n    white-space: nowrap\n}\n\n.input-group-btn>.btn {\n    position: relative\n}\n\n.input-group-btn>.btn+.btn {\n    margin-left: -1px\n}\n\n.input-group-btn>.btn:hover,.input-group-btn>.btn:focus,.input-group-btn>.btn:active {\n    z-index: 2\n}\n\n.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group {\n    margin-right: -1px\n}\n\n.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group {\n    z-index: 2;\n    margin-left: -1px\n}\n\n.nav {\n    margin-bottom: 0;\n    padding-left: 0;\n    list-style: none\n}\n\n.nav:before,.nav:after {\n    content: \" \";\n    display: table\n}\n\n.nav:after {\n    clear: both\n}\n\n.nav>li {\n    position: relative;\n    display: block\n}\n\n.nav>li>a {\n    position: relative;\n    display: block;\n    padding: 10px 15px\n}\n\n.nav>li>a:hover,.nav>li>a:focus {\n    text-decoration: none;\n    background-color: hsl(0,0%,93.5%)\n}\n\n.nav>li.disabled>a {\n    color: hsl(0,0%,46.7%)\n}\n\n.nav>li.disabled>a:hover,.nav>li.disabled>a:focus {\n    color: hsl(0,0%,46.7%);\n    text-decoration: none;\n    background-color: rgba(0,0,0,0);\n    cursor: not-allowed\n}\n\n.nav .open>a,.nav .open>a:hover,.nav .open>a:focus {\n    background-color: hsl(0,0%,93.5%);\n    border-color: #4384d0\n}\n\n.nav .nav-divider {\n    height: 1px;\n    margin: 9px 0;\n    overflow: hidden;\n    background-color: #e5e5e5\n}\n\n.nav>li>a>img {\n    max-width: none\n}\n\n.nav-tabs {\n    border-bottom: 1px solid #d8d8d8\n}\n\n.nav-tabs>li {\n    float: left;\n    margin-bottom: -1px\n}\n\n.nav-tabs>li>a {\n    margin-right: 2px;\n    line-height: 1.428571429;\n    border: 1px solid rgba(0,0,0,0);\n    border-radius: 4px 4px 0 0\n}\n\n.nav-tabs>li>a:hover {\n    border-color: rgba(0,0,0,0) rgba(0,0,0,0) #d8d8d8\n}\n\n.nav-tabs>li.active>a,.nav-tabs>li.active>a:hover,.nav-tabs>li.active>a:focus {\n    color: #222;\n    background-color: #fff;\n    border: 1px solid rgba(0,0,0,0);\n    border-bottom-color: rgba(0,0,0,0);\n    cursor: default\n}\n\n.nav-pills>li {\n    float: left\n}\n\n.nav-pills>li>a {\n    border-radius: 20px\n}\n\n.nav-pills>li+li {\n    margin-left: 2px\n}\n\n.nav-pills>li.active>a,.nav-pills>li.active>a:hover,.nav-pills>li.active>a:focus {\n    color: #fff;\n    background-color: #222\n}\n\n.nav-stacked>li {\n    float: none\n}\n\n.nav-stacked>li+li {\n    margin-top: 2px;\n    margin-left: 0\n}\n\n.nav-justified,.nav-tabs.nav-justified {\n    width: 100%\n}\n\n.nav-justified>li,.nav-tabs.nav-justified>li {\n    float: none\n}\n\n.nav-justified>li>a,.nav-tabs.nav-justified>li>a {\n    text-align: center;\n    margin-bottom: 5px\n}\n\n.nav-justified>.dropdown .dropdown-menu {\n    top: auto;\n    left: auto\n}\n\n@media(min-width: 768px) {\n    .nav-justified>li,.nav-tabs.nav-justified>li {\n        display:table-cell;\n        width: 1%\n    }\n\n    .nav-justified>li>a,.nav-tabs.nav-justified>li>a {\n        margin-bottom: 0\n    }\n}\n\n.nav-tabs-justified,.nav-tabs.nav-justified {\n    border-bottom: 0\n}\n\n.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a {\n    margin-right: 0;\n    border-radius: 4px\n}\n\n.nav-tabs-justified>.active>a,.nav-tabs.nav-justified>.active>a,.nav-tabs-justified>.active>a:hover,.nav-tabs-justified>.active>a:focus {\n    border: 1px solid #ddd\n}\n\n@media(min-width: 768px) {\n    .nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a {\n        border-bottom:1px solid #ddd;\n        border-radius: 4px 4px 0 0\n    }\n\n    .nav-tabs-justified>.active>a,.nav-tabs.nav-justified>.active>a,.nav-tabs-justified>.active>a:hover,.nav-tabs-justified>.active>a:focus {\n        border-bottom-color: #fff\n    }\n}\n\n.tab-content>.tab-pane {\n    display: none\n}\n\n.tab-content>.active {\n    display: block\n}\n\n.nav-tabs .dropdown-menu {\n    margin-top: -1px;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0\n}\n\n.navbar {\n    position: relative;\n    min-height: 60px;\n    margin-bottom: 0;\n    border: 1px solid rgba(0,0,0,0)\n}\n\n.navbar:before,.navbar:after {\n    content: \" \";\n    display: table\n}\n\n.navbar:after {\n    clear: both\n}\n\n@media(min-width: 992px) {\n    .navbar {\n        border-radius:0\n    }\n}\n\n.navbar-header:before,.navbar-header:after {\n    content: \" \";\n    display: table\n}\n\n.navbar-header:after {\n    clear: both\n}\n\n@media(min-width: 992px) {\n    .navbar-header {\n        float:left\n    }\n}\n\n.navbar-collapse {\n    overflow-x: visible;\n    padding-right: 13px;\n    padding-left: 13px;\n    border-top: 1px solid rgba(0,0,0,0);\n    box-shadow: inset 0 1px 0 hsla(0,0%,100%,.1);\n    -webkit-overflow-scrolling: touch\n}\n\n.navbar-collapse:before,.navbar-collapse:after {\n    content: \" \";\n    display: table\n}\n\n.navbar-collapse:after {\n    clear: both\n}\n\n.navbar-collapse.in {\n    overflow-y: auto\n}\n\n@media(min-width: 992px) {\n    .navbar-collapse {\n        width:auto;\n        border-top: 0;\n        box-shadow: none\n    }\n\n    .navbar-collapse.collapse {\n        display: block !important;\n        height: auto !important;\n        padding-bottom: 0;\n        overflow: visible !important\n    }\n\n    .navbar-collapse.in {\n        overflow-y: visible\n    }\n\n    .navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse,.navbar-fixed-bottom .navbar-collapse {\n        padding-left: 0;\n        padding-right: 0\n    }\n}\n\n.navbar-fixed-top .navbar-collapse,.navbar-fixed-bottom .navbar-collapse {\n    max-height: 340px\n}\n\n@media(max-device-width: 480px)and (orientation: landscape) {\n    .navbar-fixed-top .navbar-collapse,.navbar-fixed-bottom .navbar-collapse {\n        max-height:200px\n    }\n}\n\n.container>.navbar-header,.container>.navbar-collapse,.container-fluid>.navbar-header,.container-fluid>.navbar-collapse {\n    margin-right: -13px;\n    margin-left: -13px\n}\n\n@media(min-width: 992px) {\n    .container>.navbar-header,.container>.navbar-collapse,.container-fluid>.navbar-header,.container-fluid>.navbar-collapse {\n        margin-right:0;\n        margin-left: 0\n    }\n}\n\n.navbar-static-top {\n    z-index: 1000;\n    border-width: 0 0 1px\n}\n\n@media(min-width: 992px) {\n    .navbar-static-top {\n        border-radius:0\n    }\n}\n\n.navbar-fixed-top,.navbar-fixed-bottom {\n    position: fixed;\n    right: 0;\n    left: 0;\n    z-index: 1030\n}\n\n@media(min-width: 992px) {\n    .navbar-fixed-top,.navbar-fixed-bottom {\n        border-radius:0\n    }\n}\n\n.navbar-fixed-top {\n    top: 0;\n    border-width: 0 0 1px\n}\n\n.navbar-fixed-bottom {\n    bottom: 0;\n    margin-bottom: 0;\n    border-width: 1px 0 0\n}\n\n.navbar-brand {\n    float: left;\n    padding: 20px 13px;\n    font-size: 17px;\n    line-height: 20px;\n    height: 60px\n}\n\n.navbar-brand:hover,.navbar-brand:focus {\n    text-decoration: none\n}\n\n.navbar-brand>img {\n    display: block\n}\n\n@media(min-width: 992px) {\n    .navbar>.container .navbar-brand,.navbar>.container-fluid .navbar-brand {\n        margin-left:-13px\n    }\n}\n\n.navbar-toggle {\n    position: relative;\n    float: right;\n    margin-right: 13px;\n    padding: 9px 10px;\n    margin-top: 13px;\n    margin-bottom: 13px;\n    background-color: rgba(0,0,0,0);\n    background-image: none;\n    border: 1px solid rgba(0,0,0,0);\n    border-radius: 4px\n}\n\n.navbar-toggle:focus {\n    outline: 0\n}\n\n.navbar-toggle .icon-bar {\n    display: block;\n    width: 22px;\n    height: 2px;\n    border-radius: 1px\n}\n\n.navbar-toggle .icon-bar+.icon-bar {\n    margin-top: 4px\n}\n\n@media(min-width: 992px) {\n    .navbar-toggle {\n        display:none\n    }\n}\n\n.navbar-nav {\n    margin: 10px -13px\n}\n\n.navbar-nav>li>a {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    line-height: 20px\n}\n\n@media(max-width: 991px) {\n    .navbar-nav .open .dropdown-menu {\n        position:static;\n        float: none;\n        width: auto;\n        margin-top: 0;\n        background-color: rgba(0,0,0,0);\n        border: 0;\n        box-shadow: none\n    }\n\n    .navbar-nav .open .dropdown-menu>li>a,.navbar-nav .open .dropdown-menu .dropdown-header {\n        padding: 5px 15px 5px 25px\n    }\n\n    .navbar-nav .open .dropdown-menu>li>a {\n        line-height: 20px\n    }\n\n    .navbar-nav .open .dropdown-menu>li>a:hover,.navbar-nav .open .dropdown-menu>li>a:focus {\n        background-image: none\n    }\n}\n\n@media(min-width: 992px) {\n    .navbar-nav {\n        float:left;\n        margin: 0\n    }\n\n    .navbar-nav>li {\n        float: left\n    }\n\n    .navbar-nav>li>a {\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n}\n\n.navbar-form {\n    margin-left: -13px;\n    margin-right: -13px;\n    padding: 10px 13px;\n    border-top: 1px solid rgba(0,0,0,0);\n    border-bottom: 1px solid rgba(0,0,0,0);\n    -webkit-box-shadow: inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);\n    box-shadow: inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);\n    margin-top: 11px;\n    margin-bottom: 11px\n}\n\n@media(min-width: 768px) {\n    .navbar-form .form-group {\n        display:inline-block;\n        margin-bottom: 0;\n        vertical-align: middle\n    }\n\n    .navbar-form .form-control {\n        display: inline-block;\n        width: auto;\n        vertical-align: middle\n    }\n\n    .navbar-form .form-control-static {\n        display: inline-block\n    }\n\n    .navbar-form .input-group {\n        display: inline-table;\n        vertical-align: middle\n    }\n\n    .navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn,.navbar-form .input-group .form-control {\n        width: auto\n    }\n\n    .navbar-form .input-group>.form-control {\n        width: 100%\n    }\n\n    .navbar-form .control-label {\n        margin-bottom: 0;\n        vertical-align: middle\n    }\n\n    .navbar-form .radio,.navbar-form .checkbox {\n        display: inline-block;\n        margin-top: 0;\n        margin-bottom: 0;\n        vertical-align: middle\n    }\n\n    .navbar-form .radio label,.navbar-form .checkbox label {\n        padding-left: 0\n    }\n\n    .navbar-form .radio input[type=radio],.navbar-form .checkbox input[type=checkbox] {\n        position: relative;\n        margin-left: 0\n    }\n\n    .navbar-form .has-feedback .form-control-feedback {\n        top: 0\n    }\n}\n\n@media(max-width: 991px) {\n    .navbar-form .form-group {\n        margin-bottom:5px\n    }\n\n    .navbar-form .form-group:last-child {\n        margin-bottom: 0\n    }\n}\n\n@media(min-width: 992px) {\n    .navbar-form {\n        width:auto;\n        border: 0;\n        margin-left: 0;\n        margin-right: 0;\n        padding-top: 0;\n        padding-bottom: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none\n    }\n}\n\n.navbar-nav>li>.dropdown-menu {\n    margin-top: 0;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0\n}\n\n.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu {\n    margin-bottom: 0;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.navbar-btn {\n    margin-top: 11px;\n    margin-bottom: 11px\n}\n\n.navbar-btn.btn-sm,.btn-group-sm>.navbar-btn.btn {\n    margin-top: 15px;\n    margin-bottom: 15px\n}\n\n.navbar-btn.btn-xs,.btn-group-xs>.navbar-btn.btn {\n    margin-top: 19px;\n    margin-bottom: 19px\n}\n\n.navbar-text {\n    margin-top: 20px;\n    margin-bottom: 20px\n}\n\n@media(min-width: 992px) {\n    .navbar-text {\n        float:left;\n        margin-left: 13px;\n        margin-right: 13px\n    }\n}\n\n@media(min-width: 992px) {\n    .navbar-left {\n        float:left !important\n    }\n\n    .navbar-right {\n        float: right !important;\n        margin-right: -13px\n    }\n\n    .navbar-right~.navbar-right {\n        margin-right: 0\n    }\n}\n\n.navbar-default {\n    background-color: #fff;\n    border-color: #e4e4e4\n}\n\n.navbar-default .navbar-brand {\n    color: #919191\n}\n\n.navbar-default .navbar-brand:hover,.navbar-default .navbar-brand:focus {\n    color: rgb(119.5,119.5,119.5);\n    background-color: rgba(0,0,0,0)\n}\n\n.navbar-default .navbar-text {\n    color: #919191\n}\n\n.navbar-default .navbar-nav>li>a {\n    color: #919191\n}\n\n.navbar-default .navbar-nav>li>a:hover,.navbar-default .navbar-nav>li>a:focus {\n    color: rgb(81.25,81.25,81.25);\n    background-color: rgba(0,0,0,0)\n}\n\n.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:hover,.navbar-default .navbar-nav>.active>a:focus {\n    color: #000;\n    background-color: rgba(0,0,0,0)\n}\n\n.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:hover,.navbar-default .navbar-nav>.disabled>a:focus {\n    color: #ccc;\n    background-color: rgba(0,0,0,0)\n}\n\n.navbar-default .navbar-toggle {\n    border-color: rgba(0,0,0,0)\n}\n\n.navbar-default .navbar-toggle:hover,.navbar-default .navbar-toggle:focus {\n    background-color: #ddd\n}\n\n.navbar-default .navbar-toggle .icon-bar {\n    background-color: #919191\n}\n\n.navbar-default .navbar-collapse,.navbar-default .navbar-form {\n    border-color: #e4e4e4\n}\n\n.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:hover,.navbar-default .navbar-nav>.open>a:focus {\n    background-color: rgba(0,0,0,0);\n    color: #000\n}\n\n@media(max-width: 991px) {\n    .navbar-default .navbar-nav .open .dropdown-menu>li>a {\n        color:#919191\n    }\n\n    .navbar-default .navbar-nav .open .dropdown-menu>li>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus {\n        color: rgb(81.25,81.25,81.25);\n        background-color: rgba(0,0,0,0)\n    }\n\n    .navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus {\n        color: #000;\n        background-color: rgba(0,0,0,0)\n    }\n\n    .navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus {\n        color: #ccc;\n        background-color: rgba(0,0,0,0)\n    }\n}\n\n.navbar-default .navbar-link {\n    color: #919191\n}\n\n.navbar-default .navbar-link:hover {\n    color: rgb(81.25,81.25,81.25)\n}\n\n.navbar-default .btn-link {\n    color: #919191\n}\n\n.navbar-default .btn-link:hover,.navbar-default .btn-link:focus {\n    color: rgb(81.25,81.25,81.25)\n}\n\n.navbar-default .btn-link[disabled]:hover,.navbar-default .btn-link[disabled]:focus,fieldset[disabled] .navbar-default .btn-link:hover,fieldset[disabled] .navbar-default .btn-link:focus {\n    color: #ccc\n}\n\n.navbar-inverse {\n    background-color: #222;\n    border-color: rgb(8.5,8.5,8.5)\n}\n\n.navbar-inverse .navbar-brand {\n    color: hsl(0,0%,61.7%)\n}\n\n.navbar-inverse .navbar-brand:hover,.navbar-inverse .navbar-brand:focus {\n    color: #fff;\n    background-color: rgba(0,0,0,0)\n}\n\n.navbar-inverse .navbar-text {\n    color: hsl(0,0%,61.7%)\n}\n\n.navbar-inverse .navbar-nav>li>a {\n    color: hsl(0,0%,61.7%)\n}\n\n.navbar-inverse .navbar-nav>li>a:hover,.navbar-inverse .navbar-nav>li>a:focus {\n    color: #fff;\n    background-color: rgba(0,0,0,0)\n}\n\n.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:hover,.navbar-inverse .navbar-nav>.active>a:focus {\n    color: #fff;\n    background-color: rgb(8.5,8.5,8.5)\n}\n\n.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:hover,.navbar-inverse .navbar-nav>.disabled>a:focus {\n    color: #444;\n    background-color: rgba(0,0,0,0)\n}\n\n.navbar-inverse .navbar-toggle {\n    border-color: #333\n}\n\n.navbar-inverse .navbar-toggle:hover,.navbar-inverse .navbar-toggle:focus {\n    background-color: #333\n}\n\n.navbar-inverse .navbar-toggle .icon-bar {\n    background-color: #fff\n}\n\n.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form {\n    border-color: rgb(16.15,16.15,16.15)\n}\n\n.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:hover,.navbar-inverse .navbar-nav>.open>a:focus {\n    background-color: rgb(8.5,8.5,8.5);\n    color: #fff\n}\n\n@media(max-width: 991px) {\n    .navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header {\n        border-color:rgb(8.5,8.5,8.5)\n    }\n\n    .navbar-inverse .navbar-nav .open .dropdown-menu .divider {\n        background-color: rgb(8.5,8.5,8.5)\n    }\n\n    .navbar-inverse .navbar-nav .open .dropdown-menu>li>a {\n        color: hsl(0,0%,61.7%)\n    }\n\n    .navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus {\n        color: #fff;\n        background-color: rgba(0,0,0,0)\n    }\n\n    .navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus {\n        color: #fff;\n        background-color: rgb(8.5,8.5,8.5)\n    }\n\n    .navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus {\n        color: #444;\n        background-color: rgba(0,0,0,0)\n    }\n}\n\n.navbar-inverse .navbar-link {\n    color: hsl(0,0%,61.7%)\n}\n\n.navbar-inverse .navbar-link:hover {\n    color: #fff\n}\n\n.navbar-inverse .btn-link {\n    color: hsl(0,0%,61.7%)\n}\n\n.navbar-inverse .btn-link:hover,.navbar-inverse .btn-link:focus {\n    color: #fff\n}\n\n.navbar-inverse .btn-link[disabled]:hover,.navbar-inverse .btn-link[disabled]:focus,fieldset[disabled] .navbar-inverse .btn-link:hover,fieldset[disabled] .navbar-inverse .btn-link:focus {\n    color: #444\n}\n\n.breadcrumb {\n    padding: 0px 0px;\n    margin-bottom: 20px;\n    list-style: none;\n    background-color: rgba(0,0,0,0);\n    border-radius: 4px\n}\n\n.breadcrumb>li {\n    display: inline-block\n}\n\n.breadcrumb>li+li:before {\n    content: \"· \";\n    padding: 0 5px;\n    color: #4384d0\n}\n\n.breadcrumb>.active {\n    color: #222\n}\n\n.pagination {\n    display: inline-block;\n    padding-left: 0;\n    margin: 20px 0;\n    border-radius: 4px\n}\n\n.pagination>li {\n    display: inline\n}\n\n.pagination>li>a,.pagination>li>span {\n    position: relative;\n    float: left;\n    padding: 8px 12px;\n    line-height: 1.428571429;\n    text-decoration: none;\n    color: #4384d0;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    margin-left: -1px\n}\n\n.pagination>li:first-child>a,.pagination>li:first-child>span {\n    margin-left: 0;\n    border-bottom-left-radius: 4px;\n    border-top-left-radius: 4px\n}\n\n.pagination>li:last-child>a,.pagination>li:last-child>span {\n    border-bottom-right-radius: 4px;\n    border-top-right-radius: 4px\n}\n\n.pagination>li>a:hover,.pagination>li>a:focus,.pagination>li>span:hover,.pagination>li>span:focus {\n    z-index: 2;\n    color: rgb(39.7,94.6042553191,158.8);\n    background-color: hsl(0,0%,93.5%);\n    border-color: #ddd\n}\n\n.pagination>.active>a,.pagination>.active>a:hover,.pagination>.active>a:focus,.pagination>.active>span,.pagination>.active>span:hover,.pagination>.active>span:focus {\n    z-index: 3;\n    color: #fff;\n    background-color: #4384d0;\n    border-color: #4384d0;\n    cursor: default\n}\n\n.pagination>.disabled>span,.pagination>.disabled>span:hover,.pagination>.disabled>span:focus,.pagination>.disabled>a,.pagination>.disabled>a:hover,.pagination>.disabled>a:focus {\n    color: hsl(0,0%,46.7%);\n    background-color: #fff;\n    border-color: #ddd;\n    cursor: not-allowed\n}\n\n.pagination-lg>li>a,.pagination-lg>li>span {\n    padding: 10px 16px;\n    font-size: 17px;\n    line-height: 1.3333333\n}\n\n.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span {\n    border-bottom-left-radius: 6px;\n    border-top-left-radius: 6px\n}\n\n.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span {\n    border-bottom-right-radius: 6px;\n    border-top-right-radius: 6px\n}\n\n.pagination-sm>li>a,.pagination-sm>li>span {\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5\n}\n\n.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span {\n    border-bottom-left-radius: 3px;\n    border-top-left-radius: 3px\n}\n\n.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span {\n    border-bottom-right-radius: 3px;\n    border-top-right-radius: 3px\n}\n\n.pager {\n    padding-left: 0;\n    margin: 20px 0;\n    list-style: none;\n    text-align: center\n}\n\n.pager:before,.pager:after {\n    content: \" \";\n    display: table\n}\n\n.pager:after {\n    clear: both\n}\n\n.pager li {\n    display: inline\n}\n\n.pager li>a,.pager li>span {\n    display: inline-block;\n    padding: 5px 14px;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 15px\n}\n\n.pager li>a:hover,.pager li>a:focus {\n    text-decoration: none;\n    background-color: hsl(0,0%,93.5%)\n}\n\n.pager .next>a,.pager .next>span {\n    float: right\n}\n\n.pager .previous>a,.pager .previous>span {\n    float: left\n}\n\n.pager .disabled>a,.pager .disabled>a:hover,.pager .disabled>a:focus,.pager .disabled>span {\n    color: hsl(0,0%,46.7%);\n    background-color: #fff;\n    cursor: not-allowed\n}\n\n.label {\n    display: inline;\n    padding: .2em .6em .3em;\n    font-size: 75%;\n    font-weight: bold;\n    line-height: 1;\n    color: #fff;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: .25em\n}\n\n.label:empty {\n    display: none\n}\n\n.btn .label {\n    position: relative;\n    top: -1px\n}\n\na.label:hover,a.label:focus {\n    color: #fff;\n    text-decoration: none;\n    cursor: pointer\n}\n\n.label-default {\n    background-color: hsl(0,0%,46.7%)\n}\n\n.label-default[href]:hover,.label-default[href]:focus {\n    background-color: hsl(0,0%,36.7%)\n}\n\n.label-primary {\n    background-color: #4384d0\n}\n\n.label-primary[href]:hover,.label-primary[href]:focus {\n    background-color: rgb(44.8,106.7574468085,179.2)\n}\n\n.label-success {\n    background-color: #7ed320\n}\n\n.label-success[href]:hover,.label-success[href]:focus {\n    background-color: rgb(99.5555555556,166.7160493827,25.2839506173)\n}\n\n.label-info {\n    background-color: #5bc0de\n}\n\n.label-info[href]:hover,.label-info[href]:focus {\n    background-color: rgb(48.5431472081,175.6903553299,213.4568527919)\n}\n\n.label-warning {\n    background-color: #f5a623\n}\n\n.label-warning[href]:hover,.label-warning[href]:focus {\n    background-color: rgb(219.0434782609,140.3869565217,9.9565217391)\n}\n\n.label-danger {\n    background-color: #d0011b\n}\n\n.label-danger[href]:hover,.label-danger[href]:focus {\n    background-color: rgb(157.2440191388,.7559808612,20.4114832536)\n}\n\n.badge {\n    display: inline-block;\n    min-width: 10px;\n    padding: 3px 7px;\n    font-size: 12px;\n    font-weight: 500;\n    color: #fff;\n    line-height: 12px;\n    vertical-align: middle;\n    white-space: nowrap;\n    text-align: center;\n    background-color: #919191;\n    border-radius: 10px\n}\n\n.badge:empty {\n    display: none\n}\n\n.btn .badge {\n    position: relative;\n    top: -1px\n}\n\n.btn-xs .badge,.btn-group-xs>.btn .badge {\n    top: 0;\n    padding: 1px 5px\n}\n\n.list-group-item.active>.badge,.nav-pills>.active>a>.badge {\n    color: #4384d0;\n    background-color: #fff\n}\n\n.list-group-item>.badge {\n    float: right\n}\n\n.list-group-item>.badge+.badge {\n    margin-right: 5px\n}\n\n.nav-pills>li>a>.badge {\n    margin-left: 3px\n}\n\na.badge:hover,a.badge:focus {\n    color: #fff;\n    text-decoration: none;\n    cursor: pointer\n}\n\n.jumbotron {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    margin-bottom: 30px;\n    color: inherit;\n    background-color: hsl(0,0%,93.5%)\n}\n\n.jumbotron h1,.jumbotron .h1 {\n    color: inherit\n}\n\n.jumbotron p {\n    margin-bottom: 15px;\n    font-size: 21px;\n    font-weight: 200\n}\n\n.jumbotron>hr {\n    border-top-color: hsl(0,0%,83.5%)\n}\n\n.container .jumbotron,.container-fluid .jumbotron {\n    border-radius: 6px;\n    padding-left: 15px;\n    padding-right: 15px\n}\n\n.jumbotron .container {\n    max-width: 100%\n}\n\n@media screen and (min-width: 768px) {\n    .jumbotron {\n        padding-top:48px;\n        padding-bottom: 48px\n    }\n\n    .container .jumbotron,.container-fluid .jumbotron {\n        padding-left: 60px;\n        padding-right: 60px\n    }\n\n    .jumbotron h1,.jumbotron .h1 {\n        font-size: 63px\n    }\n}\n\n.thumbnail {\n    display: block;\n    padding: 4px;\n    margin-bottom: 20px;\n    line-height: 1.428571429;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    -webkit-transition: border .2s ease-in-out;\n    -o-transition: border .2s ease-in-out;\n    transition: border .2s ease-in-out\n}\n\n.thumbnail>img,.thumbnail a>img {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.thumbnail .caption {\n    padding: 9px;\n    color: #222\n}\n\na.thumbnail:hover,a.thumbnail:focus,a.thumbnail.active {\n    border-color: #4384d0\n}\n\n.alert {\n    padding: 20px;\n    margin-bottom: 20px;\n    border: 1px solid rgba(0,0,0,0);\n    border-radius: 4px\n}\n\n.alert h4 {\n    margin-top: 0;\n    color: inherit\n}\n\n.alert .alert-link {\n    font-weight: bold\n}\n\n.alert>p,.alert>ul {\n    margin-bottom: 0\n}\n\n.alert>p+p {\n    margin-top: 5px\n}\n\n.alert-dismissable .close,.alert-dismissible .close {\n    position: relative;\n    top: -2px;\n    right: -21px;\n    color: inherit\n}\n\n.alert-success {\n    background-color: #d8f0bc;\n    border-color: #d8f0bc;\n    color: #222\n}\n\n.alert-success hr {\n    border-top-color: hsl(87.6923076923,63.4146341463%,78.9215686275%)\n}\n\n.alert-success .alert-link {\n    color: rgb(8.5,8.5,8.5)\n}\n\n.alert-info {\n    background-color: #f5f5f5;\n    border-color: #f5f5f5;\n    color: #222\n}\n\n.alert-info hr {\n    border-top-color: hsl(0,0%,91.0784313725%)\n}\n\n.alert-info .alert-link {\n    color: rgb(8.5,8.5,8.5)\n}\n\n.alert-warning {\n    background-color: #fdf8b8;\n    border-color: #fdf8b8;\n    color: #222\n}\n\n.alert-warning hr {\n    border-top-color: rgb(252.301369863,245.5547945205,159.198630137)\n}\n\n.alert-warning .alert-link {\n    color: rgb(8.5,8.5,8.5)\n}\n\n.alert-danger {\n    background-color: #ffd8d9;\n    border-color: #ffd8d9;\n    color: #222\n}\n\n.alert-danger hr {\n    border-top-color: rgb(255,190.5,192.1538461538)\n}\n\n.alert-danger .alert-link {\n    color: rgb(8.5,8.5,8.5)\n}\n\n@-webkit-keyframes progress-bar-stripes {\n    from {\n        background-position: 40px 0\n    }\n\n    to {\n        background-position: 0 0\n    }\n}\n\n@keyframes progress-bar-stripes {\n    from {\n        background-position: 40px 0\n    }\n\n    to {\n        background-position: 0 0\n    }\n}\n\n.progress {\n    overflow: hidden;\n    height: 20px;\n    margin-bottom: 20px;\n    background-color: #f5f5f5;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);\n    box-shadow: inset 0 1px 2px rgba(0,0,0,.1)\n}\n\n.progress-bar {\n    float: left;\n    width: 0%;\n    height: 100%;\n    font-size: 12px;\n    line-height: 20px;\n    color: #fff;\n    text-align: center;\n    background-color: #4384d0;\n    -webkit-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);\n    box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);\n    -webkit-transition: width .6s ease;\n    -o-transition: width .6s ease;\n    transition: width .6s ease\n}\n\n.progress-striped .progress-bar,.progress-bar-striped {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-size: 40px 40px\n}\n\n.progress.active .progress-bar,.progress-bar.active {\n    -webkit-animation: progress-bar-stripes 2s linear infinite;\n    -o-animation: progress-bar-stripes 2s linear infinite;\n    animation: progress-bar-stripes 2s linear infinite\n}\n\n.progress-bar-success {\n    background-color: #7ed320\n}\n\n.progress-striped .progress-bar-success {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)\n}\n\n.progress-bar-info {\n    background-color: #5bc0de\n}\n\n.progress-striped .progress-bar-info {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)\n}\n\n.progress-bar-warning {\n    background-color: #f5a623\n}\n\n.progress-striped .progress-bar-warning {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)\n}\n\n.progress-bar-danger {\n    background-color: #d0011b\n}\n\n.progress-striped .progress-bar-danger {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)\n}\n\n.media {\n    margin-top: 15px\n}\n\n.media:first-child {\n    margin-top: 0\n}\n\n.media,.media-body {\n    zoom:1;overflow: hidden\n}\n\n.media-body {\n    width: 10000px\n}\n\n.media-object {\n    display: block\n}\n\n.media-object.img-thumbnail {\n    max-width: none\n}\n\n.media-right,.media>.pull-right {\n    padding-left: 10px\n}\n\n.media-left,.media>.pull-left {\n    padding-right: 10px\n}\n\n.media-left,.media-right,.media-body {\n    display: table-cell;\n    vertical-align: top\n}\n\n.media-middle {\n    vertical-align: middle\n}\n\n.media-bottom {\n    vertical-align: bottom\n}\n\n.media-heading {\n    margin-top: 0;\n    margin-bottom: 5px\n}\n\n.media-list {\n    padding-left: 0;\n    list-style: none\n}\n\n.list-group {\n    margin-bottom: 20px;\n    padding-left: 0\n}\n\n.list-group-item {\n    position: relative;\n    display: block;\n    padding: 10px 15px;\n    margin-bottom: -1px;\n    background-color: #fff;\n    border: 1px solid #ddd\n}\n\n.list-group-item:first-child {\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px\n}\n\n.list-group-item:last-child {\n    margin-bottom: 0;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px\n}\n\na.list-group-item,button.list-group-item {\n    color: #555\n}\n\na.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading {\n    color: #333\n}\n\na.list-group-item:hover,a.list-group-item:focus,button.list-group-item:hover,button.list-group-item:focus {\n    text-decoration: none;\n    color: #555;\n    background-color: #f5f5f5\n}\n\nbutton.list-group-item {\n    width: 100%;\n    text-align: left\n}\n\n.list-group-item.disabled,.list-group-item.disabled:hover,.list-group-item.disabled:focus {\n    background-color: hsl(0,0%,93.5%);\n    color: hsl(0,0%,46.7%);\n    cursor: not-allowed\n}\n\n.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading {\n    color: inherit\n}\n\n.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text {\n    color: hsl(0,0%,46.7%)\n}\n\n.list-group-item.active,.list-group-item.active:hover,.list-group-item.active:focus {\n    z-index: 2;\n    color: #fff;\n    background-color: #4384d0;\n    border-color: #4384d0\n}\n\n.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>small,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading>.small {\n    color: inherit\n}\n\n.list-group-item.active .list-group-item-text,.list-group-item.active:hover .list-group-item-text,.list-group-item.active:focus .list-group-item-text {\n    color: rgb(230.2,238.7744680851,248.8)\n}\n\n.list-group-item-success {\n    color: #7ed320;\n    background-color: rgb(235.65,248.4,221.55)\n}\n\na.list-group-item-success,button.list-group-item-success {\n    color: #7ed320\n}\n\na.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading {\n    color: inherit\n}\n\na.list-group-item-success:hover,a.list-group-item-success:focus,button.list-group-item-success:hover,button.list-group-item-success:focus {\n    color: #7ed320;\n    background-color: rgb(223.3297752809,244.197752809,200.252247191)\n}\n\na.list-group-item-success.active,a.list-group-item-success.active:hover,a.list-group-item-success.active:focus,button.list-group-item-success.active,button.list-group-item-success.active:hover,button.list-group-item-success.active:focus {\n    color: #fff;\n    background-color: #7ed320;\n    border-color: #7ed320\n}\n\n.list-group-item-info {\n    color: rgb(46.9,92.4,145.6);\n    background-color: rgb(236.2,242.7,250.3)\n}\n\na.list-group-item-info,button.list-group-item-info {\n    color: rgb(46.9,92.4,145.6)\n}\n\na.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading {\n    color: inherit\n}\n\na.list-group-item-info:hover,a.list-group-item-info:focus,button.list-group-item-info:hover,button.list-group-item-info:focus {\n    color: rgb(46.9,92.4,145.6);\n    background-color: rgb(215.8,229.3531914894,245.2)\n}\n\na.list-group-item-info.active,a.list-group-item-info.active:hover,a.list-group-item-info.active:focus,button.list-group-item-info.active,button.list-group-item-info.active:hover,button.list-group-item-info.active:focus {\n    color: #fff;\n    background-color: rgb(46.9,92.4,145.6);\n    border-color: rgb(46.9,92.4,145.6)\n}\n\n.list-group-item-warning {\n    color: #f5a623;\n    background-color: rgb(254.09,251.88,225.49)\n}\n\na.list-group-item-warning,button.list-group-item-warning {\n    color: #f5a623\n}\n\na.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading {\n    color: inherit\n}\n\na.list-group-item-warning:hover,a.list-group-item-warning:focus,button.list-group-item-warning:hover,button.list-group-item-warning:focus {\n    color: #f5a623;\n    background-color: hsl(55.3636363636,94.0170940171%,89.0352941176%)\n}\n\na.list-group-item-warning.active,a.list-group-item-warning.active:hover,a.list-group-item-warning.active:focus,button.list-group-item-warning.active,button.list-group-item-warning.active:hover,button.list-group-item-warning.active:focus {\n    color: #fff;\n    background-color: #f5a623;\n    border-color: #f5a623\n}\n\n.list-group-item-danger {\n    color: #f52323;\n    background-color: rgb(249.36,224.52,227.64)\n}\n\na.list-group-item-danger,button.list-group-item-danger {\n    color: #f52323\n}\n\na.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading {\n    color: inherit\n}\n\na.list-group-item-danger:hover,a.list-group-item-danger:focus,button.list-group-item-danger:hover,button.list-group-item-danger:focus {\n    color: #f52323;\n    background-color: rgb(245.3782724252,203.0017275748,208.3243853821)\n}\n\na.list-group-item-danger.active,a.list-group-item-danger.active:hover,a.list-group-item-danger.active:focus,button.list-group-item-danger.active,button.list-group-item-danger.active:hover,button.list-group-item-danger.active:focus {\n    color: #fff;\n    background-color: #f52323;\n    border-color: #f52323\n}\n\n.list-group-item-heading {\n    margin-top: 0;\n    margin-bottom: 5px\n}\n\n.list-group-item-text {\n    margin-bottom: 0;\n    line-height: 1.3\n}\n\n.panel {\n    margin-bottom: 20px;\n    background-color: #fff;\n    border: 1px solid rgba(0,0,0,0);\n    border-radius: 4px;\n    -webkit-box-shadow: 0 1px 1px rgba(0,0,0,.05);\n    box-shadow: 0 1px 1px rgba(0,0,0,.05)\n}\n\n.panel-body {\n    padding: 15px\n}\n\n.panel-body:before,.panel-body:after {\n    content: \" \";\n    display: table\n}\n\n.panel-body:after {\n    clear: both\n}\n\n.panel-heading {\n    padding: 10px 15px;\n    border-bottom: 1px solid rgba(0,0,0,0);\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px\n}\n\n.panel-heading>.dropdown .dropdown-toggle {\n    color: inherit\n}\n\n.panel-title {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 16px;\n    color: inherit\n}\n\n.panel-title>a,.panel-title>small,.panel-title>.small,.panel-title>small>a,.panel-title>.small>a {\n    color: inherit\n}\n\n.panel-footer {\n    padding: 10px 15px;\n    background-color: #f5f5f5;\n    border-top: 1px solid #ddd;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px\n}\n\n.panel>.list-group,.panel>.panel-collapse>.list-group {\n    margin-bottom: 0\n}\n\n.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item {\n    border-width: 1px 0;\n    border-radius: 0\n}\n\n.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child {\n    border-top: 0;\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px\n}\n\n.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child {\n    border-bottom: 0;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px\n}\n\n.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0\n}\n\n.panel-heading+.list-group .list-group-item:first-child {\n    border-top-width: 0\n}\n\n.list-group+.panel-footer {\n    border-top-width: 0\n}\n\n.panel>.table,.panel>.table-responsive>.table,.panel>.panel-collapse>.table {\n    margin-bottom: 0\n}\n\n.panel>.table caption,.panel>.table-responsive>.table caption,.panel>.panel-collapse>.table caption {\n    padding-left: 15px;\n    padding-right: 15px\n}\n\n.panel>.table:first-child,.panel>.table-responsive:first-child>.table:first-child {\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px\n}\n\n.panel>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child {\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px\n}\n\n.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child {\n    border-top-left-radius: 3px\n}\n\n.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child {\n    border-top-right-radius: 3px\n}\n\n.panel>.table:last-child,.panel>.table-responsive:last-child>.table:last-child {\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px\n}\n\n.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child {\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 3px\n}\n\n.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child {\n    border-bottom-left-radius: 3px\n}\n\n.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child {\n    border-bottom-right-radius: 3px\n}\n\n.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body {\n    border-top: 1px solid #eaeaea\n}\n\n.panel>.table>tbody:first-child>tr:first-child th,.panel>.table>tbody:first-child>tr:first-child td {\n    border-top: 0\n}\n\n.panel>.table-bordered,.panel>.table-responsive>.table-bordered {\n    border: 0\n}\n\n.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child {\n    border-left: 0\n}\n\n.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child {\n    border-right: 0\n}\n\n.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th {\n    border-bottom: 0\n}\n\n.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th {\n    border-bottom: 0\n}\n\n.panel>.table-responsive {\n    border: 0;\n    margin-bottom: 0\n}\n\n.panel-group {\n    margin-bottom: 20px\n}\n\n.panel-group .panel {\n    margin-bottom: 0;\n    border-radius: 4px\n}\n\n.panel-group .panel+.panel {\n    margin-top: 5px\n}\n\n.panel-group .panel-heading {\n    border-bottom: 0\n}\n\n.panel-group .panel-heading+.panel-collapse>.panel-body,.panel-group .panel-heading+.panel-collapse>.list-group {\n    border-top: 1px solid #ddd\n}\n\n.panel-group .panel-footer {\n    border-top: 0\n}\n\n.panel-group .panel-footer+.panel-collapse .panel-body {\n    border-bottom: 1px solid #ddd\n}\n\n.panel-default {\n    border-color: #ddd\n}\n\n.panel-default>.panel-heading {\n    color: #333;\n    background-color: #f5f5f5;\n    border-color: #ddd\n}\n\n.panel-default>.panel-heading+.panel-collapse>.panel-body {\n    border-top-color: #ddd\n}\n\n.panel-default>.panel-heading .badge {\n    color: #f5f5f5;\n    background-color: #333\n}\n\n.panel-default>.panel-footer+.panel-collapse>.panel-body {\n    border-bottom-color: #ddd\n}\n\n.panel-primary {\n    border-color: #4384d0\n}\n\n.panel-primary>.panel-heading {\n    color: #fff;\n    background-color: #4384d0;\n    border-color: #4384d0\n}\n\n.panel-primary>.panel-heading+.panel-collapse>.panel-body {\n    border-top-color: #4384d0\n}\n\n.panel-primary>.panel-heading .badge {\n    color: #4384d0;\n    background-color: #fff\n}\n\n.panel-primary>.panel-footer+.panel-collapse>.panel-body {\n    border-bottom-color: #4384d0\n}\n\n.panel-success {\n    border-color: rgb(230.6540262172,244.197752809,200.252247191)\n}\n\n.panel-success>.panel-heading {\n    color: #7ed320;\n    background-color: rgb(235.65,248.4,221.55);\n    border-color: rgb(230.6540262172,244.197752809,200.252247191)\n}\n\n.panel-success>.panel-heading+.panel-collapse>.panel-body {\n    border-top-color: rgb(230.6540262172,244.197752809,200.252247191)\n}\n\n.panel-success>.panel-heading .badge {\n    color: rgb(235.65,248.4,221.55);\n    background-color: #7ed320\n}\n\n.panel-success>.panel-footer+.panel-collapse>.panel-body {\n    border-bottom-color: rgb(230.6540262172,244.197752809,200.252247191)\n}\n\n.panel-info {\n    border-color: rgb(207.64,229.9344680851,243.16)\n}\n\n.panel-info>.panel-heading {\n    color: rgb(46.9,92.4,145.6);\n    background-color: rgb(236.2,242.7,250.3);\n    border-color: rgb(207.64,229.9344680851,243.16)\n}\n\n.panel-info>.panel-heading+.panel-collapse>.panel-body {\n    border-top-color: rgb(207.64,229.9344680851,243.16)\n}\n\n.panel-info>.panel-heading .badge {\n    color: rgb(236.2,242.7,250.3);\n    background-color: rgb(46.9,92.4,145.6)\n}\n\n.panel-info>.panel-footer+.panel-collapse>.panel-body {\n    border-bottom-color: rgb(207.64,229.9344680851,243.16)\n}\n\n.panel-warning {\n    border-color: hsl(45.3636363636,94.0170940171%,89.0352941176%)\n}\n\n.panel-warning>.panel-heading {\n    color: #f5a623;\n    background-color: rgb(254.09,251.88,225.49);\n    border-color: hsl(45.3636363636,94.0170940171%,89.0352941176%)\n}\n\n.panel-warning>.panel-heading+.panel-collapse>.panel-body {\n    border-top-color: hsl(45.3636363636,94.0170940171%,89.0352941176%)\n}\n\n.panel-warning>.panel-heading .badge {\n    color: rgb(254.09,251.88,225.49);\n    background-color: #f5a623\n}\n\n.panel-warning>.panel-footer+.panel-collapse>.panel-body {\n    border-bottom-color: hsl(45.3636363636,94.0170940171%,89.0352941176%)\n}\n\n.panel-danger {\n    border-color: rgb(245.3782724252,203.0017275748,215.3871428571)\n}\n\n.panel-danger>.panel-heading {\n    color: #f52323;\n    background-color: rgb(249.36,224.52,227.64);\n    border-color: rgb(245.3782724252,203.0017275748,215.3871428571)\n}\n\n.panel-danger>.panel-heading+.panel-collapse>.panel-body {\n    border-top-color: rgb(245.3782724252,203.0017275748,215.3871428571)\n}\n\n.panel-danger>.panel-heading .badge {\n    color: rgb(249.36,224.52,227.64);\n    background-color: #f52323\n}\n\n.panel-danger>.panel-footer+.panel-collapse>.panel-body {\n    border-bottom-color: rgb(245.3782724252,203.0017275748,215.3871428571)\n}\n\n.embed-responsive {\n    position: relative;\n    display: block;\n    height: 0;\n    padding: 0;\n    overflow: hidden\n}\n\n.embed-responsive .embed-responsive-item,.embed-responsive iframe,.embed-responsive embed,.embed-responsive object,.embed-responsive video {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    height: 100%;\n    width: 100%;\n    border: 0\n}\n\n.embed-responsive-16by9 {\n    padding-bottom: 56.25%\n}\n\n.embed-responsive-4by3 {\n    padding-bottom: 75%\n}\n\n.well {\n    min-height: 20px;\n    padding: 19px;\n    margin-bottom: 20px;\n    background-color: #f5f5f5;\n    border: 1px solid hsl(0,0%,89.0784313725%);\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.05)\n}\n\n.well blockquote {\n    border-color: #ddd;\n    border-color: rgba(0,0,0,.15)\n}\n\n.well-lg {\n    padding: 24px;\n    border-radius: 6px\n}\n\n.well-sm {\n    padding: 9px;\n    border-radius: 3px\n}\n\n.close {\n    float: right;\n    font-size: 21px;\n    font-weight: normal;\n    line-height: 1;\n    color: #000;\n    text-shadow: none;\n    opacity: .2;\n    filter: alpha(opacity=20)\n}\n\n.close:hover,.close:focus {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n    opacity: .5;\n    filter: alpha(opacity=50)\n}\n\nbutton.close {\n    padding: 0;\n    cursor: pointer;\n    background: rgba(0,0,0,0);\n    border: 0;\n    -webkit-appearance: none\n}\n\n.modal-open {\n    overflow: hidden\n}\n\n.modal {\n    display: none;\n    overflow: hidden;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1050;\n    -webkit-overflow-scrolling: touch;\n    outline: 0\n}\n\n.modal.fade .modal-dialog {\n    -webkit-transform: translate(0, -25%);\n    -ms-transform: translate(0, -25%);\n    -o-transform: translate(0, -25%);\n    transform: translate(0, -25%);\n    -webkit-transition: -webkit-transform .3s ease-out;\n    -moz-transition: -moz-transform .3s ease-out;\n    -o-transition: -o-transform .3s ease-out;\n    transition: transform .3s ease-out\n}\n\n.modal.in .modal-dialog {\n    -webkit-transform: translate(0, 0);\n    -ms-transform: translate(0, 0);\n    -o-transform: translate(0, 0);\n    transform: translate(0, 0)\n}\n\n.modal-open .modal {\n    overflow-x: hidden;\n    overflow-y: auto\n}\n\n.modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px\n}\n\n.modal-content {\n    position: relative;\n    background-color: #fff;\n    border: 1px solid #999;\n    border: 1px solid rgba(0,0,0,0);\n    border-radius: 6px;\n    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5);\n    box-shadow: 0 3px 9px rgba(0,0,0,.5);\n    background-clip: padding-box;\n    outline: 0\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1040;\n    background-color: #000\n}\n\n.modal-backdrop.fade {\n    opacity: 0;\n    filter: alpha(opacity=0)\n}\n\n.modal-backdrop.in {\n    opacity: .5;\n    filter: alpha(opacity=50)\n}\n\n.modal-header {\n    padding: 25px 25px 0;\n    border-bottom: 1px solid rgba(0,0,0,0)\n}\n\n.modal-header:before,.modal-header:after {\n    content: \" \";\n    display: table\n}\n\n.modal-header:after {\n    clear: both\n}\n\n.modal-header .close {\n    margin-top: -2px\n}\n\n.modal-title {\n    margin: 0;\n    line-height: 1.428571429\n}\n\n.modal-body {\n    position: relative;\n    padding: 25px\n}\n\n.modal-footer {\n    padding: 25px;\n    text-align: right;\n    border-top: 1px solid rgba(0,0,0,0)\n}\n\n.modal-footer:before,.modal-footer:after {\n    content: \" \";\n    display: table\n}\n\n.modal-footer:after {\n    clear: both\n}\n\n.modal-footer .btn+.btn {\n    margin-left: 5px;\n    margin-bottom: 0\n}\n\n.modal-footer .btn-group .btn+.btn {\n    margin-left: -1px\n}\n\n.modal-footer .btn-block+.btn-block {\n    margin-left: 0\n}\n\n.modal-scrollbar-measure {\n    position: absolute;\n    top: -9999px;\n    width: 50px;\n    height: 50px;\n    overflow: scroll\n}\n\n@media(min-width: 768px) {\n    .modal-dialog {\n        width:600px;\n        margin: 30px auto\n    }\n\n    .modal-content {\n        -webkit-box-shadow: 0 5px 15px rgba(0,0,0,.5);\n        box-shadow: 0 5px 15px rgba(0,0,0,.5)\n    }\n\n    .modal-sm {\n        width: 406px\n    }\n}\n\n@media(min-width: 992px) {\n    .modal-lg {\n        width:900px\n    }\n}\n\n.tooltip {\n    position: absolute;\n    z-index: 1070;\n    display: block;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    line-break: auto;\n    line-height: 1.428571429;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    white-space: normal;\n    word-break: normal;\n    word-spacing: normal;\n    word-wrap: normal;\n    font-size: 12px;\n    opacity: 0;\n    filter: alpha(opacity=0)\n}\n\n.tooltip.in {\n    opacity: .9;\n    filter: alpha(opacity=90)\n}\n\n.tooltip.top {\n    margin-top: -3px;\n    padding: 5px 0\n}\n\n.tooltip.right {\n    margin-left: 3px;\n    padding: 0 5px\n}\n\n.tooltip.bottom {\n    margin-top: 3px;\n    padding: 5px 0\n}\n\n.tooltip.left {\n    margin-left: -3px;\n    padding: 0 5px\n}\n\n.tooltip-inner {\n    max-width: 200px;\n    padding: 3px 8px;\n    color: #fff;\n    text-align: center;\n    background-color: #000;\n    border-radius: 4px\n}\n\n.tooltip-arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-color: rgba(0,0,0,0);\n    border-style: solid\n}\n\n.tooltip.top .tooltip-arrow {\n    bottom: 0;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000\n}\n\n.tooltip.top-left .tooltip-arrow {\n    bottom: 0;\n    right: 5px;\n    margin-bottom: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000\n}\n\n.tooltip.top-right .tooltip-arrow {\n    bottom: 0;\n    left: 5px;\n    margin-bottom: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000\n}\n\n.tooltip.right .tooltip-arrow {\n    top: 50%;\n    left: 0;\n    margin-top: -5px;\n    border-width: 5px 5px 5px 0;\n    border-right-color: #000\n}\n\n.tooltip.left .tooltip-arrow {\n    top: 50%;\n    right: 0;\n    margin-top: -5px;\n    border-width: 5px 0 5px 5px;\n    border-left-color: #000\n}\n\n.tooltip.bottom .tooltip-arrow {\n    top: 0;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000\n}\n\n.tooltip.bottom-left .tooltip-arrow {\n    top: 0;\n    right: 5px;\n    margin-top: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000\n}\n\n.tooltip.bottom-right .tooltip-arrow {\n    top: 0;\n    left: 5px;\n    margin-top: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000\n}\n\n.popover {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1060;\n    display: none;\n    max-width: 265px;\n    padding: 1px;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    line-break: auto;\n    line-height: 1.428571429;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    white-space: normal;\n    word-break: normal;\n    word-spacing: normal;\n    word-wrap: normal;\n    font-size: 14px;\n    background-color: #f3f3f3;\n    background-clip: padding-box;\n    border: 1px solid #f3f3f3;\n    border: 1px solid #f3f3f3;\n    border-radius: 6px;\n    -webkit-box-shadow: 0 5px 10px rgba(0,0,0,.2);\n    box-shadow: 0 5px 10px rgba(0,0,0,.2)\n}\n\n.popover.top {\n    margin-top: -10px\n}\n\n.popover.right {\n    margin-left: 10px\n}\n\n.popover.bottom {\n    margin-top: 10px\n}\n\n.popover.left {\n    margin-left: -10px\n}\n\n.popover-title {\n    margin: 0;\n    padding: 8px 14px;\n    font-size: 14px;\n    background-color: hsl(0,0%,92.2941176471%);\n    border-bottom: 1px solid rgb(222.6,222.6,222.6);\n    border-radius: 5px 5px 0 0\n}\n\n.popover-content {\n    padding: 9px 14px\n}\n\n.popover>.arrow,.popover>.arrow:after {\n    position: absolute;\n    display: block;\n    width: 0;\n    height: 0;\n    border-color: rgba(0,0,0,0);\n    border-style: solid\n}\n\n.popover>.arrow {\n    border-width: 11px\n}\n\n.popover>.arrow:after {\n    border-width: 10px;\n    content: \"\"\n}\n\n.popover.top>.arrow {\n    left: 50%;\n    margin-left: -11px;\n    border-bottom-width: 0;\n    border-top-color: silver;\n    border-top-color: #f3f3f3;\n    bottom: -11px\n}\n\n.popover.top>.arrow:after {\n    content: \" \";\n    bottom: 1px;\n    margin-left: -10px;\n    border-bottom-width: 0;\n    border-top-color: #f3f3f3\n}\n\n.popover.right>.arrow {\n    top: 50%;\n    left: -11px;\n    margin-top: -11px;\n    border-left-width: 0;\n    border-right-color: silver;\n    border-right-color: #f3f3f3\n}\n\n.popover.right>.arrow:after {\n    content: \" \";\n    left: 1px;\n    bottom: -10px;\n    border-left-width: 0;\n    border-right-color: #f3f3f3\n}\n\n.popover.bottom>.arrow {\n    left: 50%;\n    margin-left: -11px;\n    border-top-width: 0;\n    border-bottom-color: silver;\n    border-bottom-color: #f3f3f3;\n    top: -11px\n}\n\n.popover.bottom>.arrow:after {\n    content: \" \";\n    top: 1px;\n    margin-left: -10px;\n    border-top-width: 0;\n    border-bottom-color: #f3f3f3\n}\n\n.popover.left>.arrow {\n    top: 50%;\n    right: -11px;\n    margin-top: -11px;\n    border-right-width: 0;\n    border-left-color: silver;\n    border-left-color: #f3f3f3\n}\n\n.popover.left>.arrow:after {\n    content: \" \";\n    right: 1px;\n    border-right-width: 0;\n    border-left-color: #f3f3f3;\n    bottom: -10px\n}\n\n.carousel {\n    position: relative\n}\n\n.carousel-inner {\n    position: relative;\n    overflow: hidden;\n    width: 100%\n}\n\n.carousel-inner>.item {\n    display: none;\n    position: relative;\n    -webkit-transition: .6s ease-in-out left;\n    -o-transition: .6s ease-in-out left;\n    transition: .6s ease-in-out left\n}\n\n.carousel-inner>.item>img,.carousel-inner>.item>a>img {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    line-height: 1\n}\n\n@media all and (transform-3d),(-webkit-transform-3d) {\n    .carousel-inner>.item {\n        -webkit-transition: -webkit-transform .6s ease-in-out;\n        -moz-transition: -moz-transform .6s ease-in-out;\n        -o-transition: -o-transform .6s ease-in-out;\n        transition: transform .6s ease-in-out;\n        -webkit-backface-visibility: hidden;\n        -moz-backface-visibility: hidden;\n        backface-visibility: hidden;\n        -webkit-perspective: 1000px;\n        -moz-perspective: 1000px;\n        perspective: 1000px\n    }\n\n    .carousel-inner>.item.next,.carousel-inner>.item.active.right {\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0);\n        left: 0\n    }\n\n    .carousel-inner>.item.prev,.carousel-inner>.item.active.left {\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0);\n        left: 0\n    }\n\n    .carousel-inner>.item.next.left,.carousel-inner>.item.prev.right,.carousel-inner>.item.active {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n        left: 0\n    }\n}\n\n.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev {\n    display: block\n}\n\n.carousel-inner>.active {\n    left: 0\n}\n\n.carousel-inner>.next,.carousel-inner>.prev {\n    position: absolute;\n    top: 0;\n    width: 100%\n}\n\n.carousel-inner>.next {\n    left: 100%\n}\n\n.carousel-inner>.prev {\n    left: -100%\n}\n\n.carousel-inner>.next.left,.carousel-inner>.prev.right {\n    left: 0\n}\n\n.carousel-inner>.active.left {\n    left: -100%\n}\n\n.carousel-inner>.active.right {\n    left: 100%\n}\n\n.carousel-control {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 15%;\n    opacity: .5;\n    filter: alpha(opacity=50);\n    font-size: 20px;\n    color: #fff;\n    text-align: center;\n    text-shadow: 0 1px 2px rgba(0,0,0,.6);\n    background-color: rgba(0,0,0,0)\n}\n\n.carousel-control.left {\n    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\", endColorstr=\"#00000000\", GradientType=1)\n}\n\n.carousel-control.right {\n    left: auto;\n    right: 0;\n    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\", endColorstr=\"#80000000\", GradientType=1)\n}\n\n.carousel-control:hover,.carousel-control:focus {\n    outline: 0;\n    color: #fff;\n    text-decoration: none;\n    opacity: .9;\n    filter: alpha(opacity=90)\n}\n\n.carousel-control .icon-prev,.carousel-control .icon-next,.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right {\n    position: absolute;\n    top: 50%;\n    margin-top: -10px;\n    z-index: 5;\n    display: inline-block\n}\n\n.carousel-control .icon-prev,.carousel-control .glyphicon-chevron-left {\n    left: 50%;\n    margin-left: -10px\n}\n\n.carousel-control .icon-next,.carousel-control .glyphicon-chevron-right {\n    right: 50%;\n    margin-right: -10px\n}\n\n.carousel-control .icon-prev,.carousel-control .icon-next {\n    width: 20px;\n    height: 20px;\n    line-height: 1;\n    font-family: serif\n}\n\n.carousel-control .icon-prev:before {\n    content: \"‹\"\n}\n\n.carousel-control .icon-next:before {\n    content: \"›\"\n}\n\n.carousel-indicators {\n    position: absolute;\n    bottom: 10px;\n    left: 50%;\n    z-index: 15;\n    width: 60%;\n    margin-left: -30%;\n    padding-left: 0;\n    list-style: none;\n    text-align: center\n}\n\n.carousel-indicators li {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    margin: 1px;\n    text-indent: -999px;\n    border: 1px solid #fff;\n    border-radius: 10px;\n    cursor: pointer;\n    background-color: #000 \\9 ;\n    background-color: rgba(0,0,0,0)\n}\n\n.carousel-indicators .active {\n    margin: 0;\n    width: 12px;\n    height: 12px;\n    background-color: #fff\n}\n\n.carousel-caption {\n    position: absolute;\n    left: 15%;\n    right: 15%;\n    bottom: 20px;\n    z-index: 10;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    color: #fff;\n    text-align: center;\n    text-shadow: 0 1px 2px rgba(0,0,0,.6)\n}\n\n.carousel-caption .btn {\n    text-shadow: none\n}\n\n@media screen and (min-width: 768px) {\n    .carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-prev,.carousel-control .icon-next {\n        width:30px;\n        height: 30px;\n        margin-top: -10px;\n        font-size: 30px\n    }\n\n    .carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev {\n        margin-left: -10px\n    }\n\n    .carousel-control .glyphicon-chevron-right,.carousel-control .icon-next {\n        margin-right: -10px\n    }\n\n    .carousel-caption {\n        left: 20%;\n        right: 20%;\n        padding-bottom: 30px\n    }\n\n    .carousel-indicators {\n        bottom: 20px\n    }\n}\n\n.clearfix:before,.clearfix:after {\n    content: \" \";\n    display: table\n}\n\n.clearfix:after {\n    clear: both\n}\n\n.center-block {\n    display: block;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.pull-right {\n    float: right !important\n}\n\n.pull-left {\n    float: left !important\n}\n\n.hide {\n    display: none !important\n}\n\n.show {\n    display: block !important\n}\n\n.invisible {\n    visibility: hidden\n}\n\n.text-hide {\n    font: 0/0 a;\n    color: rgba(0,0,0,0);\n    text-shadow: none;\n    background-color: rgba(0,0,0,0);\n    border: 0\n}\n\n.hidden {\n    display: none !important\n}\n\n.affix {\n    position: fixed\n}\n\n@-ms-viewport {\n    width: device-width\n}\n\n.visible-xs {\n    display: none !important\n}\n\n.visible-sm {\n    display: none !important\n}\n\n.visible-md {\n    display: none !important\n}\n\n.visible-lg {\n    display: none !important\n}\n\n.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block {\n    display: none !important\n}\n\n@media(max-width: 767px) {\n    .visible-xs {\n        display:block !important\n    }\n\n    table.visible-xs {\n        display: table !important\n    }\n\n    tr.visible-xs {\n        display: table-row !important\n    }\n\n    th.visible-xs,td.visible-xs {\n        display: table-cell !important\n    }\n}\n\n@media(max-width: 767px) {\n    .visible-xs-block {\n        display:block !important\n    }\n}\n\n@media(max-width: 767px) {\n    .visible-xs-inline {\n        display:inline !important\n    }\n}\n\n@media(max-width: 767px) {\n    .visible-xs-inline-block {\n        display:inline-block !important\n    }\n}\n\n@media(min-width: 768px)and (max-width: 991px) {\n    .visible-sm {\n        display:block !important\n    }\n\n    table.visible-sm {\n        display: table !important\n    }\n\n    tr.visible-sm {\n        display: table-row !important\n    }\n\n    th.visible-sm,td.visible-sm {\n        display: table-cell !important\n    }\n}\n\n@media(min-width: 768px)and (max-width: 991px) {\n    .visible-sm-block {\n        display:block !important\n    }\n}\n\n@media(min-width: 768px)and (max-width: 991px) {\n    .visible-sm-inline {\n        display:inline !important\n    }\n}\n\n@media(min-width: 768px)and (max-width: 991px) {\n    .visible-sm-inline-block {\n        display:inline-block !important\n    }\n}\n\n@media(min-width: 992px)and (max-width: 1199px) {\n    .visible-md {\n        display:block !important\n    }\n\n    table.visible-md {\n        display: table !important\n    }\n\n    tr.visible-md {\n        display: table-row !important\n    }\n\n    th.visible-md,td.visible-md {\n        display: table-cell !important\n    }\n}\n\n@media(min-width: 992px)and (max-width: 1199px) {\n    .visible-md-block {\n        display:block !important\n    }\n}\n\n@media(min-width: 992px)and (max-width: 1199px) {\n    .visible-md-inline {\n        display:inline !important\n    }\n}\n\n@media(min-width: 992px)and (max-width: 1199px) {\n    .visible-md-inline-block {\n        display:inline-block !important\n    }\n}\n\n@media(min-width: 1200px) {\n    .visible-lg {\n        display:block !important\n    }\n\n    table.visible-lg {\n        display: table !important\n    }\n\n    tr.visible-lg {\n        display: table-row !important\n    }\n\n    th.visible-lg,td.visible-lg {\n        display: table-cell !important\n    }\n}\n\n@media(min-width: 1200px) {\n    .visible-lg-block {\n        display:block !important\n    }\n}\n\n@media(min-width: 1200px) {\n    .visible-lg-inline {\n        display:inline !important\n    }\n}\n\n@media(min-width: 1200px) {\n    .visible-lg-inline-block {\n        display:inline-block !important\n    }\n}\n\n@media(max-width: 767px) {\n    .hidden-xs {\n        display:none !important\n    }\n}\n\n@media(min-width: 768px)and (max-width: 991px) {\n    .hidden-sm {\n        display:none !important\n    }\n}\n\n@media(min-width: 992px)and (max-width: 1199px) {\n    .hidden-md {\n        display:none !important\n    }\n}\n\n@media(min-width: 1200px) {\n    .hidden-lg {\n        display:none !important\n    }\n}\n\n.visible-print {\n    display: none !important\n}\n\n@media print {\n    .visible-print {\n        display: block !important\n    }\n\n    table.visible-print {\n        display: table !important\n    }\n\n    tr.visible-print {\n        display: table-row !important\n    }\n\n    th.visible-print,td.visible-print {\n        display: table-cell !important\n    }\n}\n\n.visible-print-block {\n    display: none !important\n}\n\n@media print {\n    .visible-print-block {\n        display: block !important\n    }\n}\n\n.visible-print-inline {\n    display: none !important\n}\n\n@media print {\n    .visible-print-inline {\n        display: inline !important\n    }\n}\n\n.visible-print-inline-block {\n    display: none !important\n}\n\n@media print {\n    .visible-print-inline-block {\n        display: inline-block !important\n    }\n}\n\n@media print {\n    .hidden-print {\n        display: none !important\n    }\n}\n\n/*!\n * Bootstrap-select v1.13.2 (https://developer.snapappointments.com/bootstrap-select)\n *\n * Copyright 2012-2018 SnapAppointments, LLC\n * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)\n */\nselect.bs-select-hidden,.bootstrap-select>select.bs-select-hidden,select.selectpicker {\n    display: none !important\n}\n\n.bootstrap-select {\n    width: 220px \\0\n}\n\n.bootstrap-select>.dropdown-toggle {\n    position: relative;\n    width: 100%;\n    z-index: 1;\n    text-align: right;\n    white-space: nowrap\n}\n\n.bootstrap-select>.dropdown-toggle.bs-placeholder,.bootstrap-select>.dropdown-toggle.bs-placeholder:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder:active {\n    color: #999\n}\n\n.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-primary,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-secondary,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-success,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-danger,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-info,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-dark,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-primary:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-secondary:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-success:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-danger:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-info:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-dark:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-primary:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-secondary:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-success:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-danger:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-info:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-dark:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-primary:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-secondary:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-success:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-danger:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-info:active,.bootstrap-select>.dropdown-toggle.bs-placeholder.btn-dark:active {\n    color: hsla(0,0%,100%,.5)\n}\n\n.bootstrap-select>select {\n    position: absolute !important;\n    bottom: 0;\n    left: 50%;\n    display: block !important;\n    width: .5px !important;\n    height: 100% !important;\n    padding: 0 !important;\n    opacity: 0 !important;\n    border: none\n}\n\n.bootstrap-select>select.mobile-device {\n    top: 0;\n    left: 0;\n    display: block !important;\n    width: 100% !important;\n    z-index: 2\n}\n\n.has-error .bootstrap-select .dropdown-toggle,.error .bootstrap-select .dropdown-toggle,.bootstrap-select.is-invalid .dropdown-toggle,.was-validated .bootstrap-select .selectpicker:invalid+.dropdown-toggle {\n    border-color: #f52323\n}\n\n.bootstrap-select.is-valid .dropdown-toggle,.was-validated .bootstrap-select .selectpicker:valid+.dropdown-toggle {\n    border-color: #28a745\n}\n\n.bootstrap-select.fit-width {\n    width: auto !important\n}\n\n.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {\n    width: 220px\n}\n\n.bootstrap-select .dropdown-toggle:focus {\n    outline: thin dotted #333 !important;\n    outline: 5px auto -webkit-focus-ring-color !important;\n    outline-offset: -2px\n}\n\n.bootstrap-select.form-control {\n    margin-bottom: 0;\n    padding: 0;\n    border: none\n}\n\n:not(.input-group)>.bootstrap-select.form-control:not([class*=col-]) {\n    width: 100%\n}\n\n.bootstrap-select.form-control.input-group-btn {\n    z-index: auto\n}\n\n.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child)>.btn {\n    border-radius: 0\n}\n\n.bootstrap-select:not(.input-group-btn),.bootstrap-select[class*=col-] {\n    float: none;\n    display: inline-block;\n    margin-left: 0\n}\n\n.bootstrap-select.dropdown-menu-right,.bootstrap-select[class*=col-].dropdown-menu-right,.row .bootstrap-select[class*=col-].dropdown-menu-right {\n    float: right\n}\n\n.form-inline .bootstrap-select,.form-horizontal .bootstrap-select,.form-group .bootstrap-select {\n    margin-bottom: 0\n}\n\n.form-group-lg .bootstrap-select.form-control,.form-group-sm .bootstrap-select.form-control {\n    padding: 0\n}\n\n.form-group-lg .bootstrap-select.form-control .dropdown-toggle,.form-group-sm .bootstrap-select.form-control .dropdown-toggle {\n    height: 100%;\n    font-size: inherit;\n    line-height: inherit;\n    border-radius: inherit\n}\n\n.bootstrap-select.form-control-sm .dropdown-toggle,.bootstrap-select.form-control-lg .dropdown-toggle {\n    font-size: inherit;\n    line-height: inherit;\n    border-radius: inherit\n}\n\n.bootstrap-select.form-control-sm .dropdown-toggle {\n    padding: .25rem .5rem\n}\n\n.bootstrap-select.form-control-lg .dropdown-toggle {\n    padding: .5rem 1rem\n}\n\n.form-inline .bootstrap-select .form-control {\n    width: 100%\n}\n\n.bootstrap-select.disabled,.bootstrap-select>.disabled {\n    cursor: not-allowed\n}\n\n.bootstrap-select.disabled:focus,.bootstrap-select>.disabled:focus {\n    outline: none !important\n}\n\n.bootstrap-select.bs-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 0 !important;\n    padding: 0 !important\n}\n\n.bootstrap-select.bs-container .dropdown-menu {\n    z-index: 1060\n}\n\n.bootstrap-select .dropdown-toggle:before {\n    content: \"\";\n    display: inline-block\n}\n\n.bootstrap-select .dropdown-toggle .filter-option {\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding-top: inherit;\n    padding-right: inherit;\n    padding-bottom: inherit;\n    padding-left: inherit;\n    height: 100%;\n    width: 100%;\n    text-align: left\n}\n\n.bootstrap-select .dropdown-toggle .filter-option-inner {\n    padding-right: inherit\n}\n\n.bootstrap-select .dropdown-toggle .filter-option-inner-inner {\n    overflow: hidden\n}\n\n.bootstrap-select .dropdown-toggle .caret {\n    position: absolute;\n    top: 50%;\n    right: 12px;\n    margin-top: -2px;\n    vertical-align: middle\n}\n\n.input-group .bootstrap-select.form-control .dropdown-toggle {\n    border-radius: inherit\n}\n\n.bootstrap-select[class*=col-] .dropdown-toggle {\n    width: 100%\n}\n\n.bootstrap-select .dropdown-menu {\n    min-width: 100%;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box\n}\n\n.bootstrap-select .dropdown-menu>.inner:focus {\n    outline: none !important\n}\n\n.bootstrap-select .dropdown-menu.inner {\n    position: static;\n    float: none;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    border-radius: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\n.bootstrap-select .dropdown-menu li {\n    position: relative\n}\n\n.bootstrap-select .dropdown-menu li.active small {\n    color: hsla(0,0%,100%,.5) !important\n}\n\n.bootstrap-select .dropdown-menu li.disabled a {\n    cursor: not-allowed\n}\n\n.bootstrap-select .dropdown-menu li a {\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none\n}\n\n.bootstrap-select .dropdown-menu li a.opt {\n    position: relative;\n    padding-left: 2.25em\n}\n\n.bootstrap-select .dropdown-menu li a span.check-mark {\n    display: none\n}\n\n.bootstrap-select .dropdown-menu li a span.text {\n    display: inline-block\n}\n\n.bootstrap-select .dropdown-menu li small {\n    padding-left: .5em\n}\n\n.bootstrap-select .dropdown-menu .notify {\n    position: absolute;\n    bottom: 5px;\n    width: 96%;\n    margin: 0 2%;\n    min-height: 26px;\n    padding: 3px 5px;\n    background: #f5f5f5;\n    border: 1px solid #e3e3e3;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);\n    pointer-events: none;\n    opacity: .9;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box\n}\n\n.bootstrap-select .no-results {\n    padding: 3px;\n    background: #f5f5f5;\n    margin: 0 5px;\n    white-space: nowrap\n}\n\n.bootstrap-select.fit-width .dropdown-toggle .filter-option {\n    position: static;\n    display: inline;\n    padding: 0\n}\n\n.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner,.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner-inner {\n    display: inline\n}\n\n.bootstrap-select.fit-width .dropdown-toggle .caret {\n    position: static;\n    top: auto;\n    margin-top: -1px\n}\n\n.bootstrap-select.show-tick .dropdown-menu .selected span.check-mark {\n    position: absolute;\n    display: inline-block;\n    right: 15px;\n    top: 5px\n}\n\n.bootstrap-select.show-tick .dropdown-menu li a span.text {\n    margin-right: 34px\n}\n\n.bootstrap-select .bs-ok-default:after {\n    content: \"\";\n    display: block;\n    width: .5em;\n    height: 1em;\n    border-style: solid;\n    border-width: 0 .26em .26em 0;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg)\n}\n\n.bootstrap-select.show-menu-arrow.open>.dropdown-toggle,.bootstrap-select.show-menu-arrow.show>.dropdown-toggle {\n    z-index: 1061\n}\n\n.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:before {\n    content: \"\";\n    border-left: 7px solid rgba(0,0,0,0);\n    border-right: 7px solid rgba(0,0,0,0);\n    border-bottom: 7px solid hsla(0,0%,80%,.2);\n    position: absolute;\n    bottom: -4px;\n    left: 9px;\n    display: none\n}\n\n.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:after {\n    content: \"\";\n    border-left: 6px solid rgba(0,0,0,0);\n    border-right: 6px solid rgba(0,0,0,0);\n    border-bottom: 6px solid #fff;\n    position: absolute;\n    bottom: -4px;\n    left: 10px;\n    display: none\n}\n\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:before {\n    bottom: auto;\n    top: -4px;\n    border-top: 7px solid hsla(0,0%,80%,.2);\n    border-bottom: 0\n}\n\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:after {\n    bottom: auto;\n    top: -4px;\n    border-top: 6px solid #fff;\n    border-bottom: 0\n}\n\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:before {\n    right: 12px;\n    left: auto\n}\n\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:after {\n    right: 13px;\n    left: auto\n}\n\n.bootstrap-select.show-menu-arrow.open>.dropdown-toggle .filter-option:before,.bootstrap-select.show-menu-arrow.show>.dropdown-toggle .filter-option:before,.bootstrap-select.show-menu-arrow.open>.dropdown-toggle .filter-option:after,.bootstrap-select.show-menu-arrow.show>.dropdown-toggle .filter-option:after {\n    display: block\n}\n\n.bs-searchbox,.bs-actionsbox,.bs-donebutton {\n    padding: 4px 8px\n}\n\n.bs-actionsbox {\n    width: 100%;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box\n}\n\n.bs-actionsbox .btn-group button {\n    width: 50%\n}\n\n.bs-donebutton {\n    float: left;\n    width: 100%;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box\n}\n\n.bs-donebutton .btn-group button {\n    width: 100%\n}\n\n.bs-searchbox+.bs-actionsbox {\n    padding: 0 8px 4px\n}\n\n.bs-searchbox .form-control {\n    margin-bottom: 0;\n    width: 100%;\n    float: none\n}\n\n.m-0 {\n    margin: 0 !important\n}\n\n.mt-0,.my-0 {\n    margin-top: 0 !important\n}\n\n.mr-0,.mx-0 {\n    margin-right: 0 !important\n}\n\n.mb-0,.my-0 {\n    margin-bottom: 0 !important\n}\n\n.ml-0,.mx-0 {\n    margin-left: 0 !important\n}\n\n.m-1 {\n    margin: .25rem !important\n}\n\n.mt-1,.my-1 {\n    margin-top: .25rem !important\n}\n\n.mr-1,.mx-1 {\n    margin-right: .25rem !important\n}\n\n.mb-1,.my-1 {\n    margin-bottom: .25rem !important\n}\n\n.ml-1,.mx-1 {\n    margin-left: .25rem !important\n}\n\n.m-2 {\n    margin: .5rem !important\n}\n\n.mt-2,.my-2 {\n    margin-top: .5rem !important\n}\n\n.mr-2,.mx-2 {\n    margin-right: .5rem !important\n}\n\n.mb-2,.my-2 {\n    margin-bottom: .5rem !important\n}\n\n.ml-2,.mx-2 {\n    margin-left: .5rem !important\n}\n\n.m-3 {\n    margin: 1rem !important\n}\n\n.mt-3,.my-3 {\n    margin-top: 1rem !important\n}\n\n.mr-3,.mx-3 {\n    margin-right: 1rem !important\n}\n\n.mb-3,.my-3 {\n    margin-bottom: 1rem !important\n}\n\n.ml-3,.mx-3 {\n    margin-left: 1rem !important\n}\n\n.m-4 {\n    margin: 1.5rem !important\n}\n\n.mt-4,.my-4 {\n    margin-top: 1.5rem !important\n}\n\n.mr-4,.mx-4 {\n    margin-right: 1.5rem !important\n}\n\n.mb-4,.my-4 {\n    margin-bottom: 1.5rem !important\n}\n\n.ml-4,.mx-4 {\n    margin-left: 1.5rem !important\n}\n\n.m-5 {\n    margin: 3rem !important\n}\n\n.mt-5,.my-5 {\n    margin-top: 3rem !important\n}\n\n.mr-5,.mx-5 {\n    margin-right: 3rem !important\n}\n\n.mb-5,.my-5 {\n    margin-bottom: 3rem !important\n}\n\n.ml-5,.mx-5 {\n    margin-left: 3rem !important\n}\n\n.p-0 {\n    padding: 0 !important\n}\n\n.pt-0,.py-0 {\n    padding-top: 0 !important\n}\n\n.pr-0,.px-0 {\n    padding-right: 0 !important\n}\n\n.pb-0,.py-0 {\n    padding-bottom: 0 !important\n}\n\n.pl-0,.px-0 {\n    padding-left: 0 !important\n}\n\n.p-1 {\n    padding: .25rem !important\n}\n\n.pt-1,.py-1 {\n    padding-top: .25rem !important\n}\n\n.pr-1,.px-1 {\n    padding-right: .25rem !important\n}\n\n.pb-1,.py-1 {\n    padding-bottom: .25rem !important\n}\n\n.pl-1,.px-1 {\n    padding-left: .25rem !important\n}\n\n.p-2 {\n    padding: .5rem !important\n}\n\n.pt-2,.py-2 {\n    padding-top: .5rem !important\n}\n\n.pr-2,.px-2 {\n    padding-right: .5rem !important\n}\n\n.pb-2,.py-2 {\n    padding-bottom: .5rem !important\n}\n\n.pl-2,.px-2 {\n    padding-left: .5rem !important\n}\n\n.p-3 {\n    padding: 1rem !important\n}\n\n.pt-3,.py-3 {\n    padding-top: 1rem !important\n}\n\n.pr-3,.px-3 {\n    padding-right: 1rem !important\n}\n\n.pb-3,.py-3 {\n    padding-bottom: 1rem !important\n}\n\n.pl-3,.px-3 {\n    padding-left: 1rem !important\n}\n\n.p-4 {\n    padding: 1.5rem !important\n}\n\n.pt-4,.py-4 {\n    padding-top: 1.5rem !important\n}\n\n.pr-4,.px-4 {\n    padding-right: 1.5rem !important\n}\n\n.pb-4,.py-4 {\n    padding-bottom: 1.5rem !important\n}\n\n.pl-4,.px-4 {\n    padding-left: 1.5rem !important\n}\n\n.p-5 {\n    padding: 3rem !important\n}\n\n.pt-5,.py-5 {\n    padding-top: 3rem !important\n}\n\n.pr-5,.px-5 {\n    padding-right: 3rem !important\n}\n\n.pb-5,.py-5 {\n    padding-bottom: 3rem !important\n}\n\n.pl-5,.px-5 {\n    padding-left: 3rem !important\n}\n\n.m-auto {\n    margin: auto !important\n}\n\n.mt-auto,.my-auto {\n    margin-top: auto !important\n}\n\n.mr-auto,.mx-auto {\n    margin-right: auto !important\n}\n\n.mb-auto,.my-auto {\n    margin-bottom: auto !important\n}\n\n.ml-auto,.mx-auto {\n    margin-left: auto !important\n}\n\n.counter-list {\n    margin-right: -6px;\n    margin-bottom: 17px\n}\n\n.counter-list .counter-item {\n    display: inline-block;\n    position: relative;\n    vertical-align: middle;\n    overflow: hidden;\n    text-decoration: none;\n    background: #f5f5f5;\n    border-radius: 20px;\n    padding: 12px 22px;\n    margin-right: 6px;\n    margin-bottom: 7px\n}\n\n.counter-list .counter-item.active {\n    background: #222;\n    color: #fff\n}\n\n.counter-list .counter-item:hover,.counter-list .counter-item:active,.counter-list .counter-item:focus {\n    text-decoration: none;\n    outline: none\n}\n\n.counter-list .counter-param,.counter-list .counter-value {\n    display: inline-block;\n    margin-left: 2px;\n    margin-right: 2px\n}\n\n.counter-list .counter-param {\n    font-weight: bold\n}\n\n.counter-list .counter-value {\n    font-size: 11px\n}\n\n@media(max-width: 991px) {\n    .counter-list .counter-item {\n        width:auto !important;\n        height: auto !important\n    }\n}\n\n@media(min-width: 992px) {\n    .counter-list.counter-list-pills {\n        margin-top:10px\n    }\n\n    .counter-list.counter-list-pills .counter-item {\n        margin-bottom: 10px;\n        width: auto !important;\n        height: auto !important\n    }\n\n    .counter-list.counter-list-circles {\n        margin-bottom: 2px\n    }\n\n    .counter-list.counter-list-circles .counter-item {\n        border-radius: 50%;\n        margin-bottom: 10px;\n        width: 100px;\n        height: 100px\n    }\n\n    .counter-list.counter-list-circles .counter-item .inside {\n        position: absolute;\n        top: 50%;\n        left: 10px;\n        right: 10px;\n        margin-top: 4px;\n        text-align: center;\n        -webkit-transform: translate(0, -50%);\n        -ms-transform: translate(0, -50%);\n        -o-transform: translate(0, -50%);\n        transform: translate(0, -50%)\n    }\n\n    .counter-list.counter-list-circles .counter-param,.counter-list.counter-list-circles .counter-value {\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .counter-list.counter-list-circles .counter-param {\n        display: flex;\n        justify-content: center\n    }\n\n    .counter-list.counter-list-circles .counter-value {\n        display: block;\n        margin-top: 4px\n    }\n\n    .counter-list.counter-list-circles.counter-list-wide {\n        margin-right: -26px\n    }\n\n    .counter-list.counter-list-circles.counter-list-wide .counter-item {\n        margin-right: 26px\n    }\n}\n\n.nav-similar-games {\n    padding-left: 0;\n    list-style: none;\n    margin: 0 0 15px;\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px 20px\n}\n\n.nav-similar-games__item {\n    flex: 0 0 auto;\n    text-align: center\n}\n\n.nav-similar-games__circle {\n    display: inline-block;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: #f9f9f9;\n    background-size: 100%;\n    background-repeat: no-repeat;\n    vertical-align: middle\n}\n\n.nav-similar-games__link {\n    display: inline-block;\n    font-weight: bold;\n    vertical-align: middle;\n    margin-left: .4em\n}\n\n.nav-similar-games__item-active .nav-similar-games__link,.nav-similar-games__item-active .nav-similar-games__link:hover,.nav-similar-games__item-active .nav-similar-games__link:focus,.nav-similar-games__item-active .nav-similar-games__link:active {\n    color: #222;\n    text-decoration: none;\n    outline: none\n}\n\n@media(max-width: 767px) {\n    .nav-similar-games {\n        margin-left:-10px;\n        margin-right: -10px;\n        padding-left: 10px;\n        padding-right: 10px;\n        flex-wrap: nowrap;\n        gap: 0;\n        overflow-x: auto;\n        overflow-y: hidden;\n        -webkit-overflow-scrolling: touch;\n        -ms-overflow-style: none;\n        scrollbar-width: none\n    }\n\n    .nav-similar-games::-webkit-scrollbar {\n        display: none\n    }\n\n    .nav-similar-games__item {\n        width: 80px\n    }\n}\n\n@media(max-width: 767px)and (min-width: 385px) {\n    .nav-similar-games__item {\n        width:85px\n    }\n}\n\n@media(max-width: 767px)and (min-width: 410px) {\n    .nav-similar-games__item {\n        width:90px\n    }\n}\n\n@media(max-width: 767px) {\n    .nav-similar-games__circle {\n        display:block;\n        margin: auto\n    }\n\n    .nav-similar-games__link {\n        display: flex;\n        justify-content: center;\n        margin: .3em auto auto;\n        white-space: normal\n    }\n}\n\n.megaswitch-items {\n    padding-left: 0;\n    list-style: none;\n    margin-bottom: 0\n}\n\n.megaswitch-disabled .megaswitch-items {\n    cursor: not-allowed;\n    opacity: .65;\n    filter: alpha(opacity=65)\n}\n\n.megaswitch-head-title {\n    font-weight: bold;\n    margin-bottom: 10px\n}\n\n.megaswitch-radio {\n    display: flex;\n    align-items: center;\n    cursor: pointer\n}\n\n.megaswitch-locked .megaswitch-radio {\n    cursor: default\n}\n\n.megaswitch-disabled .megaswitch-radio {\n    cursor: not-allowed\n}\n\n.megaswitch-radio+.megaswitch-radio {\n    margin-top: 10px\n}\n\n.megaswitch-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid #b1b1b1;\n    border-radius: 50%;\n    margin-right: 10px;\n    color: #fff;\n    font-size: 9px;\n    overflow: hidden\n}\n\n.megaswitch-icon i {\n    display: none\n}\n\n.megaswitch-locked .megaswitch-icon {\n    border-color: rgba(0,0,0,0)\n}\n\n.megaswitch-radio.active .megaswitch-icon {\n    border: 5px solid #4384d0\n}\n\n.megaswitch-locked .megaswitch-radio.active .megaswitch-icon {\n    background-color: #4384d0;\n    border: 0\n}\n\n.megaswitch-locked .megaswitch-radio.active .megaswitch-icon i {\n    display: inline-block\n}\n\n.megaswitch-content {\n    display: flex;\n    flex-direction: column\n}\n\n.megaswitch-title {\n    font-weight: bold\n}\n\n.video-box-fake {\n    aspect-ratio: 16/9;\n    width: 100%;\n    height: auto;\n    position: relative\n}\n\n.video-box-fake .video-box-fake__play-button svg path:nth-child(1) {\n    fill: #212121\n}\n\n.video-box-fake:hover .video-box-fake__play-button svg path:nth-child(1) {\n    fill: red\n}\n\n.video-box-fake__link {\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat\n}\n\n.video-box-fake__play-button {\n    width: 68px;\n    height: 48px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none\n}\n\n.video-box-fake__play-button svg {\n    display: block\n}\n\n.attachments-list {\n    padding-left: 0;\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px\n}\n\n.attachments-item {\n    width: 96px;\n    height: 96px;\n    border-radius: 4px;\n    background-color: #f9f9f9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    overflow: hidden;\n    float: left\n}\n\n.attachments-item .attachments-thumb {\n    display: block;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    cursor: pointer\n}\n\n.attachments-item img {\n    object-fit: cover\n}\n\n.attachments-item a.attachments-thumb {\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat\n}\n\n.attachments-new {\n    cursor: pointer;\n    font-size: 30px;\n    color: #4384d0;\n    background-color: #fff;\n    border: 1px solid #e4e4e4\n}\n\n.attachments-upload-spinner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 40px;\n    height: 40px;\n    margin-left: -20px;\n    margin-top: -20px;\n    background-color: rgba(0,0,0,.5);\n    border-radius: 50%;\n    color: #fff;\n    border: 3px solid rgba(0,0,0,0);\n    z-index: 2\n}\n\n.attachments-upload-spinner::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    border: 2px solid #fff;\n    border-top-color: rgba(0,0,0,0);\n    border-radius: 50%;\n    animation: attachments-upload-spinner-animation 2s linear infinite\n}\n\n@keyframes attachments-upload-spinner-animation {\n    0% {\n        transform: rotate(0deg)\n    }\n\n    100% {\n        transform: rotate(360deg)\n    }\n}\n\n.attachments-upload-cancel {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 3;\n    cursor: pointer\n}\n\n.attachments-upload-cancel::before,.attachments-upload-cancel::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 16px;\n    height: 2px;\n    background-color: #fff\n}\n\n.attachments-upload-cancel::before {\n    transform: translate(-50%, -50%) rotate(45deg)\n}\n\n.attachments-upload-cancel::after {\n    transform: translate(-50%, -50%) rotate(-45deg)\n}\n\n.attachments-controls {\n    padding-left: 0;\n    list-style: none;\n    display: flex;\n    flex-wrap: nowrap;\n    background-color: rgba(0,0,0,.5);\n    color: #fff;\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    padding: 0;\n    border-radius: 3px;\n    font-size: 13px;\n    z-index: 2\n}\n\n.attachments-control {\n    padding: 4px 10px;\n    cursor: pointer\n}\n\n.ui-sortable-handle {\n    -ms-touch-action: none;\n    touch-action: none\n}\n\n\n\n\n::selection {\n    background-color: #bfddff;\n    color: #222;\n    text-shadow: none\n}\n\n-webkit-::selection {\n    background-color: #bfddff;\n    color: #222;\n    text-shadow: none\n}\n\n::-moz-selection {\n    background-color: #bfddff;\n    color: #222;\n    text-shadow: none\n}\n\nimg {\n    display: inline-block;\n    max-width: 100%\n}\n\nhtml>body .mt0 {\n    margin-top: 0\n}\n\nhtml>body .mt10 {\n    margin-top: 10px\n}\n\nhtml>body .mt20 {\n    margin-top: 20px\n}\n\nhtml>body .mt35 {\n    margin-top: 35px\n}\n\nhtml>body .mb0 {\n    margin-bottom: 0\n}\n\nhtml>body .mb5 {\n    margin-bottom: 5px\n}\n\nhtml>body .mb10 {\n    margin-bottom: 10px\n}\n\nhtml>body .mb20 {\n    margin-bottom: 20px\n}\n\nhtml>body .mb25 {\n    margin-bottom: 25px\n}\n\nhtml>body .mb35 {\n    margin-bottom: 35px\n}\n\nhtml>body .mb40 {\n    margin-bottom: 40px\n}\n\nhtml>body .mb50 {\n    margin-bottom: 50px\n}\n\nhtml>body .mr4 {\n    margin-right: 4px\n}\n\nhtml>body .mr10 {\n    margin-right: 10px\n}\n\nhtml>body .mr20 {\n    margin-right: 20px\n}\n\nhtml>body .mr25 {\n    margin-right: 25px\n}\n\nhtml>body .pb0 {\n    padding-bottom: 0\n}\n\n.wfull {\n    width: 100%\n}\n\n.w-200px {\n    width: 200px\n}\n\n.w-50 {\n    width: 50% !important\n}\n\n.font-custom {\n    font-family: \"Graphik Bold\",\"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\n.text-mini {\n    font-size: 11px\n}\n\n.text-lg {\n    font-size: 17px\n}\n\n.text-xl {\n    font-size: 21px\n}\n\n.text-light {\n    color: #888\n}\n\n.bg-light-style .text-light {\n    color: #555\n}\n\n.text-info-muted {\n    color: rgb(130.14,157.44,189.36)\n}\n\na.text-info-muted:hover,a.text-info-muted:focus {\n    color: rgb(96.7129133858,131.3215748031,171.7870866142)\n}\n\n.page-header {\n    padding-bottom: 30px\n}\n\n.page-content-full .page-header,.with-corner-cd .page-header {\n    margin-top: 0\n}\n\n.page-header.page-header-no-hr {\n    padding-bottom: 0;\n    border-bottom: 0\n}\n\n.page-header.page-header-params {\n    margin-bottom: 30px\n}\n\n.page-header h1 {\n    padding: 0;\n    margin: 0\n}\n\nhtml>body .text-normal {\n    font-weight: normal\n}\n\n.text-medium {\n    font-weight: 500\n}\n\n.text-bold {\n    font-weight: bold\n}\n\na.text-muted:hover,a.text-muted:focus {\n    color: #a6a6a6\n}\n\nth.table-col-narrow,td.table-col-narrow {\n    width: 1%\n}\n\n.block-info {\n    color: #777;\n    letter-spacing: 1px\n}\n\n.bg-light-color {\n    background: #f9f9f9\n}\n\nh1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,.h1:first-child,.h2:first-child,.h3:first-child,.h4:first-child,.h5:first-child,.h6:first-child {\n    margin-top: 0\n}\n\nh1,.h1 {\n    margin-top: 15px;\n    line-height: 1;\n    font-family: \"Graphik Bold\",\"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\nh2,.h2 {\n    font-family: \"Graphik Bold\",\"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\nh3,h4,.h3,.h4 {\n    font-weight: bold\n}\n\ndl {\n    margin-bottom: 30px\n}\n\nh5,.h5,.form-group>label {\n    font-size: 9px;\n    line-height: 14px;\n    vertical-align: top;\n    margin-bottom: 7px;\n    text-transform: uppercase;\n    font-weight: normal;\n    letter-spacing: 1.3px;\n    color: #666\n}\n\nlabel+.radio {\n    margin-top: 0\n}\n\n.first-radio-no-margin .radio:first-child {\n    margin-top: 0\n}\n\n.first-checkbox-no-margin .checkbox:first-child {\n    margin-top: 0\n}\n\n.has-feedback label~.form-control-feedback {\n    top: 21px\n}\n\n.row-20 {\n    margin-left: -10px;\n    margin-right: -10px\n}\n\n.row-20>[class^=col-],.row-20>[class*=\" col-\"] {\n    padding-left: 10px;\n    padding-right: 10px\n}\n\n.inline-block {\n    display: inline-block\n}\n\n.inline-block-vat {\n    display: inline-block;\n    vertical-align: top\n}\n\n.form-control-inline {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle\n}\n\ninput[type=range].range-premium {\n    appearance: auto\n}\n\n.flex {\n    display: flex;\n    flex-wrap: wrap\n}\n\n.flex:before,.flex:after {\n    display: none\n}\n\n.flex [class^=col-],.flex [class*=\" col-\"] {\n    float: none\n}\n\n@media(min-width: 768px) {\n    .flex-nowrap {\n        display:flex;\n        flex-wrap: nowrap\n    }\n\n    .flex-nowrap:before,.flex-nowrap:after {\n        display: none\n    }\n\n    .flex-nowrap>div {\n        width: 100%\n    }\n}\n\n.row-inline [class^=col-],.row-inline [class*=\" col-\"] {\n    float: none;\n    display: inline-block;\n    vertical-align: top;\n    margin-right: -4px\n}\n\n.vertical-middle,.row-middle>[class^=col-],.row-middle>[class*=\" col-\"] {\n    vertical-align: middle\n}\n\n@media(max-width: 767px) {\n    .container {\n        padding-left:10px;\n        padding-right: 10px\n    }\n\n    .row {\n        margin-left: -10px;\n        margin-right: -10px\n    }\n\n    .row [class^=col-],.row [class*=\" col-\"] {\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .row-inline .col-xs-12 {\n        display: block;\n        width: 100%;\n        margin-right: 0\n    }\n}\n\n.row-10 {\n    margin-left: -5px;\n    margin-right: -5px\n}\n\n.row-10>[class^=col-],.row-10>[class*=\" col-\"] {\n    padding-left: 5px;\n    padding-right: 5px\n}\n\n.visible-xxs {\n    display: none !important\n}\n\n@media(max-width: 480px) {\n    .hidden-xxs {\n        display:none !important\n    }\n\n    .visible-xxs {\n        display: block !important\n    }\n}\n\nul.form-messages {\n    padding-left: 0;\n    list-style: none;\n    margin-bottom: 17px\n}\n\nul.form-messages li {\n    margin-top: 5px\n}\n\nul.form-messages li:first-child {\n    margin-top: 0\n}\n\ninput:not([type=radio]),button {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    -webkit-appearance: none\n}\n\n.has-success .form-control,.has-success .form-control:focus,.has-warning .form-control,.has-warning .form-control:focus,.has-error .form-control,.has-error .form-control:focus {\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\ntextarea {\n    max-width: 100%;\n    min-width: 100%\n}\n\n.with-corner-cd .navbar-form .form-control {\n    color: #919191\n}\n\n.form-control {\n    font-weight: bold\n}\n\ntextarea.form-control {\n    font-weight: normal\n}\n\n.form-control,.form-control:focus {\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\n.form-control::-moz-placeholder {\n    font-weight: normal\n}\n\n.form-control:-ms-input-placeholder {\n    font-weight: normal\n}\n\n.form-control::-webkit-input-placeholder {\n    font-weight: normal\n}\n\n.has-feedback .form-control {\n    padding-right: 35px\n}\n\n.help-block {\n    color: #b2b2b2\n}\n\n.help-form {\n    margin-top: 12px;\n    margin-bottom: 0;\n    color: #888\n}\n\n.help-form>p {\n    margin-bottom: 0\n}\n\n.help-form>p+p {\n    margin-top: 10px\n}\n\n.help-form.overpayment-callout {\n    margin-bottom: 12px;\n    color: #222\n}\n\n.checkbox input[type=checkbox] {\n    display: none\n}\n\n.checkbox label,.form-inline .checkbox label {\n    padding-left: 24px\n}\n\n.checkbox input[type=checkbox]+i {\n    display: block;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    top: 0;\n    margin-left: -24px;\n    margin-top: 1px;\n    border: rgb(202.5,202.5,202.5) 1px solid;\n    background: #fff;\n    border-radius: 4px;\n    cursor: pointer\n}\n\n.checkbox label:hover input[type=checkbox]+i {\n    border-color: #4384d0\n}\n\n.checkbox input[type=checkbox]+i:after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 2px;\n    background: #fff;\n    transform: translate(5px, 10px) rotate(-45deg);\n    -webkit-transform-origin: left;\n    transform-origin: left\n}\n\n.checkbox input[type=checkbox]+i:before {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 2px;\n    background: #fff;\n    transform: translate(2px, 6px) rotate(45deg);\n    -webkit-transform-origin: left;\n    transform-origin: left\n}\n\n.checkbox input[type=checkbox]:checked+i {\n    border-color: #4384d0;\n    background-color: #4384d0\n}\n\n.checkbox input[type=checkbox]:checked+i:before {\n    width: 5px\n}\n\n.checkbox input[type=checkbox]:checked+i:after {\n    width: 11px\n}\n\n.checkbox input[type=checkbox]:disabled+i {\n    opacity: .5;\n    cursor: not-allowed\n}\n\n.checkbox-switch label,.form-inline .checkbox-switch label {\n    padding-left: 35px\n}\n\n.checkbox-switch input[type=checkbox]+i {\n    width: 27px;\n    height: 13px;\n    border-radius: 10px;\n    background: #ccc;\n    border: #ccc 1px solid;\n    margin-left: -35px\n}\n\n.checkbox-switch label:hover input[type=checkbox]+i,label:hover .checkbox-switch input[type=checkbox]+i {\n    background: #b3b3b3;\n    border-color: #b3b3b3\n}\n\n.checkbox-switch input[type=checkbox]+i:before {\n    width: 11px;\n    height: 11px;\n    background: #fff;\n    border-radius: 10px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    transform: none\n}\n\n.checkbox-switch input[type=checkbox]+i:after {\n    display: none\n}\n\n.checkbox-switch input[type=checkbox]:checked+i {\n    background: #4384d0;\n    border-color: #4384d0\n}\n\n.checkbox-switch input[type=checkbox]:checked+i:before {\n    width: 11px;\n    left: 14px\n}\n\n.checkbox-switch label:hover input[type=checkbox]:checked+i,label:hover .checkbox-switch input[type=checkbox]:checked+i {\n    background: rgb(39.7,94.6042553191,158.8);\n    border-color: rgb(39.7,94.6042553191,158.8)\n}\n\n.form-control-feedback {\n    font-family: \"Graphik Bold\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    width: auto;\n    right: 14px\n}\n\n.form-control-box {\n    background: #fff;\n    border: 1px solid #e4e4e4;\n    border-radius: 4px;\n    padding: 8px 12px;\n    margin-bottom: 0;\n    height: 38px;\n    position: relative;\n    font-weight: bold\n}\n\ndiv.form-group>label.form-control-box {\n    display: block;\n    opacity: 1;\n    margin: 0;\n    text-transform: none;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 20px;\n    cursor: pointer;\n    letter-spacing: 0\n}\n\n.form-inline .form-control-box {\n    vertical-align: middle\n}\n\n.form-control-box.switch {\n    padding-right: 53px\n}\n\n.form-control-box .checkbox-switch {\n    margin: 1px -8px -3px 10px\n}\n\n.form-control-box .checkbox-switch.pull-right {\n    display: inline-block;\n    vertical-align: top;\n    margin: 0;\n    line-height: 1\n}\n\n.form-control-box .checkbox-switch.pull-right {\n    position: absolute;\n    right: 14px;\n    top: 50%;\n    margin-top: -8px\n}\n\n.form-control-box .checkbox-switch input[type=checkbox]+i {\n    margin-left: 0;\n    display: inline-block;\n    position: relative\n}\n\n.form-inline-long {\n    margin-right: -3px\n}\n\n.form-inline-long .form-group {\n    margin-bottom: 5px;\n    margin-right: 3px\n}\n\nselect.selectpicker {\n    display: block !important;\n    visibility: hidden\n}\n\n.bootstrap-select select.selectpicker {\n    display: none !important\n}\n\n.bootstrap-select>.dropdown-toggle.bs-placeholder,.bootstrap-select>.dropdown-toggle.bs-placeholder:hover,.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder:active {\n    color: #222\n}\n\n.bootstrap-select.input-lg .btn,.input-group-lg>.bootstrap-select.form-control .btn,.input-group-lg>.bootstrap-select.input-group-addon .btn,.input-group-lg>.input-group-btn>.bootstrap-select.btn .btn,.bootstrap-select.input-lg .dropdown-menu>li>a,.input-group-lg>.bootstrap-select.form-control .dropdown-menu>li>a,.input-group-lg>.bootstrap-select.input-group-addon .dropdown-menu>li>a,.input-group-lg>.input-group-btn>.bootstrap-select.btn .dropdown-menu>li>a {\n    padding: 10px 16px;\n    line-height: 23px\n}\n\n.bootstrap-select.input-lg .dropdown-toggle .caret,.input-group-lg>.bootstrap-select.form-control .dropdown-toggle .caret,.input-group-lg>.bootstrap-select.input-group-addon .dropdown-toggle .caret,.input-group-lg>.input-group-btn>.bootstrap-select.btn .dropdown-toggle .caret {\n    right: 16px\n}\n\n.bootstrap-select .dropdown-menu li a span.text {\n    display: block;\n    white-space: normal\n}\n\n.bootstrap-select .dropdown-menu>li>a {\n    color: #222\n}\n\n.bootstrap-select .dropdown-menu>.active>a,.bootstrap-select .dropdown-menu>.active>a:hover,.bootstrap-select .dropdown-menu>.active>a:focus {\n    background: #f5f5f5;\n    color: #222\n}\n\n@media(max-width: 767px) {\n    .form-inline .form-group {\n        margin-right:0 !important\n    }\n\n    .form-inline-long {\n        margin-right: 0\n    }\n}\n\n.badge {\n    padding: 3px;\n    min-width: 18px;\n    font-size: 11px\n}\n\n.badge-success {\n    background: #7ed320\n}\n\n.badge-warning {\n    background: #f5a623\n}\n\n.badge-danger {\n    background: #d0011b\n}\n\n.badge-primary {\n    background: #4384d0\n}\n\n.alert {\n    position: relative;\n    margin: 0\n}\n\n.alert-with-icon .alert-icon {\n    display: block;\n    font-size: 18px;\n    line-height: 20px;\n    margin-bottom: 10px\n}\n\n.alert button.close {\n    font-size: 22px;\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    width: 25px;\n    height: 25px;\n    outline: none\n}\n\n.alert-container {\n    margin-bottom: 20px;\n    width: 100%;\n    position: relative\n}\n\n.alert-container .content-with-cd {\n    margin-right: 0\n}\n\n#content-body>.container>.alert-container {\n    margin-top: 20px;\n    margin-bottom: -20px\n}\n\n.product-page .alert-container {\n    margin-top: 20px;\n    margin-bottom: -10px\n}\n\n.profile-header .alert-container {\n    margin-top: 20px\n}\n\n.alert-container.default-alert {\n    margin-top: -20px\n}\n\n.alert-container.with-small-circle,.alert-container.with-chat {\n    margin-top: 13px;\n    margin-bottom: -10px\n}\n\n.alert-container.with-small-circle+.alert-container.with-small-circle {\n    margin-top: 23px\n}\n\n.alert-container.dark .alert-info {\n    background-color: hsl(0,0%,93.0784313725%);\n    border-color: hsl(0,0%,93.0784313725%);\n    color: #222\n}\n\n.alert-container.dark .alert-info hr {\n    border-top-color: rgb(224.6,224.6,224.6)\n}\n\n.alert-container.dark .alert-info .alert-link {\n    color: rgb(8.5,8.5,8.5)\n}\n\n@media(max-width: 767px) {\n    #content-body>.container>.alert-container {\n        margin-bottom:-17px\n    }\n\n    .alert-container.default-alert {\n        margin-top: -17px\n    }\n\n    .alert-container.with-small-circle {\n        margin-top: 40px\n    }\n}\n\n.alert-container:empty {\n    display: none\n}\n\n@media(min-width: 768px) {\n    .alert-with-icon {\n        padding-left:48px;\n        position: relative\n    }\n\n    .alert-with-icon .alert-icon {\n        position: absolute;\n        left: 20px;\n        top: 20px;\n        margin-bottom: 0\n    }\n}\n\n.alert-info .alert-icon {\n    color: #4384d0\n}\n\n.alert-info .alert-icon.text-success,.alert-success .alert-icon {\n    color: #7ed320\n}\n\n.alert-warning .alert-icon {\n    color: #f8e71c\n}\n\n.alert-danger .alert-icon {\n    color: #d0011b\n}\n\n#header {\n    position: relative;\n    z-index: 911\n}\n\n@media(max-width: 991px) {\n    .hide-navbar {\n        display:none;\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        z-index: 998\n    }\n\n    .menu-opened .hide-navbar {\n        display: block\n    }\n\n    .container>.navbar-header,.container>.navbar-collapse,.container-fluid>.navbar-header {\n        margin-right: -10px;\n        margin-left: -10px\n    }\n}\n\n.navbar {\n    position: static;\n    border-width: 0;\n    border-bottom-width: 1px;\n    font-weight: 500;\n    margin-left: -10px;\n    margin-right: -10px;\n    padding-left: 10px;\n    padding-right: 10px;\n    min-height: 49px\n}\n\n@media(min-width: 768px) {\n    .navbar {\n        margin-left:0;\n        margin-right: 0;\n        padding-left: 0;\n        padding-right: 0\n    }\n}\n\n@media(min-width: 992px) {\n    .navbar {\n        min-height:61px\n    }\n}\n\n@media(max-width: 991px) {\n    .nav-container {\n        position:relative\n    }\n}\n\n.navbar .container-fluid {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.navbar-toggle {\n    padding-left: 0;\n    padding-right: 0;\n    margin-top: 7px;\n    margin-bottom: 7px\n}\n\n.navbar-toggle-logged {\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-top: 6px;\n    margin-bottom: 6px;\n    margin-right: 8px\n}\n\n@media(max-width: 767px) {\n    .navbar-toggle-logged {\n        margin-right:13px\n    }\n}\n\na.navbar-xs-icon {\n    display: block;\n    height: 34px;\n    line-height: 34px;\n    float: right;\n    margin-right: 13px;\n    padding: 0 5px;\n    margin-top: 7px;\n    margin-bottom: 7px;\n    position: relative;\n    color: #d5d5d5\n}\n\na.navbar-xs-icon svg {\n    fill: #d5d5d5\n}\n\na.navbar-xs-icon:hover,a.navbar-xs-icon:focus {\n    color: hsl(0,0%,78.5294117647%)\n}\n\na.navbar-xs-icon:hover svg,a.navbar-xs-icon:focus svg {\n    fill: hsl(0,0%,78.5294117647%)\n}\n\na.navbar-xs-icon.active,a.navbar-xs-icon.active:hover,a.navbar-xs-icon.active:focus {\n    color: #4384d0\n}\n\na.navbar-xs-icon.active svg,a.navbar-xs-icon.active:hover svg,a.navbar-xs-icon.active:focus svg {\n    fill: #4384d0\n}\n\n@media(min-width: 992px) {\n    a.navbar-xs-icon {\n        display:none\n    }\n}\n\na.navbar-xs-icon i {\n    font-size: 28px;\n    line-height: inherit\n}\n\na.navbar-xs-icon svg {\n    display: block\n}\n\na.navbar-xs-icon span {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    text-align: center;\n    color: #fff;\n    font-size: 12px\n}\n\na.navbar-xs-icon.icon-chat {\n    padding-top: 4px;\n    padding-bottom: 4px\n}\n\na.navbar-xs-icon.icon-chat svg {\n    width: 26px;\n    height: 26px\n}\n\n.navbar-default .navbar-toggle:hover,.navbar-default .navbar-toggle:focus {\n    background: rgba(0,0,0,0)\n}\n\n.navbar-toggle .icon-bar {\n    width: 24px\n}\n\n.navbar-brand {\n    height: 48px;\n    padding-top: 13px;\n    padding-bottom: 13px\n}\n\n.navbar-brand img {\n    height: 22px;\n    min-width: 59px\n}\n\n.navbar-header>.navbar-form {\n    float: left;\n    border: none\n}\n\n.navbar-form {\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\n.navbar-form.dropdown {\n    position: static\n}\n\n.navbar-form .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle\n}\n\n.navbar-form .form-control {\n    padding-left: 0;\n    padding-right: 0;\n    border: rgba(0,0,0,0);\n    display: inline-block;\n    vertical-align: middle;\n    width: 130px\n}\n\n.navbar-form .form-control:lang(en) {\n    width: 140px\n}\n\n.navbar-form .form-control:lang(uk) {\n    width: 135px\n}\n\n.navbar-form>.btn {\n    padding-left: 5px;\n    padding-right: 5px\n}\n\n.navbar-form>.btn:focus {\n    outline: none\n}\n\n.navbar-form>.btn i {\n    font-size: 12px;\n    line-height: inherit;\n    position: relative;\n    top: 1px\n}\n\n@media(min-width: 992px) {\n    .navbar-brand {\n        height:60px;\n        padding-top: 19px;\n        padding-bottom: 19px\n    }\n\n    .navbar-brand img {\n        height: 22px;\n        min-width: 59px\n    }\n\n    .navbar-form {\n        margin-top: 11px;\n        margin-bottom: 11px\n    }\n}\n\n@media(max-width: 370px) {\n    .navbar-form .form-control {\n        width:43px\n    }\n\n    .navbar-form .form-control:lang(en) {\n        width: 48px\n    }\n\n    .navbar-form .form-control:lang(uk) {\n        width: 46px\n    }\n}\n\n.dropdown-menu.dropdown-autocomplete {\n    left: 0;\n    right: 0;\n    width: 100%;\n    margin-top: 0;\n    border-radius: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    border-bottom: #e4e4e4 1px solid;\n    padding-top: 2px;\n    padding-bottom: 4px\n}\n\n.dropdown-menu.dropdown-autocomplete .promo-game-list-header {\n    margin-top: 3px\n}\n\n.navbar-nav>li>a {\n    padding-left: 10px;\n    padding-right: 10px\n}\n\n.navbar-nav.logged>li>a {\n    padding-left: 7px;\n    padding-right: 7px\n}\n\n@media(max-width: 991px) {\n    .navbar-nav {\n        margin-top:0;\n        margin-bottom: 0\n    }\n\n    .navbar-nav>li>a,.navbar-nav.logged>li>a {\n        padding: 7px 15px;\n        border-top: #f2f2f2 1px solid\n    }\n\n    .navbar-nav .open>a,.navbar-nav .open>a:hover,.navbar-nav .open>a:focus {\n        border-top: #f2f2f2 1px solid\n    }\n\n    .navbar-default .navbar-collapse {\n        border-top: none;\n        position: absolute;\n        right: 0;\n        top: 100%;\n        border-radius: 4px;\n        -webkit-box-shadow: rgba(0,0,0,.22) 0 1px 4px;\n        box-shadow: rgba(0,0,0,.22) 0 1px 4px;\n        min-width: 240px;\n        left: auto;\n        z-index: 999;\n        background: #fff;\n        margin-left: 0;\n        margin-right: 1px;\n        margin-top: 12px\n    }\n}\n\n@media(max-width: 767px) {\n    .navbar-default .navbar-collapse {\n        margin-right:6px\n    }\n}\n\n@media(min-width: 992px) {\n    .navbar-right {\n        margin-right:-23px\n    }\n\n    .navbar-right.logged {\n        margin-right: -20px\n    }\n}\n\n.no-transition {\n    -webkit-transition: height .01s !important;\n    -moz-transition: height .01s !important;\n    -ms-transition: height .01s !important;\n    -o-transition: height .01s !important;\n    transition: height .01s !important\n}\n\n.no-select {\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -khtml-user-select: none;\n    -webkit-user-select: none;\n    user-select: none\n}\n\n.navbar-nav .badge {\n    vertical-align: baseline;\n    margin-left: 3px;\n    margin-bottom: -2px\n}\n\n.navbar-nav .badge.badge-balance {\n    padding-left: 6px;\n    padding-right: 6px\n}\n\n.navbar-nav>li>a.user-link {\n    padding-top: 13px;\n    padding-bottom: 13px\n}\n\n.user-link-name {\n    color: #222;\n    font-weight: bold;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis\n}\n\n.user-link-photo {\n    display: inline-block;\n    vertical-align: middle;\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    overflow: hidden;\n    margin-right: 2px\n}\n\n.form-phone-verification p.phone {\n    margin: 0;\n    padding: 0;\n    color: #888;\n    font-size: 1.6em\n}\n\n\n.menu-icon.menu-icon-lang-en {\n    background-position: 0px 0\n}\n\n.menu-icon.menu-icon-lang-ru {\n    background-position: -19px 0\n}\n\n.menu-icon.menu-icon-lang-uk {\n    background-position: -38px 0\n}\n\n.navbar-nav .dropdown-menu li.dropdown:before,.navbar-nav .dropdown-menu li.dropdown:after {\n    content: \" \";\n    display: table\n}\n\n.navbar-nav .dropdown-menu li.dropdown:after {\n    clear: both\n}\n\n.navbar-nav>li>.dropdown-menu,.dropdown-menu,.nav-tabs .dropdown-menu {\n    margin-top: 7px;\n    border-radius: 4px;\n    border: none;\n    padding: 0;\n    -webkit-box-shadow: rgba(0,0,0,.22) 0 1px 4px;\n    box-shadow: rgba(0,0,0,.22) 0 1px 4px\n}\n\n.navbar-nav .dropdown-menu {\n    margin-left: -6px\n}\n\n.navbar-right .dropdown-menu {\n    right: 11px\n}\n\n.navbar-right.logged .dropdown-menu {\n    right: 8px;\n    min-width: 200px\n}\n\n.navbar-nav>li>.dropdown-menu>.active>a {\n    background: #fff;\n    color: #222\n}\n\n.navbar-nav>li>.dropdown-menu>.active>a:hover {\n    background-color: #f5f5f5\n}\n\n.dropdown-menu>li:first-child>a {\n    border-radius: 4px 4px 0 0\n}\n\n.dropdown-menu>li:last-child>a {\n    border-radius: 0 0 4px 4px\n}\n\n.dropdown-menu>li>a {\n    padding: 7px 15px;\n    font-weight: 500\n}\n\n.navbar .dropdown-menu .dropdown-menu>li>a {\n    padding-left: 30px\n}\n\na.user-link-dropdown .user-link-desc {\n    font-size: 12px;\n    margin-top: 2px\n}\n\n.dropdown-menu>li+li,.dropdown-menu .dropdown-menu>li {\n    border-top: #f2f2f2 1px solid\n}\n\n@media(min-width: 768px) {\n    .dropdown-menu .dropdown-menu {\n        position:static;\n        margin: 0;\n        border-radius: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none\n    }\n\n    .dropdown-menu .dropdown-menu>li:first-child>a,.dropdown-menu .dropdown-menu>li:last-child>a {\n        border-radius: 0\n    }\n}\n\n@media(max-width: 991px) {\n    .navbar-nav .open .dropdown-menu>li>a,.navbar-nav .open .dropdown-menu .dropdown-header {\n        padding:7px 15px 7px 30px\n    }\n\n    .navbar-nav .dropdown-menu {\n        margin: 0\n    }\n\n    .navbar-nav .dropdown-menu>li:first-child {\n        border-top: #f2f2f2 1px solid\n    }\n}\n\n.breadcrumb {\n    margin-bottom: 20px;\n    font-weight: bold\n}\n\n.breadcrumb>li {\n    padding-top: 1px;\n    padding-bottom: 1px\n}\n\n.breadcrumb>li+li:before {\n    padding: 0;\n    position: relative;\n    top: 1px\n}\n\n.nav-tabs {\n    font-family: \"Graphik Bold\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-size: 17px\n}\n\n.nav-tabs>li {\n    margin-right: 20px;\n    margin-bottom: 0\n}\n\n.nav-tabs>li:last-child {\n    margin-right: 0\n}\n\n.nav-tabs>li>a {\n    padding: 15px 0;\n    margin-right: 0\n}\n\n.nav-tabs>li>a,.nav-tabs>li.active>a,.nav-tabs>li.active>a:hover,.nav-tabs>li.active>a:focus {\n    border: none;\n    position: relative;\n    background-color: rgba(0,0,0,0)\n}\n\n.nav-tabs>li>a:hover,.nav-tabs>li>a:focus {\n    background: rgba(0,0,0,0)\n}\n\n.nav-tabs>li.active>a:before {\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: 1px;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background: #222\n}\n\n.nav-tabs .open>a,.nav-tabs .open>a:hover,.nav-tabs .open>a:focus {\n    border-color: rgba(0,0,0,0);\n    background-color: rgba(0,0,0,0)\n}\n\n.nav-tabs-justified>.active>a,.nav-tabs.nav-justified>.active>a,.nav-tabs-justified>.active>a:hover,.nav-tabs-justified>.active>a:focus {\n    border-left-width: 0;\n    border-right-width: 0;\n    border-top-width: 0\n}\n\n@media(max-width: 767px) {\n    .nav-tabs {\n        font-size:14px\n    }\n}\n\n.nav-pills {\n    margin-right: -10px;\n    font-weight: bold\n}\n\n.nav-pills>li,.nav-pills>li+li {\n    margin-left: 0;\n    margin-right: 10px;\n    margin-bottom: 10px\n}\n\n.nav-pills>li>a {\n    padding: 12px 22px\n}\n\n.nav-pills>li.dropdown>a {\n    padding-left: 5px;\n    padding-right: 5px;\n    text-align: center;\n    min-width: 40px\n}\n\n.nav-pills>li>a,.nav-pills>li>a:hover,.nav-pills>li>a:focus,.nav-pills .open>a,.nav-pills .open>a:hover,.nav-pills .open>a:focus {\n    background: #f5f5f5\n}\n\n.list-inline {\n    margin-left: 0\n}\n\n.list-inline>li {\n    padding-left: 0;\n    padding-right: 0;\n    display: inline\n}\n\n.list-inline>li:after {\n    content: \" ·\";\n    color: #4384d0\n}\n\n.list-inline>li:last-child:after {\n    display: none\n}\n\n.list-inline>.active a,.list-inline>.active a:hover,.list-inline>.active a:focus {\n    text-decoration: none;\n    cursor: default;\n    color: #222\n}\n\n.popover-content {\n    display: none\n}\n\n.popover .popover-content {\n    display: block\n}\n\n.popover-content>p {\n    margin-bottom: 0\n}\n\n.popover-content>p+p {\n    margin-top: 5px\n}\n\n.table-buyers-prices {\n    color: #888;\n    font-size: 12px;\n    line-height: 1.15\n}\n\n.table-buyers-prices th,.table-buyers-prices td {\n    vertical-align: baseline;\n    padding-top: 8px;\n    white-space: nowrap\n}\n\n.table-buyers-prices tr:first-child th,.table-buyers-prices tr:first-child td {\n    padding-top: 0\n}\n\n.table-buyers-prices th {\n    font-weight: normal\n}\n\n.table-buyers-prices td {\n    padding-left: 1em\n}\n\nlabel+.table-buyers-prices {\n    margin-top: 3px\n}\n\n.popover .table-buyers-prices {\n    color: #222;\n    margin-top: 10px\n}\n\n.form-narrow .btn-block,.form-narrow .form-control,.form-narrow .input-group {\n    max-width: 300px\n}\n\n.form-group-swap {\n    position: relative\n}\n\n.form-group-swap .swap-btn {\n    position: absolute;\n    display: block;\n    z-index: 100;\n    left: 50%;\n    top: 21px;\n    width: 20px;\n    margin-left: -10px;\n    line-height: 38px;\n    text-align: center\n}\n\n.form-group-swap .help-block {\n    color: #b2b2b2 !important\n}\n\n.btn:active,.btn.active,.btn-group.open .dropdown-toggle {\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\n.btn-default {\n    color: #4384d0;\n    background-color: #fff;\n    border-color: #e4e4e4\n}\n\n.bg-light-style .btn-default {\n    border-color: #fff\n}\n\n.btn-default:focus,.btn-default.focus {\n    color: #4384d0;\n    background-color: hsl(0,0%,95%);\n    border-color: hsl(0,0%,85%)\n}\n\n.btn-default:hover {\n    color: #4384d0;\n    background-color: hsl(0,0%,95%);\n    border-color: hsl(0,0%,93%)\n}\n\n.btn-default:active,.btn-default.active,.open>.btn-default.dropdown-toggle {\n    color: #4384d0;\n    background-color: hsl(0,0%,95%);\n    border-color: hsl(0,0%,93%)\n}\n\n.btn-default:active:hover,.btn-default:active:focus,.btn-default:active.focus,.btn-default.active:hover,.btn-default.active:focus,.btn-default.active.focus,.open>.btn-default.dropdown-toggle:hover,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle.focus {\n    color: #4384d0;\n    background-color: hsl(0,0%,91%);\n    border-color: hsl(0,0%,85%)\n}\n\n.btn-default:active,.btn-default.active,.open>.btn-default.dropdown-toggle {\n    background-image: none\n}\n\n.btn-default.disabled:hover,.btn-default.disabled:focus,.btn-default.disabled.focus,.btn-default[disabled]:hover,.btn-default[disabled]:focus,.btn-default[disabled].focus,fieldset[disabled] .btn-default:hover,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default.focus {\n    background-color: #fff;\n    border-color: #e4e4e4\n}\n\n.btn-default .badge {\n    color: #fff;\n    background-color: #4384d0\n}\n\n.btn-default.dropdown-toggle,.btn-default.dropdown-toggle:hover,.btn-default.dropdown-toggle:focus,.btn-default.dropdown-toggle:active,.open>.btn-default.dropdown-toggle,.open>.btn-default.dropdown-toggle:hover,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:active {\n    color: #222\n}\n\n.btn-dark {\n    color: #fff;\n    background-color: #222;\n    border-color: #222\n}\n\n.btn-dark:focus,.btn-dark.focus {\n    color: #fff;\n    background-color: #4d4d4d;\n    border-color: rgb(51.5,51.5,51.5)\n}\n\n.btn-dark:hover {\n    color: #fff;\n    background-color: #4d4d4d;\n    border-color: rgb(71.9,71.9,71.9)\n}\n\n.btn-dark:active,.btn-dark.active,.open>.btn-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #4d4d4d;\n    border-color: rgb(71.9,71.9,71.9)\n}\n\n.btn-dark:active:hover,.btn-dark:active:focus,.btn-dark:active.focus,.btn-dark.active:hover,.btn-dark.active:focus,.btn-dark.active.focus,.open>.btn-dark.dropdown-toggle:hover,.open>.btn-dark.dropdown-toggle:focus,.open>.btn-dark.dropdown-toggle.focus {\n    color: #fff;\n    background-color: #666;\n    border-color: rgb(51.5,51.5,51.5)\n}\n\n.btn-dark:active,.btn-dark.active,.open>.btn-dark.dropdown-toggle {\n    background-image: none\n}\n\n.btn-dark.disabled:hover,.btn-dark.disabled:focus,.btn-dark.disabled.focus,.btn-dark[disabled]:hover,.btn-dark[disabled]:focus,.btn-dark[disabled].focus,fieldset[disabled] .btn-dark:hover,fieldset[disabled] .btn-dark:focus,fieldset[disabled] .btn-dark.focus {\n    background-color: #222;\n    border-color: #222\n}\n\n.btn-dark .badge {\n    color: #222;\n    background-color: #fff\n}\n\n.btn-gray {\n    color: #4384d0;\n    background-color: #f5f5f5;\n    border-color: #f5f5f5\n}\n\n.btn-gray:focus,.btn-gray.focus {\n    color: #4384d0;\n    background-color: rgb(234.8,234.8,234.8);\n    border-color: rgb(209.3,209.3,209.3)\n}\n\n.btn-gray:hover {\n    color: #4384d0;\n    background-color: rgb(234.8,234.8,234.8);\n    border-color: rgb(229.7,229.7,229.7)\n}\n\n.btn-gray:active,.btn-gray.active,.open>.btn-gray.dropdown-toggle {\n    color: #4384d0;\n    background-color: rgb(234.8,234.8,234.8);\n    border-color: rgb(229.7,229.7,229.7)\n}\n\n.btn-gray:active:hover,.btn-gray:active:focus,.btn-gray:active.focus,.btn-gray.active:hover,.btn-gray.active:focus,.btn-gray.active.focus,.open>.btn-gray.dropdown-toggle:hover,.open>.btn-gray.dropdown-toggle:focus,.open>.btn-gray.dropdown-toggle.focus {\n    color: #4384d0;\n    background-color: rgb(219.5,219.5,219.5);\n    border-color: rgb(209.3,209.3,209.3)\n}\n\n.btn-gray:active,.btn-gray.active,.open>.btn-gray.dropdown-toggle {\n    background-image: none\n}\n\n.btn-gray.disabled:hover,.btn-gray.disabled:focus,.btn-gray.disabled.focus,.btn-gray[disabled]:hover,.btn-gray[disabled]:focus,.btn-gray[disabled].focus,fieldset[disabled] .btn-gray:hover,fieldset[disabled] .btn-gray:focus,fieldset[disabled] .btn-gray.focus {\n    background-color: #f5f5f5;\n    border-color: #f5f5f5\n}\n\n.btn-gray .badge {\n    color: #f5f5f5;\n    background-color: #4384d0\n}\n\n.btn-info-sm {\n    padding-top: 2px;\n    padding-bottom: 4px;\n    height: 39px;\n    line-height: 30px;\n    font-size: 11px\n}\n\n.btn-info-sm .inside {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 12px\n}\n\n.btn-info-icon {\n    padding-left: 37px;\n    padding-right: 0;\n    position: relative;\n    text-align: left\n}\n\n.btn-info-icon .inside {\n    padding-right: 12px\n}\n\n.btn-info-icon .icon {\n    position: absolute;\n    left: 5px;\n    top: 50%;\n    width: 27px;\n    text-align: center;\n    font-size: 16px;\n    transform: translate(0, -50%)\n}\n\n.btn-xs,.btn-group-xs>.btn {\n    padding: 3px 7px 2px 8px;\n    font-size: 9px;\n    line-height: 1.33333333;\n    letter-spacing: 1px\n}\n\n.btn-group-xs>span.btn {\n    cursor: default\n}\n\n.btn-wide {\n    padding-left: 20px;\n    padding-right: 20px\n}\n\n.btn-round {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    padding: 0;\n    line-height: 40px\n}\n\n.chat-form-btn .btn-round {\n    font-size: 22px\n}\n\n.section {\n    padding-top: 50px;\n    padding-bottom: 50px\n}\n\nhtml,body {\n    height: 100%\n}\n\n.wrapper {\n    display: flex;\n    flex-direction: column;\n    height: 100%\n}\n\n.wrapper-content {\n    flex: 1 0 auto\n}\n\n.wrapper-footer {\n    flex: 0 0 auto\n}\n\n.bg-light-color #header,.bg-light-color .wrapper-footer {\n    background-color: #fff\n}\n\n.promo-cd {\n    position: relative;\n    overflow: hidden;\n    min-height: 826px\n}\n\n.promo-cd .container {\n    position: relative\n}\n\n.cd-forward {\n    position: relative;\n    z-index: 200\n}\n\n@media(max-width: 767px) {\n    .cd-forward {\n        margin-top:-50%;\n        padding-top: 28px\n    }\n}\n\n.cd-container {\n    position: absolute;\n    z-index: 100;\n    top: 22px;\n    left: 50%;\n    margin-left: 562.5px;\n    transform: translate(-50%, 0)\n}\n\n.cd {\n    position: relative;\n    z-index: 100;\n    border-radius: 50%;\n    width: 800px;\n    height: 800px;\n    overflow: hidden;\n    font-family: \"Graphik Bold\",\"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\n.cd .spacer {\n    width: 100%;\n    padding-bottom: 100%;\n    background: #f9f9f9\n}\n\n.cd img,.cd svg,.cd a {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%\n}\n\n.cd a {\n    display: block;\n    z-index: 100;\n    border-radius: 50%\n}\n\n.cd .spacer,.cd img,.cd svg {\n    pointer-events: none\n}\n\n.cd svg {\n    fill: #fff\n}\n\n.cd-empty svg {\n    transform: rotate(30deg)\n}\n\n.cd-satellite {\n    position: absolute;\n    top: 1px;\n    left: 14px;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    background: #4384d0;\n    padding: 57px 34px;\n    color: #fff;\n    line-height: 1.21428571\n}\n\na.cd-satellite,a.cd-satellite:hover,a.cd-satellite:focus,a.cd-satellite:active {\n    color: #fff;\n    text-decoration: none;\n    outline: none\n}\n\na.cd-satellite:hover,a.cd-satellite:focus {\n    background: rgb(54.76,123.9919148936,204.94)\n}\n\na.cd-satellite:active {\n    background: rgb(49.9,118.9106382979,199.6)\n}\n\n.social-statistic-list {\n    position: absolute;\n    left: 0;\n    top: 50%;\n    margin-top: 107px;\n    z-index: 553;\n    max-width: 480px;\n    color: #fff\n}\n\n.social-statistic-list-xs {\n    position: relative;\n    top: 0;\n    left: 20px;\n    margin-top: -130px;\n    margin-bottom: 15px;\n    width: 10px\n}\n\n@media(max-width: 1300px) {\n    .social-statistic-list {\n        max-width:300px\n    }\n}\n\n.social-statistic {\n    display: inline-block;\n    width: 114px;\n    height: 114px;\n    border-radius: 50%;\n    position: relative;\n    text-align: center;\n    margin-bottom: 4px;\n    background: #4384d0\n}\n\n.social-statistic,.social-statistic:hover,.social-statistic:active,.social-statistic:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: none\n}\n\n.social-statistic:hover,.social-statistic:focus {\n    background: rgb(79.24,140.0080851064,211.06)\n}\n\n.social-statistic:active {\n    background: rgb(91.48,148.0161702128,214.12)\n}\n\n.social-statistic-logo {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0\n}\n\n.social-statistic-logo i,.social-statistic-logo span,.social-statistic-logo svg {\n    position: relative\n}\n\n\n.social-statistic-info {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 23px;\n    line-height: 1.15;\n    font-size: 12px\n}\n\n.social-statistic-vk {\n    background: #07f\n}\n\n.social-statistic-vk:hover,.social-statistic-vk:focus {\n    background: hsl(212,100%,53%)\n}\n\n.social-statistic-vk:active {\n    background: hsl(212,100%,56%)\n}\n\n.social-statistic-vk svg {\n    width: 29px;\n    height: 29px;\n    top: 27px\n}\n\n.social-statistic-telegram {\n    background: #3390ec\n}\n\n.social-statistic-telegram:hover,.social-statistic-telegram:focus {\n    background: rgb(64.9964125561,151.6156950673,237.3035874439)\n}\n\n.social-statistic-telegram:active {\n    background: rgb(78.9928251121,159.2313901345,238.6071748879)\n}\n\n.social-statistic-telegram svg {\n    color: #fff;\n    width: 39px;\n    height: 31px;\n    top: 24px\n}\n\n.social-statistic-fb {\n    background: #1877f2\n}\n\n.social-statistic-fb:hover,.social-statistic-fb:focus {\n    background: rgb(38.4848360656,127.5278688525,242.8151639344)\n}\n\n.social-statistic-fb:active {\n    background: rgb(52.9696721311,136.0557377049,243.6303278689)\n}\n\n.social-statistic-fb i {\n    font-size: 31px;\n    top: 26px\n}\n\n.social-statistic-goha {\n    background: #222\n}\n\n.social-statistic-goha:hover,.social-statistic-goha:focus {\n    background: rgb(51.85,51.85,51.85)\n}\n\n.social-statistic-goha:active {\n    background: rgb(59.5,59.5,59.5)\n}\n\n.social-statistic-goha span {\n    background-position: 0 -142px;\n    width: 50px;\n    height: 23px;\n    top: 30px\n}\n\n.social-statistic-wot {\n    background: #042e3c\n}\n\n.social-statistic-wot:hover,.social-statistic-wot:focus {\n    background: hsl(195,87.5%,15.5490196078%)\n}\n\n.social-statistic-wot:active {\n    background: rgb(5.9125,67.99375,88.6875)\n}\n\n.social-statistic-wot span {\n    background-position: 0 -117px;\n    width: 64px;\n    height: 24px;\n    top: 30px;\n    left: -2px\n}\n\n.social-statistic-trustpilot {\n    background: #000032\n}\n\n.social-statistic-trustpilot:hover,.social-statistic-trustpilot:focus {\n    background: rgb(0,0,70.4)\n}\n\n.social-statistic-trustpilot:active {\n    background: rgb(0,0,85.7)\n}\n\n.social-statistic-trustpilot span {\n    background-position: 0 -95px;\n    width: 82px;\n    height: 21px;\n    top: 30px\n}\n\n.promo-games {\n    padding-top: 22px;\n    padding-bottom: 0\n}\n\n.content-with-cd {\n    margin-right: 440px\n}\n\n.content-with-cd:before,.content-with-cd:after {\n    content: \" \";\n    display: table\n}\n\n.content-with-cd:after {\n    clear: both\n}\n\n.content-with-cd-wide {\n    margin-left: -12px;\n    margin-right: -12px;\n    padding: 12px;\n    background: #fff;\n    border-radius: 4px\n}\n\n.promo-game-list-header {\n    float: left;\n    width: 40px\n}\n\n.nav-abc {\n    font-size: 10px;\n    overflow: hidden;\n    font-weight: bold\n}\n\n.nav-abc.affix {\n    top: 20px;\n    position: fixed\n}\n\n.nav-abc.affix-bottom {\n    position: absolute;\n    top: auto\n}\n\n.nav-abc ul {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch\n}\n\n.nav-abc ul .active a,.nav-abc ul .active a:hover,.nav-abc ul .active a:focus {\n    text-decoration: none;\n    cursor: default;\n    color: #222\n}\n\n.nav-abc ul li {\n    margin-bottom: 6px\n}\n\n.nav-abc .nav>li>a {\n    display: inline-block;\n    padding: 0\n}\n\n.nav-abc .nav>li>a,.nav-abc .nav>li>a:hover,.nav-abc .nav>li>a:focus {\n    background: rgba(0,0,0,0)\n}\n\n.title-mini {\n    font-size: 9px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 1.3px;\n    line-height: 1.22222222\n}\n\n.promo-game-list {\n    margin-left: 80px\n}\n\n.game-title {\n    margin-bottom: 7px;\n    font-family: \"Graphik Semibold\",\"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\n.game-title a {\n    color: #222;\n    text-decoration: none\n}\n\n.game-title a:hover,.game-title a:focus {\n    text-decoration: underline\n}\n\n.promo-game-item {\n    margin-bottom: 20px\n}\n\n.promo-game-item .btn-group {\n    margin-bottom: 5px\n}\n\n.promo-game-item .btn-group .btn {\n    margin-left: 0\n}\n\n.promo-game-item .btn-group .btn,.promo-game-item .btn-group .btn:hover,.promo-game-item .btn-group .btn:focus,.promo-game-item .btn-group .btn:active,.promo-game-item .btn-group .btn:active:hover,.promo-game-item .btn-group .btn:active:focus {\n    outline: none\n}\n\n.promo-game-item .list-inline {\n    font-size: 13px;\n    line-height: 20px\n}\n\n.promo-game-item .list-inline li {\n    white-space: nowrap\n}\n\n.promo-game-list-title {\n    margin-top: 0;\n    margin-bottom: 10px;\n    font-size: 10px;\n    color: #888\n}\n\n.promo-games-all {\n    margin-bottom: 20px\n}\n\n@media(max-width: 1199px) {\n    .content-with-cd {\n        margin-right:320px\n    }\n}\n\n@media(max-width: 991px) {\n    .content-with-cd {\n        margin-right:220px\n    }\n}\n\n@media(max-width: 767px) {\n    .promo-cd {\n        min-height:auto\n    }\n\n    .cd-container {\n        position: static;\n        left: auto;\n        top: auto;\n        margin-left: auto;\n        margin-right: auto;\n        width: 100%;\n        transform: none\n    }\n\n    .cd {\n        width: auto;\n        height: auto;\n        margin-left: 20px;\n        margin-right: 20px;\n        margin-top: 4px\n    }\n\n    .cd-container+.promo-games {\n        margin-top: -16px\n    }\n\n    .content-with-cd {\n        margin-right: 0\n    }\n\n    .promo-abc .content-with-cd {\n        margin-right: 20px\n    }\n\n    .promo-game-list-header {\n        float: none;\n        width: auto;\n        margin-bottom: 16px\n    }\n\n    .promo-game-list {\n        margin-left: 0\n    }\n\n    .nav-abc {\n        position: absolute;\n        right: 10px;\n        margin-top: 16px\n    }\n\n    .nav-abc.affix {\n        margin-top: 0\n    }\n\n    .nav-abc ul {\n        text-align: center\n    }\n}\n\n@media(max-width: 480px) {\n    .cd {\n        margin-left:10px;\n        margin-right: 10px\n    }\n\n    .social-statistic-list-xs {\n        left: 10px\n    }\n}\n\n@media(max-width: 767px) {\n    .showcase-filters label.control-label {\n        display:block;\n        margin-bottom: 0\n    }\n}\n\n@media(min-width: 768px) {\n    .showcase-filters {\n        display:block !important;\n        height: auto !important\n    }\n\n    .showcase-filters .showcase-filter-text {\n        width: 14em\n    }\n\n    .filter-container {\n        margin-bottom: 3px\n    }\n}\n\n@media(max-width: 767px) {\n    .form-inline .form-control {\n        width:100%\n    }\n\n    .form-inline .bootstrap-select select.form-control {\n        width: .5px !important\n    }\n\n    .filter-btn-container {\n        display: flex !important;\n        flex-wrap: nowrap;\n        padding-bottom: 10px\n    }\n\n    .filter-btn-container:before,.filter-btn-container:after {\n        display: none\n    }\n\n    .filter-btn-container>div {\n        width: 100%\n    }\n\n    .offer-btn .btn-wide {\n        width: 100%\n    }\n}\n\n@media(max-width: 480px) {\n    .filter-btn-container .btn {\n        padding-left:8px;\n        padding-right: 8px\n    }\n}\n\n.tc {\n    display: table;\n    width: 100%;\n    margin-bottom: 20px\n}\n\n.tc:not(.tc-selling):not(.tc-finance) .tc-item>div {\n    border-top: #eaeaea 1px solid\n}\n\n.tc:not(.tc-selling):not(.tc-finance) .tc-header>div {\n    border-bottom: none\n}\n\n.tc-header,.tc-item {\n    display: table-row\n}\n\n.tc-header>div,.tc-header>[class^=col-],.tc-header>[class*=\" col-\"],.tc-item>div,.tc-item>[class^=col-],.tc-item>[class*=\" col-\"] {\n    display: table-cell;\n    float: none;\n    vertical-align: top;\n    padding-left: 8px;\n    padding-right: 8px\n}\n\na.tc-item {\n    color: #222;\n    text-decoration: none\n}\n\na.tc-item .pseudo-a,a.tc-item .pseudo-a:hover,a.tc-item .pseudo-a:focus,a.tc-item .pseudo-a:active {\n    outline: none\n}\n\na.tc-item .pseudo-a:hover {\n    text-decoration: underline\n}\n\n.tc-header>div {\n    padding-top: 12px;\n    padding-bottom: 12px;\n    border-bottom: #eaeaea 1px solid\n}\n\n.tc-item>div {\n    padding-top: 12px;\n    padding-bottom: 12px;\n    height: 67px\n}\n\n.media-user {\n    margin-top: 0\n}\n\n.tc .media-user {\n    display: block\n}\n\n.tc .media-user .media-body {\n    width: auto\n}\n\n.tc .form-group {\n    margin-bottom: 0\n}\n\n.tc .checkbox-switch {\n    margin-top: 2px;\n    margin-bottom: 3px;\n    line-height: 1\n}\n\n.media-user.style-circle .avatar-photo {\n    overflow: visible\n}\n\n.media-user.style-circle .avatar-photo:after {\n    display: block;\n    width: 16px;\n    height: 16px;\n    background: #a6a6a6;\n    border: 3px solid #fff;\n    border-radius: 50%;\n    content: \"\";\n    position: absolute;\n    right: -3px;\n    bottom: -3px;\n    z-index: 10\n}\n\n.media-user.style-circle.online .avatar-photo:after {\n    background: #7ed320\n}\n\n.media-user.style-circle.offline .media-user-name,.media-user.style-circle.offline .media-user-name .pseudo-a {\n    color: #a6a6a6\n}\n\n.media-user.style-circle.offline .media-user-reviews {\n    color: #888\n}\n\n.tc-visible-inside {\n    display: none\n}\n\n.table>thead>tr>th {\n    border-bottom-width: 1px\n}\n\ntable.table-clickable tbody tr,.tc.table-clickable .tc-item {\n    cursor: pointer\n}\n\n.tc.table-hover .tc-item:hover {\n    background-color: #f9f9f9\n}\n\n.tc-desc-text a {\n    color: #222\n}\n\n.showcase-table .tc-desc-text {\n    word-wrap: break-word;\n    word-break: break-word\n}\n\n@media(max-width: 767px) {\n    .showcase-table .tc-header>div,.showcase-table .tc-item>div {\n        padding-left:5px;\n        padding-right: 5px\n    }\n\n    .showcase-table .media-user-name {\n        max-width: 120px\n    }\n}\n\n.showcase-has-actions .showcase-actions {\n    display: none\n}\n\n.showcase-has-actions .showcase-actions span {\n    color: #888\n}\n\n.showcase-has-actions .showcase-actions span:hover {\n    color: #222\n}\n\n.showcase-has-actions .tc-item:hover .tc-price .price-admin {\n    display: none\n}\n\n.showcase-has-actions .tc-item:hover .showcase-actions {\n    display: block\n}\n\n.tc-amount,.tc-price {\n    text-align: right;\n    white-space: nowrap\n}\n\n.tc-amount .unit {\n    font-size: 12px\n}\n\n.tc-item .tc-price {\n    font-weight: bold\n}\n\n.tc .image-list-mini {\n    margin-top: 3px\n}\n\na.image-list-mini {\n    display: inline-block;\n    text-decoration: none\n}\n\n.tc-user .media-user {\n    line-height: 1.15\n}\n\n.image-list-mini-title {\n    display: inline-block;\n    vertical-align: top;\n    margin-right: 6px;\n    margin-bottom: 4px\n}\n\n.image-list-mini-item {\n    display: inline-block;\n    vertical-align: top;\n    margin-bottom: 4px;\n    line-height: 1\n}\n\n.table-condensed .tc-header>div,.table-condensed .tc-item>div {\n    padding: 5px\n}\n\n@media(max-width: 767px) {\n    .tc {\n        margin-bottom:14px\n    }\n\n    .tc .tc-header>div,.tc .tc-item>div {\n        height: auto\n    }\n\n    .tc:not(.tc-selling):not(.tc-finance) .tc-item>div {\n        border-top: #eaeaea 1px solid\n    }\n\n    .tc:not(.tc-selling) .tc-header>div {\n        border-bottom: none\n    }\n\n    .tc-item>div.tc-amount,.tc-item>div.tc-price {\n        padding-top: 10px\n    }\n\n    .tc-visible-inside {\n        display: block;\n        margin-bottom: 5px\n    }\n\n    .tc-server-inside,.tc-side-inside {\n        display: inline\n    }\n\n    .tc-visible-inside,.tc-server-inside,.tc-side-inside {\n        font-size: 12px;\n        line-height: 1.16666667;\n        color: #888\n    }\n\n    .tc-server-inside:after {\n        content: \" ·\"\n    }\n\n    .tc-server-inside:last-child:after {\n        display: none\n    }\n\n    .tc-desc-text {\n        display: inline;\n        margin-right: 10px\n    }\n\n    .tc .image-list-mini {\n        display: inline-block;\n        margin-top: 0\n    }\n\n    .tc .media-user-name {\n        font-size: 12px\n    }\n\n    .tc .media-user-name .pseudo-a {\n        color: #4384d0\n    }\n\n    .tc-price .unit {\n        font-size: 12px\n    }\n}\n\n@media(max-width: 480px) {\n    .tc-short,.tc-short .tc-item,.tc.tc-short .tc-item>div {\n        display:block\n    }\n\n    .tc-short .tc-header {\n        display: table;\n        width: 100%\n    }\n\n    .tc-short .tc-item {\n        border-top: #eaeaea 1px solid;\n        padding-top: 12px;\n        padding-bottom: 12px;\n        position: relative\n    }\n\n    .tc.tc-short .tc-item>div {\n        border: none !important;\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .tc-item .tc-desc,.tc-item .tc-user {\n        margin-right: 85px\n    }\n\n    .tc-item .tc-user {\n        margin-top: 5px\n    }\n\n    .tc-short .tc-item .tc-price {\n        position: absolute;\n        right: 0;\n        top: 9px\n    }\n}\n\n.game-about {\n    border-top: #e4e4e4 1px solid;\n    padding-top: 34px;\n    padding-bottom: 34px\n}\n\n.game-about,.game-about h3,.game-about .h3 {\n    line-height: 1.29411764\n}\n\n.game-about h3,.game-about .h3 {\n    margin-bottom: 11px\n}\n\n.game-about .block-info>:last-child {\n    margin-bottom: 0\n}\n\n@media(max-width: 767px) {\n    .game-about {\n        padding-top:17px;\n        padding-bottom: 17px\n    }\n}\n\n.chat-promo {\n    display: table;\n    width: 100%;\n    margin-bottom: 12px;\n    border: 1px solid #f9f9f9;\n    border-radius: 4px;\n    background: #f9f9f9;\n    padding: 15px;\n    height: 72px\n}\n\n.chat-promo>div {\n    display: table-cell;\n    vertical-align: middle\n}\n\n.chat-promo-user {\n    width: 26.31578947%;\n    padding-right: 15px\n}\n\n.media-user>div {\n    vertical-align: middle\n}\n\n.media-user .avatar-photo {\n    width: 40px;\n    height: 40px\n}\n\n.chat-promo-user .avatar-photo,.tc .avatar-photo {\n    width: 36px;\n    height: 36px\n}\n\n.media-user-name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-weight: bold\n}\n\n.media-user-name a {\n    color: #222\n}\n\n.chat-promo-user .media-user-name {\n    max-width: 250px\n}\n\n.media-user-reviews {\n    white-space: nowrap\n}\n\n.media-user-reviews,.media-user-status,.media-user-info {\n    font-size: 12px\n}\n\n.media-user-info {\n    color: #a6a6a6;\n    font-weight: bold\n}\n\n.media-user-status {\n    font-weight: bold\n}\n\n.chat-header .media-user-status,.profile h1 .media-user-status {\n    font-size: 14px\n}\n\n.profile h1 .media-user-status {\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\n.online .media-user-status {\n    color: #7ed320\n}\n\n.offline .media-user-status {\n    color: #a6a6a6\n}\n\n.banned .media-user-status {\n    color: #f52323\n}\n\n.chat-header .offline .media-user-status {\n    font-weight: normal\n}\n\n.chat-promo-desc {\n    width: 57.2368421%;\n    padding-right: 15px\n}\n\n.chat-promo-desc>.inside {\n    overflow: hidden;\n    max-height: 2.857142858em\n}\n\n.chat-promo-btn {\n    width: 16.44736842%\n}\n\n@media(max-width: 767px) {\n    .chat-promo>div {\n        display:block;\n        width: auto;\n        padding-right: 0\n    }\n\n    .chat-promo-user {\n        margin-bottom: 10px\n    }\n\n    .chat-promo-desc {\n        margin-bottom: 15px\n    }\n\n    .profile h1,.profile .h1 {\n        margin-bottom: 28px !important\n    }\n\n    .profile h1 .media-user-status,.profile .h1 .media-user-status {\n        display: block;\n        margin-top: 6px\n    }\n}\n\n.chat {\n    height: 500px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 4px;\n    background: #fff;\n    margin-bottom: 18px\n}\n\n.chat-img {\n    display: inline-block;\n    border-radius: 4px;\n    background-color: #f9f9f9\n}\n\n.chat-img-link {\n    display: inline-block;\n    outline: none\n}\n\n.chat-float {\n    height: 595px\n}\n\n.chat.affix {\n    position: static\n}\n\n@media(min-width: 992px) {\n    .chat.affix {\n        position:fixed;\n        top: 13px\n    }\n\n    .chat.affix-bottom {\n        position: absolute\n    }\n\n    .chat.affix,.chat.affix-bottom {\n        width: 374px\n    }\n}\n\n@media(min-width: 1200px) {\n    .chat.affix,.chat.affix-bottom {\n        width:451px\n    }\n}\n\n.chat-not-selected .chat-header,.chat-not-selected .chat-form {\n    display: none\n}\n\n.chat-not-selected .chat-message-container {\n    border-bottom: 1px solid #eaeaea\n}\n\n@media(min-width: 768px) {\n    .chat-not-selected .chat-message-container {\n        border-top:1px solid #eaeaea\n    }\n}\n\n.chat-header {\n    border-radius: 4px 4px 0 0;\n    border: #eaeaea 1px solid;\n    padding: 15px 15px 15px 20px\n}\n\n.chat-header.bg-light-style {\n    border-color: #f9f9f9\n}\n\n.chat-float .chat-header {\n    padding: 10px 13px 10px 20px\n}\n\n.chat-header .media-user-name {\n    max-width: 134px\n}\n\n.chat-header h1,.chat-header .h1 {\n    margin-bottom: 0\n}\n\n.chat-header .media-left img {\n    min-width: 50px\n}\n\n.h1 .fa-clone {\n    vertical-align: text-top;\n    position: relative;\n    top: 8px;\n    margin-left: 4px;\n    font-size: 21px\n}\n\n.chat-user-count {\n    display: inline-block;\n    vertical-align: text-top;\n    margin-left: 12px;\n    margin-top: 11px;\n    font-size: 14px;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\n.chat-header {\n    display: table;\n    width: 100%;\n    height: 72px\n}\n\n.chat-header>div {\n    display: table-cell;\n    vertical-align: middle\n}\n\n.chat-header .media-user {\n    display: block\n}\n\n.chat-header .media-user .media-body {\n    width: auto\n}\n\n.chat-panel-mobile {\n    line-height: 1.15;\n    padding: 10px;\n    border-bottom: 1px solid #eaeaea\n}\n\n@media(min-width: 768px) {\n    .chat-panel-mobile {\n        padding:10px 20px;\n        border-left: 1px solid #eaeaea;\n        border-right: 1px solid #eaeaea\n    }\n}\n\n@media(min-width: 992px) {\n    .chat-panel-mobile {\n        display:none\n    }\n}\n\n.chat-panel-mobile a {\n    word-wrap: break-word\n}\n\n.chat-header .media-body {\n    height: 50px;\n    vertical-align: middle\n}\n\n.chat-header-controls {\n    text-align: right;\n    white-space: nowrap\n}\n\n.chat-header-controls .chat-control {\n    margin-right: 4px\n}\n\n.chat-header-controls .chat-control:last-child {\n    margin-right: 0\n}\n\n.chat-message-container {\n    flex: 1 1 auto;\n    border-left: #eaeaea 1px solid;\n    border-right: #eaeaea 1px solid;\n    display: flex;\n    position: relative\n}\n\n.chat-message-list-date {\n    position: relative;\n    margin-bottom: 18px;\n    text-align: center;\n    color: #a6a6a6\n}\n\n.chat-message-list-date:before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 50%;\n    height: 1px;\n    background: rgb(239.1,239.1,239.1);\n    font-size: 0;\n    margin-top: 1px\n}\n\n.chat-message-list-date .inside {\n    display: inline-block;\n    vertical-align: top;\n    padding-left: 9px;\n    padding-right: 9px;\n    background: #fff;\n    position: relative;\n    z-index: 1\n}\n\n.chat-empty {\n    display: flex;\n    align-items: center;\n    text-align: center\n}\n\n.chat-message-list,.chat-empty {\n    padding: 0 20px;\n    overflow-x: hidden;\n    overflow-y: auto\n}\n\n.chat-message-list .chat-msg-item,.chat-empty .chat-msg-item {\n    margin-bottom: 6px\n}\n\n.chat-message-list .chat-msg-item:first-child,.chat-empty .chat-msg-item:first-child {\n    margin-top: 20px\n}\n\n.chat-message-list .chat-msg-item:last-child,.chat-empty .chat-msg-item:last-child {\n    margin-bottom: 20px\n}\n\n.chat-message-container .chat-message-list,.chat-message-container .chat-empty {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0\n}\n\n.chat-msg-with-head {\n    margin-top: 18px\n}\n\n.chat-msg-author-label {\n    display: inline-block;\n    position: relative;\n    top: -1px\n}\n\n.message-append-compact {\n    padding-left: 50px\n}\n\n.chat-msg-text {\n    word-break: break-word;\n    white-space: pre-wrap\n}\n\n.chat-msg-widget {\n    margin-top: 18px\n}\n\n.chat-message:after {\n    clear: both\n}\n\n.chat-message .media-user>div {\n    vertical-align: top\n}\n\n.chat-message .media-user-name {\n    margin-bottom: 3px\n}\n\n.chat-message.blocked .chat-msg-author-link {\n    color: #a6a6a6\n}\n\n.chat-message.blocked .chat-msg-text {\n    color: #a6a6a6\n}\n\n.chat-message.blocked .avatar-photo {\n    opacity: .5\n}\n\n.chat-msg-date {\n    float: right;\n    width: 20%;\n    padding-left: 10px;\n    padding-top: 1px;\n    white-space: nowrap;\n    text-align: right;\n    color: #a6a6a6;\n    font-weight: normal;\n    display: inline-block\n}\n\n.chat-msg-body {\n    position: relative\n}\n\n.chat-msg-meta {\n    color: #a6a6a6;\n    opacity: .5;\n    position: absolute;\n    top: 0;\n    right: 0\n}\n\n.chat-msg-meta.chat-msg-meta-inside-alert {\n    right: 4px\n}\n\n.chat-msg-author-color-seller .chat-msg-author-link {\n    color: rgb(46.9,92.4,145.6)\n}\n\n.chat-msg-author-color-buyer .chat-msg-author-link {\n    color: #ce671b\n}\n\n.chat-msg-author-color-user1 .chat-msg-author-link {\n    color: #cd4073\n}\n\n.chat-msg-author-color-user2 .chat-msg-author-link {\n    color: #2996ad\n}\n\n.chat-form {\n    border: #eaeaea 1px solid;\n    padding: 10px 14px 10px 25px;\n    border-radius: 0 0 4px 4px;\n    position: relative\n}\n\n.chat-form form {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    width: 100%\n}\n\n.chat-form button,.chat-form button:hover,.chat-form button:focus,.chat-form button:active,.chat-form button:active:hover,.chat-form button:active:focus {\n    outline: none\n}\n\n.chat-form-input {\n    width: 100%;\n    padding-right: 12px\n}\n\n.chat-form-input textarea[readonly],.chat-form-input textarea[disabled] {\n    background: none;\n    color: #a6a6a6\n}\n\n.chat-form-input textarea[readonly]::-moz-placeholder,.chat-form-input textarea[disabled]::-moz-placeholder {\n    color: rgb(170.5,170.5,170.5);\n    opacity: 1\n}\n\n.chat-form-input textarea[readonly]:-ms-input-placeholder,.chat-form-input textarea[disabled]:-ms-input-placeholder {\n    color: rgb(170.5,170.5,170.5)\n}\n\n.chat-form-input textarea[readonly]::-webkit-input-placeholder,.chat-form-input textarea[disabled]::-webkit-input-placeholder {\n    color: rgb(170.5,170.5,170.5)\n}\n\n.chat-form-input .form-group {\n    width: 100%;\n    margin-bottom: 0;\n    position: relative\n}\n\n.chat-form-input .form-control {\n    resize: none;\n    border-color: rgba(0,0,0,0);\n    border-width: 0;\n    outline: none;\n    max-height: 12.1428571em\n}\n\n.chat-form-input .form-control,.chat-form-input .hiddendiv {\n    padding: 10px 10px 10px 0;\n    line-height: 1.21428571;\n    font-weight: normal;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    overflow: hidden\n}\n\n.chat-form-input .form-control.over,.chat-form-input .hiddendiv.over {\n    overflow: auto\n}\n\n.chat-form-input .hiddendiv {\n    position: absolute;\n    z-index: -1;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    opacity: 0;\n    border: none\n}\n\n.chat-form-attach {\n    padding-right: 12px\n}\n\n@media(max-width: 767px) {\n    .chat-message-list,.chat-header,.chat-form {\n        padding-left:20px\n    }\n\n    .chat-header {\n        padding-right: 20px\n    }\n\n    .chat-header h1,.chat-header .h1 {\n        margin-bottom: 10px\n    }\n\n    .chat-msg-date {\n        width: auto;\n        float: unset\n    }\n\n    .chat-float .chat-header {\n        padding-left: 10px;\n        padding-right: 10px;\n        position: relative\n    }\n\n    .chat-header .media-user {\n        overflow: hidden;\n        display: block\n    }\n\n    .chat-header .media-user .media-left {\n        padding-right: 5px\n    }\n\n    .chat-full .chat-header-controls {\n        position: absolute;\n        z-index: 10;\n        right: 10px;\n        top: 50%;\n        transform: translate(0, -50%)\n    }\n}\n\n.chat-profile-container {\n    float: right\n}\n\n@media(min-width: 992px) {\n    .chat-profile-container {\n        padding-left:16px !important\n    }\n}\n\n@media(max-width: 991px) {\n    .chat-profile-container {\n        float:unset\n    }\n}\n\n.chat-full-container {\n    padding-top: 20px;\n    padding-bottom: 20px\n}\n\n.chat-full {\n    display: flex;\n    width: 100%;\n    height: 270px\n}\n\n.chat-full .chat {\n    margin-bottom: 0;\n    width: 50.22222222%;\n    height: auto\n}\n\n.chat-full .chat-header,.chat-full .chat-form,.chat-full .chat-message-list {\n    border-radius: 0\n}\n\n.chat-not-selected-info {\n    margin: auto;\n    color: #a6a6a6\n}\n\n.chat-not-selected-info i {\n    display: block;\n    font-size: 80px\n}\n\n.chat-not-selected-info span {\n    display: block;\n    margin-top: 10px\n}\n\n.chat-bookmarks-empty .chat-not-selected-info .bookmarks-nonempty,.chat-bookmarks-nonempty .chat-not-selected-info .bookmarks-empty {\n    display: none\n}\n\n.chat-contacts,.chat-detail {\n    width: 24.88888889%;\n    background: #fff;\n    border: #eaeaea 1px solid;\n    display: flex;\n    flex-direction: column\n}\n\n.chat-contacts {\n    border-radius: 4px 0 0 4px;\n    border-right: none\n}\n\n.chat-detail {\n    border-radius: 0 4px 4px 0;\n    border-left: none\n}\n\n.chat-full-header {\n    padding: 20px;\n    border-bottom: #eaeaea 1px solid;\n    white-space: nowrap\n}\n\n.chat-full-header h1 {\n    margin: 0\n}\n\n.chat-full-header .badge {\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-weight: 500\n}\n\n.contact-list {\n    flex: 1 1 auto;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto\n}\n\n.custom-scroll,.chat-message-list,.chat-empty,.chat-form-input .form-control,.chat-form-input .hiddendiv {\n    -webkit-overflow-scrolling: touch\n}\n\n.custom-scroll::-webkit-scrollbar,.chat-message-list::-webkit-scrollbar,.chat-empty::-webkit-scrollbar,.chat-form-input .form-control::-webkit-scrollbar,.chat-form-input .hiddendiv::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n    background: #fff;\n    border: 0\n}\n\n.custom-scroll::-webkit-scrollbar-thumb,.chat-message-list::-webkit-scrollbar-thumb,.chat-empty::-webkit-scrollbar-thumb,.chat-form-input .form-control::-webkit-scrollbar-thumb,.chat-form-input .hiddendiv::-webkit-scrollbar-thumb {\n    cursor: pointer;\n    background: #ddd;\n    border: 0\n}\n\n.contact-item {\n    line-height: 1.15;\n    border-bottom: #eaeaea 1px solid;\n    padding: 6px 10px 6px 75px;\n    position: relative;\n    cursor: pointer;\n    letter-spacing: .2px;\n    display: block\n}\n\n.contact-item:before,.contact-item:after {\n    content: \" \";\n    display: table\n}\n\n.contact-item:after {\n    clear: both\n}\n\n.contact-item:hover {\n    background: #f9f9f9\n}\n\n.contact-item.active,.contact-item.active:hover,.contact-item.active:focus {\n    background: #4384d0\n}\n\n.contact-item.active,.contact-item.active>div {\n    color: #fff\n}\n\n.contact-item.unread {\n    background: #f5a623\n}\n\n.contact-item.unread:hover,.contact-item.unread:focus {\n    background: rgb(244.1130434783,158.1060869565,15.4869565217)\n}\n\n.contact-item.unread,.contact-item.unread>div {\n    color: #fff\n}\n\n.contact-item .media-user-name {\n    margin-right: 50px\n}\n\na.contact-item {\n    text-decoration: none;\n    color: unset\n}\n\n.contact-item-photo {\n    width: 50px;\n    float: left;\n    margin-left: -65px\n}\n\n.contact-item-message {\n    margin-top: 2px;\n    line-height: 15px;\n    height: 30px;\n    overflow: hidden;\n    color: #c2c2c2\n}\n\n.contact-item-time {\n    position: absolute;\n    top: 6px;\n    right: 10px;\n    color: #4a4a4a\n}\n\na.chat-clone {\n    text-decoration: none;\n    color: unset\n}\n\n.chat-detail {\n    padding: 15px 0 15px 0\n}\n\n.chat-detail-list {\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding-right: 50px;\n    padding-left: 65px\n}\n\n.chat-back {\n    display: none\n}\n\n@media(max-width: 1199px) {\n    .chat-detail-list {\n        padding-right:20px;\n        padding-left: 20px\n    }\n}\n\n@media(max-width: 991px) {\n    .chat-detail {\n        display:none\n    }\n\n    .chat-contacts {\n        width: 35%\n    }\n\n    .chat-full .chat {\n        width: 65%\n    }\n\n    .chat-full .chat-header {\n        border-radius: 0 4px 0 0\n    }\n\n    .chat-full .chat-form {\n        border-radius: 0 0 4px 0\n    }\n}\n\n@media(max-width: 767px) {\n    .chat-full-container {\n        padding-top:0;\n        padding-bottom: 0;\n        overflow: hidden\n    }\n\n    .chat-full-container .container {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .chat-contacts {\n        border: none;\n        border-radius: 0\n    }\n\n    .chat-full {\n        width: 200%;\n        -webkit-transition: transform .3s ease-in-out;\n        -o-transition: transform .3s ease-in-out;\n        transition: transform .3s ease-in-out\n    }\n\n    .chat-full .chat-header,.chat-full .chat-message-container,.chat-full .chat-form {\n        border-left: none;\n        border-right: none;\n        border-radius: 0\n    }\n\n    .chat-full .chat-form {\n        border-bottom: none\n    }\n\n    .chat-full.moved {\n        transform: translate(-50%, 0)\n    }\n\n    .chat-contacts,.chat-full .chat {\n        width: 50%\n    }\n\n    .chat-full .chat-header {\n        padding-right: 10px;\n        border-top: none\n    }\n\n    .chat-full .chat-message-list {\n        padding: 0 10px\n    }\n\n    .chat-full .chat-message-list .chat-msg-item:first-child {\n        margin-top: 10px\n    }\n\n    .chat-full .chat-message-list .chat-msg-item:last-child {\n        margin-bottom: 10px\n    }\n\n    .chat-full .chat-form {\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .chat-full.chat-bookmarks-nonempty .chat-header {\n        padding-left: 35px\n    }\n\n    .chat-full.chat-bookmarks-nonempty .chat-back {\n        display: block;\n        position: absolute;\n        left: 10px;\n        width: 15px;\n        text-align: center;\n        top: 50%;\n        font-size: 16px;\n        transform: translate(0, -50%);\n        cursor: pointer\n    }\n}\n\n.chat-message-list.no-padding .chat-msg-item {\n    margin-top: 10px;\n    margin-bottom: 0\n}\n\n.chat-message-list.no-padding .chat-msg-item:first-child {\n    margin-top: 0\n}\n\n.chat-msg-item .video-box-fake {\n    margin-top: 1em\n}\n\n\n.rating-stars {\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 8px\n}\n\n.rating-stars .fas:before,.rating-stars .far:before {\n    content: \"\"\n}\n\n.rating-stars.rating-1,.rating-stars.rating-2,.rating-stars.rating-3 {\n    color: #d0011b\n}\n\n.rating-stars.rating-4 {\n    color: #f5a623\n}\n\n.rating-stars.rating-5 {\n    color: #f8e71c\n}\n\n.rating-mini-count {\n    color: #888;\n    vertical-align: middle\n}\n\n.rating-value {\n    font-family: \"Graphik Bold\",\"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\n.rating-value .big {\n    display: inline-block;\n    margin-right: 8px;\n    position: relative;\n    line-height: .83333333;\n    font-size: 60px;\n    letter-spacing: -3px\n}\n\n.rating-value>* {\n    vertical-align: baseline\n}\n\n.rating-full {\n    line-height: 10px;\n    white-space: nowrap\n}\n\n.rating-full .rating-mini {\n    margin-right: 3px;\n    vertical-align: top\n}\n\n.rating-full-item4 .rating-mini {\n    width: 40px;\n    margin-left: 10px\n}\n\n.rating-full-item3 .rating-mini {\n    width: 30px;\n    margin-left: 20px\n}\n\n.rating-full-item2 .rating-mini {\n    width: 20px;\n    margin-left: 30px\n}\n\n.rating-full-item1 .rating-mini {\n    width: 10px;\n    margin-left: 40px\n}\n\n.rating-progress {\n    display: inline-block;\n    vertical-align: top;\n    margin-top: 4px;\n    height: 1px;\n    width: 67px;\n    background: #dcdcdc\n}\n\n.rating-progress>div {\n    height: 1px;\n    background: #444\n}\n\n\n\n\n.rating>span {\n    position: absolute;\n    left: 0;\n    top: 0;\n    cursor: pointer\n}\n\n\n\n.rating1 {\n    width: 17px\n}\n\n.rating2 {\n    width: 37px\n}\n\n.rating3 {\n    width: 57px\n}\n\n.rating4 {\n    width: 77px\n}\n\n.rating5 {\n    width: 97px\n}\n\n.review-container {\n    border-top: #e4e4e4 1px solid\n}\n\n.review-editor-review {\n    padding-top: 21px;\n    margin-bottom: -30px\n}\n\n.review-item {\n    padding-top: 21px;\n    padding-bottom: 20px;\n    padding-left: 55px\n}\n\n.review-item:before,.review-item:after {\n    content: \" \";\n    display: table\n}\n\n.review-item:after {\n    clear: both\n}\n\n.review-item-user {\n    margin-right: -7px\n}\n\n.review-item-user>div {\n    display: inline-block;\n    vertical-align: top;\n    margin-right: 7px;\n    margin-bottom: 3px\n}\n\n.review-item-photo {\n    width: 40px;\n    float: left;\n    margin-left: -55px;\n    margin-top: 3px\n}\n\n.review-item-photo img {\n    width: 100%;\n    border-radius: 40px\n}\n\n.review-item-detail {\n    color: #a6a6a6;\n    font-weight: bold\n}\n\n.review-item-order {\n    font-weight: bold\n}\n\n.review-item-rating.pull-right {\n    margin-right: 4px\n}\n\n.review-item-text {\n    margin-top: 5px\n}\n\n.review-item-answer {\n    display: inline-block;\n    padding: 16px 20px;\n    background: #f5f5f5;\n    border-radius: 4px;\n    position: relative\n}\n\n.bg-light-style .review-item-answer {\n    background: hsl(0,0%,95.0784313725%)\n}\n\n.review-item-text,.review-item-answer {\n    word-wrap: break-word;\n    word-break: break-word\n}\n\n@media(max-width: 767px) {\n    .review-item {\n        padding-left:0\n    }\n\n    .review-item-user {\n        padding-left: 55px;\n        margin-right: 0;\n        margin-bottom: 5px\n    }\n\n    .review-item-user:before,.review-item-user:after {\n        content: \" \";\n        display: table\n    }\n\n    .review-item-user:after {\n        clear: both\n    }\n\n    .review-item-user>div {\n        display: block;\n        margin-right: 0\n    }\n\n    .review-item-rating {\n        margin-top: 3px\n    }\n}\n\n.dyn-table-filter .filter-text {\n    display: inline-block;\n    min-width: 7.5em;\n    text-align: left\n}\n\n.review-rating {\n    display: inline-block;\n    color: #f8e71c\n}\n\n.review-rating a {\n    font-size: 30px;\n    color: inherit;\n    text-decoration: none;\n    outline: none;\n    padding: 0 6px\n}\n\n.review-rating a:first-child {\n    padding-left: 0\n}\n\n.review-rating a:last-child {\n    padding-right: 0\n}\n\n.review-rating span {\n    font-size: 16px\n}\n\n@media(min-width: 768px) {\n    .review-empty-text {\n        margin-left:-55px\n    }\n}\n\n.reviews-filter {\n    position: relative\n}\n\n.reviews-filter .dropdown-toggle {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.reviews-filter .dropdown-toggle .filter-text {\n    min-width: unset\n}\n\n.reviews-filter .dropdown-menu {\n    min-width: initial;\n    width: 100%;\n    left: inherit\n}\n\n.reviews-filter .dropdown-menu .review-rating>.rating {\n    background: none\n}\n\n.reviews-filter .review-rating {\n    position: relative;\n    top: 2px\n}\n\n.review-controls {\n    margin-top: 15px\n}\n\n.review-item>.review-item-row {\n    margin-bottom: 20px\n}\n\n.review-item>.review-item-row:last-child {\n    margin-bottom: 0\n}\n\n.with-corner-cd {\n    position: relative\n}\n\n.with-corner-cd .wrapper {\n    position: relative\n}\n\n.navbar-brand>img.logo-white {\n    display: none\n}\n\n.with-corner-cd .navbar-brand>img.logo-white {\n    display: block\n}\n\n.with-corner-cd .navbar-brand>img.logo-color {\n    display: none\n}\n\n.with-corner-cd .navbar-default,.with-corner-cd .navbar-form .form-control {\n    background: rgba(0,0,0,0)\n}\n\n.with-corner-cd .back-link a {\n    color: #fff\n}\n\n.corner-cd-container {\n    width: 100%;\n    height: 450px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    overflow: hidden\n}\n\n.corner-cd {\n    width: 715px;\n    height: 715px;\n    position: absolute;\n    z-index: -1;\n    right: 50%;\n    margin-right: 352px;\n    bottom: 100%;\n    margin-bottom: -293px;\n    border-radius: 500px;\n    overflow: hidden\n}\n\n.corner-cd img {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 100\n}\n\n.corner-cd:before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 200;\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) 85%, rgba(0, 0, 0, 0.8) 100%)\n}\n\n@media(max-width: 1199px) {\n    .corner-cd {\n        margin-right:270px\n    }\n}\n\n@media(max-width: 991px) {\n    .corner-cd {\n        margin-right:140px\n    }\n}\n\n@media(max-width: 767px) {\n    .corner-cd {\n        margin-right:0;\n        right: auto;\n        margin-bottom: -132px;\n        left: 0;\n        margin-left: -275px\n    }\n\n    .with-corner-cd .navbar-default {\n        background: #fff\n    }\n\n    .with-corner-cd .navbar-brand>img.logo-color {\n        display: block\n    }\n\n    .with-corner-cd .navbar-brand>img.logo-white {\n        display: none\n    }\n}\n\n.back-link {\n    margin-top: 32px\n}\n\n.back-link a {\n    display: inline-block;\n    padding-left: 25px;\n    min-height: 2.857142858em;\n    line-height: 2.657142858;\n    position: relative;\n    font-weight: bold\n}\n\n.back-link .inside {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1.428571429\n}\n\n.back-link i {\n    position: absolute;\n    left: 2px;\n    top: 50%;\n    transform: translate(0, -50%)\n}\n\n@media(max-width: 767px) {\n    .back-link {\n        max-width:200px;\n        margin-top: 22px;\n        margin-bottom: 15px\n    }\n\n    body:not(.with-corner-cd) .product-page .back-link {\n        margin-bottom: -15px\n    }\n}\n\n.page-content {\n    padding-top: 30px;\n    padding-bottom: 30px\n}\n\n.product-page .page-content {\n    padding-right: 12px\n}\n\n@media(max-width: 767px) {\n    .page-content-custom {\n        padding-bottom:0\n    }\n}\n\n.page-content-full {\n    padding-top: 40px;\n    padding-bottom: 30px\n}\n\n.param-item {\n    margin-bottom: 25px\n}\n\n.param-item .h1 {\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\n.payment {\n    width: 100%;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    padding-right: 8px\n}\n\n.dropdown-menu .payment {\n    padding-right: 24px\n}\n\n.payment .payment-logo {\n    margin-right: 8px\n}\n\n.selectpicker-option-normal {\n    font-weight: normal\n}\n\n.payment-title {\n    width: 46.57534246%;\n    font-weight: normal;\n    flex-grow: 2\n}\n\n.payment-value {\n    width: 22.73972603%;\n    text-align: right;\n    font-weight: bold;\n    flex-grow: 1\n}\n\n.btn .payment-logo,.btn .payment-title,.btn .payment-value {\n    overflow: hidden\n}\n\n@media(max-width: 1199px) {\n    .product-page .page-content {\n        padding-left:0;\n        padding-right: 0\n    }\n}\n\n@media(max-width: 767px) {\n    .page-content-full {\n        padding-top:27px\n    }\n\n    .payment-value {\n        width: 38%\n    }\n\n    .payment-title {\n        display: block;\n        width: 62%\n    }\n}\n\n@media(min-width: 992px) {\n    .product-page-with-chat {\n        min-height:630px\n    }\n\n    .product-page>.row {\n        position: relative\n    }\n\n    .product-page>.row>div {\n        position: static\n    }\n\n    .chat-float-container {\n        position: absolute;\n        right: 0;\n        top: 13px;\n        width: 41.6666666667%;\n        padding-left: 15px;\n        padding-right: 15px\n    }\n}\n\n.seller-promo {\n    width: 250px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.seller-promo .rating-stars {\n    font-size: 24px;\n    letter-spacing: 8px;\n    margin-right: -8px;\n    margin-bottom: 11px\n}\n\n.seller-promo-title,.seller-promo-desc {\n    margin-bottom: 14px\n}\n\n.seller-promo .rating {\n    margin-bottom: 15px\n}\n\n.seller-promo-note {\n    color: #a6a6a6\n}\n\n.payment-card {\n    background: #fff;\n    padding: 20px;\n    border-radius: 4px;\n    margin: 30px 0\n}\n\n.payment-card .payment-title {\n    display: inline-block;\n    width: 100%\n}\n\n.payment-row .payment-logo {\n    display: inline-block;\n    vertical-align: 1px\n}\n\n.payment-row .payment-title {\n    display: inline;\n    width: auto;\n    white-space: nowrap\n}\n\n@media(max-width: 767px) {\n    .payment-card {\n        margin-top:0;\n        margin-left: -10px;\n        margin-right: -10px;\n        padding: 20px 10px;\n        border-radius: 0\n    }\n}\n\n.profile-cover-container {\n    position: absolute;\n    bottom: 0;\n    left: -150px;\n    right: -150px;\n    width: auto;\n    overflow: hidden;\n    padding-top: 100%;\n    border-radius: 50%\n}\n\n\n\n.profile-cover {\n    position: relative;\n    overflow: hidden;\n    margin-left: -30px;\n    margin-right: -30px;\n    padding-left: 30px;\n    padding-right: 30px;\n    padding-top: 63px\n}\n\n.profile-cover:before,.profile-cover:after {\n    content: \" \";\n    display: table\n}\n\n.profile-cover:after {\n    clear: both\n}\n\n.avatar {\n    float: left;\n    position: relative;\n    z-index: 100\n}\n\n\n.avatar-photo:before {\n    content: \"\";\n    display: block;\n    width: 100%;\n    padding-bottom: 100%\n}\n\n.avatar-photo a {\n    display: block;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 50%\n}\n\n.avatar .avatar-photo {\n    width: 170px;\n    height: 170px\n}\n\n.edit-avatar {\n    position: absolute;\n    top: 3px;\n    right: 3px\n}\n\n.edit-cover {\n    float: right;\n    margin-right: 60px;\n    position: relative;\n    z-index: 200\n}\n\n@media(max-width: 1280px) {\n    .profile-cover {\n        padding-left:15px;\n        padding-right: 15px;\n        margin-left: -15px;\n        margin-right: -15px\n    }\n\n    .profile-cover-container {\n        left: -140px;\n        right: -140px\n    }\n}\n\n@media(max-width: 1199px) {\n    .profile-cover {\n        padding-left:30px;\n        padding-right: 30px;\n        margin-left: -30px;\n        margin-right: -30px\n    }\n\n    .profile-cover-container {\n        left: -90px;\n        right: -90px\n    }\n}\n\n@media(max-width: 1050px) {\n    .profile-cover {\n        padding-left:15px;\n        padding-right: 15px;\n        margin-left: -15px;\n        margin-right: -15px\n    }\n\n    .profile-cover-container {\n        left: -80px;\n        right: -80px\n    }\n}\n\n@media(max-width: 991px) {\n    .profile-cover {\n        padding-left:35px;\n        padding-right: 35px;\n        margin-left: -35px;\n        margin-right: -35px\n    }\n\n    .profile-cover-container {\n        left: -35px;\n        right: -35px\n    }\n}\n\n@media(max-width: 820px) {\n    .profile-cover {\n        padding-left:15px;\n        padding-right: 15px;\n        margin-left: -15px;\n        margin-right: -15px\n    }\n\n    .profile-cover-container {\n        left: -28px;\n        right: -28px\n    }\n}\n\n@media(max-width: 991px) {\n    .profile-cover {\n        padding-top:30px\n    }\n\n    .edit-cover {\n        margin-right: 0\n    }\n}\n\n@media(max-width: 767px) {\n    .profile-cover {\n        padding-top:33px;\n        margin-left: 0;\n        margin-right: 0;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .profile-cover-container {\n        left: 0;\n        right: 0\n    }\n\n    .avatar .avatar-photo {\n        width: 70px;\n        height: 70px\n    }\n}\n\n.profile {\n    margin-top: 30px\n}\n\n.achievement-item {\n    margin-top: 5px\n}\n\n.achievement-icon {\n    display: inline-block;\n    width: 20px;\n    margin-right: 2px;\n    text-align: center\n}\n\n.profile-header-cols {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0 80px;\n    margin-bottom: 10px\n}\n\n.profile-header-cols .param-item {\n    margin-bottom: 15px\n}\n\n.profile .rating-value {\n    margin-left: -2px;\n    margin-top: 4px\n}\n\n.profile .rating-full {\n    margin-right: 15px;\n    margin-top: 4px;\n    margin-left: -24px\n}\n\n.rating-full-count {\n    display: inline-block;\n    font-weight: bold\n}\n\n.offer {\n    background: #fff;\n    border-radius: 8px;\n    padding: 15px;\n    margin-bottom: 13px\n}\n\n.offer .tc {\n    margin-bottom: 0\n}\n\n.btn-plus {\n    width: 33px;\n    height: 33px;\n    padding: 7px\n}\n\n.btn-plus .inside {\n    position: relative;\n    top: -1px\n}\n\n.offer-tc-container {\n    border-top: #eaeaea 1px solid\n}\n\n.offer-tc-container .tc {\n    padding-bottom: 0\n}\n\n@media(max-width: 767px) {\n    .profile {\n        margin-top:17px\n    }\n\n    .profile-header-cols {\n        gap: 0 30px\n    }\n\n    .profile-header-col-rating {\n        width: 100%\n    }\n\n    .rating-full-count {\n        display: block;\n        margin-top: 12px\n    }\n\n    .rating-full-count br {\n        display: none\n    }\n\n    .offer {\n        padding-right: 16px\n    }\n\n    .offer .tc-header>div {\n        padding-bottom: 12px\n    }\n}\n\n.offer-controls {\n    margin-top: 20px;\n    margin-bottom: 9px\n}\n\n@media(min-width: 992px) {\n    .offer-controls {\n        margin-left:15px;\n        margin-top: -4px;\n        margin-bottom: 0\n    }\n}\n\n@media(min-width: 1200px) {\n    .offer-controls {\n        margin-left:25px\n    }\n}\n\n.setting-group {\n    padding: 30px 0\n}\n\n.setting-group+.setting-group {\n    border-top: 1px solid #eaeaea\n}\n\n.setting-item {\n    margin-bottom: 40px\n}\n\n.setting-item:last-child {\n    margin-bottom: 0\n}\n\n.setting-item h3,.setting-item .h3 {\n    margin-top: 0\n}\n\n.setting-item .btn {\n    width: 209px\n}\n\n.setting-item .btn-gray,.setting-item .btn-gray:hover,.setting-item .btn-gray:focus,.setting-item .btn-gray:active {\n    color: #222\n}\n\n.setting-buttons {\n    padding-left: 0;\n    list-style: none;\n    padding: 0;\n    margin: 0\n}\n\n.setting-buttons li {\n    margin-top: 8px\n}\n\n.setting-buttons li:first-child {\n    margin-top: 0\n}\n\n.setting-photo {\n    width: 115px;\n    margin-bottom: 20px;\n    font-size: 45px;\n    color: #fff\n}\n\n.setting-photo .avatar-photo {\n    background-color: #4384d0;\n    background-image: none\n}\n\n\n.setting-photo img,.setting-photo i {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%)\n}\n\n@media(min-width: 768px) {\n    .setting-item {\n        padding-left:140px\n    }\n\n    .setting-item:before,.setting-item:after {\n        content: \" \";\n        display: table\n    }\n\n    .setting-item:after {\n        clear: both\n    }\n\n    .setting-photo {\n        float: left;\n        margin-left: -140px;\n        margin-bottom: 0\n    }\n}\n\n.modal-auth .nav-tabs {\n    font-size: 23px;\n    font-weight: normal;\n    margin-top: -22px;\n    margin-bottom: 15px\n}\n\n.modal-auth .nav-tabs>li>a {\n    padding: 15px 0\n}\n\n.modal-auth .nav-tabs>li:last-child {\n    float: right\n}\n\n.social-login {\n    margin-right: -10px\n}\n\n.social-login-item {\n    display: inline-block;\n    position: relative;\n    vertical-align: middle;\n    margin-right: 10px;\n    background: #eee;\n    border: none;\n    border-radius: 50%;\n    width: 74px;\n    height: 74px;\n    line-height: 74px;\n    text-align: center;\n    font-size: 28px\n}\n\n.social-login-item-google {\n    background: #fff;\n    border: 1px solid #777\n}\n\n.social-login-item-google svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%\n}\n\n.social-login-item-google:hover,.social-login-item-google:focus,.social-login-item-google:active {\n    background: #fcfcfc\n}\n\n.social-login-item-vk {\n    background: #07f\n}\n\n.social-login-item-vk svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 36px;\n    height: 36px\n}\n\n.social-login-item-vk:hover,.social-login-item-vk:focus,.social-login-item-vk:active {\n    background: #0071f2\n}\n\n.success-icon {\n    margin-top: 3px;\n    font-size: 74px\n}\n\n@media(max-width: 767px) {\n    .modal-auth .nav-tabs {\n        font-size:21px\n    }\n\n    .modal-auth .nav-tabs>li {\n        margin-right: 5%\n    }\n\n    .modal-auth .nav-tabs>li:last-child {\n        margin-right: 0;\n        float: left\n    }\n\n    .social-login-item {\n        width: 64px;\n        height: 64px;\n        line-height: 64px\n    }\n\n    .social-login-item-vk svg {\n        width: 32px;\n        height: 32px\n    }\n}\n\n.balances-header .balances-list {\n    font-size: .8em\n}\n\n.balances-header .balances-list .balances-delimiter {\n    margin: 0 14px;\n    color: #888\n}\n\n.balances-header .balances-list .balances-value {\n    display: inline-block;\n    white-space: nowrap\n}\n\n@media(max-width: 480px) {\n    .balances-header .balances-list {\n        display:block;\n        margin-top: 10px;\n        font-size: .7em\n    }\n\n    .balances-header .balances-list .balances-delimiter {\n        display: none\n    }\n\n    .balances-header .balances-list .balances-value {\n        display: block;\n        margin-top: 6px\n    }\n}\n\n.finance-controls:before,.finance-controls:after {\n    content: \" \";\n    display: table\n}\n\n.finance-controls:after {\n    clear: both\n}\n\n.finance-controls .pull-right {\n    padding-left: 3px\n}\n\n.tc-finance {\n    border-bottom: #eaeaea 1px solid\n}\n\n.tc-finance .tc-header>div,.tc-finance .tc-item>div {\n    padding-top: 16px;\n    padding-bottom: 17px;\n    border-top: #eaeaea 1px solid;\n    height: auto\n}\n\n.tc-finance .tc-header>div {\n    border-bottom: none\n}\n\n.tc-finance .payment-logo {\n    display: inline-block;\n    margin: -6px 0\n}\n\n.tc-finance .tc-item>div.tc-go {\n    width: 2.66666667%;\n    text-align: right;\n    font-size: 16px;\n    line-height: 1.25;\n    color: #4384d0\n}\n\n.tc-finance .tc-go i {\n    position: relative;\n    top: 1px\n}\n\n.tc-finance .tc-date-time {\n    margin-right: 4px\n}\n\n.tc-finance .tc-payment-number {\n    white-space: nowrap\n}\n\n.tc-finance .tc-date-left,.tc-finance .tc-txn-obj-info,.tc-finance .tc-payment-number {\n    color: #a6a6a6\n}\n\n.tc-finance .tc-title,.tc-finance .tc-payment-number {\n    margin-right: 10px\n}\n\n.tc-finance .tc-title a {\n    color: #222\n}\n\n.tc-finance .dyn-table-body {\n    display: table-row-group\n}\n\n.tc-finance .tc-item .tc-status {\n    font-weight: bold\n}\n\n@media(max-width: 767px) {\n    .tc-finance {\n        display:block;\n        border-top: #eaeaea 1px solid\n    }\n\n    .tc-finance .tc-header {\n        width: 100%;\n        display: table\n    }\n\n    .tc-finance .tc-header>div,.tc-finance .tc-header>[class^=col-],.tc-finance .tc-header>[class*=\" col-\"] {\n        padding-top: 15px;\n        padding-bottom: 14px;\n        float: left;\n        border-top: none\n    }\n\n    .tc-finance .tc-header>div.tc-price {\n        float: right\n    }\n\n    .tc-finance .tc-item {\n        border-top: #eaeaea 1px solid;\n        display: block;\n        position: relative;\n        padding-top: 11px;\n        padding-bottom: 12px\n    }\n\n    .tc-finance .tc-item:before,.tc-finance .tc-item:after {\n        content: \" \";\n        display: table\n    }\n\n    .tc-finance .tc-item:after {\n        clear: both\n    }\n\n    .tc-finance .tc-item>div {\n        display: block;\n        border-top: none\n    }\n\n    .tc-finance .tc-item>div {\n        padding-top: 4px;\n        padding-bottom: 4px\n    }\n\n    .tc-finance .tc-item .tc-status,.tc-finance .tc-item .tc-price {\n        float: left;\n        width: 50%\n    }\n\n    .tc-finance .tc-title {\n        display: block\n    }\n\n    .tc-finance .tc-txn-obj-info,.tc-finance .tc-payment-number {\n        display: inline-block;\n        margin-top: 8px\n    }\n\n    .tc-finance .tc-item>div.tc-go {\n        position: absolute;\n        right: 0;\n        top: 12px;\n        width: auto\n    }\n\n    .tc-finance .tc-order {\n        font-weight: bold\n    }\n\n    .tc-finance .tc-date-time,.tc-finance .tc-date-left {\n        display: inline-block\n    }\n\n    .tc-finance .dyn-table-body {\n        display: block\n    }\n}\n\n@media(max-width: 480px) {\n    .tc-finance .tc-item .tc-desc {\n        margin-right:0\n    }\n}\n\n.selling-min {\n    margin-top: 32px;\n    margin-bottom: 30px\n}\n\n.selling-min.affix {\n    position: static\n}\n\n@media(min-width: 992px) {\n    .selling-min.affix {\n        position:fixed;\n        top: 13px;\n        margin-top: 0\n    }\n\n    .selling-min.affix-bottom {\n        position: absolute\n    }\n\n    .selling-min.affix,.selling-min.affix-bottom {\n        width: 187px\n    }\n}\n\n@media(min-width: 1200px) {\n    .selling-min.affix,.selling-min.affix-bottom {\n        width:225px\n    }\n}\n\n.tooltip-inner {\n    white-space: pre-line\n}\n\n.help-tooltip {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: -3px;\n    line-height: 18px;\n    font-size: 18px\n}\n\n.help-tooltip a,.help-tooltip i {\n    display: block;\n    text-decoration: none\n}\n\n.popover {\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\n.popover>.arrow,.popover>.arrow:after {\n    border-left-width: 20px;\n    border-right-width: 20px\n}\n\n.popover.bottom>.arrow,.popover.top>.arrow {\n    margin-left: -20px\n}\n\n.popover.bottom>.arrow:after,.popover.top>.arrow:after {\n    margin-left: -20px\n}\n\n.popover h5,.popover .h5 {\n    color: #222\n}\n\n.popover.bottom {\n    margin-top: 19px\n}\n\n.popover-content {\n    padding: 16px 17px\n}\n\n.tc-selling {\n    margin-bottom: 17px\n}\n\n.tc-selling .help-block {\n    margin-top: 0;\n    margin-bottom: 0;\n    display: inline\n}\n\n.tc-selling .help-block.complete {\n    color: #222\n}\n\n.tc-selling-divider {\n    height: 5px\n}\n\n.tc-selling .tc-item>div {\n    height: auto\n}\n\n.tc-selling .tc-item>div.tc-input {\n    padding-top: 4px;\n    padding-bottom: 16px\n}\n\n.tc-selling .tc-item>div.tc-checkbox,.tc-selling .tc-item>div.tc-server,.tc-selling .tc-item>div.tc-side {\n    padding-top: 3px;\n    padding-bottom: 5px\n}\n\n@media(max-width: 767px) {\n    .fixed-btn {\n        position:fixed;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: #fff;\n        padding: 9px 10px;\n        border-top: #e4e4e4 1px solid;\n        z-index: 1020\n    }\n\n    .tc-selling .tc-header>div,.tc-selling .tc-header>[class^=col-],.tc-selling .tc-header>[class*=\" col-\"],.tc-selling .tc-item>div,.tc-selling .tc-item>[class^=col-],.tc-selling .tc-item>[class*=\" col-\"] {\n        padding-right: 0;\n        padding-left: 8px\n    }\n\n    .tc-selling .tc-header>div:first-child,.tc-selling .tc-header>[class^=col-]:first-child,.tc-selling .tc-header>[class*=\" col-\"]:first-child,.tc-selling .tc-item>div:first-child,.tc-selling .tc-item>[class^=col-]:first-child,.tc-selling .tc-item>[class*=\" col-\"]:first-child {\n        padding-left: 0\n    }\n\n    .tc-selling .tc-header>div.tc-server {\n        padding-left: 0\n    }\n\n    .tc-selling .form-group {\n        margin-top: 0;\n        margin-bottom: 0\n    }\n\n    .catalog-price.help-block {\n        margin-top: 5px;\n        width: 200%;\n        font-size: 12px\n    }\n}\n\n#footer {\n    padding-top: 24px;\n    padding-bottom: 26px;\n    border-top: #e4e4e4 1px solid;\n    display: flex;\n    align-items: center\n}\n\n.footer-block {\n    flex-shrink: 0;\n    white-space: nowrap;\n    margin-left: 30px\n}\n\n.footer-block:first-child {\n    margin-left: 0\n}\n\n.footer-block-strings {\n    flex: 1 1 auto;\n    white-space: normal\n}\n\n.footer-block-strings>span,.footer-block-strings>a {\n    display: inline-block;\n    margin-right: 20px\n}\n\n.footer-block-social a {\n    font-size: 24px;\n    font-weight: normal;\n    margin-left: 5px\n}\n\n.footer-block-social a:first-child {\n    margin-left: 0\n}\n\n.footer-block-als {\n    display: flex\n}\n\n.footer-block-als img {\n    width: 100px;\n    height: 45px;\n    margin-right: 12px\n}\n\n.footer-block-als div {\n    display: inline-block;\n    font-size: 10px\n}\n\n@media(max-width: 767px) {\n    #footer {\n        display:block\n    }\n\n    .footer-block {\n        margin-left: 0;\n        margin-top: 20px\n    }\n\n    .footer-block:first-child {\n        margin-top: 0\n    }\n}\n\n.modal-footer {\n    padding-top: 0\n}\n\n.modal-actions {\n    padding-top: 25px;\n    text-align: right;\n    border-top: 1px solid rgba(0,0,0,0)\n}\n\n.modal-actions .btn+.btn {\n    margin-left: 5px;\n    margin-bottom: 0\n}\n\n.modal-dialog {\n    margin: 0\n}\n\n.modal-dialog .close {\n    outline: none;\n    position: absolute;\n    top: -40px;\n    right: 0;\n    color: #fff;\n    font-size: 36px;\n    opacity: 1;\n    filter: alpha(opacity=100)\n}\n\n.modal-dialog .close:hover,.modal-dialog .close:focus {\n    opacity: 1;\n    filter: alpha(opacity=100);\n    color: hsl(0,0%,90%)\n}\n\n.modal-dialog .close i:before {\n    content: \"×\"\n}\n\n.modal-content {\n    border-radius: 4px 4px 0 0;\n    -webkit-box-shadow: none;\n    box-shadow: none\n}\n\n@media(max-width: 767px) {\n    .modal-header,.modal-body,.modal-footer {\n        padding-left:10px;\n        padding-right: 10px\n    }\n\n    .modal-dialog {\n        width: 100%;\n        height: 100%;\n        padding-top: 80px\n    }\n\n    .modal-dialog .close {\n        top: 0;\n        right: 0;\n        left: 0;\n        width: 100%;\n        height: 80px;\n        text-align: right;\n        padding-right: 20px\n    }\n\n    .modal-content {\n        min-height: 100%\n    }\n\n    .modal-open .modal {\n        padding-left: 0 !important;\n        padding-right: 0 !important\n    }\n}\n\n@media(min-width: 768px) {\n    .modal {\n        text-align:center\n    }\n\n    .modal:after {\n        display: inline-block;\n        vertical-align: middle;\n        height: 100%;\n        margin-left: -0.05em;\n        content: \"\"\n    }\n\n    .modal-dialog {\n        display: inline-block;\n        vertical-align: top;\n        text-align: left;\n        margin: 45px 0;\n        max-width: 94%\n    }\n\n    .modal-content {\n        border-radius: 4px\n    }\n}\n\n.modal-header>.h1 {\n    margin-bottom: 0\n}\n\n.image-item+.image-item {\n    margin-top: 37px\n}\n\n.descending .caret {\n    transform: rotate(180deg);\n    position: relative;\n    top: -1px\n}\n\n.no-padding {\n    padding: 0\n}\n\n#global-origin {\n    position: relative\n}\n\n#site-message {\n    position: fixed;\n    z-index: 5000;\n    font-size: 1.1em;\n    padding: .8em 1em;\n    margin: 0;\n    white-space: pre-line;\n    display: none\n}\n\n#db-log {\n    margin-bottom: 20px;\n    padding: .5em;\n    border: 1px solid #ddd;\n    background-color: #f4f1ec;\n    font-size: 12px;\n    font-family: Menlo,Monaco,Consolas,\"Courier New\",monospace\n}\n\n#db-log>div {\n    margin-top: .5em\n}\n\n#db-log>div:first-child {\n    margin-top: 0\n}\n\ntextarea {\n    resize: vertical\n}\n\n.fa-margin-left {\n    margin-left: 5px\n}\n\n.param-list>hr {\n    margin-top: 0;\n    margin-bottom: 25px\n}\n\n.param-list .param-item {\n    word-wrap: break-word\n}\n\n.lot-fields {\n    display: inline\n}\n\n.sort>a {\n    white-space: nowrap\n}\n\n.profile-container {\n    margin-top: 44px;\n    margin-bottom: 18px\n}\n\n.profile-data-container {\n    margin-top: -24px\n}\n\n.profile-data-container .offer-list-title-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px\n}\n\n.profile-data-container .offer-list-title-container .offer-list-title {\n    flex-grow: 1\n}\n\n.profile-data-container .offer-list-title-container .offer-list-title h3 {\n    font-family: \"Graphik Bold\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    margin-bottom: 0\n}\n\n.profile-data-container .offer-list-title-container .offer-list-title-button {\n    padding-left: 20px\n}\n\ntable.values {\n    border-collapse: collapse;\n    border: 0;\n    padding: 0;\n    margin: 0\n}\n\ntable.values>tbody>tr>* {\n    vertical-align: baseline;\n    text-align: left;\n    padding: .6em 0 0 1.2em\n}\n\ntable.values>tbody>tr:first-child>* {\n    padding-top: 0\n}\n\ntable.values>tbody>tr.top>* {\n    vertical-align: top\n}\n\ntable.values>tbody>tr>th {\n    padding-left: 0;\n    font-weight: bold;\n    color: #888;\n    white-space: nowrap\n}\n\ntable.values>tbody>tr>th.wrap {\n    white-space: normal\n}\n\nul.user-gates {\n    padding: 0;\n    margin: 0;\n    list-style: none\n}\n\nul.user-gates li {\n    margin-top: 10px;\n    white-space: nowrap\n}\n\nul.user-gates li:first-child {\n    margin-top: 0\n}\n\nul.user-gates li .pic,ul.user-gates li .body {\n    display: inline-block;\n    vertical-align: middle\n}\n\nul.user-gates li .pic {\n    margin-right: 10px\n}\n\nul.user-gates li .pic img {\n    display: inline-block;\n    width: 36px;\n    height: 36px;\n    border-radius: 5px;\n    background: hsl(0,0%,93.5%)\n}\n\nul.user-gates li .body {\n    line-height: 1.15\n}\n\nul.user-gates li .name {\n    font-size: 1.3em\n}\n\nul.user-gates li .email {\n    color: #888\n}\n\n.profile-operator-block {\n    margin-bottom: 44px\n}\n\n.margin-top {\n    margin-top: 20px\n}\n\n.margin-bottom {\n    margin-bottom: 20px\n}\n\n.margin-bottom-half {\n    margin-bottom: 10px\n}\n\n.modal-body {\n    overflow-x: hidden\n}\n\n.guess-rating table .player {\n    width: 100%\n}\n\n.guess-rating table .pos,.guess-rating table .points,.guess-rating table .prize {\n    text-align: right\n}\n\n.guess-rating td {\n    white-space: nowrap\n}\n\n.modal .guess-rating {\n    margin-top: 20px\n}\n\n.modal .guess-rating:first-child {\n    margin-top: 0\n}\n\n.modal .guess-rating h3,.modal .guess-rating h4 {\n    margin-top: 0\n}\n\n.modal .guess-rating table {\n    margin-bottom: 0\n}\n\n.guess-box div.image {\n    width: 360px;\n    height: 360px\n}\n\n.guess-box .btn {\n    margin-right: 10px\n}\n\n.guess-box .online {\n    color: #a6a6a6\n}\n\n.guess-box .tab-game {\n    font-size: 1.3em\n}\n\n.guess-box .tab-game td {\n    vertical-align: top\n}\n\n.guess-box .tab-game td.right {\n    padding-left: 20px;\n    white-space: nowrap\n}\n\n.guess-box .tab-game ul {\n    list-style: none;\n    padding: 0;\n    margin: 20px 0 0\n}\n\n.guess-box .tab-game li.img {\n    padding: 2px 0 3px\n}\n\n.guess-box .tab-game li.img a {\n    display: block;\n    height: 20px;\n    float: left;\n    overflow: hidden\n}\n\n.guess-box .tab-game li.img a img {\n    display: block\n}\n\n.guess-box .tab-game li.img a img:hover {\n    margin-top: -20px\n}\n\n.guess-box .ratings {\n    margin-top: 20px\n}\n\n.guess-box .ratings .guess-rating {\n    float: left;\n    margin-right: 40px\n}\n\n.guess-box .ratings .guess-rating table {\n    width: 300px\n}\n\nbody.vk-z-index .navbar-static-top {\n    z-index: 999\n}\n\nbody.vk-z-index .modal-backdrop {\n    z-index: 1000\n}\n\nbody.vk-z-index .modal {\n    z-index: 1001\n}\n\n.no-margin-bottom {\n    margin-bottom: 0\n}\n\n.no-margin-top {\n    margin-top: 0\n}\n\n.mw150 {\n    min-width: 150px\n}\n\n.input-group-btn .btn {\n    border: 1px solid #e4e4e4 !important\n}\n\ntable.exchange-rates-edit {\n    margin-bottom: 20px\n}\n\ntable.exchange-rates-edit td {\n    vertical-align: middle;\n    padding: 8px\n}\n\ntable.exchange-rates-edit td:first-child {\n    padding-left: 0\n}\n\n.pb20 {\n    padding-bottom: 20px\n}\n\n.monospace {\n    font-family: Menlo,Monaco,Consolas,\"Courier New\",monospace\n}\n\n.masked-links a {\n    color: inherit\n}\n\n.ajax-alert {\n    padding: 20px;\n    border-radius: 4px\n}\n\n.ajax-alert-danger {\n    background-color: rgb(249.36,224.52,227.64);\n    color: #f52323\n}\n\n.ajax-alert-info {\n    background-color: rgb(236.2,242.7,250.3);\n    color: rgb(46.9,92.4,145.6)\n}\n\nh1 .user-badges {\n    position: relative;\n    top: -2px\n}\n\n.w100 {\n    width: 100px\n}\n\n.w200p {\n    width: 200%\n}\n\n.blur {\n    opacity: .5\n}\n\n.callout {\n    padding: 20px;\n    margin-bottom: 20px;\n    border: 1px solid #e4e4e4;\n    border-left-width: 5px;\n    border-radius: 3px\n}\n\n.callout.callout-info {\n    border-left-color: #4384d0\n}\n\n.callout.callout-warning {\n    border-left-color: #f5a623\n}\n\n.callout.callout-danger {\n    border-left-color: #d0011b\n}\n\n.cd-click {\n    position: absolute;\n    background: none;\n    z-index: 551;\n    margin-top: 0\n}\n\n.cd-small {\n    width: 400px;\n    height: 400px\n}\n\n.pr10 {\n    padding-right: 10px\n}\n\n.menu-img-blur {\n    filter: brightness(0.5)\n}\n\n.chat-btn-image {\n    border: none;\n    color: #a6a6a6;\n    font-size: 27px;\n    padding: 0 5px;\n    margin: -5px 0\n}\n\n.chat-btn-image,.chat-btn-image:hover,.chat-btn-image:focus,.chat-btn-image:active,.chat-btn-image:active:hover,.chat-btn-image:active:focus {\n    background: none\n}\n\n.modal {\n    -webkit-overflow-scrolling: auto\n}\n\n.modal-lightbox .link-original-box {\n    margin-top: 12px\n}\n\n.drop-area {\n    display: flex;\n    align-items: center;\n    min-height: 200px;\n    color: #888;\n    font-size: 17px;\n    border: 2px dashed #888;\n    border-radius: 5px\n}\n\n.drop-area.hover {\n    background: #f9f9f9\n}\n\n.drop-area.error {\n    background: #ffd8d9\n}\n\n.drop-area .drop-area-hint {\n    pointer-events: none;\n    width: 100%;\n    text-align: center;\n    padding: 20px\n}\n\n.drop-area .drop-area-hint i {\n    display: block;\n    font-size: 40px;\n    margin-bottom: 10px\n}\n\n.crop-save {\n    float: right\n}\n\nlabel.payment-method {\n    width: 100%\n}\n\nlabel.payment-method span {\n    float: right\n}\n\n.w100 {\n    width: 100px\n}\n\n\n.payment-logo.payment-method-1 {\n    background-position: -345px -94px\n}\n\n.payment-logo.payment-method-2 {\n    background-position: -345px -34px\n}\n\n.payment-logo.payment-method-3 {\n    background-position: -345px -64px\n}\n\n.payment-logo.payment-method-4 {\n    background-position: -345px -64px\n}\n\n.payment-logo.payment-method-5 {\n    background-position: -345px -64px\n}\n\n.payment-logo.payment-method-6 {\n    background-position: -345px -64px\n}\n\n.payment-logo.payment-method-7 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-8 {\n    background-position: -345px -124px\n}\n\n.payment-logo.payment-method-9 {\n    background-position: -345px -154px\n}\n\n.payment-logo.payment-method-10 {\n    background-position: -345px -64px\n}\n\n.payment-logo.payment-method-11 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-12 {\n    background-position: -345px -274px\n}\n\n.payment-logo.payment-method-13 {\n    background-position: -345px -304px\n}\n\n.payment-logo.payment-method-14 {\n    background-position: -345px -244px\n}\n\n.payment-logo.payment-method-15 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-16 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-17 {\n    background-position: -345px -244px\n}\n\n.payment-logo.payment-method-18 {\n    background-position: -345px -244px\n}\n\n.payment-logo.payment-method-19 {\n    background-position: -345px -154px\n}\n\n.payment-logo.payment-method-20 {\n    background-position: -345px -154px\n}\n\n.payment-logo.payment-method-21 {\n    background-position: -345px -364px\n}\n\n.payment-logo.payment-method-22 {\n    background-position: -345px -274px\n}\n\n.payment-logo.payment-method-23 {\n    background-position: -345px -274px\n}\n\n.payment-logo.payment-method-24 {\n    background-position: -345px -214px\n}\n\n.payment-logo.payment-method-25 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-26 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-27 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-28 {\n    background-position: -345px -304px\n}\n\n.payment-logo.payment-method-29 {\n    background-position: -345px -304px\n}\n\n.payment-logo.payment-method-30 {\n    background-position: -375px -4px\n}\n\n.payment-logo.payment-method-31 {\n    background-position: -375px -34px\n}\n\n.payment-logo.payment-method-32 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-33 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-34 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-35 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-36 {\n    background-position: -345px -184px\n}\n\n.payment-logo.payment-method-37 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-38 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-39 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-40 {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-41 {\n    background-position: -375px -64px\n}\n\n.payment-logo.payment-method-card_eur {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-card_rub {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-card_uah {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-card_usd {\n    background-position: -345px -4px\n}\n\n.payment-logo.payment-method-fps {\n    background-position: -345px -364px\n}\n\n.payment-logo.payment-method-paypal {\n    background-position: -345px -184px\n}\n\n.payment-logo.payment-method-qiwi {\n    background-position: -345px -94px\n}\n\n.payment-logo.payment-method-wme {\n    background-position: -345px -64px\n}\n\n.payment-logo.payment-method-wmp {\n    background-position: -345px -64px\n}\n\n.payment-logo.payment-method-wmr {\n    background-position: -345px -64px\n}\n\n.payment-logo.payment-method-wmz {\n    background-position: -345px -64px\n}\n\n.payment-logo.payment-method-yandex {\n    background-position: -345px -34px\n}\n\n.payment-logo.payment-method-usdt_trc {\n    background-position: -375px -64px\n}\n\n.payment-logo.payment-method-binance_usdc {\n    background-position: -375px -34px\n}\n\n.payment-logo.payment-method-binance_usdt {\n    background-position: -375px -34px\n}\n\n.withdraw-select .dropdown-menu {\n    width: 100%\n}\n\n.orders-table .order-desc {\n    word-wrap: break-word;\n    word-break: break-word\n}\n\n.orders-filter {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 20px\n}\n\n.orders-filter .form-group {\n    margin-bottom: 0\n}\n\n.orders-filter .filter-text {\n    width: 11em\n}\n\n.orders-filter .filter-range {\n    width: 8em\n}\n\n@media(max-width: 767px) {\n    .w100 {\n        width:100%\n    }\n}\n\n.panel-heading-buttons {\n    display: inline-block;\n    margin-left: 15px\n}\n\n.panel-heading-buttons button,.panel-heading-buttons .btn {\n    vertical-align: top;\n    margin: -2px 0 -5px 0\n}\n\n@media(max-width: 767px) {\n    .panel-heading-buttons button span,.panel-heading-buttons .btn span {\n        display:none\n    }\n}\n\n.lot-field .lot-field-range {\n    width: 6em;\n    display: inline-block\n}\n\n.lot-field .lot-field-radio-box {\n    margin-bottom: -4px\n}\n\n.lot-field .lot-field-radio-box button {\n    margin-bottom: 4px\n}\n\n@media(min-width: 768px) {\n    .lot-field .lot-field-range-box {\n        display:inline-block;\n        vertical-align: middle\n    }\n}\n\n.modal-upload-preview img.preview {\n    display: block;\n    width: 100%;\n    height: 200px;\n    object-fit: contain;\n    background-color: hsl(0,0%,93.5%)\n}\n\n@media(min-width: 768px) {\n    .form-inline-margins .form-group {\n        margin-right:10px\n    }\n\n    .form-inline-margins .form-group label {\n        margin-right: 5px\n    }\n}\n\n.withdraw-box .slave {\n    background-color: #f5f5f5\n}\n\n.withdraw-box .slave:hover {\n    background-color: #fff\n}\n\n.withdraw-box .preview .wallet {\n    word-wrap: break-word;\n    word-break: break-word\n}\n\n.transaction-values {\n    word-break: break-word\n}\n\n.transaction-status-complete .transaction-status {\n    color: #7ed320\n}\n\n.transaction-status-waiting .transaction-status {\n    color: #f5a623\n}\n\n.transaction-status-cancel .transaction-status {\n    color: #f52323\n}\n\n.table>thead>tr>td.transaction-status-waiting,.table>thead>tr>th.transaction-status-waiting,.table>thead>tr.transaction-status-waiting>td,.table>thead>tr.transaction-status-waiting>th,.table>tbody>tr>td.transaction-status-waiting,.table>tbody>tr>th.transaction-status-waiting,.table>tbody>tr.transaction-status-waiting>td,.table>tbody>tr.transaction-status-waiting>th,.table>tfoot>tr>td.transaction-status-waiting,.table>tfoot>tr>th.transaction-status-waiting,.table>tfoot>tr.transaction-status-waiting>td,.table>tfoot>tr.transaction-status-waiting>th {\n    background-color: rgb(254.09,251.88,225.49)\n}\n\n.table-hover>tbody>tr>td.transaction-status-waiting:hover,.table-hover>tbody>tr>th.transaction-status-waiting:hover,.table-hover>tbody>tr.transaction-status-waiting:hover>td,.table-hover>tbody>tr:hover>.transaction-status-waiting,.table-hover>tbody>tr.transaction-status-waiting:hover>th {\n    background-color: hsl(55.3636363636,94.0170940171%,89.0352941176%)\n}\n\n.tc.table-hover .tc-item.transaction-status-waiting {\n    background-color: rgb(254.09,251.88,225.49)\n}\n\n.tc.table-hover .tc-item.transaction-status-waiting:hover {\n    background-color: hsl(55.3636363636,94.0170940171%,89.0352941176%)\n}\n\n.nav-pills>li,.nav-pills>li+li {\n    margin-bottom: 0\n}\n\nform div.captcha {\n    display: block;\n    height: 80px;\n    margin-bottom: 1em;\n    line-height: 80px;\n    vertical-align: middle\n}\n\nform div.captcha img {\n    width: 180px;\n    height: 80px;\n    vertical-align: bottom;\n    cursor: pointer\n}\n\nform div.captcha span {\n    margin-left: 1em;\n    cursor: pointer;\n    color: #a6a6a6\n}\n\nform div.captcha span:hover {\n    color: #222\n}\n\ntable.table-controls tbody>tr>td {\n    vertical-align: middle\n}\n\ntable.table-controls div.checkbox {\n    margin-top: 0;\n    margin-bottom: 0\n}\n\ntable.table-controls div.checkbox label {\n    vertical-align: bottom\n}\n\ntable.table-controls select.form-control {\n    width: auto\n}\n\n.table-sortable .sort,.tc-sortable .sort {\n    cursor: pointer\n}\n\n.table-sortable .sort .fa,.tc-sortable .sort .fa {\n    margin-left: 1px;\n    vertical-align: -1px\n}\n\n.table-sortable .sort .fa:before,.tc-sortable .sort .fa:before {\n    content: \"\"\n}\n\n.table-sortable .sort.descending .fa,.tc-sortable .sort.descending .fa {\n    vertical-align: -1px\n}\n\n.table-sortable .sort.descending .fa:before,.tc-sortable .sort.descending .fa:before {\n    content: \"\"\n}\n\n.table-sortable .sort.ascending .fa,.tc-sortable .sort.ascending .fa {\n    vertical-align: 0\n}\n\n.table-sortable .sort.ascending .fa:before,.tc-sortable .sort.ascending .fa:before {\n    content: \"\"\n}\n\n.table-sortable .sort.loading .fa,.tc-sortable .sort.loading .fa {\n    color: #a6a6a6\n}\n\n.main-container {\n    padding-top: 20px;\n    padding-bottom: 80px\n}\n\n.security-challenge {\n    max-width: 400px;\n    margin: 0 auto\n}\n\n.security-challenge h1 {\n    margin-bottom: 20px\n}\n\n.search-fade {\n    background: #000;\n    position: absolute;\n    left: 0;\n    top: 61px;\n    width: 100%;\n    height: 100%;\n    opacity: .5;\n    z-index: 900;\n    display: none\n}\n\n.js-price-row i {\n    font-size: 12px\n}\n\n.layout-swap {\n    display: table;\n    table-layout: fixed;\n    width: 100%\n}\n\n.layout-swap>div {\n    display: table-row-group\n}\n\n.layout-swap>div:first-child {\n    display: table-footer-group\n}\n\n.layout-swap .content-with-cd-wide.tbl-footer {\n    padding-top: 0\n}\n\n.layout-swap>.with-tbl-footer .content-with-cd-wide.showcase {\n    padding-bottom: 20px;\n    border-bottom-right-radius: 0\n}\n\n.layout-swap>.with-tbl-footer .content-with-cd-wide.showcase .tc {\n    margin-bottom: 0\n}\n\n.layout-swap.layout-swap-disabled>div {\n    display: table-row-group\n}\n\n.content-lots-node .layout-swap .content-with-cd-wide.tbl-footer {\n    border-top-right-radius: 0\n}\n\n@media(max-width: 767px) {\n    .layout-swap>.with-tbl-footer .content-with-cd-wide.showcase {\n        padding-bottom:14px\n    }\n}\n\n.container.nested-menu+.container .page-content-full {\n    padding-top: 0;\n    margin-top: 20px\n}\n\n.lazyload-hidden {\n    display: none !important\n}\n\n@media(max-width: 767px) {\n    .btn-block-mobile {\n        display:block;\n        width: 100%\n    }\n\n    .btn-block-mobile+.btn-block-mobile {\n        margin-top: 5px\n    }\n\n    .modal-footer .btn-block-mobile+.btn-block-mobile,.modal-actions .btn-block-mobile+.btn-block-mobile {\n        margin-left: 0\n    }\n}\n\n@media(min-width: 768px) {\n    .modal-offer-editor .modal-dialog {\n        width:540px\n    }\n}\n\n.order-log-table th:first-child,.order-log-table td:first-child {\n    padding-left: 0\n}\n\n.order-log-table th:last-child,.order-log-table td:last-child {\n    padding-right: 0\n}\n\n.order-log-table .order-log-actor {\n    width: 37%;\n    min-width: 50px;\n    max-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis\n}\n\n.order-log-table .ip-info .pseudo-a {\n    color: #a6a6a6;\n    text-decoration: none\n}\n\n.order-log-table .ip-info .pseudo-a:hover,.order-log-table .ip-info .pseudo-a:focus {\n    color: #a6a6a6;\n    text-decoration: underline\n}\n\n@media(min-width: 480px) {\n    .order-log-table {\n        white-space:nowrap\n    }\n}\n\n.account-blocked-box .h5 {\n    margin-top: 20px\n}\n\n.account-blocked-comment {\n    padding: 10px 16px;\n    background: #f5f5f5;\n    border-radius: 4px;\n    max-width: 100%;\n    word-wrap: break-word\n}\n\n@media(min-width: 480px) {\n    .account-blocked-comment {\n        display:inline-block;\n        min-width: 250px\n    }\n}\n\n.account-blocked-comment.balance-claim-box {\n    font-size: 10px\n}\n\n.table-site-rules td:first-child,.table-site-rules th:first-child {\n    width: 60%;\n    padding-left: 0\n}\n\n.table-site-rules td:last-child,.table-site-rules th:last-child {\n    width: 40%;\n    padding-right: 0\n}\n\n.modal-custom-bg-block {\n    padding-left: 25px;\n    padding-right: 25px;\n    padding-bottom: 17px;\n    margin-bottom: 0\n}\n\n.modal .modal-custom-bg-block {\n    margin-left: -25px;\n    margin-right: -25px\n}\n\n@media(max-width: 767px) {\n    .modal-custom-bg-block {\n        padding-left:10px;\n        padding-right: 10px\n    }\n\n    .modal .modal-custom-bg-block {\n        margin-left: -10px;\n        margin-right: -10px\n    }\n}\n\n.modal-custom-bg-block.modal-custom-bg-block-top {\n    padding-top: 17px\n}\n\n.modal-custom-bg-block .help-block {\n    margin-bottom: 0\n}\n\n.lot-fields-multilingual {\n    border-bottom: 1px solid #d8d8d8;\n    margin-bottom: 17px\n}\n\n.lot-fields-multilingual .nav-tabs {\n    font-size: 14px\n}\n\n.lot-fields-multilingual .nav-tabs a {\n    padding-top: 0;\n    padding-bottom: 8px\n}\n\n\n\n@media(max-width: 1400px) {\n    .note-choose-server {\n        display:none\n    }\n}\n\n.note-choose-server:lang(ru),.note-choose-server:lang(uk) {\n    display: none\n}\n\n.payment-hold-box blockquote {\n    margin: 10px 0\n}\n\n.payment-hold-box blockquote em {\n    color: #a6a6a6;\n    font-style: normal\n}\n\n.payment-hold-box img {\n    border-radius: 4px\n}\n\n.ip-info {\n    cursor: pointer\n}\n\n.ip-info .label {\n    top: -0.125em;\n    position: relative\n}\n\n.ip-info .pseudo-a {\n    color: #4384d0;\n    text-decoration: none\n}\n\n.ip-info .pseudo-a:hover,.ip-info .pseudo-a:focus {\n    color: rgb(39.7,94.6042553191,158.8);\n    text-decoration: underline\n}\n\n.ip-info-popover .label {\n    top: -0.125em;\n    position: relative\n}\n\n.relation-cases {\n    cursor: pointer;\n    color: #4384d0;\n    text-decoration: none\n}\n\n.relation-cases:hover,.relation-cases:focus {\n    color: rgb(39.7,94.6042553191,158.8);\n    text-decoration: underline\n}\n\n.relation-cases-details {\n    word-break: break-word\n}\n\n.relation-cases-details .relation-cases-category:not(:last-child) {\n    padding-bottom: 20px\n}\n\n.modal-cookie-consent .panel-title {\n    font-size: 12px\n}\n\n.modal-cookie-consent .checkbox-indent {\n    margin-left: 24px\n}\n\n.banner-cookie-consent {\n    position: fixed;\n    bottom: 8px;\n    z-index: 1030;\n    background-color: rgb(209.8,225.4276595745,243.7);\n    padding: 12px 18px;\n    border-radius: 4px\n}\n\n@media(max-width: 767px) {\n    .banner-cookie-consent {\n        bottom:0;\n        left: 0;\n        right: 0;\n        padding: 10px;\n        border-radius: 0\n    }\n\n    .banner-cookie-consent .cc-text {\n        margin-bottom: 10px\n    }\n}\n\n@media(min-width: 768px) {\n    .banner-cookie-consent {\n        width:720px;\n        display: flex;\n        align-items: center\n    }\n\n    .banner-cookie-consent .cc-text {\n        flex: 1 1 auto\n    }\n\n    .banner-cookie-consent .cc-buttons {\n        margin-left: 50px\n    }\n\n    .banner-cookie-consent .cc-buttons .btn {\n        float: right;\n        margin: 4px 0 4px 8px\n    }\n}\n\n@media(min-width: 992px) {\n    .banner-cookie-consent {\n        margin-left:20px;\n        width: 900px\n    }\n\n    .banner-cookie-consent .cc-buttons {\n        flex-shrink: 0\n    }\n}\n\n@media(min-width: 1200px) {\n    .banner-cookie-consent {\n        margin-left:112.5px\n    }\n}\n\n.cursor-pointer {\n    cursor: pointer\n}\n\n.form-two-factor .secret-box {\n    font-size: 17px;\n    white-space: nowrap\n}\n\n.form-two-factor .secret-placeholder {\n    font-family: Menlo,Monaco,Consolas,\"Courier New\",monospace;\n    margin-right: .4em\n}\n\n.table-payments-admin .text-clipped-s,.table-payments-admin .text-clipped-l {\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n}\n\n.table-payments-admin .text-clipped-s {\n    max-width: 10em\n}\n\n.table-payments-admin .text-clipped-l {\n    max-width: 15em\n}\n\n.textarea-lot-secrets {\n    font-family: Menlo,Monaco,Consolas,\"Courier New\",monospace;\n    white-space: pre;\n    word-wrap: normal\n}\n\n.order-secrets-box {\n    background: #d8f0bc;\n    padding: 20px;\n    border-radius: 4px;\n    color: #222\n}\n\n.order-secrets-box h5 {\n    color: #222\n}\n\n.order-secrets-list {\n    padding-left: 0;\n    list-style: none;\n    font-size: 16px;\n    margin-bottom: 0\n}\n\n.order-secrets-list li+li {\n    margin-top: .4em\n}\n\n.order-secrets-list .secret-placeholder {\n    font-family: Menlo,Monaco,Consolas,\"Courier New\",monospace;\n    margin-right: .4em\n}\n\n.auto-dlv-icon {\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    color: #4384d0\n}\n\n.auto-dlv-icon:before {\n    content: \"\"\n}\n\n.offer-header-auto-dlv-label {\n    font-size: 15px;\n    margin-top: .6em\n}\n\n.promo-offer-icon {\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    color: #f5a623\n}\n\n.promo-offer-icon:before {\n    content: \"\"\n}\n\n.qr-code-box {\n    width: 150px;\n    height: 150px;\n    display: block\n}\n\n@media(max-width: 767px) {\n    .details-editor .btn-link {\n        padding-left:0;\n        padding-right: 0\n    }\n\n    .details-editor .detail-data {\n        margin-top: 5px;\n        margin-bottom: 5px\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
